import React from 'react';

const SVGDotsWrap = () => (
  <svg
    width="541"
    height="527"
    viewBox="0 0 541 527"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.1">
      <mask
        id="mask0_257_5117"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="37"
        y="138"
        width="480"
        height="279"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M81.7446 215.766C49.6284 224.372 30.5692 257.383 39.1747 289.5C56.688 354.86 118.887 404.032 183.09 414.695C217.396 420.393 255.551 415.787 290.049 394.201C324.54 372.619 349.64 337.682 364.747 293.027C371.903 271.872 379.113 263.371 382.299 260.497C384.413 258.59 385.216 258.575 385.806 258.564C385.855 258.563 385.902 258.562 385.948 258.56C387.787 258.484 392.087 258.985 398.694 262.09C405.178 265.138 411.415 269.561 416.008 273.773C440.51 296.248 478.593 294.605 501.068 270.102C523.543 245.6 521.9 207.517 497.397 185.042C474.913 164.418 432.059 136.132 380.944 138.258C353.24 139.411 325.474 149.6 301.649 171.093C278.722 191.775 262.225 220.347 250.691 254.443C242.434 278.849 232.206 288.36 226.181 292.13C220.164 295.895 212.618 297.544 202.818 295.916C192.472 294.198 181.083 288.91 171.53 280.804C161.828 272.571 157.004 264.033 155.478 258.336C146.872 226.22 113.861 207.161 81.7446 215.766Z"
          fill="#FEFAF5"
        />
      </mask>
      <g mask="url(#mask0_257_5117)">
        <path
          d="M185.051 0.181049C186.159 0.820814 187.586 0.424756 188.237 -0.703571C188.889 -1.8319 188.518 -3.26522 187.41 -3.90498C186.302 -4.54475 184.876 -4.14869 184.224 -3.02037C183.573 -1.89204 183.943 -0.458717 185.051 0.181049Z"
          fill="#3A2933"
        />
        <path
          d="M190.718 8.90067C191.826 9.54044 193.252 9.14438 193.904 8.01605C194.555 6.88772 194.185 5.4544 193.077 4.81464C191.969 4.17487 190.542 4.57093 189.891 5.69926C189.239 6.82758 189.61 8.26091 190.718 8.90067Z"
          fill="#3A2933"
        />
        <path
          d="M195.436 0.728605C196.544 1.36837 197.97 0.972313 198.622 -0.156013C199.273 -1.28434 198.903 -2.71766 197.795 -3.35743C196.687 -3.99719 195.261 -3.60114 194.609 -2.47281C193.958 -1.34448 194.328 0.0888401 195.436 0.728605Z"
          fill="#3A2933"
        />
        <path
          d="M180.333 8.35311C181.441 8.99288 182.868 8.59682 183.519 7.4685C184.17 6.34017 183.8 4.90685 182.692 4.26708C181.584 3.62732 180.158 4.02337 179.506 5.1517C178.855 6.28003 179.225 7.71335 180.333 8.35311Z"
          fill="#3A2933"
        />
        <path
          d="M186 17.0727C187.108 17.7125 188.534 17.3164 189.186 16.1881C189.837 15.0598 189.467 13.6265 188.359 12.9867C187.251 12.3469 185.824 12.743 185.173 13.8713C184.521 14.9996 184.892 16.433 186 17.0727Z"
          fill="#3A2933"
        />
        <path
          d="M175.615 16.5252C176.723 17.1649 178.149 16.7689 178.801 15.6406C179.452 14.5122 179.082 13.0789 177.974 12.4391C176.866 11.7994 175.44 12.1954 174.788 13.3238C174.137 14.4521 174.507 15.8854 175.615 16.5252Z"
          fill="#3A2933"
        />
        <path
          d="M181.282 25.2448C182.39 25.8846 183.816 25.4885 184.467 24.3602C185.119 23.2319 184.749 21.7985 183.641 21.1588C182.532 20.519 181.106 20.9151 180.455 22.0434C179.803 23.1717 180.173 24.605 181.282 25.2448Z"
          fill="#3A2933"
        />
        <path
          d="M176.563 33.4169C177.671 34.0566 179.098 33.6606 179.749 32.5322C180.401 31.4039 180.031 29.9706 178.922 29.3308C177.814 28.6911 176.388 29.0871 175.737 30.2155C175.085 31.3438 175.455 32.7771 176.563 33.4169Z"
          fill="#3A2933"
        />
        <path
          d="M170.897 24.6972C172.005 25.337 173.431 24.941 174.083 23.8126C174.734 22.6843 174.364 21.251 173.256 20.6112C172.148 19.9714 170.721 20.3675 170.07 21.4958C169.419 22.6242 169.789 24.0575 170.897 24.6972Z"
          fill="#3A2933"
        />
        <path
          d="M166.179 32.8693C167.287 33.5091 168.713 33.113 169.365 31.9847C170.016 30.8564 169.646 29.423 168.538 28.7833C167.43 28.1435 166.003 28.5396 165.352 29.6679C164.7 30.7962 165.071 32.2295 166.179 32.8693Z"
          fill="#3A2933"
        />
        <path
          d="M171.845 41.5889C172.953 42.2287 174.38 41.8326 175.031 40.7043C175.683 39.576 175.312 38.1427 174.204 37.5029C173.096 36.8631 171.67 37.2592 171.018 38.3875C170.367 39.5158 170.737 40.9492 171.845 41.5889Z"
          fill="#3A2933"
        />
        <path
          d="M161.461 41.0414C162.569 41.6811 163.995 41.2851 164.646 40.1568C165.298 39.0284 164.928 37.5951 163.82 36.9553C162.712 36.3156 161.285 36.7116 160.634 37.84C159.982 38.9683 160.352 40.4016 161.461 41.0414Z"
          fill="#3A2933"
        />
        <path
          d="M167.127 49.761C168.235 50.4008 169.662 50.0047 170.313 48.8764C170.964 47.7481 170.594 46.3147 169.486 45.675C168.378 45.0352 166.952 45.4313 166.3 46.5596C165.649 47.6879 166.019 49.1212 167.127 49.761Z"
          fill="#3A2933"
        />
        <path
          d="M156.742 49.2134C157.851 49.8532 159.277 49.4571 159.928 48.3288C160.58 47.2005 160.21 45.7672 159.101 45.1274C157.993 44.4876 156.567 44.8837 155.916 46.012C155.264 47.1404 155.634 48.5737 156.742 49.2134Z"
          fill="#3A2933"
        />
        <path
          d="M162.409 57.9331C163.517 58.5728 164.943 58.1768 165.595 57.0485C166.246 55.9201 165.876 54.4868 164.768 53.847C163.66 53.2073 162.234 53.6033 161.582 54.7317C160.931 55.86 161.301 57.2933 162.409 57.9331Z"
          fill="#3A2933"
        />
        <path
          d="M157.691 66.1051C158.799 66.7449 160.225 66.3488 160.877 65.2205C161.528 64.0922 161.158 62.6589 160.05 62.0191C158.942 61.3793 157.515 61.7754 156.864 62.9037C156.212 64.032 156.583 65.4654 157.691 66.1051Z"
          fill="#3A2933"
        />
        <path
          d="M152.024 57.3855C153.132 58.0253 154.559 57.6292 155.21 56.5009C155.862 55.3726 155.491 53.9392 154.383 53.2995C153.275 52.6597 151.849 53.0558 151.197 54.1841C150.546 55.3124 150.916 56.7457 152.024 57.3855Z"
          fill="#3A2933"
        />
        <path
          d="M147.306 65.5576C148.414 66.1973 149.841 65.8013 150.492 64.6729C151.143 63.5446 150.773 62.1113 149.665 61.4715C148.557 60.8318 147.131 61.2278 146.479 62.3562C145.828 63.4845 146.198 64.9178 147.306 65.5576Z"
          fill="#3A2933"
        />
        <path
          d="M152.973 74.2772C154.081 74.917 155.507 74.5209 156.159 73.3926C156.81 72.2642 156.44 70.8309 155.332 70.1912C154.224 69.5514 152.797 69.9475 152.146 71.0758C151.494 72.2041 151.865 73.6374 152.973 74.2772Z"
          fill="#3A2933"
        />
        <path
          d="M142.588 73.7296C143.696 74.3694 145.122 73.9733 145.774 72.845C146.425 71.7167 146.055 70.2834 144.947 69.6436C143.839 69.0038 142.413 69.3999 141.761 70.5282C141.11 71.6566 141.48 73.0899 142.588 73.7296Z"
          fill="#3A2933"
        />
        <path
          d="M148.255 82.4493C149.363 83.089 150.789 82.693 151.44 81.5646C152.092 80.4363 151.722 79.003 150.614 78.3632C149.505 77.7235 148.079 78.1195 147.428 79.2478C146.776 80.3762 147.146 81.8095 148.255 82.4493Z"
          fill="#3A2933"
        />
        <path
          d="M143.536 90.6213C144.644 91.2611 146.071 90.865 146.722 89.7367C147.374 88.6084 147.004 87.1751 145.895 86.5353C144.787 85.8955 143.361 86.2916 142.709 87.4199C142.058 88.5482 142.428 89.9816 143.536 90.6213Z"
          fill="#3A2933"
        />
        <path
          d="M137.87 81.9017C138.978 82.5415 140.404 82.1454 141.056 81.0171C141.707 79.8888 141.337 78.4554 140.229 77.8157C139.121 77.1759 137.694 77.572 137.043 78.7003C136.392 79.8286 136.762 81.2619 137.87 81.9017Z"
          fill="#3A2933"
        />
        <path
          d="M133.152 90.0738C134.26 90.7135 135.686 90.3175 136.338 89.1891C136.989 88.0608 136.619 86.6275 135.511 85.9877C134.403 85.348 132.976 85.744 132.325 86.8724C131.673 88.0007 132.044 89.434 133.152 90.0738Z"
          fill="#3A2933"
        />
        <path
          d="M138.818 98.7934C139.926 99.4332 141.353 99.0371 142.004 97.9088C142.656 96.7804 142.285 95.3471 141.177 94.7074C140.069 94.0676 138.643 94.4637 137.991 95.592C137.34 96.7203 137.71 98.1536 138.818 98.7934Z"
          fill="#3A2933"
        />
        <path
          d="M128.434 98.2458C129.542 98.8856 130.968 98.4895 131.619 97.3612C132.271 96.2329 131.901 94.7996 130.793 94.1598C129.685 93.52 128.258 93.9161 127.607 95.0444C126.955 96.1727 127.325 97.6061 128.434 98.2458Z"
          fill="#3A2933"
        />
        <path
          d="M134.1 106.965C135.208 107.605 136.635 107.209 137.286 106.081C137.937 104.953 137.567 103.519 136.459 102.879C135.351 102.24 133.925 102.636 133.273 103.764C132.622 104.892 132.992 106.326 134.1 106.965Z"
          fill="#3A2933"
        />
        <path
          d="M123.715 106.418C124.823 107.058 126.25 106.662 126.901 105.533C127.553 104.405 127.183 102.972 126.074 102.332C124.966 101.692 123.54 102.088 122.889 103.216C122.237 104.345 122.607 105.778 123.715 106.418Z"
          fill="#3A2933"
        />
        <path
          d="M129.382 115.138C130.49 115.777 131.916 115.381 132.568 114.253C133.219 113.125 132.849 111.691 131.741 111.051C130.633 110.412 129.207 110.808 128.555 111.936C127.904 113.064 128.274 114.498 129.382 115.138Z"
          fill="#3A2933"
        />
        <path
          d="M124.664 123.31C125.772 123.949 127.198 123.553 127.85 122.425C128.501 121.297 128.131 119.863 127.023 119.224C125.915 118.584 124.488 118.98 123.837 120.108C123.185 121.236 123.556 122.67 124.664 123.31Z"
          fill="#3A2933"
        />
        <path
          d="M118.997 114.59C120.105 115.23 121.532 114.834 122.183 113.705C122.835 112.577 122.464 111.144 121.356 110.504C120.248 109.864 118.822 110.26 118.17 111.389C117.519 112.517 117.889 113.95 118.997 114.59Z"
          fill="#3A2933"
        />
        <path
          d="M114.279 122.762C115.387 123.402 116.814 123.006 117.465 121.877C118.116 120.749 117.746 119.316 116.638 118.676C115.53 118.036 114.104 118.432 113.452 119.561C112.801 120.689 113.171 122.122 114.279 122.762Z"
          fill="#3A2933"
        />
        <path
          d="M119.946 131.482C121.054 132.121 122.48 131.725 123.132 130.597C123.783 129.469 123.413 128.035 122.305 127.396C121.197 126.756 119.77 127.152 119.119 128.28C118.467 129.409 118.838 130.842 119.946 131.482Z"
          fill="#3A2933"
        />
        <path
          d="M109.561 130.934C110.669 131.574 112.095 131.178 112.747 130.049C113.398 128.921 113.028 127.488 111.92 126.848C110.812 126.208 109.386 126.604 108.734 127.733C108.083 128.861 108.453 130.294 109.561 130.934Z"
          fill="#3A2933"
        />
        <path
          d="M115.228 139.654C116.336 140.293 117.762 139.897 118.413 138.769C119.065 137.641 118.695 136.207 117.587 135.568C116.478 134.928 115.052 135.324 114.401 136.452C113.749 137.581 114.119 139.014 115.228 139.654Z"
          fill="#3A2933"
        />
        <path
          d="M104.843 139.106C105.951 139.746 107.377 139.35 108.029 138.222C108.68 137.093 108.31 135.66 107.202 135.02C106.094 134.38 104.667 134.776 104.016 135.905C103.365 137.033 103.735 138.466 104.843 139.106Z"
          fill="#3A2933"
        />
        <path
          d="M110.509 147.826C111.617 148.466 113.044 148.069 113.695 146.941C114.347 145.813 113.977 144.38 112.868 143.74C111.76 143.1 110.334 143.496 109.682 144.624C109.031 145.753 109.401 147.186 110.509 147.826Z"
          fill="#3A2933"
        />
        <path
          d="M105.791 155.998C106.899 156.638 108.326 156.242 108.977 155.113C109.629 153.985 109.258 152.552 108.15 151.912C107.042 151.272 105.616 151.668 104.964 152.796C104.313 153.925 104.683 155.358 105.791 155.998Z"
          fill="#3A2933"
        />
        <path
          d="M100.125 147.278C101.233 147.918 102.659 147.522 103.311 146.394C103.962 145.265 103.592 143.832 102.484 143.192C101.376 142.552 99.9493 142.948 99.2978 144.077C98.6464 145.205 99.0166 146.638 100.125 147.278Z"
          fill="#3A2933"
        />
        <path
          d="M95.4065 155.45C96.5146 156.09 97.941 155.694 98.5925 154.566C99.2439 153.437 98.8737 152.004 97.7656 151.364C96.6575 150.724 95.2311 151.121 94.5797 152.249C93.9282 153.377 94.2984 154.811 95.4065 155.45Z"
          fill="#3A2933"
        />
        <path
          d="M101.073 164.17C102.181 164.81 103.608 164.414 104.259 163.285C104.91 162.157 104.54 160.724 103.432 160.084C102.324 159.444 100.898 159.84 100.246 160.968C99.5948 162.097 99.965 163.53 101.073 164.17Z"
          fill="#3A2933"
        />
        <path
          d="M90.6884 163.622C91.7965 164.262 93.2229 163.866 93.8743 162.738C94.5258 161.609 94.1556 160.176 93.0475 159.536C91.9394 158.897 90.513 159.293 89.8615 160.421C89.2101 161.549 89.5803 162.983 90.6884 163.622Z"
          fill="#3A2933"
        />
        <path
          d="M96.3549 172.342C97.463 172.982 98.8894 172.586 99.5409 171.457C100.192 170.329 99.8221 168.896 98.714 168.256C97.6059 167.616 96.1795 168.012 95.5281 169.141C94.8766 170.269 95.2468 171.702 96.3549 172.342Z"
          fill="#3A2933"
        />
        <path
          d="M91.6368 180.514C92.7449 181.154 94.1713 180.758 94.8227 179.629C95.4742 178.501 95.104 177.068 93.9959 176.428C92.8877 175.788 91.4614 176.184 90.8099 177.313C90.1585 178.441 90.5287 179.874 91.6368 180.514Z"
          fill="#3A2933"
        />
        <path
          d="M85.9702 171.794C87.0783 172.434 88.5047 172.038 89.1562 170.91C89.8076 169.781 89.4374 168.348 88.3293 167.708C87.2212 167.069 85.7948 167.465 85.1434 168.593C84.4919 169.721 84.8621 171.155 85.9702 171.794Z"
          fill="#3A2933"
        />
        <path
          d="M201.102 9.44823C202.211 10.088 203.637 9.69194 204.288 8.56361C204.94 7.43528 204.57 6.00196 203.462 5.36219C202.353 4.72243 200.927 5.11849 200.276 6.24681C199.624 7.37514 199.994 8.80846 201.102 9.44823Z"
          fill="#3A2933"
        />
        <path
          d="M206.769 18.1678C207.877 18.8076 209.304 18.4116 209.955 17.2832C210.606 16.1549 210.236 14.7216 209.128 14.0818C208.02 13.4421 206.594 13.8381 205.942 14.9664C205.291 16.0948 205.661 17.5281 206.769 18.1678Z"
          fill="#3A2933"
        />
        <path
          d="M211.487 9.99578C212.595 10.6355 214.022 10.2395 214.673 9.11117C215.325 7.98284 214.954 6.54952 213.846 5.90975C212.738 5.26999 211.312 5.66604 210.66 6.79437C210.009 7.9227 210.379 9.35602 211.487 9.99578Z"
          fill="#3A2933"
        />
        <path
          d="M196.384 17.6203C197.492 18.2601 198.919 17.864 199.57 16.7357C200.222 15.6073 199.852 14.174 198.743 13.5343C197.635 12.8945 196.209 13.2906 195.557 14.4189C194.906 15.5472 195.276 16.9805 196.384 17.6203Z"
          fill="#3A2933"
        />
        <path
          d="M202.051 26.3399C203.159 26.9797 204.585 26.5836 205.237 25.4553C205.888 24.327 205.518 22.8936 204.41 22.2539C203.302 21.6141 201.875 22.0102 201.224 23.1385C200.573 24.2668 200.943 25.7001 202.051 26.3399Z"
          fill="#3A2933"
        />
        <path
          d="M191.666 25.7924C192.774 26.4321 194.201 26.0361 194.852 24.9077C195.504 23.7794 195.133 22.3461 194.025 21.7063C192.917 21.0666 191.491 21.4626 190.839 22.5909C190.188 23.7193 190.558 25.1526 191.666 25.7924Z"
          fill="#3A2933"
        />
        <path
          d="M197.333 34.512C198.441 35.1517 199.867 34.7557 200.519 33.6274C201.17 32.499 200.8 31.0657 199.692 30.4259C198.584 29.7862 197.157 30.1822 196.506 31.3106C195.854 32.4389 196.225 33.8722 197.333 34.512Z"
          fill="#3A2933"
        />
        <path
          d="M192.615 42.684C193.723 43.3238 195.149 42.9278 195.801 41.7994C196.452 40.6711 196.082 39.2378 194.974 38.598C193.866 37.9582 192.439 38.3543 191.788 39.4826C191.136 40.611 191.506 42.0443 192.615 42.684Z"
          fill="#3A2933"
        />
        <path
          d="M186.948 33.9644C188.056 34.6042 189.483 34.2081 190.134 33.0798C190.785 31.9515 190.415 30.5182 189.307 29.8784C188.199 29.2386 186.773 29.6347 186.121 30.763C185.47 31.8913 185.84 33.3247 186.948 33.9644Z"
          fill="#3A2933"
        />
        <path
          d="M182.23 42.1365C183.338 42.7763 184.764 42.3802 185.416 41.2519C186.067 40.1235 185.697 38.6902 184.589 38.0505C183.481 37.4107 182.054 37.8067 181.403 38.9351C180.752 40.0634 181.122 41.4967 182.23 42.1365Z"
          fill="#3A2933"
        />
        <path
          d="M187.896 50.8561C189.005 51.4959 190.431 51.0998 191.082 49.9715C191.734 48.8432 191.364 47.4098 190.256 46.7701C189.147 46.1303 187.721 46.5264 187.07 47.6547C186.418 48.783 186.788 50.2163 187.896 50.8561Z"
          fill="#3A2933"
        />
        <path
          d="M177.512 50.3086C178.62 50.9483 180.046 50.5523 180.698 49.4239C181.349 48.2956 180.979 46.8623 179.871 46.2225C178.763 45.5828 177.336 45.9788 176.685 47.1071C176.033 48.2355 176.404 49.6688 177.512 50.3086Z"
          fill="#3A2933"
        />
        <path
          d="M183.178 59.0282C184.286 59.6679 185.713 59.2719 186.364 58.1436C187.016 57.0152 186.645 55.5819 185.537 54.9421C184.429 54.3024 183.003 54.6984 182.351 55.8268C181.7 56.9551 182.07 58.3884 183.178 59.0282Z"
          fill="#3A2933"
        />
        <path
          d="M172.794 58.4806C173.902 59.1204 175.328 58.7243 175.98 57.596C176.631 56.4677 176.261 55.0344 175.153 54.3946C174.045 53.7548 172.618 54.1509 171.967 55.2792C171.315 56.4075 171.686 57.8409 172.794 58.4806Z"
          fill="#3A2933"
        />
        <path
          d="M178.46 67.2002C179.568 67.84 180.995 67.444 181.646 66.3156C182.298 65.1873 181.927 63.754 180.819 63.1142C179.711 62.4744 178.285 62.8705 177.633 63.9988C176.982 65.1272 177.352 66.5605 178.46 67.2002Z"
          fill="#3A2933"
        />
        <path
          d="M173.742 75.3723C174.85 76.0121 176.277 75.616 176.928 74.4877C177.579 73.3594 177.209 71.926 176.101 71.2863C174.993 70.6465 173.567 71.0426 172.915 72.1709C172.264 73.2992 172.634 74.7325 173.742 75.3723Z"
          fill="#3A2933"
        />
        <path
          d="M168.075 66.6527C169.184 67.2925 170.61 66.8964 171.261 65.7681C171.913 64.6397 171.543 63.2064 170.435 62.5666C169.326 61.9269 167.9 62.3229 167.249 63.4513C166.597 64.5796 166.967 66.0129 168.075 66.6527Z"
          fill="#3A2933"
        />
        <path
          d="M163.357 74.8247C164.465 75.4645 165.892 75.0685 166.543 73.9401C167.195 72.8118 166.825 71.3785 165.716 70.7387C164.608 70.099 163.182 70.495 162.53 71.6233C161.879 72.7517 162.249 74.185 163.357 74.8247Z"
          fill="#3A2933"
        />
        <path
          d="M169.024 83.5444C170.132 84.1841 171.558 83.7881 172.21 82.6598C172.861 81.5314 172.491 80.0981 171.383 79.4583C170.275 78.8186 168.848 79.2146 168.197 80.343C167.546 81.4713 167.916 82.9046 169.024 83.5444Z"
          fill="#3A2933"
        />
        <path
          d="M158.639 82.9968C159.747 83.6366 161.174 83.2405 161.825 82.1122C162.477 80.9839 162.106 79.5506 160.998 78.9108C159.89 78.271 158.464 78.6671 157.812 79.7954C157.161 80.9237 157.531 82.357 158.639 82.9968Z"
          fill="#3A2933"
        />
        <path
          d="M164.306 91.7164C165.414 92.3562 166.84 91.9601 167.492 90.8318C168.143 89.7035 167.773 88.2702 166.665 87.6304C165.557 86.9906 164.13 87.3867 163.479 88.515C162.827 89.6433 163.198 91.0767 164.306 91.7164Z"
          fill="#3A2933"
        />
        <path
          d="M159.588 99.8885C160.696 100.528 162.122 100.132 162.774 99.0039C163.425 97.8756 163.055 96.4422 161.947 95.8025C160.839 95.1627 159.412 95.5588 158.761 96.6871C158.109 97.8154 158.479 99.2487 159.588 99.8885Z"
          fill="#3A2933"
        />
        <path
          d="M153.921 91.1689C155.029 91.8087 156.456 91.4126 157.107 90.2843C157.758 89.1559 157.388 87.7226 156.28 87.0829C155.172 86.4431 153.746 86.8391 153.094 87.9675C152.443 89.0958 152.813 90.5291 153.921 91.1689Z"
          fill="#3A2933"
        />
        <path
          d="M149.203 99.3409C150.311 99.9807 151.737 99.5847 152.389 98.4563C153.04 97.328 152.67 95.8947 151.562 95.2549C150.454 94.6151 149.027 95.0112 148.376 96.1395C147.725 97.2679 148.095 98.7012 149.203 99.3409Z"
          fill="#3A2933"
        />
        <path
          d="M154.869 108.061C155.978 108.7 157.404 108.304 158.055 107.176C158.707 106.048 158.337 104.614 157.229 103.975C156.12 103.335 154.694 103.731 154.043 104.859C153.391 105.987 153.761 107.421 154.869 108.061Z"
          fill="#3A2933"
        />
        <path
          d="M144.485 107.513C145.593 108.153 147.019 107.757 147.671 106.628C148.322 105.5 147.952 104.067 146.844 103.427C145.736 102.787 144.309 103.183 143.658 104.312C143.006 105.44 143.377 106.873 144.485 107.513Z"
          fill="#3A2933"
        />
        <path
          d="M150.151 116.233C151.259 116.872 152.686 116.476 153.337 115.348C153.989 114.22 153.618 112.786 152.51 112.147C151.402 111.507 149.976 111.903 149.324 113.031C148.673 114.16 149.043 115.593 150.151 116.233Z"
          fill="#3A2933"
        />
        <path
          d="M139.767 115.685C140.875 116.325 142.301 115.929 142.953 114.8C143.604 113.672 143.234 112.239 142.126 111.599C141.018 110.959 139.591 111.355 138.94 112.484C138.288 113.612 138.659 115.045 139.767 115.685Z"
          fill="#3A2933"
        />
        <path
          d="M145.433 124.405C146.541 125.044 147.968 124.648 148.619 123.52C149.271 122.392 148.9 120.958 147.792 120.319C146.684 119.679 145.258 120.075 144.606 121.203C143.955 122.332 144.325 123.765 145.433 124.405Z"
          fill="#3A2933"
        />
        <path
          d="M140.715 132.577C141.823 133.217 143.25 132.82 143.901 131.692C144.552 130.564 144.182 129.13 143.074 128.491C141.966 127.851 140.54 128.247 139.888 129.375C139.237 130.504 139.607 131.937 140.715 132.577Z"
          fill="#3A2933"
        />
        <path
          d="M135.048 123.857C136.157 124.497 137.583 124.101 138.234 122.973C138.886 121.844 138.516 120.411 137.408 119.771C136.299 119.131 134.873 119.527 134.222 120.656C133.57 121.784 133.94 123.217 135.048 123.857Z"
          fill="#3A2933"
        />
        <path
          d="M130.33 132.029C131.438 132.669 132.865 132.273 133.516 131.145C134.168 130.016 133.798 128.583 132.689 127.943C131.581 127.303 130.155 127.699 129.503 128.828C128.852 129.956 129.222 131.389 130.33 132.029Z"
          fill="#3A2933"
        />
        <path
          d="M135.997 140.749C137.105 141.389 138.531 140.993 139.183 139.864C139.834 138.736 139.464 137.303 138.356 136.663C137.248 136.023 135.821 136.419 135.17 137.547C134.519 138.676 134.889 140.109 135.997 140.749Z"
          fill="#3A2933"
        />
        <path
          d="M125.612 140.201C126.72 140.841 128.147 140.445 128.798 139.317C129.45 138.188 129.079 136.755 127.971 136.115C126.863 135.475 125.437 135.872 124.785 137C124.134 138.128 124.504 139.562 125.612 140.201Z"
          fill="#3A2933"
        />
        <path
          d="M131.279 148.921C132.387 149.561 133.813 149.165 134.465 148.036C135.116 146.908 134.746 145.475 133.638 144.835C132.53 144.195 131.103 144.591 130.452 145.719C129.8 146.848 130.171 148.281 131.279 148.921Z"
          fill="#3A2933"
        />
        <path
          d="M120.894 148.373C122.002 149.013 123.429 148.617 124.08 147.489C124.731 146.36 124.361 144.927 123.253 144.287C122.145 143.648 120.719 144.044 120.067 145.172C119.416 146.3 119.786 147.734 120.894 148.373Z"
          fill="#3A2933"
        />
        <path
          d="M126.561 157.093C127.669 157.733 129.095 157.337 129.747 156.208C130.398 155.08 130.028 153.647 128.92 153.007C127.812 152.367 126.385 152.763 125.734 153.892C125.082 155.02 125.452 156.453 126.561 157.093Z"
          fill="#3A2933"
        />
        <path
          d="M121.842 165.265C122.951 165.905 124.377 165.509 125.028 164.38C125.68 163.252 125.31 161.819 124.202 161.179C123.093 160.539 121.667 160.935 121.016 162.064C120.364 163.192 120.734 164.625 121.842 165.265Z"
          fill="#3A2933"
        />
        <path
          d="M116.176 156.545C117.284 157.185 118.71 156.789 119.362 155.661C120.013 154.532 119.643 153.099 118.535 152.459C117.427 151.82 116 152.216 115.349 153.344C114.698 154.472 115.068 155.906 116.176 156.545Z"
          fill="#3A2933"
        />
        <path
          d="M111.458 164.717C112.566 165.357 113.992 164.961 114.644 163.833C115.295 162.705 114.925 161.271 113.817 160.631C112.709 159.992 111.282 160.388 110.631 161.516C109.979 162.644 110.35 164.078 111.458 164.717Z"
          fill="#3A2933"
        />
        <path
          d="M117.124 173.437C118.232 174.077 119.659 173.681 120.31 172.552C120.962 171.424 120.591 169.991 119.483 169.351C118.375 168.711 116.949 169.107 116.297 170.236C115.646 171.364 116.016 172.797 117.124 173.437Z"
          fill="#3A2933"
        />
        <path
          d="M106.74 172.89C107.848 173.529 109.274 173.133 109.926 172.005C110.577 170.877 110.207 169.443 109.099 168.803C107.991 168.164 106.564 168.56 105.913 169.688C105.261 170.816 105.632 172.25 106.74 172.89Z"
          fill="#3A2933"
        />
        <path
          d="M112.406 181.609C113.514 182.249 114.941 181.853 115.592 180.725C116.244 179.596 115.873 178.163 114.765 177.523C113.657 176.883 112.231 177.279 111.579 178.408C110.928 179.536 111.298 180.969 112.406 181.609Z"
          fill="#3A2933"
        />
        <path
          d="M107.688 189.781C108.796 190.421 110.223 190.025 110.874 188.897C111.525 187.768 111.155 186.335 110.047 185.695C108.939 185.055 107.513 185.451 106.861 186.58C106.21 187.708 106.58 189.141 107.688 189.781Z"
          fill="#3A2933"
        />
        <path
          d="M102.021 181.062C103.13 181.701 104.556 181.305 105.207 180.177C105.859 179.049 105.489 177.615 104.381 176.976C103.272 176.336 101.846 176.732 101.195 177.86C100.543 178.989 100.913 180.422 102.021 181.062Z"
          fill="#3A2933"
        />
        <path
          d="M217.154 18.7154C218.262 19.3552 219.688 18.9591 220.34 17.8308C220.991 16.7025 220.621 15.2691 219.513 14.6294C218.405 13.9896 216.978 14.3857 216.327 15.514C215.675 16.6423 216.046 18.0756 217.154 18.7154Z"
          fill="#3A2933"
        />
        <path
          d="M222.82 27.435C223.928 28.0748 225.355 27.6787 226.006 26.5504C226.658 25.4221 226.287 23.9888 225.179 23.349C224.071 22.7092 222.645 23.1053 221.993 24.2336C221.342 25.3619 221.712 26.7953 222.82 27.435Z"
          fill="#3A2933"
        />
        <path
          d="M227.538 19.263C228.647 19.9027 230.073 19.5067 230.724 18.3783C231.376 17.25 231.006 15.8167 229.897 15.1769C228.789 14.5372 227.363 14.9332 226.712 16.0615C226.06 17.1899 226.43 18.6232 227.538 19.263Z"
          fill="#3A2933"
        />
        <path
          d="M212.436 26.8875C213.544 27.5272 214.97 27.1312 215.622 26.0029C216.273 24.8745 215.903 23.4412 214.795 22.8014C213.687 22.1617 212.26 22.5577 211.609 23.6861C210.957 24.8144 211.327 26.2477 212.436 26.8875Z"
          fill="#3A2933"
        />
        <path
          d="M218.102 35.6071C219.21 36.2469 220.637 35.8508 221.288 34.7225C221.939 33.5941 221.569 32.1608 220.461 31.5211C219.353 30.8813 217.927 31.2774 217.275 32.4057C216.624 33.534 216.994 34.9673 218.102 35.6071Z"
          fill="#3A2933"
        />
        <path
          d="M207.717 35.0595C208.826 35.6993 210.252 35.3032 210.903 34.1749C211.555 33.0466 211.185 31.6133 210.076 30.9735C208.968 30.3337 207.542 30.7298 206.891 31.8581C206.239 32.9865 206.609 34.4198 207.717 35.0595Z"
          fill="#3A2933"
        />
        <path
          d="M213.384 43.7792C214.492 44.4189 215.918 44.0229 216.57 42.8945C217.221 41.7662 216.851 40.3329 215.743 39.6931C214.635 39.0534 213.209 39.4494 212.557 40.5777C211.906 41.7061 212.276 43.1394 213.384 43.7792Z"
          fill="#3A2933"
        />
        <path
          d="M208.666 51.9512C209.774 52.591 211.2 52.1949 211.852 51.0666C212.503 49.9383 212.133 48.505 211.025 47.8652C209.917 47.2254 208.49 47.6215 207.839 48.7498C207.188 49.8781 207.558 51.3115 208.666 51.9512Z"
          fill="#3A2933"
        />
        <path
          d="M202.999 43.2316C204.107 43.8714 205.534 43.4753 206.185 42.347C206.837 41.2187 206.466 39.7853 205.358 39.1456C204.25 38.5058 202.824 38.9019 202.172 40.0302C201.521 41.1585 201.891 42.5918 202.999 43.2316Z"
          fill="#3A2933"
        />
        <path
          d="M198.281 51.4037C199.389 52.0434 200.816 51.6474 201.467 50.519C202.119 49.3907 201.748 47.9574 200.64 47.3176C199.532 46.6779 198.106 47.0739 197.454 48.2023C196.803 49.3306 197.173 50.7639 198.281 51.4037Z"
          fill="#3A2933"
        />
        <path
          d="M203.948 60.1233C205.056 60.7631 206.482 60.367 207.134 59.2387C207.785 58.1103 207.415 56.677 206.307 56.0373C205.199 55.3975 203.772 55.7936 203.121 56.9219C202.469 58.0502 202.84 59.4835 203.948 60.1233Z"
          fill="#3A2933"
        />
        <path
          d="M193.563 59.5757C194.671 60.2155 196.097 59.8194 196.749 58.6911C197.4 57.5628 197.03 56.1295 195.922 55.4897C194.814 54.8499 193.388 55.246 192.736 56.3743C192.085 57.5026 192.455 58.936 193.563 59.5757Z"
          fill="#3A2933"
        />
        <path
          d="M199.23 68.2954C200.338 68.9351 201.764 68.5391 202.415 67.4107C203.067 66.2824 202.697 64.8491 201.589 64.2093C200.481 63.5696 199.054 63.9656 198.403 65.0939C197.751 66.2223 198.121 67.6556 199.23 68.2954Z"
          fill="#3A2933"
        />
        <path
          d="M188.845 67.7478C189.953 68.3876 191.379 67.9915 192.031 66.8632C192.682 65.7349 192.312 64.3015 191.204 63.6618C190.096 63.022 188.669 63.4181 188.018 64.5464C187.367 65.6747 187.737 67.108 188.845 67.7478Z"
          fill="#3A2933"
        />
        <path
          d="M194.511 76.4674C195.619 77.1072 197.046 76.7111 197.697 75.5828C198.349 74.4545 197.979 73.0212 196.87 72.3814C195.762 71.7416 194.336 72.1377 193.685 73.266C193.033 74.3943 193.403 75.8277 194.511 76.4674Z"
          fill="#3A2933"
        />
        <path
          d="M189.793 84.6395C190.901 85.2793 192.328 84.8832 192.979 83.7549C193.631 82.6265 193.26 81.1932 192.152 80.5535C191.044 79.9137 189.618 80.3097 188.966 81.4381C188.315 82.5664 188.685 83.9997 189.793 84.6395Z"
          fill="#3A2933"
        />
        <path
          d="M184.127 75.9199C185.235 76.5596 186.661 76.1636 187.313 75.0352C187.964 73.9069 187.594 72.4736 186.486 71.8338C185.378 71.1941 183.951 71.5901 183.3 72.7184C182.648 73.8468 183.019 75.2801 184.127 75.9199Z"
          fill="#3A2933"
        />
        <path
          d="M179.409 84.0919C180.517 84.7317 181.943 84.3356 182.595 83.2073C183.246 82.079 182.876 80.6457 181.768 80.0059C180.66 79.3661 179.233 79.7622 178.582 80.8905C177.93 82.0188 178.3 83.4522 179.409 84.0919Z"
          fill="#3A2933"
        />
        <path
          d="M185.075 92.8116C186.183 93.4513 187.61 93.0553 188.261 91.9269C188.912 90.7986 188.542 89.3653 187.434 88.7255C186.326 88.0858 184.9 88.4818 184.248 89.6101C183.597 90.7385 183.967 92.1718 185.075 92.8116Z"
          fill="#3A2933"
        />
        <path
          d="M174.69 92.264C175.799 92.9038 177.225 92.5077 177.876 91.3794C178.528 90.251 178.158 88.8177 177.049 88.178C175.941 87.5382 174.515 87.9343 173.864 89.0626C173.212 90.1909 173.582 91.6242 174.69 92.264Z"
          fill="#3A2933"
        />
        <path
          d="M180.357 100.984C181.465 101.623 182.891 101.227 183.543 100.099C184.194 98.9707 183.824 97.5373 182.716 96.8976C181.608 96.2578 180.182 96.6539 179.53 97.7822C178.879 98.9105 179.249 100.344 180.357 100.984Z"
          fill="#3A2933"
        />
        <path
          d="M175.639 109.156C176.747 109.795 178.173 109.399 178.825 108.271C179.476 107.143 179.106 105.709 177.998 105.07C176.89 104.43 175.463 104.826 174.812 105.954C174.161 107.083 174.531 108.516 175.639 109.156Z"
          fill="#3A2933"
        />
        <path
          d="M169.972 100.436C171.08 101.076 172.507 100.68 173.158 99.5514C173.81 98.4231 173.439 96.9898 172.331 96.35C171.223 95.7103 169.797 96.1063 169.145 97.2346C168.494 98.363 168.864 99.7963 169.972 100.436Z"
          fill="#3A2933"
        />
        <path
          d="M165.254 108.608C166.362 109.248 167.789 108.852 168.44 107.724C169.092 106.595 168.721 105.162 167.613 104.522C166.505 103.882 165.079 104.278 164.427 105.407C163.776 106.535 164.146 107.968 165.254 108.608Z"
          fill="#3A2933"
        />
        <path
          d="M170.921 117.328C172.029 117.968 173.455 117.571 174.107 116.443C174.758 115.315 174.388 113.881 173.28 113.242C172.172 112.602 170.745 112.998 170.094 114.126C169.442 115.255 169.813 116.688 170.921 117.328Z"
          fill="#3A2933"
        />
        <path
          d="M160.536 116.78C161.644 117.42 163.07 117.024 163.722 115.896C164.373 114.767 164.003 113.334 162.895 112.694C161.787 112.054 160.361 112.45 159.709 113.579C159.058 114.707 159.428 116.14 160.536 116.78Z"
          fill="#3A2933"
        />
        <path
          d="M166.203 125.5C167.311 126.14 168.737 125.744 169.388 124.615C170.04 123.487 169.67 122.054 168.562 121.414C167.453 120.774 166.027 121.17 165.376 122.298C164.724 123.427 165.094 124.86 166.203 125.5Z"
          fill="#3A2933"
        />
        <path
          d="M155.818 124.952C156.926 125.592 158.352 125.196 159.004 124.068C159.655 122.939 159.285 121.506 158.177 120.866C157.069 120.226 155.642 120.623 154.991 121.751C154.34 122.879 154.71 124.312 155.818 124.952Z"
          fill="#3A2933"
        />
        <path
          d="M161.484 133.672C162.592 134.312 164.019 133.916 164.67 132.787C165.322 131.659 164.952 130.226 163.843 129.586C162.735 128.946 161.309 129.342 160.658 130.47C160.006 131.599 160.376 133.032 161.484 133.672Z"
          fill="#3A2933"
        />
        <path
          d="M156.766 141.844C157.874 142.484 159.301 142.088 159.952 140.959C160.604 139.831 160.233 138.398 159.125 137.758C158.017 137.118 156.591 137.514 155.939 138.643C155.288 139.771 155.658 141.204 156.766 141.844Z"
          fill="#3A2933"
        />
        <path
          d="M151.1 133.124C152.208 133.764 153.634 133.368 154.286 132.24C154.937 131.111 154.567 129.678 153.459 129.038C152.351 128.399 150.924 128.795 150.273 129.923C149.621 131.051 149.992 132.485 151.1 133.124Z"
          fill="#3A2933"
        />
        <path
          d="M146.382 141.296C147.49 141.936 148.916 141.54 149.567 140.412C150.219 139.283 149.849 137.85 148.741 137.21C147.633 136.571 146.206 136.967 145.555 138.095C144.903 139.223 145.273 140.657 146.382 141.296Z"
          fill="#3A2933"
        />
        <path
          d="M152.048 150.016C153.156 150.656 154.583 150.26 155.234 149.131C155.885 148.003 155.515 146.57 154.407 145.93C153.299 145.29 151.873 145.686 151.221 146.815C150.57 147.943 150.94 149.376 152.048 150.016Z"
          fill="#3A2933"
        />
        <path
          d="M141.663 149.468C142.772 150.108 144.198 149.712 144.849 148.584C145.501 147.456 145.131 146.022 144.022 145.382C142.914 144.743 141.488 145.139 140.837 146.267C140.185 147.395 140.555 148.829 141.663 149.468Z"
          fill="#3A2933"
        />
        <path
          d="M147.33 158.188C148.438 158.828 149.864 158.432 150.516 157.303C151.167 156.175 150.797 154.742 149.689 154.102C148.581 153.462 147.155 153.858 146.503 154.987C145.852 156.115 146.222 157.548 147.33 158.188Z"
          fill="#3A2933"
        />
        <path
          d="M136.945 157.641C138.053 158.28 139.48 157.884 140.131 156.756C140.783 155.628 140.412 154.194 139.304 153.554C138.196 152.915 136.77 153.311 136.118 154.439C135.467 155.567 135.837 157.001 136.945 157.641Z"
          fill="#3A2933"
        />
        <path
          d="M142.612 166.36C143.72 167 145.146 166.604 145.798 165.476C146.449 164.347 146.079 162.914 144.971 162.274C143.863 161.634 142.436 162.03 141.785 163.159C141.134 164.287 141.504 165.72 142.612 166.36Z"
          fill="#3A2933"
        />
        <path
          d="M137.894 174.532C139.002 175.172 140.428 174.776 141.08 173.648C141.731 172.519 141.361 171.086 140.253 170.446C139.145 169.806 137.718 170.202 137.067 171.331C136.415 172.459 136.786 173.892 137.894 174.532Z"
          fill="#3A2933"
        />
        <path
          d="M132.227 165.813C133.335 166.452 134.762 166.056 135.413 164.928C136.065 163.8 135.694 162.366 134.586 161.727C133.478 161.087 132.052 161.483 131.4 162.611C130.749 163.739 131.119 165.173 132.227 165.813Z"
          fill="#3A2933"
        />
        <path
          d="M127.509 173.985C128.617 174.624 130.043 174.228 130.695 173.1C131.346 171.972 130.976 170.538 129.868 169.899C128.76 169.259 127.334 169.655 126.682 170.783C126.031 171.912 126.401 173.345 127.509 173.985Z"
          fill="#3A2933"
        />
        <path
          d="M133.176 182.704C134.284 183.344 135.71 182.948 136.361 181.82C137.013 180.691 136.643 179.258 135.535 178.618C134.426 177.978 133 178.375 132.349 179.503C131.697 180.631 132.067 182.064 133.176 182.704Z"
          fill="#3A2933"
        />
        <path
          d="M122.791 182.157C123.899 182.796 125.325 182.4 125.977 181.272C126.628 180.144 126.258 178.71 125.15 178.071C124.042 177.431 122.615 177.827 121.964 178.955C121.313 180.084 121.683 181.517 122.791 182.157Z"
          fill="#3A2933"
        />
        <path
          d="M128.457 190.876C129.565 191.516 130.992 191.12 131.643 189.992C132.295 188.863 131.925 187.43 130.816 186.79C129.708 186.151 128.282 186.547 127.631 187.675C126.979 188.803 127.349 190.237 128.457 190.876Z"
          fill="#3A2933"
        />
        <path
          d="M123.739 199.048C124.847 199.688 126.274 199.292 126.925 198.164C127.577 197.035 127.206 195.602 126.098 194.962C124.99 194.323 123.564 194.719 122.912 195.847C122.261 196.975 122.631 198.409 123.739 199.048Z"
          fill="#3A2933"
        />
        <path
          d="M118.073 190.329C119.181 190.969 120.607 190.572 121.259 189.444C121.91 188.316 121.54 186.883 120.432 186.243C119.324 185.603 117.897 185.999 117.246 187.127C116.594 188.256 116.965 189.689 118.073 190.329Z"
          fill="#3A2933"
        />
        <path
          d="M233.205 27.9826C234.313 28.6224 235.739 28.2263 236.391 27.098C237.042 25.9696 236.672 24.5363 235.564 23.8966C234.456 23.2568 233.03 23.6528 232.378 24.7812C231.727 25.9095 232.097 27.3428 233.205 27.9826Z"
          fill="#3A2933"
        />
        <path
          d="M238.871 36.7022C239.98 37.342 241.406 36.9459 242.057 35.8176C242.709 34.6893 242.339 33.2559 241.231 32.6162C240.122 31.9764 238.696 32.3725 238.045 33.5008C237.393 34.6291 237.763 36.0624 238.871 36.7022Z"
          fill="#3A2933"
        />
        <path
          d="M243.59 28.5301C244.698 29.1699 246.124 28.7738 246.776 27.6455C247.427 26.5172 247.057 25.0839 245.949 24.4441C244.841 23.8043 243.414 24.2004 242.763 25.3287C242.111 26.4571 242.482 27.8904 243.59 28.5301Z"
          fill="#3A2933"
        />
        <path
          d="M228.487 36.1547C229.595 36.7944 231.021 36.3984 231.673 35.27C232.324 34.1417 231.954 32.7084 230.846 32.0686C229.738 31.4289 228.311 31.8249 227.66 32.9532C227.008 34.0816 227.379 35.5149 228.487 36.1547Z"
          fill="#3A2933"
        />
        <path
          d="M234.153 44.8743C235.261 45.514 236.688 45.118 237.339 43.9897C237.991 42.8613 237.621 41.428 236.512 40.7882C235.404 40.1485 233.978 40.5445 233.326 41.6729C232.675 42.8012 233.045 44.2345 234.153 44.8743Z"
          fill="#3A2933"
        />
        <path
          d="M223.769 44.3267C224.877 44.9665 226.303 44.5704 226.955 43.4421C227.606 42.3138 227.236 40.8804 226.128 40.2407C225.02 39.6009 223.593 39.997 222.942 41.1253C222.29 42.2536 222.661 43.687 223.769 44.3267Z"
          fill="#3A2933"
        />
        <path
          d="M229.435 53.0463C230.543 53.6861 231.97 53.29 232.621 52.1617C233.273 51.0334 232.902 49.6001 231.794 48.9603C230.686 48.3205 229.26 48.7166 228.608 49.8449C227.957 50.9733 228.327 52.4066 229.435 53.0463Z"
          fill="#3A2933"
        />
        <path
          d="M224.717 61.2184C225.825 61.8582 227.252 61.4621 227.903 60.3338C228.554 59.2055 228.184 57.7721 227.076 57.1324C225.968 56.4926 224.542 56.8887 223.89 58.017C223.239 59.1453 223.609 60.5786 224.717 61.2184Z"
          fill="#3A2933"
        />
        <path
          d="M219.051 52.4988C220.159 53.1385 221.585 52.7425 222.236 51.6142C222.888 50.4858 222.518 49.0525 221.41 48.4127C220.301 47.773 218.875 48.169 218.224 49.2974C217.572 50.4257 217.942 51.859 219.051 52.4988Z"
          fill="#3A2933"
        />
        <path
          d="M214.332 60.6708C215.44 61.3106 216.867 60.9146 217.518 59.7862C218.17 58.6579 217.8 57.2246 216.691 56.5848C215.583 55.945 214.157 56.3411 213.505 57.4694C212.854 58.5978 213.224 60.0311 214.332 60.6708Z"
          fill="#3A2933"
        />
        <path
          d="M219.999 69.3905C221.107 70.0302 222.533 69.6342 223.185 68.5058C223.836 67.3775 223.466 65.9442 222.358 65.3044C221.25 64.6647 219.823 65.0607 219.172 66.1891C218.521 67.3174 218.891 68.7507 219.999 69.3905Z"
          fill="#3A2933"
        />
        <path
          d="M209.614 68.8429C210.722 69.4827 212.149 69.0866 212.8 67.9583C213.452 66.83 213.081 65.3966 211.973 64.7569C210.865 64.1171 209.439 64.5132 208.787 65.6415C208.136 66.7698 208.506 68.2031 209.614 68.8429Z"
          fill="#3A2933"
        />
        <path
          d="M215.281 77.5625C216.389 78.2023 217.815 77.8062 218.467 76.6779C219.118 75.5496 218.748 74.1163 217.64 73.4765C216.532 72.8367 215.105 73.2328 214.454 74.3611C213.802 75.4894 214.173 76.9228 215.281 77.5625Z"
          fill="#3A2933"
        />
        <path
          d="M204.896 77.015C206.004 77.6547 207.431 77.2587 208.082 76.1304C208.733 75.002 208.363 73.5687 207.255 72.9289C206.147 72.2892 204.721 72.6852 204.069 73.8136C203.418 74.9419 203.788 76.3752 204.896 77.015Z"
          fill="#3A2933"
        />
        <path
          d="M210.563 85.7346C211.671 86.3744 213.097 85.9783 213.749 84.85C214.4 83.7217 214.03 82.2883 212.922 81.6486C211.814 81.0088 210.387 81.4049 209.736 82.5332C209.084 83.6615 209.455 85.0948 210.563 85.7346Z"
          fill="#3A2933"
        />
        <path
          d="M205.844 93.9067C206.953 94.5464 208.379 94.1504 209.03 93.022C209.682 91.8937 209.312 90.4604 208.204 89.8206C207.095 89.1809 205.669 89.5769 205.018 90.7053C204.366 91.8336 204.736 93.2669 205.844 93.9067Z"
          fill="#3A2933"
        />
        <path
          d="M200.178 85.187C201.286 85.8268 202.712 85.4307 203.364 84.3024C204.015 83.1741 203.645 81.7408 202.537 81.101C201.429 80.4612 200.003 80.8573 199.351 81.9856C198.7 83.114 199.07 84.5473 200.178 85.187Z"
          fill="#3A2933"
        />
        <path
          d="M195.46 93.3591C196.568 93.9989 197.994 93.6028 198.646 92.4745C199.297 91.3462 198.927 89.9128 197.819 89.2731C196.711 88.6333 195.284 89.0294 194.633 90.1577C193.981 91.286 194.352 92.7193 195.46 93.3591Z"
          fill="#3A2933"
        />
        <path
          d="M201.126 102.079C202.234 102.718 203.661 102.322 204.312 101.194C204.964 100.066 204.594 98.6325 203.485 97.9927C202.377 97.3529 200.951 97.749 200.299 98.8773C199.648 100.006 200.018 101.439 201.126 102.079Z"
          fill="#3A2933"
        />
        <path
          d="M190.742 101.531C191.85 102.171 193.276 101.775 193.928 100.647C194.579 99.5182 194.209 98.0849 193.101 97.4451C191.993 96.8054 190.566 97.2014 189.915 98.3298C189.263 99.4581 189.634 100.891 190.742 101.531Z"
          fill="#3A2933"
        />
        <path
          d="M196.408 110.251C197.516 110.891 198.943 110.494 199.594 109.366C200.246 108.238 199.875 106.805 198.767 106.165C197.659 105.525 196.233 105.921 195.581 107.049C194.93 108.178 195.3 109.611 196.408 110.251Z"
          fill="#3A2933"
        />
        <path
          d="M191.69 118.423C192.798 119.063 194.225 118.667 194.876 117.538C195.527 116.41 195.157 114.977 194.049 114.337C192.941 113.697 191.515 114.093 190.863 115.221C190.212 116.35 190.582 117.783 191.69 118.423Z"
          fill="#3A2933"
        />
        <path
          d="M186.024 109.703C187.132 110.343 188.558 109.947 189.209 108.819C189.861 107.69 189.491 106.257 188.383 105.617C187.274 104.977 185.848 105.373 185.197 106.502C184.545 107.63 184.915 109.063 186.024 109.703Z"
          fill="#3A2933"
        />
        <path
          d="M181.305 117.875C182.413 118.515 183.84 118.119 184.491 116.991C185.143 115.862 184.773 114.429 183.664 113.789C182.556 113.15 181.13 113.546 180.478 114.674C179.827 115.802 180.197 117.236 181.305 117.875Z"
          fill="#3A2933"
        />
        <path
          d="M186.972 126.595C188.08 127.235 189.506 126.839 190.158 125.71C190.809 124.582 190.439 123.149 189.331 122.509C188.223 121.869 186.796 122.265 186.145 123.394C185.494 124.522 185.864 125.955 186.972 126.595Z"
          fill="#3A2933"
        />
        <path
          d="M176.587 126.047C177.695 126.687 179.122 126.291 179.773 125.163C180.425 124.034 180.054 122.601 178.946 121.961C177.838 121.322 176.412 121.718 175.76 122.846C175.109 123.974 175.479 125.408 176.587 126.047Z"
          fill="#3A2933"
        />
        <path
          d="M182.254 134.767C183.362 135.407 184.788 135.011 185.44 133.882C186.091 132.754 185.721 131.321 184.613 130.681C183.505 130.041 182.078 130.437 181.427 131.566C180.775 132.694 181.146 134.127 182.254 134.767Z"
          fill="#3A2933"
        />
        <path
          d="M171.869 134.219C172.977 134.859 174.404 134.463 175.055 133.335C175.706 132.206 175.336 130.773 174.228 130.133C173.12 129.494 171.694 129.89 171.042 131.018C170.391 132.146 170.761 133.58 171.869 134.219Z"
          fill="#3A2933"
        />
        <path
          d="M177.536 142.939C178.644 143.579 180.07 143.183 180.722 142.054C181.373 140.926 181.003 139.493 179.895 138.853C178.787 138.213 177.36 138.609 176.709 139.738C176.057 140.866 176.428 142.299 177.536 142.939Z"
          fill="#3A2933"
        />
        <path
          d="M172.817 151.111C173.926 151.751 175.352 151.355 176.003 150.226C176.655 149.098 176.285 147.665 175.177 147.025C174.068 146.385 172.642 146.781 171.991 147.91C171.339 149.038 171.709 150.471 172.817 151.111Z"
          fill="#3A2933"
        />
        <path
          d="M167.151 142.391C168.259 143.031 169.685 142.635 170.337 141.507C170.988 140.379 170.618 138.945 169.51 138.305C168.402 137.666 166.976 138.062 166.324 139.19C165.673 140.318 166.043 141.752 167.151 142.391Z"
          fill="#3A2933"
        />
        <path
          d="M162.433 150.564C163.541 151.203 164.967 150.807 165.619 149.679C166.27 148.551 165.9 147.117 164.792 146.478C163.684 145.838 162.257 146.234 161.606 147.362C160.954 148.49 161.325 149.924 162.433 150.564Z"
          fill="#3A2933"
        />
        <path
          d="M168.099 159.283C169.207 159.923 170.634 159.527 171.285 158.399C171.937 157.27 171.567 155.837 170.458 155.197C169.35 154.557 167.924 154.953 167.272 156.082C166.621 157.21 166.991 158.643 168.099 159.283Z"
          fill="#3A2933"
        />
        <path
          d="M157.715 158.736C158.823 159.375 160.249 158.979 160.901 157.851C161.552 156.723 161.182 155.289 160.074 154.65C158.966 154.01 157.539 154.406 156.888 155.534C156.236 156.663 156.607 158.096 157.715 158.736Z"
          fill="#3A2933"
        />
        <path
          d="M163.381 167.455C164.489 168.095 165.916 167.699 166.567 166.571C167.219 165.442 166.848 164.009 165.74 163.369C164.632 162.729 163.206 163.126 162.554 164.254C161.903 165.382 162.273 166.815 163.381 167.455Z"
          fill="#3A2933"
        />
        <path
          d="M152.996 166.908C154.105 167.547 155.531 167.151 156.182 166.023C156.834 164.895 156.464 163.461 155.356 162.822C154.247 162.182 152.821 162.578 152.17 163.706C151.518 164.835 151.888 166.268 152.996 166.908Z"
          fill="#3A2933"
        />
        <path
          d="M158.663 175.627C159.771 176.267 161.198 175.871 161.849 174.743C162.5 173.614 162.13 172.181 161.022 171.541C159.914 170.902 158.488 171.298 157.836 172.426C157.185 173.554 157.555 174.988 158.663 175.627Z"
          fill="#3A2933"
        />
        <path
          d="M153.945 183.799C155.053 184.439 156.479 184.043 157.131 182.915C157.782 181.786 157.412 180.353 156.304 179.713C155.196 179.074 153.769 179.47 153.118 180.598C152.467 181.726 152.837 183.16 153.945 183.799Z"
          fill="#3A2933"
        />
        <path
          d="M148.278 175.08C149.386 175.72 150.813 175.323 151.464 174.195C152.116 173.067 151.746 171.633 150.637 170.994C149.529 170.354 148.103 170.75 147.451 171.878C146.8 173.007 147.17 174.44 148.278 175.08Z"
          fill="#3A2933"
        />
        <path
          d="M143.56 183.252C144.668 183.892 146.095 183.496 146.746 182.367C147.398 181.239 147.027 179.806 145.919 179.166C144.811 178.526 143.385 178.922 142.733 180.05C142.082 181.179 142.452 182.612 143.56 183.252Z"
          fill="#3A2933"
        />
        <path
          d="M149.227 191.971C150.335 192.611 151.761 192.215 152.413 191.087C153.064 189.958 152.694 188.525 151.586 187.885C150.478 187.246 149.051 187.642 148.4 188.77C147.748 189.898 148.119 191.332 149.227 191.971Z"
          fill="#3A2933"
        />
        <path
          d="M138.842 191.424C139.95 192.064 141.377 191.668 142.028 190.539C142.679 189.411 142.309 187.978 141.201 187.338C140.093 186.698 138.667 187.094 138.015 188.222C137.364 189.351 137.734 190.784 138.842 191.424Z"
          fill="#3A2933"
        />
        <path
          d="M144.509 200.144C145.617 200.783 147.043 200.387 147.695 199.259C148.346 198.131 147.976 196.697 146.868 196.057C145.76 195.418 144.333 195.814 143.682 196.942C143.03 198.07 143.401 199.504 144.509 200.144Z"
          fill="#3A2933"
        />
        <path
          d="M139.79 208.316C140.899 208.955 142.325 208.559 142.976 207.431C143.628 206.303 143.258 204.869 142.15 204.23C141.041 203.59 139.615 203.986 138.964 205.114C138.312 206.243 138.682 207.676 139.79 208.316Z"
          fill="#3A2933"
        />
        <path
          d="M134.124 199.596C135.232 200.236 136.658 199.84 137.31 198.711C137.961 197.583 137.591 196.15 136.483 195.51C135.375 194.87 133.948 195.266 133.297 196.395C132.646 197.523 133.016 198.956 134.124 199.596Z"
          fill="#3A2933"
        />
        <path
          d="M249.256 37.2498C250.364 37.8895 251.791 37.4935 252.442 36.3651C253.094 35.2368 252.723 33.8035 251.615 33.1637C250.507 32.524 249.081 32.92 248.429 34.0483C247.778 35.1767 248.148 36.61 249.256 37.2498Z"
          fill="#3A2933"
        />
        <path
          d="M254.923 45.9694C256.031 46.6092 257.457 46.2131 258.109 45.0848C258.76 43.9564 258.39 42.5231 257.282 41.8834C256.174 41.2436 254.747 41.6396 254.096 42.768C253.444 43.8963 253.815 45.3296 254.923 45.9694Z"
          fill="#3A2933"
        />
        <path
          d="M259.641 37.7973C260.749 38.4371 262.175 38.041 262.827 36.9127C263.478 35.7844 263.108 34.3511 262 33.7113C260.892 33.0715 259.465 33.4676 258.814 34.5959C258.163 35.7242 258.533 37.1576 259.641 37.7973Z"
          fill="#3A2933"
        />
        <path
          d="M244.538 45.4218C245.646 46.0616 247.073 45.6655 247.724 44.5372C248.375 43.4089 248.005 41.9756 246.897 41.3358C245.789 40.696 244.363 41.0921 243.711 42.2204C243.06 43.3487 243.43 44.7821 244.538 45.4218Z"
          fill="#3A2933"
        />
        <path
          d="M250.205 54.1415C251.313 54.7812 252.739 54.3852 253.391 53.2568C254.042 52.1285 253.672 50.6952 252.564 50.0554C251.456 49.4157 250.029 49.8117 249.378 50.94C248.726 52.0684 249.096 53.5017 250.205 54.1415Z"
          fill="#3A2933"
        />
        <path
          d="M239.82 53.5939C240.928 54.2337 242.354 53.8376 243.006 52.7093C243.657 51.581 243.287 50.1476 242.179 49.5079C241.071 48.8681 239.644 49.2642 238.993 50.3925C238.342 51.5208 238.712 52.9541 239.82 53.5939Z"
          fill="#3A2933"
        />
        <path
          d="M245.486 62.3135C246.595 62.9533 248.021 62.5572 248.672 61.4289C249.324 60.3006 248.954 58.8672 247.845 58.2275C246.737 57.5877 245.311 57.9838 244.66 59.1121C244.008 60.2404 244.378 61.6738 245.486 62.3135Z"
          fill="#3A2933"
        />
        <path
          d="M240.768 70.4856C241.876 71.1253 243.303 70.7293 243.954 69.601C244.606 68.4726 244.235 67.0393 243.127 66.3995C242.019 65.7598 240.593 66.1558 239.941 67.2842C239.29 68.4125 239.66 69.8458 240.768 70.4856Z"
          fill="#3A2933"
        />
        <path
          d="M235.102 61.766C236.21 62.4057 237.636 62.0097 238.288 60.8813C238.939 59.753 238.569 58.3197 237.461 57.6799C236.353 57.0402 234.926 57.4362 234.275 58.5645C233.623 59.6929 233.994 61.1262 235.102 61.766Z"
          fill="#3A2933"
        />
        <path
          d="M230.384 69.938C231.492 70.5778 232.918 70.1817 233.57 69.0534C234.221 67.9251 233.851 66.4918 232.743 65.852C231.635 65.2122 230.208 65.6083 229.557 66.7366C228.905 67.8649 229.275 69.2983 230.384 69.938Z"
          fill="#3A2933"
        />
        <path
          d="M236.05 78.6576C237.158 79.2974 238.585 78.9014 239.236 77.773C239.888 76.6447 239.517 75.2114 238.409 74.5716C237.301 73.9318 235.875 74.3279 235.223 75.4562C234.572 76.5846 234.942 78.0179 236.05 78.6576Z"
          fill="#3A2933"
        />
        <path
          d="M225.665 78.1101C226.774 78.7499 228.2 78.3538 228.851 77.2255C229.503 76.0971 229.133 74.6638 228.025 74.0241C226.916 73.3843 225.49 73.7803 224.839 74.9087C224.187 76.037 224.557 77.4703 225.665 78.1101Z"
          fill="#3A2933"
        />
        <path
          d="M231.332 86.8297C232.44 87.4695 233.866 87.0734 234.518 85.9451C235.169 84.8168 234.799 83.3834 233.691 82.7437C232.583 82.1039 231.157 82.5 230.505 83.6283C229.854 84.7566 230.224 86.1899 231.332 86.8297Z"
          fill="#3A2933"
        />
        <path
          d="M220.947 86.2822C222.055 86.9219 223.482 86.5259 224.133 85.3975C224.785 84.2692 224.414 82.8359 223.306 82.1961C222.198 81.5564 220.772 81.9524 220.12 83.0807C219.469 84.2091 219.839 85.6424 220.947 86.2822Z"
          fill="#3A2933"
        />
        <path
          d="M226.614 95.0018C227.722 95.6415 229.148 95.2455 229.8 94.1172C230.451 92.9888 230.081 91.5555 228.973 90.9157C227.865 90.276 226.438 90.672 225.787 91.8004C225.136 92.9287 225.506 94.362 226.614 95.0018Z"
          fill="#3A2933"
        />
        <path
          d="M221.896 103.174C223.004 103.814 224.43 103.418 225.082 102.289C225.733 101.161 225.363 99.7276 224.255 99.0878C223.147 98.448 221.72 98.8441 221.069 99.9724C220.417 101.101 220.788 102.534 221.896 103.174Z"
          fill="#3A2933"
        />
        <path
          d="M216.229 94.4542C217.337 95.094 218.764 94.6979 219.415 93.5696C220.067 92.4413 219.696 91.008 218.588 90.3682C217.48 89.7284 216.054 90.1245 215.402 91.2528C214.751 92.3811 215.121 93.8145 216.229 94.4542Z"
          fill="#3A2933"
        />
        <path
          d="M211.511 102.626C212.619 103.266 214.046 102.87 214.697 101.742C215.348 100.613 214.978 99.18 213.87 98.5403C212.762 97.9005 211.336 98.2965 210.684 99.4249C210.033 100.553 210.403 101.987 211.511 102.626Z"
          fill="#3A2933"
        />
        <path
          d="M217.178 111.346C218.286 111.986 219.712 111.59 220.363 110.461C221.015 109.333 220.645 107.9 219.537 107.26C218.429 106.62 217.002 107.016 216.351 108.144C215.699 109.273 216.069 110.706 217.178 111.346Z"
          fill="#3A2933"
        />
        <path
          d="M206.793 110.798C207.901 111.438 209.327 111.042 209.979 109.914C210.63 108.785 210.26 107.352 209.152 106.712C208.044 106.073 206.617 106.469 205.966 107.597C205.315 108.725 205.685 110.159 206.793 110.798Z"
          fill="#3A2933"
        />
        <path
          d="M212.459 119.518C213.568 120.158 214.994 119.762 215.645 118.633C216.297 117.505 215.927 116.072 214.818 115.432C213.71 114.792 212.284 115.188 211.633 116.317C210.981 117.445 211.351 118.878 212.459 119.518Z"
          fill="#3A2933"
        />
        <path
          d="M207.741 127.69C208.849 128.33 210.276 127.934 210.927 126.805C211.579 125.677 211.208 124.244 210.1 123.604C208.992 122.964 207.566 123.36 206.914 124.489C206.263 125.617 206.633 127.05 207.741 127.69Z"
          fill="#3A2933"
        />
        <path
          d="M202.075 118.97C203.183 119.61 204.609 119.214 205.261 118.086C205.912 116.957 205.542 115.524 204.434 114.884C203.326 114.245 201.899 114.641 201.248 115.769C200.596 116.897 200.967 118.331 202.075 118.97Z"
          fill="#3A2933"
        />
        <path
          d="M197.357 127.142C198.465 127.782 199.891 127.386 200.543 126.258C201.194 125.13 200.824 123.696 199.716 123.056C198.608 122.417 197.181 122.813 196.53 123.941C195.878 125.069 196.248 126.503 197.357 127.142Z"
          fill="#3A2933"
        />
        <path
          d="M203.023 135.862C204.131 136.502 205.558 136.106 206.209 134.977C206.861 133.849 206.49 132.416 205.382 131.776C204.274 131.136 202.848 131.532 202.196 132.661C201.545 133.789 201.915 135.222 203.023 135.862Z"
          fill="#3A2933"
        />
        <path
          d="M192.638 135.315C193.747 135.954 195.173 135.558 195.824 134.43C196.476 133.302 196.106 131.868 194.998 131.229C193.889 130.589 192.463 130.985 191.812 132.113C191.16 133.241 191.53 134.675 192.638 135.315Z"
          fill="#3A2933"
        />
        <path
          d="M198.305 144.034C199.413 144.674 200.839 144.278 201.491 143.15C202.142 142.021 201.772 140.588 200.664 139.948C199.556 139.308 198.13 139.704 197.478 140.833C196.827 141.961 197.197 143.394 198.305 144.034Z"
          fill="#3A2933"
        />
        <path
          d="M187.92 143.487C189.028 144.126 190.455 143.73 191.106 142.602C191.758 141.474 191.387 140.04 190.279 139.401C189.171 138.761 187.745 139.157 187.093 140.285C186.442 141.414 186.812 142.847 187.92 143.487Z"
          fill="#3A2933"
        />
        <path
          d="M193.587 152.206C194.695 152.846 196.121 152.45 196.773 151.322C197.424 150.193 197.054 148.76 195.946 148.12C194.838 147.48 193.411 147.876 192.76 149.005C192.109 150.133 192.479 151.566 193.587 152.206Z"
          fill="#3A2933"
        />
        <path
          d="M188.869 160.378C189.977 161.018 191.403 160.622 192.055 159.494C192.706 158.365 192.336 156.932 191.228 156.292C190.12 155.652 188.693 156.049 188.042 157.177C187.39 158.305 187.761 159.739 188.869 160.378Z"
          fill="#3A2933"
        />
        <path
          d="M183.202 151.659C184.31 152.298 185.737 151.902 186.388 150.774C187.04 149.646 186.669 148.212 185.561 147.573C184.453 146.933 183.027 147.329 182.375 148.457C181.724 149.586 182.094 151.019 183.202 151.659Z"
          fill="#3A2933"
        />
        <path
          d="M178.484 159.831C179.592 160.471 181.019 160.074 181.67 158.946C182.321 157.818 181.951 156.384 180.843 155.745C179.735 155.105 178.309 155.501 177.657 156.629C177.006 157.758 177.376 159.191 178.484 159.831Z"
          fill="#3A2933"
        />
        <path
          d="M184.151 168.55C185.259 169.19 186.685 168.794 187.336 167.666C187.988 166.537 187.618 165.104 186.51 164.464C185.402 163.825 183.975 164.221 183.324 165.349C182.672 166.477 183.042 167.911 184.151 168.55Z"
          fill="#3A2933"
        />
        <path
          d="M173.766 168.003C174.874 168.643 176.3 168.247 176.952 167.118C177.603 165.99 177.233 164.557 176.125 163.917C175.017 163.277 173.59 163.673 172.939 164.801C172.288 165.93 172.658 167.363 173.766 168.003Z"
          fill="#3A2933"
        />
        <path
          d="M179.432 176.722C180.541 177.362 181.967 176.966 182.618 175.838C183.27 174.709 182.9 173.276 181.791 172.636C180.683 171.997 179.257 172.393 178.606 173.521C177.954 174.649 178.324 176.083 179.432 176.722Z"
          fill="#3A2933"
        />
        <path
          d="M169.048 176.175C170.156 176.815 171.582 176.419 172.234 175.29C172.885 174.162 172.515 172.729 171.407 172.089C170.299 171.449 168.872 171.845 168.221 172.973C167.569 174.102 167.94 175.535 169.048 176.175Z"
          fill="#3A2933"
        />
        <path
          d="M174.714 184.894C175.822 185.534 177.249 185.138 177.9 184.01C178.552 182.882 178.181 181.448 177.073 180.808C175.965 180.169 174.539 180.565 173.887 181.693C173.236 182.821 173.606 184.255 174.714 184.894Z"
          fill="#3A2933"
        />
        <path
          d="M169.996 193.067C171.104 193.706 172.531 193.31 173.182 192.182C173.833 191.054 173.463 189.62 172.355 188.981C171.247 188.341 169.821 188.737 169.169 189.865C168.518 190.993 168.888 192.427 169.996 193.067Z"
          fill="#3A2933"
        />
        <path
          d="M164.33 184.347C165.438 184.987 166.864 184.591 167.516 183.462C168.167 182.334 167.797 180.901 166.689 180.261C165.581 179.621 164.154 180.017 163.503 181.146C162.851 182.274 163.221 183.707 164.33 184.347Z"
          fill="#3A2933"
        />
        <path
          d="M159.611 192.519C160.72 193.159 162.146 192.763 162.797 191.634C163.449 190.506 163.079 189.073 161.971 188.433C160.862 187.793 159.436 188.189 158.785 189.318C158.133 190.446 158.503 191.879 159.611 192.519Z"
          fill="#3A2933"
        />
        <path
          d="M165.278 201.239C166.386 201.878 167.812 201.482 168.464 200.354C169.115 199.226 168.745 197.792 167.637 197.153C166.529 196.513 165.103 196.909 164.451 198.037C163.8 199.166 164.17 200.599 165.278 201.239Z"
          fill="#3A2933"
        />
        <path
          d="M154.893 200.691C156.001 201.331 157.428 200.935 158.079 199.806C158.731 198.678 158.36 197.245 157.252 196.605C156.144 195.965 154.718 196.361 154.066 197.49C153.415 198.618 153.785 200.051 154.893 200.691Z"
          fill="#3A2933"
        />
        <path
          d="M160.56 209.411C161.668 210.05 163.094 209.654 163.746 208.526C164.397 207.398 164.027 205.964 162.919 205.325C161.811 204.685 160.384 205.081 159.733 206.209C159.082 207.338 159.452 208.771 160.56 209.411Z"
          fill="#3A2933"
        />
        <path
          d="M155.842 217.583C156.95 218.223 158.376 217.826 159.028 216.698C159.679 215.57 159.309 214.137 158.201 213.497C157.093 212.857 155.666 213.253 155.015 214.381C154.363 215.51 154.734 216.943 155.842 217.583Z"
          fill="#3A2933"
        />
        <path
          d="M150.175 208.863C151.283 209.503 152.71 209.107 153.361 207.979C154.013 206.85 153.642 205.417 152.534 204.777C151.426 204.137 150 204.533 149.348 205.662C148.697 206.79 149.067 208.223 150.175 208.863Z"
          fill="#3A2933"
        />
        <path
          d="M265.307 46.5169C266.415 47.1567 267.842 46.7607 268.493 45.6323C269.145 44.504 268.775 43.0707 267.666 42.4309C266.558 41.7911 265.132 42.1872 264.481 43.3155C263.829 44.4439 264.199 45.8772 265.307 46.5169Z"
          fill="#3A2933"
        />
        <path
          d="M270.974 55.2366C272.082 55.8763 273.508 55.4803 274.16 54.3519C274.811 53.2236 274.441 51.7903 273.333 51.1505C272.225 50.5108 270.799 50.9068 270.147 52.0352C269.496 53.1635 269.866 54.5968 270.974 55.2366Z"
          fill="#3A2933"
        />
        <path
          d="M275.692 47.0645C276.8 47.7043 278.227 47.3082 278.878 46.1799C279.529 45.0516 279.159 43.6182 278.051 42.9785C276.943 42.3387 275.517 42.7348 274.865 43.8631C274.214 44.9914 274.584 46.4247 275.692 47.0645Z"
          fill="#3A2933"
        />
        <path
          d="M260.589 54.689C261.697 55.3288 263.124 54.9327 263.775 53.8044C264.427 52.6761 264.056 51.2427 262.948 50.603C261.84 49.9632 260.414 50.3593 259.762 51.4876C259.111 52.6159 259.481 54.0492 260.589 54.689Z"
          fill="#3A2933"
        />
        <path
          d="M266.256 63.4086C267.364 64.0484 268.79 63.6523 269.442 62.524C270.093 61.3957 269.723 59.9624 268.615 59.3226C267.507 58.6828 266.08 59.0789 265.429 60.2072C264.777 61.3355 265.148 62.7689 266.256 63.4086Z"
          fill="#3A2933"
        />
        <path
          d="M255.871 62.8611C256.979 63.5008 258.406 63.1048 259.057 61.9765C259.708 60.8481 259.338 59.4148 258.23 58.775C257.122 58.1353 255.696 58.5313 255.044 59.6597C254.393 60.788 254.763 62.2213 255.871 62.8611Z"
          fill="#3A2933"
        />
        <path
          d="M261.538 71.5807C262.646 72.2205 264.072 71.8244 264.724 70.6961C265.375 69.5677 265.005 68.1344 263.897 67.4947C262.789 66.8549 261.362 67.251 260.711 68.3793C260.059 69.5076 260.43 70.9409 261.538 71.5807Z"
          fill="#3A2933"
        />
        <path
          d="M256.82 79.7528C257.928 80.3925 259.354 79.9965 260.005 78.8681C260.657 77.7398 260.287 76.3065 259.179 75.6667C258.07 75.027 256.644 75.423 255.993 76.5513C255.341 77.6797 255.711 79.113 256.82 79.7528Z"
          fill="#3A2933"
        />
        <path
          d="M251.153 71.0331C252.261 71.6729 253.687 71.2768 254.339 70.1485C254.99 69.0202 254.62 67.5869 253.512 66.9471C252.404 66.3073 250.978 66.7034 250.326 67.8317C249.675 68.9601 250.045 70.3934 251.153 71.0331Z"
          fill="#3A2933"
        />
        <path
          d="M246.435 79.2052C247.543 79.845 248.969 79.4489 249.621 78.3206C250.272 77.1923 249.902 75.7589 248.794 75.1192C247.686 74.4794 246.259 74.8755 245.608 76.0038C244.957 77.1321 245.327 78.5654 246.435 79.2052Z"
          fill="#3A2933"
        />
        <path
          d="M252.101 87.9248C253.209 88.5646 254.636 88.1685 255.287 87.0402C255.939 85.9119 255.569 84.4786 254.46 83.8388C253.352 83.199 251.926 83.5951 251.274 84.7234C250.623 85.8517 250.993 87.2851 252.101 87.9248Z"
          fill="#3A2933"
        />
        <path
          d="M241.717 87.3773C242.825 88.017 244.251 87.621 244.903 86.4926C245.554 85.3643 245.184 83.931 244.076 83.2912C242.968 82.6515 241.541 83.0475 240.89 84.1759C240.238 85.3042 240.609 86.7375 241.717 87.3773Z"
          fill="#3A2933"
        />
        <path
          d="M247.383 96.0969C248.491 96.7367 249.918 96.3406 250.569 95.2123C251.221 94.0839 250.85 92.6506 249.742 92.0109C248.634 91.3711 247.208 91.7672 246.556 92.8955C245.905 94.0238 246.275 95.4571 247.383 96.0969Z"
          fill="#3A2933"
        />
        <path
          d="M236.999 95.5493C238.107 96.1891 239.533 95.793 240.184 94.6647C240.836 93.5364 240.466 92.1031 239.358 91.4633C238.249 90.8235 236.823 91.2196 236.172 92.3479C235.52 93.4762 235.89 94.9096 236.999 95.5493Z"
          fill="#3A2933"
        />
        <path
          d="M242.665 104.269C243.773 104.909 245.2 104.513 245.851 103.384C246.502 102.256 246.132 100.823 245.024 100.183C243.916 99.5432 242.49 99.9392 241.838 101.068C241.187 102.196 241.557 103.629 242.665 104.269Z"
          fill="#3A2933"
        />
        <path
          d="M237.947 112.441C239.055 113.081 240.481 112.685 241.133 111.556C241.784 110.428 241.414 108.995 240.306 108.355C239.198 107.715 237.772 108.111 237.12 109.24C236.469 110.368 236.839 111.801 237.947 112.441Z"
          fill="#3A2933"
        />
        <path
          d="M232.28 103.721C233.388 104.361 234.815 103.965 235.466 102.837C236.118 101.708 235.748 100.275 234.639 99.6354C233.531 98.9956 232.105 99.3917 231.454 100.52C230.802 101.648 231.172 103.082 232.28 103.721Z"
          fill="#3A2933"
        />
        <path
          d="M227.562 111.893C228.67 112.533 230.097 112.137 230.748 111.009C231.4 109.881 231.029 108.447 229.921 107.807C228.813 107.168 227.387 107.564 226.735 108.692C226.084 109.82 226.454 111.254 227.562 111.893Z"
          fill="#3A2933"
        />
        <path
          d="M233.229 120.613C234.337 121.253 235.763 120.857 236.415 119.728C237.066 118.6 236.696 117.167 235.588 116.527C234.48 115.887 233.053 116.283 232.402 117.412C231.75 118.54 232.121 119.973 233.229 120.613Z"
          fill="#3A2933"
        />
        <path
          d="M222.844 120.066C223.952 120.705 225.379 120.309 226.03 119.181C226.681 118.053 226.311 116.619 225.203 115.98C224.095 115.34 222.669 115.736 222.017 116.864C221.366 117.992 221.736 119.426 222.844 120.066Z"
          fill="#3A2933"
        />
        <path
          d="M228.511 128.785C229.619 129.425 231.045 129.029 231.697 127.901C232.348 126.772 231.978 125.339 230.87 124.699C229.762 124.059 228.335 124.455 227.684 125.584C227.032 126.712 227.403 128.145 228.511 128.785Z"
          fill="#3A2933"
        />
        <path
          d="M223.793 136.957C224.901 137.597 226.327 137.201 226.978 136.073C227.63 134.944 227.26 133.511 226.152 132.871C225.043 132.231 223.617 132.627 222.966 133.756C222.314 134.884 222.684 136.317 223.793 136.957Z"
          fill="#3A2933"
        />
        <path
          d="M218.126 128.238C219.234 128.877 220.66 128.481 221.312 127.353C221.963 126.225 221.593 124.791 220.485 124.152C219.377 123.512 217.951 123.908 217.299 125.036C216.648 126.165 217.018 127.598 218.126 128.238Z"
          fill="#3A2933"
        />
        <path
          d="M213.408 136.41C214.516 137.049 215.942 136.653 216.594 135.525C217.245 134.397 216.875 132.963 215.767 132.324C214.659 131.684 213.232 132.08 212.581 133.208C211.93 134.337 212.3 135.77 213.408 136.41Z"
          fill="#3A2933"
        />
        <path
          d="M219.074 145.129C220.182 145.769 221.609 145.373 222.26 144.245C222.912 143.116 222.542 141.683 221.433 141.043C220.325 140.403 218.899 140.8 218.247 141.928C217.596 143.056 217.966 144.49 219.074 145.129Z"
          fill="#3A2933"
        />
        <path
          d="M208.69 144.582C209.798 145.221 211.224 144.825 211.876 143.697C212.527 142.569 212.157 141.135 211.049 140.496C209.941 139.856 208.514 140.252 207.863 141.38C207.211 142.509 207.582 143.942 208.69 144.582Z"
          fill="#3A2933"
        />
        <path
          d="M214.356 153.301C215.464 153.941 216.891 153.545 217.542 152.417C218.194 151.288 217.823 149.855 216.715 149.215C215.607 148.576 214.181 148.972 213.529 150.1C212.878 151.228 213.248 152.662 214.356 153.301Z"
          fill="#3A2933"
        />
        <path
          d="M203.972 152.754C205.08 153.394 206.506 152.998 207.157 151.869C207.809 150.741 207.439 149.308 206.331 148.668C205.222 148.028 203.796 148.424 203.145 149.552C202.493 150.681 202.863 152.114 203.972 152.754Z"
          fill="#3A2933"
        />
        <path
          d="M209.638 161.473C210.746 162.113 212.173 161.717 212.824 160.589C213.475 159.46 213.105 158.027 211.997 157.387C210.889 156.748 209.463 157.144 208.811 158.272C208.16 159.4 208.53 160.834 209.638 161.473Z"
          fill="#3A2933"
        />
        <path
          d="M204.92 169.645C206.028 170.285 207.454 169.889 208.106 168.761C208.757 167.633 208.387 166.199 207.279 165.559C206.171 164.92 204.744 165.316 204.093 166.444C203.442 167.572 203.812 169.006 204.92 169.645Z"
          fill="#3A2933"
        />
        <path
          d="M199.253 160.926C200.361 161.566 201.788 161.17 202.439 160.041C203.091 158.913 202.721 157.48 201.612 156.84C200.504 156.2 199.078 156.596 198.427 157.724C197.775 158.853 198.145 160.286 199.253 160.926Z"
          fill="#3A2933"
        />
        <path
          d="M194.535 169.098C195.643 169.738 197.07 169.342 197.721 168.213C198.373 167.085 198.002 165.652 196.894 165.012C195.786 164.372 194.36 164.768 193.708 165.897C193.057 167.025 193.427 168.458 194.535 169.098Z"
          fill="#3A2933"
        />
        <path
          d="M200.202 177.818C201.31 178.457 202.736 178.061 203.388 176.933C204.039 175.805 203.669 174.371 202.561 173.732C201.453 173.092 200.026 173.488 199.375 174.616C198.723 175.744 199.094 177.178 200.202 177.818Z"
          fill="#3A2933"
        />
        <path
          d="M189.817 177.27C190.925 177.91 192.352 177.514 193.003 176.385C193.654 175.257 193.284 173.824 192.176 173.184C191.068 172.544 189.642 172.94 188.99 174.069C188.339 175.197 188.709 176.63 189.817 177.27Z"
          fill="#3A2933"
        />
        <path
          d="M195.484 185.99C196.592 186.629 198.018 186.233 198.67 185.105C199.321 183.977 198.951 182.543 197.843 181.904C196.735 181.264 195.308 181.66 194.657 182.788C194.005 183.917 194.376 185.35 195.484 185.99Z"
          fill="#3A2933"
        />
        <path
          d="M185.099 185.442C186.207 186.082 187.633 185.686 188.285 184.557C188.936 183.429 188.566 181.996 187.458 181.356C186.35 180.716 184.924 181.112 184.272 182.241C183.621 183.369 183.991 184.802 185.099 185.442Z"
          fill="#3A2933"
        />
        <path
          d="M190.765 194.162C191.874 194.801 193.3 194.405 193.951 193.277C194.603 192.149 194.233 190.715 193.125 190.076C192.016 189.436 190.59 189.832 189.939 190.96C189.287 192.089 189.657 193.522 190.765 194.162Z"
          fill="#3A2933"
        />
        <path
          d="M186.047 202.334C187.155 202.974 188.582 202.577 189.233 201.449C189.885 200.321 189.515 198.887 188.406 198.248C187.298 197.608 185.872 198.004 185.22 199.132C184.569 200.261 184.939 201.694 186.047 202.334Z"
          fill="#3A2933"
        />
        <path
          d="M180.381 193.614C181.489 194.254 182.915 193.858 183.567 192.729C184.218 191.601 183.848 190.168 182.74 189.528C181.632 188.888 180.205 189.284 179.554 190.413C178.903 191.541 179.273 192.974 180.381 193.614Z"
          fill="#3A2933"
        />
        <path
          d="M175.663 201.786C176.771 202.426 178.197 202.03 178.849 200.902C179.5 199.773 179.13 198.34 178.022 197.7C176.914 197.06 175.487 197.456 174.836 198.585C174.184 199.713 174.555 201.146 175.663 201.786Z"
          fill="#3A2933"
        />
        <path
          d="M181.329 210.506C182.437 211.146 183.864 210.75 184.515 209.621C185.167 208.493 184.796 207.06 183.688 206.42C182.58 205.78 181.154 206.176 180.502 207.304C179.851 208.433 180.221 209.866 181.329 210.506Z"
          fill="#3A2933"
        />
        <path
          d="M170.945 209.958C172.053 210.598 173.479 210.202 174.13 209.074C174.782 207.945 174.412 206.512 173.304 205.872C172.195 205.232 170.769 205.629 170.118 206.757C169.466 207.885 169.836 209.318 170.945 209.958Z"
          fill="#3A2933"
        />
        <path
          d="M176.611 218.678C177.719 219.318 179.146 218.922 179.797 217.793C180.448 216.665 180.078 215.232 178.97 214.592C177.862 213.952 176.436 214.348 175.784 215.476C175.133 216.605 175.503 218.038 176.611 218.678Z"
          fill="#3A2933"
        />
        <path
          d="M171.893 226.85C173.001 227.49 174.427 227.094 175.079 225.965C175.73 224.837 175.36 223.404 174.252 222.764C173.144 222.124 171.717 222.52 171.066 223.649C170.415 224.777 170.785 226.21 171.893 226.85Z"
          fill="#3A2933"
        />
        <path
          d="M166.226 218.13C167.334 218.77 168.761 218.374 169.412 217.246C170.064 216.117 169.694 214.684 168.585 214.044C167.477 213.405 166.051 213.801 165.4 214.929C164.748 216.057 165.118 217.491 166.226 218.13Z"
          fill="#3A2933"
        />
        <path
          d="M281.359 55.7841C282.467 56.4239 283.893 56.0278 284.545 54.8995C285.196 53.7712 284.826 52.3379 283.718 51.6981C282.61 51.0583 281.183 51.4544 280.532 52.5827C279.88 53.711 280.251 55.1444 281.359 55.7841Z"
          fill="#3A2933"
        />
        <path
          d="M287.025 64.5037C288.133 65.1435 289.56 64.7474 290.211 63.6191C290.863 62.4908 290.492 61.0575 289.384 60.4177C288.276 59.7779 286.85 60.174 286.198 61.3023C285.547 62.4307 285.917 63.864 287.025 64.5037Z"
          fill="#3A2933"
        />
        <path
          d="M291.743 56.3317C292.851 56.9714 294.278 56.5754 294.929 55.4471C295.581 54.3187 295.21 52.8854 294.102 52.2456C292.994 51.6059 291.568 52.0019 290.916 53.1303C290.265 54.2586 290.635 55.6919 291.743 56.3317Z"
          fill="#3A2933"
        />
        <path
          d="M276.64 63.9562C277.749 64.596 279.175 64.1999 279.826 63.0716C280.478 61.9432 280.108 60.5099 279 59.8702C277.891 59.2304 276.465 59.6264 275.814 60.7548C275.162 61.8831 275.532 63.3164 276.64 63.9562Z"
          fill="#3A2933"
        />
        <path
          d="M282.307 72.6758C283.415 73.3156 284.842 72.9195 285.493 71.7912C286.144 70.6629 285.774 69.2295 284.666 68.5898C283.558 67.95 282.132 68.3461 281.48 69.4744C280.829 70.6027 281.199 72.036 282.307 72.6758Z"
          fill="#3A2933"
        />
        <path
          d="M271.922 72.1283C273.03 72.768 274.457 72.372 275.108 71.2436C275.76 70.1153 275.39 68.682 274.281 68.0422C273.173 67.4025 271.747 67.7985 271.095 68.9268C270.444 70.0552 270.814 71.4885 271.922 72.1283Z"
          fill="#3A2933"
        />
        <path
          d="M277.589 80.8479C278.697 81.4876 280.123 81.0916 280.775 79.9633C281.426 78.8349 281.056 77.4016 279.948 76.7618C278.84 76.1221 277.413 76.5181 276.762 77.6465C276.111 78.7748 276.481 80.2081 277.589 80.8479Z"
          fill="#3A2933"
        />
        <path
          d="M272.871 89.0199C273.979 89.6597 275.405 89.2636 276.057 88.1353C276.708 87.007 276.338 85.5737 275.23 84.9339C274.122 84.2941 272.695 84.6902 272.044 85.8185C271.392 86.9469 271.763 88.3802 272.871 89.0199Z"
          fill="#3A2933"
        />
        <path
          d="M267.204 80.3003C268.312 80.9401 269.739 80.544 270.39 79.4157C271.042 78.2874 270.671 76.8541 269.563 76.2143C268.455 75.5745 267.029 75.9706 266.377 77.0989C265.726 78.2272 266.096 79.6606 267.204 80.3003Z"
          fill="#3A2933"
        />
        <path
          d="M262.486 88.4724C263.594 89.1121 265.021 88.7161 265.672 87.5878C266.323 86.4594 265.953 85.0261 264.845 84.3864C263.737 83.7466 262.311 84.1426 261.659 85.271C261.008 86.3993 261.378 87.8326 262.486 88.4724Z"
          fill="#3A2933"
        />
        <path
          d="M268.153 97.192C269.261 97.8318 270.687 97.4357 271.339 96.3074C271.99 95.1791 271.62 93.7457 270.512 93.106C269.404 92.4662 267.977 92.8623 267.326 93.9906C266.674 95.1189 267.044 96.5522 268.153 97.192Z"
          fill="#3A2933"
        />
        <path
          d="M257.768 96.6444C258.876 97.2842 260.302 96.8882 260.954 95.7598C261.605 94.6315 261.235 93.1982 260.127 92.5584C259.019 91.9187 257.592 92.3147 256.941 93.443C256.29 94.5714 256.66 96.0047 257.768 96.6444Z"
          fill="#3A2933"
        />
        <path
          d="M263.434 105.364C264.543 106.004 265.969 105.608 266.62 104.479C267.272 103.351 266.902 101.918 265.794 101.278C264.685 100.638 263.259 101.034 262.608 102.163C261.956 103.291 262.326 104.724 263.434 105.364Z"
          fill="#3A2933"
        />
        <path
          d="M253.05 104.817C254.158 105.456 255.584 105.06 256.236 103.932C256.887 102.804 256.517 101.37 255.409 100.73C254.301 100.091 252.874 100.487 252.223 101.615C251.571 102.743 251.942 104.177 253.05 104.817Z"
          fill="#3A2933"
        />
        <path
          d="M258.716 113.536C259.824 114.176 261.251 113.78 261.902 112.652C262.554 111.523 262.183 110.09 261.075 109.45C259.967 108.81 258.541 109.206 257.889 110.335C257.238 111.463 257.608 112.896 258.716 113.536Z"
          fill="#3A2933"
        />
        <path
          d="M253.998 121.708C255.106 122.348 256.533 121.952 257.184 120.824C257.836 119.695 257.465 118.262 256.357 117.622C255.249 116.982 253.823 117.378 253.171 118.507C252.52 119.635 252.89 121.068 253.998 121.708Z"
          fill="#3A2933"
        />
        <path
          d="M248.332 112.989C249.44 113.628 250.866 113.232 251.518 112.104C252.169 110.976 251.799 109.542 250.691 108.903C249.583 108.263 248.156 108.659 247.505 109.787C246.853 110.915 247.224 112.349 248.332 112.989Z"
          fill="#3A2933"
        />
        <path
          d="M243.613 121.161C244.722 121.8 246.148 121.404 246.799 120.276C247.451 119.148 247.081 117.714 245.973 117.075C244.864 116.435 243.438 116.831 242.787 117.959C242.135 119.088 242.505 120.521 243.613 121.161Z"
          fill="#3A2933"
        />
        <path
          d="M249.28 129.88C250.388 130.52 251.815 130.124 252.466 128.996C253.117 127.867 252.747 126.434 251.639 125.794C250.531 125.154 249.105 125.551 248.453 126.679C247.802 127.807 248.172 129.241 249.28 129.88Z"
          fill="#3A2933"
        />
        <path
          d="M238.895 129.333C240.003 129.972 241.43 129.576 242.081 128.448C242.733 127.32 242.363 125.886 241.254 125.247C240.146 124.607 238.72 125.003 238.068 126.131C237.417 127.26 237.787 128.693 238.895 129.333Z"
          fill="#3A2933"
        />
        <path
          d="M244.562 138.052C245.67 138.692 247.096 138.296 247.748 137.168C248.399 136.039 248.029 134.606 246.921 133.966C245.813 133.327 244.386 133.723 243.735 134.851C243.084 135.979 243.454 137.413 244.562 138.052Z"
          fill="#3A2933"
        />
        <path
          d="M239.844 146.224C240.952 146.864 242.378 146.468 243.03 145.34C243.681 144.211 243.311 142.778 242.203 142.138C241.095 141.499 239.668 141.895 239.017 143.023C238.365 144.151 238.736 145.585 239.844 146.224Z"
          fill="#3A2933"
        />
        <path
          d="M234.177 137.505C235.285 138.145 236.712 137.748 237.363 136.62C238.015 135.492 237.644 134.059 236.536 133.419C235.428 132.779 234.002 133.175 233.35 134.303C232.699 135.432 233.069 136.865 234.177 137.505Z"
          fill="#3A2933"
        />
        <path
          d="M229.459 145.677C230.567 146.317 231.994 145.921 232.645 144.792C233.296 143.664 232.926 142.231 231.818 141.591C230.71 140.951 229.284 141.347 228.632 142.475C227.981 143.604 228.351 145.037 229.459 145.677Z"
          fill="#3A2933"
        />
        <path
          d="M235.126 154.396C236.234 155.036 237.66 154.64 238.312 153.512C238.963 152.384 238.593 150.95 237.485 150.31C236.377 149.671 234.95 150.067 234.299 151.195C233.647 152.323 234.017 153.757 235.126 154.396Z"
          fill="#3A2933"
        />
        <path
          d="M224.741 153.849C225.849 154.489 227.275 154.093 227.927 152.964C228.578 151.836 228.208 150.403 227.1 149.763C225.992 149.123 224.565 149.519 223.914 150.647C223.263 151.776 223.633 153.209 224.741 153.849Z"
          fill="#3A2933"
        />
        <path
          d="M230.407 162.569C231.516 163.208 232.942 162.812 233.593 161.684C234.245 160.556 233.875 159.122 232.767 158.482C231.658 157.843 230.232 158.239 229.581 159.367C228.929 160.495 229.299 161.929 230.407 162.569Z"
          fill="#3A2933"
        />
        <path
          d="M220.023 162.021C221.131 162.661 222.557 162.265 223.209 161.136C223.86 160.008 223.49 158.575 222.382 157.935C221.274 157.295 219.847 157.691 219.196 158.82C218.544 159.948 218.915 161.381 220.023 162.021Z"
          fill="#3A2933"
        />
        <path
          d="M225.689 170.741C226.797 171.38 228.224 170.984 228.875 169.856C229.527 168.728 229.156 167.294 228.048 166.655C226.94 166.015 225.514 166.411 224.862 167.539C224.211 168.668 224.581 170.101 225.689 170.741Z"
          fill="#3A2933"
        />
        <path
          d="M220.971 178.913C222.079 179.552 223.506 179.156 224.157 178.028C224.809 176.9 224.438 175.466 223.33 174.827C222.222 174.187 220.796 174.583 220.144 175.711C219.493 176.84 219.863 178.273 220.971 178.913Z"
          fill="#3A2933"
        />
        <path
          d="M215.305 170.193C216.413 170.833 217.839 170.437 218.491 169.308C219.142 168.18 218.772 166.747 217.664 166.107C216.556 165.467 215.129 165.863 214.478 166.992C213.826 168.12 214.197 169.553 215.305 170.193Z"
          fill="#3A2933"
        />
        <path
          d="M210.586 178.365C211.695 179.005 213.121 178.609 213.772 177.48C214.424 176.352 214.054 174.919 212.946 174.279C211.837 173.639 210.411 174.035 209.76 175.164C209.108 176.292 209.478 177.725 210.586 178.365Z"
          fill="#3A2933"
        />
        <path
          d="M216.253 187.085C217.361 187.724 218.788 187.328 219.439 186.2C220.09 185.072 219.72 183.638 218.612 182.999C217.504 182.359 216.078 182.755 215.426 183.883C214.775 185.012 215.145 186.445 216.253 187.085Z"
          fill="#3A2933"
        />
        <path
          d="M205.868 186.537C206.976 187.177 208.403 186.781 209.054 185.653C209.706 184.524 209.336 183.091 208.227 182.451C207.119 181.811 205.693 182.207 205.041 183.336C204.39 184.464 204.76 185.897 205.868 186.537Z"
          fill="#3A2933"
        />
        <path
          d="M211.535 195.257C212.643 195.897 214.069 195.501 214.721 194.372C215.372 193.244 215.002 191.811 213.894 191.171C212.786 190.531 211.359 190.927 210.708 192.055C210.057 193.184 210.427 194.617 211.535 195.257Z"
          fill="#3A2933"
        />
        <path
          d="M201.15 194.709C202.258 195.349 203.685 194.953 204.336 193.825C204.988 192.696 204.617 191.263 203.509 190.623C202.401 189.983 200.975 190.379 200.323 191.508C199.672 192.636 200.042 194.069 201.15 194.709Z"
          fill="#3A2933"
        />
        <path
          d="M206.817 203.429C207.925 204.069 209.351 203.673 210.003 202.544C210.654 201.416 210.284 199.983 209.176 199.343C208.068 198.703 206.641 199.099 205.99 200.227C205.338 201.356 205.709 202.789 206.817 203.429Z"
          fill="#3A2933"
        />
        <path
          d="M202.099 211.601C203.207 212.241 204.633 211.845 205.285 210.716C205.936 209.588 205.566 208.155 204.458 207.515C203.35 206.875 201.923 207.271 201.272 208.4C200.62 209.528 200.99 210.961 202.099 211.601Z"
          fill="#3A2933"
        />
        <path
          d="M196.432 202.881C197.54 203.521 198.967 203.125 199.618 201.997C200.269 200.868 199.899 199.435 198.791 198.795C197.683 198.155 196.257 198.552 195.605 199.68C194.954 200.808 195.324 202.242 196.432 202.881Z"
          fill="#3A2933"
        />
        <path
          d="M191.714 211.053C192.822 211.693 194.248 211.297 194.9 210.169C195.551 209.04 195.181 207.607 194.073 206.967C192.965 206.328 191.538 206.724 190.887 207.852C190.236 208.98 190.606 210.414 191.714 211.053Z"
          fill="#3A2933"
        />
        <path
          d="M197.38 219.773C198.489 220.413 199.915 220.017 200.566 218.888C201.218 217.76 200.848 216.327 199.74 215.687C198.631 215.047 197.205 215.443 196.554 216.572C195.902 217.7 196.272 219.133 197.38 219.773Z"
          fill="#3A2933"
        />
        <path
          d="M186.996 219.225C188.104 219.865 189.53 219.469 190.182 218.341C190.833 217.212 190.463 215.779 189.355 215.139C188.247 214.5 186.82 214.896 186.169 216.024C185.517 217.152 185.888 218.586 186.996 219.225Z"
          fill="#3A2933"
        />
        <path
          d="M192.662 227.945C193.77 228.585 195.197 228.189 195.848 227.06C196.5 225.932 196.129 224.499 195.021 223.859C193.913 223.219 192.487 223.615 191.835 224.744C191.184 225.872 191.554 227.305 192.662 227.945Z"
          fill="#3A2933"
        />
        <path
          d="M187.944 236.117C189.052 236.757 190.479 236.361 191.13 235.233C191.782 234.104 191.411 232.671 190.303 232.031C189.195 231.391 187.769 231.787 187.117 232.916C186.466 234.044 186.836 235.477 187.944 236.117Z"
          fill="#3A2933"
        />
        <path
          d="M182.278 227.398C183.386 228.037 184.812 227.641 185.464 226.513C186.115 225.385 185.745 223.951 184.637 223.311C183.529 222.672 182.102 223.068 181.451 224.196C180.799 225.324 181.169 226.758 182.278 227.398Z"
          fill="#3A2933"
        />
        <path
          d="M297.41 65.0513C298.518 65.6911 299.944 65.295 300.596 64.1667C301.247 63.0384 300.877 61.605 299.769 60.9653C298.661 60.3255 297.234 60.7216 296.583 61.8499C295.932 62.9782 296.302 64.4115 297.41 65.0513Z"
          fill="#3A2933"
        />
        <path
          d="M303.076 73.7709C304.184 74.4107 305.611 74.0146 306.262 72.8863C306.914 71.758 306.544 70.3247 305.435 69.6849C304.327 69.0451 302.901 69.4412 302.25 70.5695C301.598 71.6978 301.968 73.1312 303.076 73.7709Z"
          fill="#3A2933"
        />
        <path
          d="M307.795 65.5989C308.903 66.2386 310.329 65.8426 310.98 64.7142C311.632 63.5859 311.262 62.1526 310.154 61.5128C309.045 60.8731 307.619 61.2691 306.968 62.3974C306.316 63.5258 306.686 64.9591 307.795 65.5989Z"
          fill="#3A2933"
        />
        <path
          d="M292.692 73.2234C293.8 73.8631 295.226 73.4671 295.878 72.3388C296.529 71.2104 296.159 69.7771 295.051 69.1373C293.943 68.4976 292.516 68.8936 291.865 70.022C291.213 71.1503 291.584 72.5836 292.692 73.2234Z"
          fill="#3A2933"
        />
        <path
          d="M298.358 81.943C299.466 82.5828 300.893 82.1867 301.544 81.0584C302.196 79.93 301.825 78.4967 300.717 77.857C299.609 77.2172 298.183 77.6132 297.531 78.7416C296.88 79.8699 297.25 81.3032 298.358 81.943Z"
          fill="#3A2933"
        />
        <path
          d="M287.974 81.3954C289.082 82.0352 290.508 81.6391 291.16 80.5108C291.811 79.3825 291.441 77.9492 290.333 77.3094C289.225 76.6696 287.798 77.0657 287.147 78.194C286.495 79.3223 286.865 80.7557 287.974 81.3954Z"
          fill="#3A2933"
        />
        <path
          d="M293.64 90.1151C294.748 90.7548 296.175 90.3588 296.826 89.2304C297.477 88.1021 297.107 86.6688 295.999 86.029C294.891 85.3893 293.465 85.7853 292.813 86.9136C292.162 88.042 292.532 89.4753 293.64 90.1151Z"
          fill="#3A2933"
        />
        <path
          d="M288.922 98.2871C290.03 98.9269 291.456 98.5308 292.108 97.4025C292.759 96.2742 292.389 94.8409 291.281 94.2011C290.173 93.5613 288.747 93.9574 288.095 95.0857C287.444 96.214 287.814 97.6474 288.922 98.2871Z"
          fill="#3A2933"
        />
        <path
          d="M283.255 89.5675C284.364 90.2073 285.79 89.8112 286.441 88.6829C287.093 87.5546 286.723 86.1212 285.614 85.4815C284.506 84.8417 283.08 85.2378 282.429 86.3661C281.777 87.4944 282.147 88.9277 283.255 89.5675Z"
          fill="#3A2933"
        />
        <path
          d="M278.537 97.7396C279.645 98.3793 281.072 97.9833 281.723 96.8549C282.375 95.7266 282.004 94.2933 280.896 93.6535C279.788 93.0138 278.362 93.4098 277.71 94.5382C277.059 95.6665 277.429 97.0998 278.537 97.7396Z"
          fill="#3A2933"
        />
        <path
          d="M284.204 106.459C285.312 107.099 286.738 106.703 287.39 105.575C288.041 104.446 287.671 103.013 286.563 102.373C285.455 101.733 284.028 102.129 283.377 103.258C282.725 104.386 283.096 105.819 284.204 106.459Z"
          fill="#3A2933"
        />
        <path
          d="M273.819 105.912C274.927 106.551 276.354 106.155 277.005 105.027C277.657 103.899 277.286 102.465 276.178 101.826C275.07 101.186 273.644 101.582 272.992 102.71C272.341 103.839 272.711 105.272 273.819 105.912Z"
          fill="#3A2933"
        />
        <path
          d="M279.486 114.631C280.594 115.271 282.02 114.875 282.672 113.747C283.323 112.618 282.953 111.185 281.845 110.545C280.737 109.905 279.31 110.302 278.659 111.43C278.007 112.558 278.378 113.991 279.486 114.631Z"
          fill="#3A2933"
        />
        <path
          d="M269.101 114.084C270.209 114.723 271.635 114.327 272.287 113.199C272.938 112.071 272.568 110.637 271.46 109.998C270.352 109.358 268.926 109.754 268.274 110.882C267.623 112.011 267.993 113.444 269.101 114.084Z"
          fill="#3A2933"
        />
        <path
          d="M274.768 122.803C275.876 123.443 277.302 123.047 277.953 121.919C278.605 120.79 278.235 119.357 277.127 118.717C276.018 118.078 274.592 118.474 273.941 119.602C273.289 120.73 273.659 122.164 274.768 122.803Z"
          fill="#3A2933"
        />
        <path
          d="M270.049 130.975C271.157 131.615 272.584 131.219 273.235 130.091C273.887 128.962 273.517 127.529 272.408 126.889C271.3 126.25 269.874 126.646 269.223 127.774C268.571 128.902 268.941 130.336 270.049 130.975Z"
          fill="#3A2933"
        />
        <path
          d="M264.383 122.256C265.491 122.896 266.917 122.499 267.569 121.371C268.22 120.243 267.85 118.809 266.742 118.17C265.634 117.53 264.207 117.926 263.556 119.054C262.905 120.183 263.275 121.616 264.383 122.256Z"
          fill="#3A2933"
        />
        <path
          d="M259.665 130.428C260.773 131.068 262.199 130.672 262.851 129.543C263.502 128.415 263.132 126.982 262.024 126.342C260.916 125.702 259.489 126.098 258.838 127.226C258.186 128.355 258.557 129.788 259.665 130.428Z"
          fill="#3A2933"
        />
        <path
          d="M265.331 139.147C266.439 139.787 267.866 139.391 268.517 138.263C269.169 137.134 268.798 135.701 267.69 135.061C266.582 134.422 265.156 134.818 264.504 135.946C263.853 137.074 264.223 138.508 265.331 139.147Z"
          fill="#3A2933"
        />
        <path
          d="M254.947 138.6C256.055 139.24 257.481 138.844 258.132 137.715C258.784 136.587 258.414 135.154 257.306 134.514C256.198 133.874 254.771 134.27 254.12 135.398C253.468 136.527 253.838 137.96 254.947 138.6Z"
          fill="#3A2933"
        />
        <path
          d="M260.613 147.32C261.721 147.959 263.148 147.563 263.799 146.435C264.45 145.307 264.08 143.873 262.972 143.233C261.864 142.594 260.438 142.99 259.786 144.118C259.135 145.246 259.505 146.68 260.613 147.32Z"
          fill="#3A2933"
        />
        <path
          d="M255.895 155.492C257.003 156.131 258.429 155.735 259.081 154.607C259.732 153.479 259.362 152.045 258.254 151.406C257.146 150.766 255.72 151.162 255.068 152.29C254.417 153.418 254.787 154.852 255.895 155.492Z"
          fill="#3A2933"
        />
        <path
          d="M250.228 146.772C251.337 147.412 252.763 147.016 253.414 145.887C254.066 144.759 253.696 143.326 252.587 142.686C251.479 142.046 250.053 142.442 249.402 143.571C248.75 144.699 249.12 146.132 250.228 146.772Z"
          fill="#3A2933"
        />
        <path
          d="M245.51 154.944C246.618 155.584 248.045 155.188 248.696 154.059C249.348 152.931 248.977 151.498 247.869 150.858C246.761 150.218 245.335 150.614 244.683 151.743C244.032 152.871 244.402 154.304 245.51 154.944Z"
          fill="#3A2933"
        />
        <path
          d="M251.177 163.664C252.285 164.303 253.711 163.907 254.363 162.779C255.014 161.651 254.644 160.217 253.536 159.578C252.428 158.938 251.001 159.334 250.35 160.462C249.698 161.591 250.069 163.024 251.177 163.664Z"
          fill="#3A2933"
        />
        <path
          d="M240.792 163.116C241.9 163.756 243.327 163.36 243.978 162.231C244.63 161.103 244.259 159.67 243.151 159.03C242.043 158.39 240.617 158.786 239.965 159.915C239.314 161.043 239.684 162.476 240.792 163.116Z"
          fill="#3A2933"
        />
        <path
          d="M246.459 171.836C247.567 172.475 248.993 172.079 249.645 170.951C250.296 169.823 249.926 168.389 248.818 167.75C247.71 167.11 246.283 167.506 245.632 168.634C244.98 169.763 245.351 171.196 246.459 171.836Z"
          fill="#3A2933"
        />
        <path
          d="M236.074 171.288C237.182 171.928 238.608 171.532 239.26 170.404C239.911 169.275 239.541 167.842 238.433 167.202C237.325 166.562 235.899 166.958 235.247 168.087C234.596 169.215 234.966 170.648 236.074 171.288Z"
          fill="#3A2933"
        />
        <path
          d="M241.741 180.008C242.849 180.648 244.275 180.251 244.926 179.123C245.578 177.995 245.208 176.562 244.1 175.922C242.991 175.282 241.565 175.678 240.914 176.806C240.262 177.935 240.632 179.368 241.741 180.008Z"
          fill="#3A2933"
        />
        <path
          d="M237.022 188.18C238.13 188.82 239.557 188.424 240.208 187.295C240.86 186.167 240.49 184.734 239.381 184.094C238.273 183.454 236.847 183.85 236.196 184.978C235.544 186.107 235.914 187.54 237.022 188.18Z"
          fill="#3A2933"
        />
        <path
          d="M231.356 179.46C232.464 180.1 233.89 179.704 234.542 178.576C235.193 177.447 234.823 176.014 233.715 175.374C232.607 174.734 231.18 175.13 230.529 176.259C229.878 177.387 230.248 178.82 231.356 179.46Z"
          fill="#3A2933"
        />
        <path
          d="M226.638 187.632C227.746 188.272 229.172 187.876 229.824 186.748C230.475 185.619 230.105 184.186 228.997 183.546C227.889 182.906 226.462 183.303 225.811 184.431C225.159 185.559 225.53 186.993 226.638 187.632Z"
          fill="#3A2933"
        />
        <path
          d="M232.304 196.352C233.412 196.992 234.839 196.596 235.49 195.467C236.142 194.339 235.771 192.906 234.663 192.266C233.555 191.626 232.129 192.022 231.477 193.15C230.826 194.279 231.196 195.712 232.304 196.352Z"
          fill="#3A2933"
        />
        <path
          d="M221.92 195.804C223.028 196.444 224.454 196.048 225.105 194.92C225.757 193.791 225.387 192.358 224.279 191.718C223.171 191.079 221.744 191.475 221.093 192.603C220.441 193.731 220.811 195.165 221.92 195.804Z"
          fill="#3A2933"
        />
        <path
          d="M227.586 204.524C228.694 205.164 230.121 204.768 230.772 203.639C231.423 202.511 231.053 201.078 229.945 200.438C228.837 199.798 227.411 200.194 226.759 201.323C226.108 202.451 226.478 203.884 227.586 204.524Z"
          fill="#3A2933"
        />
        <path
          d="M217.201 203.976C218.31 204.616 219.736 204.22 220.387 203.092C221.039 201.963 220.669 200.53 219.56 199.89C218.452 199.251 217.026 199.647 216.375 200.775C215.723 201.903 216.093 203.337 217.201 203.976Z"
          fill="#3A2933"
        />
        <path
          d="M222.868 212.696C223.976 213.336 225.402 212.94 226.054 211.811C226.705 210.683 226.335 209.25 225.227 208.61C224.119 207.97 222.693 208.366 222.041 209.495C221.39 210.623 221.76 212.056 222.868 212.696Z"
          fill="#3A2933"
        />
        <path
          d="M218.15 220.868C219.258 221.508 220.684 221.112 221.336 219.983C221.987 218.855 221.617 217.422 220.509 216.782C219.401 216.142 217.974 216.538 217.323 217.667C216.671 218.795 217.042 220.228 218.15 220.868Z"
          fill="#3A2933"
        />
        <path
          d="M212.483 212.148C213.591 212.788 215.018 212.392 215.669 211.264C216.321 210.136 215.95 208.702 214.842 208.062C213.734 207.423 212.308 207.819 211.656 208.947C211.005 210.075 211.375 211.509 212.483 212.148Z"
          fill="#3A2933"
        />
        <path
          d="M207.765 220.321C208.873 220.96 210.3 220.564 210.951 219.436C211.602 218.308 211.232 216.874 210.124 216.235C209.016 215.595 207.59 215.991 206.938 217.119C206.287 218.247 206.657 219.681 207.765 220.321Z"
          fill="#3A2933"
        />
        <path
          d="M213.432 229.04C214.54 229.68 215.966 229.284 216.618 228.156C217.269 227.027 216.899 225.594 215.791 224.954C214.683 224.314 213.256 224.71 212.605 225.839C211.953 226.967 212.324 228.4 213.432 229.04Z"
          fill="#3A2933"
        />
        <path
          d="M203.047 228.493C204.155 229.132 205.581 228.736 206.233 227.608C206.884 226.48 206.514 225.046 205.406 224.407C204.298 223.767 202.872 224.163 202.22 225.291C201.569 226.42 201.939 227.853 203.047 228.493Z"
          fill="#3A2933"
        />
        <path
          d="M208.714 237.212C209.822 237.852 211.248 237.456 211.899 236.328C212.551 235.199 212.181 233.766 211.073 233.126C209.964 232.486 208.538 232.882 207.887 234.011C207.235 235.139 207.605 236.572 208.714 237.212Z"
          fill="#3A2933"
        />
        <path
          d="M203.995 245.384C205.103 246.024 206.53 245.628 207.181 244.5C207.833 243.371 207.463 241.938 206.354 241.298C205.246 240.659 203.82 241.055 203.168 242.183C202.517 243.311 202.887 244.745 203.995 245.384Z"
          fill="#3A2933"
        />
        <path
          d="M198.329 236.665C199.437 237.304 200.863 236.908 201.515 235.78C202.166 234.652 201.796 233.218 200.688 232.579C199.58 231.939 198.153 232.335 197.502 233.463C196.851 234.592 197.221 236.025 198.329 236.665Z"
          fill="#3A2933"
        />
        <path
          d="M313.461 74.3185C314.569 74.9582 315.996 74.5622 316.647 73.4339C317.298 72.3055 316.928 70.8722 315.82 70.2324C314.712 69.5927 313.286 69.9887 312.634 71.1171C311.983 72.2454 312.353 73.6787 313.461 74.3185Z"
          fill="#3A2933"
        />
        <path
          d="M319.128 83.0381C320.236 83.6779 321.662 83.2818 322.314 82.1535C322.965 81.0252 322.595 79.5918 321.487 78.9521C320.379 78.3123 318.952 78.7084 318.301 79.8367C317.649 80.965 318.02 82.3983 319.128 83.0381Z"
          fill="#3A2933"
        />
        <path
          d="M323.846 74.866C324.954 75.5058 326.38 75.1097 327.032 73.9814C327.683 72.8531 327.313 71.4198 326.205 70.78C325.097 70.1402 323.67 70.5363 323.019 71.6646C322.367 72.793 322.738 74.2263 323.846 74.866Z"
          fill="#3A2933"
        />
        <path
          d="M308.743 82.4905C309.851 83.1303 311.277 82.7343 311.929 81.6059C312.58 80.4776 312.21 79.0443 311.102 78.4045C309.994 77.7647 308.567 78.1608 307.916 79.2891C307.265 80.4175 307.635 81.8508 308.743 82.4905Z"
          fill="#3A2933"
        />
        <path
          d="M314.409 91.2102C315.518 91.8499 316.944 91.4539 317.595 90.3255C318.247 89.1972 317.877 87.7639 316.769 87.1241C315.66 86.4844 314.234 86.8804 313.583 88.0088C312.931 89.1371 313.301 90.5704 314.409 91.2102Z"
          fill="#3A2933"
        />
        <path
          d="M304.025 90.6626C305.133 91.3024 306.559 90.9063 307.211 89.778C307.862 88.6497 307.492 87.2163 306.384 86.5766C305.276 85.9368 303.849 86.3329 303.198 87.4612C302.546 88.5895 302.917 90.0228 304.025 90.6626Z"
          fill="#3A2933"
        />
        <path
          d="M309.691 99.3822C310.799 100.022 312.226 99.6259 312.877 98.4976C313.529 97.3693 313.159 95.936 312.05 95.2962C310.942 94.6564 309.516 95.0525 308.864 96.1808C308.213 97.3091 308.583 98.7425 309.691 99.3822Z"
          fill="#3A2933"
        />
        <path
          d="M304.973 107.554C306.081 108.194 307.508 107.798 308.159 106.67C308.811 105.541 308.44 104.108 307.332 103.468C306.224 102.829 304.798 103.225 304.146 104.353C303.495 105.481 303.865 106.915 304.973 107.554Z"
          fill="#3A2933"
        />
        <path
          d="M299.307 98.8347C300.415 99.4744 301.841 99.0784 302.493 97.9501C303.144 96.8217 302.774 95.3884 301.666 94.7486C300.558 94.1089 299.131 94.5049 298.48 95.6333C297.828 96.7616 298.199 98.1949 299.307 98.8347Z"
          fill="#3A2933"
        />
        <path
          d="M294.588 107.007C295.697 107.647 297.123 107.25 297.774 106.122C298.426 104.994 298.056 103.56 296.948 102.921C295.839 102.281 294.413 102.677 293.762 103.805C293.11 104.934 293.48 106.367 294.588 107.007Z"
          fill="#3A2933"
        />
        <path
          d="M300.255 115.726C301.363 116.366 302.79 115.97 303.441 114.842C304.092 113.713 303.722 112.28 302.614 111.64C301.506 111.001 300.08 111.397 299.428 112.525C298.777 113.653 299.147 115.087 300.255 115.726Z"
          fill="#3A2933"
        />
        <path
          d="M289.87 115.179C290.978 115.819 292.405 115.423 293.056 114.294C293.708 113.166 293.338 111.733 292.229 111.093C291.121 110.453 289.695 110.849 289.043 111.977C288.392 113.106 288.762 114.539 289.87 115.179Z"
          fill="#3A2933"
        />
        <path
          d="M295.537 123.898C296.645 124.538 298.071 124.142 298.723 123.014C299.374 121.885 299.004 120.452 297.896 119.812C296.788 119.173 295.361 119.569 294.71 120.697C294.059 121.825 294.429 123.259 295.537 123.898Z"
          fill="#3A2933"
        />
        <path
          d="M285.152 123.351C286.26 123.991 287.687 123.595 288.338 122.466C288.99 121.338 288.619 119.905 287.511 119.265C286.403 118.625 284.977 119.021 284.325 120.149C283.674 121.278 284.044 122.711 285.152 123.351Z"
          fill="#3A2933"
        />
        <path
          d="M290.819 132.07C291.927 132.71 293.353 132.314 294.005 131.186C294.656 130.058 294.286 128.624 293.178 127.984C292.07 127.345 290.643 127.741 289.992 128.869C289.34 129.997 289.711 131.431 290.819 132.07Z"
          fill="#3A2933"
        />
        <path
          d="M286.101 140.243C287.209 140.882 288.635 140.486 289.287 139.358C289.938 138.23 289.568 136.796 288.46 136.157C287.352 135.517 285.925 135.913 285.274 137.041C284.622 138.169 284.993 139.603 286.101 140.243Z"
          fill="#3A2933"
        />
        <path
          d="M280.434 131.523C281.542 132.163 282.969 131.767 283.62 130.638C284.271 129.51 283.901 128.077 282.793 127.437C281.685 126.797 280.259 127.193 279.607 128.322C278.956 129.45 279.326 130.883 280.434 131.523Z"
          fill="#3A2933"
        />
        <path
          d="M275.716 139.695C276.824 140.335 278.25 139.939 278.902 138.81C279.553 137.682 279.183 136.249 278.075 135.609C276.967 134.969 275.54 135.365 274.889 136.494C274.238 137.622 274.608 139.055 275.716 139.695Z"
          fill="#3A2933"
        />
        <path
          d="M281.382 148.415C282.491 149.054 283.917 148.658 284.568 147.53C285.22 146.402 284.85 144.968 283.742 144.329C282.633 143.689 281.207 144.085 280.556 145.213C279.904 146.342 280.274 147.775 281.382 148.415Z"
          fill="#3A2933"
        />
        <path
          d="M270.998 147.867C272.106 148.507 273.532 148.111 274.184 146.982C274.835 145.854 274.465 144.421 273.357 143.781C272.249 143.141 270.822 143.537 270.171 144.666C269.519 145.794 269.89 147.227 270.998 147.867Z"
          fill="#3A2933"
        />
        <path
          d="M276.664 156.587C277.772 157.226 279.199 156.83 279.85 155.702C280.502 154.574 280.132 153.14 279.023 152.501C277.915 151.861 276.489 152.257 275.837 153.385C275.186 154.514 275.556 155.947 276.664 156.587Z"
          fill="#3A2933"
        />
        <path
          d="M271.946 164.759C273.054 165.399 274.481 165.002 275.132 163.874C275.784 162.746 275.413 161.312 274.305 160.673C273.197 160.033 271.771 160.429 271.119 161.557C270.468 162.686 270.838 164.119 271.946 164.759Z"
          fill="#3A2933"
        />
        <path
          d="M266.28 156.039C267.388 156.679 268.814 156.283 269.466 155.155C270.117 154.026 269.747 152.593 268.639 151.953C267.531 151.313 266.104 151.709 265.453 152.838C264.801 153.966 265.172 155.399 266.28 156.039Z"
          fill="#3A2933"
        />
        <path
          d="M261.561 164.211C262.67 164.851 264.096 164.455 264.747 163.327C265.399 162.198 265.029 160.765 263.921 160.125C262.812 159.485 261.386 159.881 260.735 161.01C260.083 162.138 260.453 163.571 261.561 164.211Z"
          fill="#3A2933"
        />
        <path
          d="M267.228 172.931C268.336 173.571 269.763 173.175 270.414 172.046C271.065 170.918 270.695 169.485 269.587 168.845C268.479 168.205 267.053 168.601 266.401 169.729C265.75 170.858 266.12 172.291 267.228 172.931Z"
          fill="#3A2933"
        />
        <path
          d="M256.843 172.383C257.951 173.023 259.378 172.627 260.029 171.499C260.681 170.37 260.311 168.937 259.202 168.297C258.094 167.657 256.668 168.054 256.016 169.182C255.365 170.31 255.735 171.743 256.843 172.383Z"
          fill="#3A2933"
        />
        <path
          d="M262.51 181.103C263.618 181.743 265.044 181.347 265.696 180.218C266.347 179.09 265.977 177.657 264.869 177.017C263.761 176.377 262.334 176.773 261.683 177.901C261.032 179.03 261.402 180.463 262.51 181.103Z"
          fill="#3A2933"
        />
        <path
          d="M252.125 180.555C253.233 181.195 254.66 180.799 255.311 179.671C255.963 178.542 255.592 177.109 254.484 176.469C253.376 175.83 251.95 176.226 251.298 177.354C250.647 178.482 251.017 179.916 252.125 180.555Z"
          fill="#3A2933"
        />
        <path
          d="M257.792 189.275C258.9 189.915 260.326 189.519 260.978 188.39C261.629 187.262 261.259 185.829 260.151 185.189C259.043 184.549 257.616 184.945 256.965 186.074C256.313 187.202 256.684 188.635 257.792 189.275Z"
          fill="#3A2933"
        />
        <path
          d="M253.074 197.447C254.182 198.087 255.608 197.691 256.26 196.562C256.911 195.434 256.541 194.001 255.433 193.361C254.325 192.721 252.898 193.117 252.247 194.246C251.595 195.374 251.966 196.807 253.074 197.447Z"
          fill="#3A2933"
        />
        <path
          d="M247.407 188.727C248.515 189.367 249.942 188.971 250.593 187.843C251.244 186.714 250.874 185.281 249.766 184.641C248.658 184.002 247.232 184.398 246.58 185.526C245.929 186.654 246.299 188.088 247.407 188.727Z"
          fill="#3A2933"
        />
        <path
          d="M242.689 196.899C243.797 197.539 245.223 197.143 245.875 196.015C246.526 194.887 246.156 193.453 245.048 192.813C243.94 192.174 242.513 192.57 241.862 193.698C241.211 194.826 241.581 196.26 242.689 196.899Z"
          fill="#3A2933"
        />
        <path
          d="M248.355 205.619C249.464 206.259 250.89 205.863 251.541 204.734C252.193 203.606 251.823 202.173 250.715 201.533C249.606 200.893 248.18 201.289 247.529 202.418C246.877 203.546 247.247 204.979 248.355 205.619Z"
          fill="#3A2933"
        />
        <path
          d="M237.971 205.072C239.079 205.711 240.505 205.315 241.157 204.187C241.808 203.059 241.438 201.625 240.33 200.985C239.222 200.346 237.795 200.742 237.144 201.87C236.492 202.998 236.863 204.432 237.971 205.072Z"
          fill="#3A2933"
        />
        <path
          d="M243.637 213.791C244.745 214.431 246.172 214.035 246.823 212.907C247.475 211.778 247.104 210.345 245.996 209.705C244.888 209.065 243.462 209.461 242.81 210.59C242.159 211.718 242.529 213.151 243.637 213.791Z"
          fill="#3A2933"
        />
        <path
          d="M233.253 213.244C234.361 213.883 235.787 213.487 236.439 212.359C237.09 211.231 236.72 209.797 235.612 209.158C234.504 208.518 233.077 208.914 232.426 210.042C231.774 211.171 232.145 212.604 233.253 213.244Z"
          fill="#3A2933"
        />
        <path
          d="M238.919 221.963C240.027 222.603 241.454 222.207 242.105 221.079C242.757 219.95 242.386 218.517 241.278 217.877C240.17 217.237 238.744 217.633 238.092 218.762C237.441 219.89 237.811 221.323 238.919 221.963Z"
          fill="#3A2933"
        />
        <path
          d="M234.201 230.135C235.309 230.775 236.736 230.379 237.387 229.251C238.038 228.122 237.668 226.689 236.56 226.049C235.452 225.409 234.026 225.806 233.374 226.934C232.723 228.062 233.093 229.496 234.201 230.135Z"
          fill="#3A2933"
        />
        <path
          d="M228.534 221.416C229.643 222.055 231.069 221.659 231.72 220.531C232.372 219.403 232.002 217.969 230.894 217.33C229.785 216.69 228.359 217.086 227.708 218.214C227.056 219.343 227.426 220.776 228.534 221.416Z"
          fill="#3A2933"
        />
        <path
          d="M223.816 229.588C224.924 230.227 226.351 229.831 227.002 228.703C227.654 227.575 227.284 226.141 226.175 225.502C225.067 224.862 223.641 225.258 222.989 226.386C222.338 227.515 222.708 228.948 223.816 229.588Z"
          fill="#3A2933"
        />
        <path
          d="M229.483 238.307C230.591 238.947 232.017 238.551 232.669 237.423C233.32 236.294 232.95 234.861 231.842 234.221C230.734 233.582 229.307 233.978 228.656 235.106C228.005 236.234 228.375 237.668 229.483 238.307Z"
          fill="#3A2933"
        />
        <path
          d="M219.098 237.76C220.206 238.4 221.633 238.003 222.284 236.875C222.936 235.747 222.565 234.314 221.457 233.674C220.349 233.034 218.923 233.43 218.271 234.558C217.62 235.687 217.99 237.12 219.098 237.76Z"
          fill="#3A2933"
        />
        <path
          d="M224.765 246.479C225.873 247.119 227.299 246.723 227.951 245.595C228.602 244.466 228.232 243.033 227.124 242.393C226.016 241.754 224.589 242.15 223.938 243.278C223.286 244.406 223.657 245.84 224.765 246.479Z"
          fill="#3A2933"
        />
        <path
          d="M220.047 254.651C221.155 255.291 222.581 254.895 223.233 253.767C223.884 252.639 223.514 251.205 222.406 250.565C221.298 249.926 219.871 250.322 219.22 251.45C218.568 252.578 218.938 254.012 220.047 254.651Z"
          fill="#3A2933"
        />
        <path
          d="M214.38 245.932C215.488 246.572 216.915 246.176 217.566 245.047C218.217 243.919 217.847 242.486 216.739 241.846C215.631 241.206 214.205 241.602 213.553 242.73C212.902 243.859 213.272 245.292 214.38 245.932Z"
          fill="#3A2933"
        />
        <path
          d="M329.512 83.5857C330.62 84.2254 332.047 83.8294 332.698 82.701C333.35 81.5727 332.979 80.1394 331.871 79.4996C330.763 78.8599 329.337 79.2559 328.685 80.3842C328.034 81.5126 328.404 82.9459 329.512 83.5857Z"
          fill="#3A2933"
        />
        <path
          d="M335.179 92.3053C336.287 92.945 337.713 92.549 338.365 91.4207C339.016 90.2923 338.646 88.859 337.538 88.2193C336.43 87.5795 335.003 87.9755 334.352 89.1039C333.701 90.2322 334.071 91.6655 335.179 92.3053Z"
          fill="#3A2933"
        />
        <path
          d="M339.897 84.1332C341.005 84.773 342.431 84.3769 343.083 83.2486C343.734 82.1203 343.364 80.687 342.256 80.0472C341.148 79.4074 339.722 79.8035 339.07 80.9318C338.419 82.0601 338.789 83.4935 339.897 84.1332Z"
          fill="#3A2933"
        />
        <path
          d="M324.794 91.7577C325.902 92.3975 327.329 92.0014 327.98 90.8731C328.632 89.7448 328.261 88.3115 327.153 87.6717C326.045 87.0319 324.619 87.428 323.967 88.5563C323.316 89.6846 323.686 91.118 324.794 91.7577Z"
          fill="#3A2933"
        />
        <path
          d="M330.461 100.477C331.569 101.117 332.995 100.721 333.647 99.5927C334.298 98.4644 333.928 97.0311 332.82 96.3913C331.712 95.7516 330.285 96.1476 329.634 97.2759C328.982 98.4043 329.353 99.8376 330.461 100.477Z"
          fill="#3A2933"
        />
        <path
          d="M320.076 99.9298C321.184 100.57 322.611 100.173 323.262 99.0452C323.913 97.9168 323.543 96.4835 322.435 95.8438C321.327 95.204 319.901 95.6 319.249 96.7284C318.598 97.8567 318.968 99.29 320.076 99.9298Z"
          fill="#3A2933"
        />
        <path
          d="M325.743 108.649C326.851 109.289 328.277 108.893 328.928 107.765C329.58 106.636 329.21 105.203 328.102 104.563C326.994 103.924 325.567 104.32 324.916 105.448C324.264 106.576 324.634 108.01 325.743 108.649Z"
          fill="#3A2933"
        />
        <path
          d="M321.024 116.821C322.133 117.461 323.559 117.065 324.21 115.937C324.862 114.809 324.492 113.375 323.383 112.735C322.275 112.096 320.849 112.492 320.198 113.62C319.546 114.748 319.916 116.182 321.024 116.821Z"
          fill="#3A2933"
        />
        <path
          d="M315.358 108.102C316.466 108.742 317.892 108.346 318.544 107.217C319.195 106.089 318.825 104.656 317.717 104.016C316.609 103.376 315.182 103.772 314.531 104.9C313.88 106.029 314.25 107.462 315.358 108.102Z"
          fill="#3A2933"
        />
        <path
          d="M310.64 116.274C311.748 116.914 313.174 116.518 313.826 115.389C314.477 114.261 314.107 112.828 312.999 112.188C311.891 111.548 310.464 111.944 309.813 113.073C309.161 114.201 309.532 115.634 310.64 116.274Z"
          fill="#3A2933"
        />
        <path
          d="M316.306 124.994C317.414 125.633 318.841 125.237 319.492 124.109C320.144 122.981 319.773 121.547 318.665 120.908C317.557 120.268 316.131 120.664 315.479 121.792C314.828 122.92 315.198 124.354 316.306 124.994Z"
          fill="#3A2933"
        />
        <path
          d="M305.922 124.446C307.03 125.086 308.456 124.69 309.108 123.561C309.759 122.433 309.389 121 308.281 120.36C307.173 119.72 305.746 120.116 305.095 121.245C304.443 122.373 304.813 123.806 305.922 124.446Z"
          fill="#3A2933"
        />
        <path
          d="M311.588 133.166C312.696 133.805 314.123 133.409 314.774 132.281C315.425 131.153 315.055 129.719 313.947 129.08C312.839 128.44 311.413 128.836 310.761 129.964C310.11 131.093 310.48 132.526 311.588 133.166Z"
          fill="#3A2933"
        />
        <path
          d="M301.203 132.618C302.312 133.258 303.738 132.862 304.389 131.733C305.041 130.605 304.671 129.172 303.563 128.532C302.454 127.892 301.028 128.288 300.377 129.417C299.725 130.545 300.095 131.978 301.203 132.618Z"
          fill="#3A2933"
        />
        <path
          d="M306.87 141.338C307.978 141.977 309.404 141.581 310.056 140.453C310.707 139.325 310.337 137.891 309.229 137.252C308.121 136.612 306.695 137.008 306.043 138.136C305.392 139.265 305.762 140.698 306.87 141.338Z"
          fill="#3A2933"
        />
        <path
          d="M302.152 149.51C303.26 150.15 304.686 149.753 305.338 148.625C305.989 147.497 305.619 146.063 304.511 145.424C303.403 144.784 301.976 145.18 301.325 146.308C300.674 147.437 301.044 148.87 302.152 149.51Z"
          fill="#3A2933"
        />
        <path
          d="M296.485 140.79C297.593 141.43 299.02 141.034 299.671 139.905C300.323 138.777 299.952 137.344 298.844 136.704C297.736 136.064 296.31 136.46 295.658 137.589C295.007 138.717 295.377 140.15 296.485 140.79Z"
          fill="#3A2933"
        />
        <path
          d="M291.767 148.962C292.875 149.602 294.302 149.206 294.953 148.078C295.605 146.949 295.234 145.516 294.126 144.876C293.018 144.236 291.592 144.632 290.94 145.761C290.289 146.889 290.659 148.322 291.767 148.962Z"
          fill="#3A2933"
        />
        <path
          d="M297.434 157.682C298.542 158.322 299.968 157.926 300.62 156.797C301.271 155.669 300.901 154.236 299.793 153.596C298.685 152.956 297.258 153.352 296.607 154.48C295.955 155.609 296.326 157.042 297.434 157.682Z"
          fill="#3A2933"
        />
        <path
          d="M287.049 157.134C288.157 157.774 289.584 157.378 290.235 156.25C290.886 155.121 290.516 153.688 289.408 153.048C288.3 152.408 286.874 152.805 286.222 153.933C285.571 155.061 285.941 156.494 287.049 157.134Z"
          fill="#3A2933"
        />
        <path
          d="M292.716 165.854C293.824 166.494 295.25 166.098 295.901 164.969C296.553 163.841 296.183 162.408 295.075 161.768C293.967 161.128 292.54 161.524 291.889 162.652C291.237 163.781 291.607 165.214 292.716 165.854Z"
          fill="#3A2933"
        />
        <path
          d="M287.997 174.026C289.106 174.666 290.532 174.27 291.183 173.141C291.835 172.013 291.465 170.58 290.356 169.94C289.248 169.3 287.822 169.696 287.171 170.825C286.519 171.953 286.889 173.386 287.997 174.026Z"
          fill="#3A2933"
        />
        <path
          d="M282.331 165.306C283.439 165.946 284.865 165.55 285.517 164.422C286.168 163.293 285.798 161.86 284.69 161.22C283.582 160.581 282.155 160.977 281.504 162.105C280.853 163.233 281.223 164.667 282.331 165.306Z"
          fill="#3A2933"
        />
        <path
          d="M277.613 173.478C278.721 174.118 280.147 173.722 280.799 172.594C281.45 171.465 281.08 170.032 279.972 169.392C278.864 168.753 277.437 169.149 276.786 170.277C276.134 171.405 276.505 172.839 277.613 173.478Z"
          fill="#3A2933"
        />
        <path
          d="M283.279 182.198C284.387 182.838 285.814 182.442 286.465 181.313C287.117 180.185 286.746 178.752 285.638 178.112C284.53 177.472 283.104 177.868 282.452 178.997C281.801 180.125 282.171 181.558 283.279 182.198Z"
          fill="#3A2933"
        />
        <path
          d="M272.895 181.65C274.003 182.29 275.429 181.894 276.081 180.766C276.732 179.637 276.362 178.204 275.254 177.564C274.146 176.925 272.719 177.321 272.068 178.449C271.416 179.577 271.786 181.011 272.895 181.65Z"
          fill="#3A2933"
        />
        <path
          d="M278.561 190.37C279.669 191.01 281.096 190.614 281.747 189.485C282.398 188.357 282.028 186.924 280.92 186.284C279.812 185.644 278.386 186.04 277.734 187.169C277.083 188.297 277.453 189.73 278.561 190.37Z"
          fill="#3A2933"
        />
        <path
          d="M268.176 189.823C269.285 190.462 270.711 190.066 271.362 188.938C272.014 187.81 271.644 186.376 270.536 185.736C269.427 185.097 268.001 185.493 267.35 186.621C266.698 187.749 267.068 189.183 268.176 189.823Z"
          fill="#3A2933"
        />
        <path
          d="M273.843 198.542C274.951 199.182 276.377 198.786 277.029 197.658C277.68 196.529 277.31 195.096 276.202 194.456C275.094 193.816 273.668 194.212 273.016 195.341C272.365 196.469 272.735 197.902 273.843 198.542Z"
          fill="#3A2933"
        />
        <path
          d="M269.125 206.714C270.233 207.354 271.659 206.958 272.311 205.83C272.962 204.701 272.592 203.268 271.484 202.628C270.376 201.988 268.949 202.384 268.298 203.513C267.647 204.641 268.017 206.074 269.125 206.714Z"
          fill="#3A2933"
        />
        <path
          d="M263.458 197.995C264.566 198.634 265.993 198.238 266.644 197.11C267.296 195.982 266.925 194.548 265.817 193.909C264.709 193.269 263.283 193.665 262.631 194.793C261.98 195.921 262.35 197.355 263.458 197.995Z"
          fill="#3A2933"
        />
        <path
          d="M258.74 206.167C259.848 206.806 261.275 206.41 261.926 205.282C262.578 204.154 262.207 202.72 261.099 202.081C259.991 201.441 258.565 201.837 257.913 202.965C257.262 204.094 257.632 205.527 258.74 206.167Z"
          fill="#3A2933"
        />
        <path
          d="M264.407 214.886C265.515 215.526 266.941 215.13 267.593 214.002C268.244 212.873 267.874 211.44 266.766 210.8C265.658 210.16 264.231 210.557 263.58 211.685C262.928 212.813 263.299 214.246 264.407 214.886Z"
          fill="#3A2933"
        />
        <path
          d="M254.022 214.339C255.13 214.978 256.556 214.582 257.208 213.454C257.859 212.326 257.489 210.892 256.381 210.253C255.273 209.613 253.847 210.009 253.195 211.137C252.544 212.266 252.914 213.699 254.022 214.339Z"
          fill="#3A2933"
        />
        <path
          d="M259.689 223.058C260.797 223.698 262.223 223.302 262.874 222.174C263.526 221.045 263.156 219.612 262.048 218.972C260.94 218.333 259.513 218.729 258.862 219.857C258.21 220.985 258.58 222.419 259.689 223.058Z"
          fill="#3A2933"
        />
        <path
          d="M249.304 222.511C250.412 223.151 251.838 222.754 252.49 221.626C253.141 220.498 252.771 219.064 251.663 218.425C250.555 217.785 249.128 218.181 248.477 219.309C247.826 220.438 248.196 221.871 249.304 222.511Z"
          fill="#3A2933"
        />
        <path
          d="M254.97 231.23C256.079 231.87 257.505 231.474 258.156 230.346C258.808 229.217 258.438 227.784 257.329 227.144C256.221 226.505 254.795 226.901 254.144 228.029C253.492 229.157 253.862 230.591 254.97 231.23Z"
          fill="#3A2933"
        />
        <path
          d="M250.252 239.402C251.36 240.042 252.787 239.646 253.438 238.518C254.09 237.39 253.719 235.956 252.611 235.316C251.503 234.677 250.077 235.073 249.425 236.201C248.774 237.329 249.144 238.763 250.252 239.402Z"
          fill="#3A2933"
        />
        <path
          d="M244.586 230.683C245.694 231.323 247.12 230.927 247.772 229.798C248.423 228.67 248.053 227.237 246.945 226.597C245.837 225.957 244.41 226.353 243.759 227.481C243.107 228.61 243.478 230.043 244.586 230.683Z"
          fill="#3A2933"
        />
        <path
          d="M239.868 238.855C240.976 239.495 242.402 239.099 243.054 237.97C243.705 236.842 243.335 235.409 242.227 234.769C241.119 234.129 239.692 234.525 239.041 235.653C238.389 236.782 238.759 238.215 239.868 238.855Z"
          fill="#3A2933"
        />
        <path
          d="M245.534 247.575C246.642 248.214 248.069 247.818 248.72 246.69C249.371 245.562 249.001 244.128 247.893 243.488C246.785 242.849 245.359 243.245 244.707 244.373C244.056 245.501 244.426 246.935 245.534 247.575Z"
          fill="#3A2933"
        />
        <path
          d="M235.149 247.027C236.258 247.667 237.684 247.271 238.335 246.142C238.987 245.014 238.617 243.581 237.509 242.941C236.4 242.301 234.974 242.697 234.323 243.826C233.671 244.954 234.041 246.387 235.149 247.027Z"
          fill="#3A2933"
        />
        <path
          d="M240.816 255.747C241.924 256.386 243.35 255.99 244.002 254.862C244.653 253.734 244.283 252.3 243.175 251.661C242.067 251.021 240.641 251.417 239.989 252.545C239.338 253.674 239.708 255.107 240.816 255.747Z"
          fill="#3A2933"
        />
        <path
          d="M236.098 263.919C237.206 264.558 238.632 264.162 239.284 263.034C239.935 261.906 239.565 260.472 238.457 259.833C237.349 259.193 235.922 259.589 235.271 260.717C234.62 261.846 234.99 263.279 236.098 263.919Z"
          fill="#3A2933"
        />
        <path
          d="M230.431 255.199C231.539 255.839 232.966 255.443 233.617 254.314C234.269 253.186 233.898 251.753 232.79 251.113C231.682 250.473 230.256 250.869 229.604 251.998C228.953 253.126 229.323 254.559 230.431 255.199Z"
          fill="#3A2933"
        />
        <path
          d="M345.564 92.8528C346.672 93.4926 348.098 93.0965 348.749 91.9682C349.401 90.8399 349.031 89.4066 347.923 88.7668C346.814 88.127 345.388 88.5231 344.737 89.6514C344.085 90.7797 344.455 92.2131 345.564 92.8528Z"
          fill="#3A2933"
        />
        <path
          d="M351.23 101.572C352.338 102.212 353.765 101.816 354.416 100.688C355.067 99.5595 354.697 98.1262 353.589 97.4864C352.481 96.8467 351.055 97.2427 350.403 98.371C349.752 99.4994 350.122 100.933 351.23 101.572Z"
          fill="#3A2933"
        />
        <path
          d="M355.948 93.4004C357.056 94.0402 358.483 93.6441 359.134 92.5158C359.786 91.3874 359.415 89.9541 358.307 89.3144C357.199 88.6746 355.773 89.0707 355.121 90.199C354.47 91.3273 354.84 92.7606 355.948 93.4004Z"
          fill="#3A2933"
        />
        <path
          d="M340.845 101.025C341.953 101.665 343.38 101.269 344.031 100.14C344.683 99.012 344.313 97.5786 343.204 96.9389C342.096 96.2991 340.67 96.6952 340.019 97.8235C339.367 98.9518 339.737 100.385 340.845 101.025Z"
          fill="#3A2933"
        />
        <path
          d="M346.512 109.745C347.62 110.384 349.046 109.988 349.698 108.86C350.349 107.732 349.979 106.298 348.871 105.658C347.763 105.019 346.336 105.415 345.685 106.543C345.034 107.671 345.404 109.105 346.512 109.745Z"
          fill="#3A2933"
        />
        <path
          d="M336.127 109.197C337.235 109.837 338.662 109.441 339.313 108.312C339.965 107.184 339.594 105.751 338.486 105.111C337.378 104.471 335.952 104.867 335.3 105.996C334.649 107.124 335.019 108.557 336.127 109.197Z"
          fill="#3A2933"
        />
        <path
          d="M341.794 117.917C342.902 118.556 344.328 118.16 344.98 117.032C345.631 115.904 345.261 114.47 344.153 113.831C343.045 113.191 341.618 113.587 340.967 114.715C340.315 115.844 340.686 117.277 341.794 117.917Z"
          fill="#3A2933"
        />
        <path
          d="M337.076 126.089C338.184 126.728 339.61 126.332 340.262 125.204C340.913 124.076 340.543 122.642 339.435 122.003C338.327 121.363 336.9 121.759 336.249 122.887C335.597 124.016 335.968 125.449 337.076 126.089Z"
          fill="#3A2933"
        />
        <path
          d="M331.409 117.369C332.517 118.009 333.944 117.613 334.595 116.484C335.246 115.356 334.876 113.923 333.768 113.283C332.66 112.643 331.234 113.039 330.582 114.168C329.931 115.296 330.301 116.729 331.409 117.369Z"
          fill="#3A2933"
        />
        <path
          d="M326.691 125.541C327.799 126.181 329.225 125.785 329.877 124.656C330.528 123.528 330.158 122.095 329.05 121.455C327.942 120.815 326.516 121.211 325.864 122.34C325.213 123.468 325.583 124.901 326.691 125.541Z"
          fill="#3A2933"
        />
        <path
          d="M332.357 134.261C333.466 134.9 334.892 134.504 335.543 133.376C336.195 132.248 335.825 130.814 334.717 130.175C333.608 129.535 332.182 129.931 331.531 131.059C330.879 132.188 331.249 133.621 332.357 134.261Z"
          fill="#3A2933"
        />
        <path
          d="M321.973 133.713C323.081 134.353 324.507 133.957 325.159 132.829C325.81 131.7 325.44 130.267 324.332 129.627C323.224 128.987 321.797 129.383 321.146 130.512C320.494 131.64 320.865 133.073 321.973 133.713Z"
          fill="#3A2933"
        />
        <path
          d="M327.639 142.433C328.747 143.073 330.174 142.676 330.825 141.548C331.477 140.42 331.107 138.987 329.998 138.347C328.89 137.707 327.464 138.103 326.812 139.231C326.161 140.36 326.531 141.793 327.639 142.433Z"
          fill="#3A2933"
        />
        <path
          d="M317.255 141.885C318.363 142.525 319.789 142.129 320.441 141.001C321.092 139.872 320.722 138.439 319.614 137.799C318.506 137.159 317.079 137.555 316.428 138.684C315.776 139.812 316.147 141.245 317.255 141.885Z"
          fill="#3A2933"
        />
        <path
          d="M322.921 150.605C324.029 151.245 325.456 150.849 326.107 149.72C326.759 148.592 326.388 147.159 325.28 146.519C324.172 145.879 322.746 146.275 322.094 147.403C321.443 148.532 321.813 149.965 322.921 150.605Z"
          fill="#3A2933"
        />
        <path
          d="M318.203 158.777C319.311 159.417 320.738 159.021 321.389 157.892C322.04 156.764 321.67 155.331 320.562 154.691C319.454 154.051 318.028 154.447 317.376 155.576C316.725 156.704 317.095 158.137 318.203 158.777Z"
          fill="#3A2933"
        />
        <path
          d="M312.537 150.057C313.645 150.697 315.071 150.301 315.722 149.173C316.374 148.044 316.004 146.611 314.896 145.971C313.787 145.331 312.361 145.728 311.71 146.856C311.058 147.984 311.428 149.418 312.537 150.057Z"
          fill="#3A2933"
        />
        <path
          d="M307.818 158.229C308.926 158.869 310.353 158.473 311.004 157.345C311.656 156.216 311.286 154.783 310.177 154.143C309.069 153.504 307.643 153.9 306.992 155.028C306.34 156.156 306.71 157.59 307.818 158.229Z"
          fill="#3A2933"
        />
        <path
          d="M313.485 166.949C314.593 167.589 316.019 167.193 316.671 166.064C317.322 164.936 316.952 163.503 315.844 162.863C314.736 162.223 313.309 162.619 312.658 163.748C312.007 164.876 312.377 166.309 313.485 166.949Z"
          fill="#3A2933"
        />
        <path
          d="M303.1 166.401C304.208 167.041 305.635 166.645 306.286 165.517C306.938 164.388 306.567 162.955 305.459 162.315C304.351 161.676 302.925 162.072 302.273 163.2C301.622 164.328 301.992 165.762 303.1 166.401Z"
          fill="#3A2933"
        />
        <path
          d="M308.767 175.121C309.875 175.761 311.301 175.365 311.953 174.236C312.604 173.108 312.234 171.675 311.126 171.035C310.018 170.395 308.591 170.791 307.94 171.92C307.288 173.048 307.659 174.481 308.767 175.121Z"
          fill="#3A2933"
        />
        <path
          d="M304.049 183.293C305.157 183.933 306.583 183.537 307.235 182.408C307.886 181.28 307.516 179.847 306.408 179.207C305.3 178.567 303.873 178.963 303.222 180.092C302.57 181.22 302.941 182.653 304.049 183.293Z"
          fill="#3A2933"
        />
        <path
          d="M298.382 174.573C299.49 175.213 300.917 174.817 301.568 173.689C302.219 172.561 301.849 171.127 300.741 170.487C299.633 169.848 298.207 170.244 297.555 171.372C296.904 172.5 297.274 173.934 298.382 174.573Z"
          fill="#3A2933"
        />
        <path
          d="M293.664 182.746C294.772 183.385 296.198 182.989 296.85 181.861C297.501 180.733 297.131 179.299 296.023 178.66C294.915 178.02 293.489 178.416 292.837 179.544C292.186 180.672 292.556 182.106 293.664 182.746Z"
          fill="#3A2933"
        />
        <path
          d="M299.33 191.465C300.439 192.105 301.865 191.709 302.516 190.581C303.168 189.452 302.798 188.019 301.69 187.379C300.581 186.739 299.155 187.135 298.504 188.264C297.852 189.392 298.222 190.825 299.33 191.465Z"
          fill="#3A2933"
        />
        <path
          d="M288.946 190.918C290.054 191.557 291.48 191.161 292.132 190.033C292.783 188.905 292.413 187.471 291.305 186.832C290.197 186.192 288.77 186.588 288.119 187.716C287.467 188.845 287.838 190.278 288.946 190.918Z"
          fill="#3A2933"
        />
        <path
          d="M294.612 199.637C295.72 200.277 297.147 199.881 297.798 198.753C298.45 197.624 298.08 196.191 296.971 195.551C295.863 194.911 294.437 195.308 293.785 196.436C293.134 197.564 293.504 198.997 294.612 199.637Z"
          fill="#3A2933"
        />
        <path
          d="M284.228 199.09C285.336 199.729 286.762 199.333 287.414 198.205C288.065 197.077 287.695 195.643 286.587 195.004C285.479 194.364 284.052 194.76 283.401 195.888C282.749 197.017 283.12 198.45 284.228 199.09Z"
          fill="#3A2933"
        />
        <path
          d="M289.894 207.809C291.002 208.449 292.429 208.053 293.08 206.925C293.732 205.796 293.361 204.363 292.253 203.723C291.145 203.084 289.719 203.48 289.067 204.608C288.416 205.736 288.786 207.17 289.894 207.809Z"
          fill="#3A2933"
        />
        <path
          d="M285.176 215.981C286.284 216.621 287.711 216.225 288.362 215.097C289.013 213.968 288.643 212.535 287.535 211.895C286.427 211.256 285.001 211.652 284.349 212.78C283.698 213.908 284.068 215.342 285.176 215.981Z"
          fill="#3A2933"
        />
        <path
          d="M279.51 207.262C280.618 207.902 282.044 207.505 282.695 206.377C283.347 205.249 282.977 203.815 281.869 203.176C280.76 202.536 279.334 202.932 278.683 204.06C278.031 205.189 278.401 206.622 279.51 207.262Z"
          fill="#3A2933"
        />
        <path
          d="M274.791 215.434C275.899 216.074 277.326 215.678 277.977 214.549C278.629 213.421 278.259 211.988 277.15 211.348C276.042 210.708 274.616 211.104 273.964 212.232C273.313 213.361 273.683 214.794 274.791 215.434Z"
          fill="#3A2933"
        />
        <path
          d="M280.458 224.153C281.566 224.793 282.992 224.397 283.644 223.269C284.295 222.14 283.925 220.707 282.817 220.067C281.709 219.428 280.282 219.824 279.631 220.952C278.98 222.08 279.35 223.514 280.458 224.153Z"
          fill="#3A2933"
        />
        <path
          d="M270.073 223.606C271.181 224.246 272.608 223.85 273.259 222.721C273.911 221.593 273.54 220.16 272.432 219.52C271.324 218.88 269.898 219.276 269.246 220.404C268.595 221.533 268.965 222.966 270.073 223.606Z"
          fill="#3A2933"
        />
        <path
          d="M275.74 232.325C276.848 232.965 278.274 232.569 278.926 231.441C279.577 230.313 279.207 228.879 278.099 228.239C276.991 227.6 275.564 227.996 274.913 229.124C274.261 230.252 274.632 231.686 275.74 232.325Z"
          fill="#3A2933"
        />
        <path
          d="M265.355 231.778C266.463 232.418 267.89 232.022 268.541 230.893C269.192 229.765 268.822 228.332 267.714 227.692C266.606 227.052 265.18 227.448 264.528 228.577C263.877 229.705 264.247 231.138 265.355 231.778Z"
          fill="#3A2933"
        />
        <path
          d="M271.022 240.498C272.13 241.137 273.556 240.741 274.208 239.613C274.859 238.485 274.489 237.051 273.381 236.412C272.273 235.772 270.846 236.168 270.195 237.296C269.543 238.424 269.914 239.858 271.022 240.498Z"
          fill="#3A2933"
        />
        <path
          d="M266.303 248.67C267.412 249.309 268.838 248.913 269.489 247.785C270.141 246.657 269.771 245.223 268.663 244.584C267.554 243.944 266.128 244.34 265.477 245.468C264.825 246.597 265.195 248.03 266.303 248.67Z"
          fill="#3A2933"
        />
        <path
          d="M260.637 239.95C261.745 240.59 263.171 240.194 263.823 239.065C264.474 237.937 264.104 236.504 262.996 235.864C261.888 235.224 260.462 235.62 259.81 236.749C259.159 237.877 259.529 239.31 260.637 239.95Z"
          fill="#3A2933"
        />
        <path
          d="M255.919 248.122C257.027 248.762 258.453 248.366 259.105 247.237C259.756 246.109 259.386 244.676 258.278 244.036C257.17 243.396 255.743 243.792 255.092 244.921C254.44 246.049 254.811 247.482 255.919 248.122Z"
          fill="#3A2933"
        />
        <path
          d="M261.585 256.842C262.693 257.481 264.12 257.085 264.771 255.957C265.423 254.829 265.053 253.395 263.944 252.756C262.836 252.116 261.41 252.512 260.758 253.64C260.107 254.769 260.477 256.202 261.585 256.842Z"
          fill="#3A2933"
        />
        <path
          d="M251.201 256.294C252.309 256.934 253.735 256.538 254.387 255.41C255.038 254.281 254.668 252.848 253.56 252.208C252.452 251.568 251.025 251.964 250.374 253.093C249.722 254.221 250.093 255.654 251.201 256.294Z"
          fill="#3A2933"
        />
        <path
          d="M256.867 265.014C257.975 265.654 259.402 265.257 260.053 264.129C260.705 263.001 260.334 261.567 259.226 260.928C258.118 260.288 256.692 260.684 256.04 261.812C255.389 262.941 255.759 264.374 256.867 265.014Z"
          fill="#3A2933"
        />
        <path
          d="M252.149 273.186C253.257 273.826 254.684 273.43 255.335 272.301C255.986 271.173 255.616 269.74 254.508 269.1C253.4 268.46 251.974 268.856 251.322 269.984C250.671 271.113 251.041 272.546 252.149 273.186Z"
          fill="#3A2933"
        />
        <path
          d="M246.482 264.466C247.591 265.106 249.017 264.71 249.668 263.582C250.32 262.453 249.95 261.02 248.842 260.38C247.733 259.74 246.307 260.136 245.656 261.265C245.004 262.393 245.374 263.826 246.482 264.466Z"
          fill="#3A2933"
        />
        <path
          d="M361.615 102.12C362.723 102.76 364.149 102.364 364.801 101.235C365.452 100.107 365.082 98.6738 363.974 98.034C362.866 97.3942 361.439 97.7903 360.788 98.9186C360.136 100.047 360.507 101.48 361.615 102.12Z"
          fill="#3A2933"
        />
        <path
          d="M356.897 110.292C358.005 110.932 359.431 110.536 360.083 109.407C360.734 108.279 360.364 106.846 359.256 106.206C358.148 105.566 356.721 105.962 356.07 107.091C355.418 108.219 355.789 109.652 356.897 110.292Z"
          fill="#3A2933"
        />
        <path
          d="M352.178 118.464C353.287 119.104 354.713 118.708 355.364 117.58C356.016 116.451 355.646 115.018 354.538 114.378C353.429 113.738 352.003 114.134 351.352 115.263C350.7 116.391 351.07 117.824 352.178 118.464Z"
          fill="#3A2933"
        />
        <path
          d="M347.46 126.636C348.568 127.276 349.995 126.88 350.646 125.752C351.298 124.623 350.928 123.19 349.819 122.55C348.711 121.91 347.285 122.306 346.633 123.435C345.982 124.563 346.352 125.996 347.46 126.636Z"
          fill="#3A2933"
        />
        <path
          d="M342.742 134.808C343.85 135.448 345.277 135.052 345.928 133.924C346.58 132.795 346.209 131.362 345.101 130.722C343.993 130.082 342.567 130.479 341.915 131.607C341.264 132.735 341.634 134.169 342.742 134.808Z"
          fill="#3A2933"
        />
        <path
          d="M338.024 142.98C339.132 143.62 340.559 143.224 341.21 142.096C341.861 140.967 341.491 139.534 340.383 138.894C339.275 138.255 337.849 138.651 337.197 139.779C336.546 140.907 336.916 142.341 338.024 142.98Z"
          fill="#3A2933"
        />
        <path
          d="M333.306 151.152C334.414 151.792 335.84 151.396 336.492 150.268C337.143 149.139 336.773 147.706 335.665 147.066C334.557 146.427 333.13 146.823 332.479 147.951C331.828 149.079 332.198 150.513 333.306 151.152Z"
          fill="#3A2933"
        />
        <path
          d="M328.588 159.324C329.696 159.964 331.122 159.568 331.774 158.44C332.425 157.312 332.055 155.878 330.947 155.238C329.839 154.599 328.412 154.995 327.761 156.123C327.109 157.251 327.48 158.685 328.588 159.324Z"
          fill="#3A2933"
        />
        <path
          d="M323.87 167.497C324.978 168.136 326.404 167.74 327.056 166.612C327.707 165.484 327.337 164.05 326.229 163.411C325.121 162.771 323.694 163.167 323.043 164.295C322.391 165.423 322.762 166.857 323.87 167.497Z"
          fill="#3A2933"
        />
        <path
          d="M319.151 175.669C320.26 176.308 321.686 175.912 322.337 174.784C322.989 173.656 322.619 172.222 321.511 171.583C320.402 170.943 318.976 171.339 318.325 172.467C317.673 173.596 318.043 175.029 319.151 175.669Z"
          fill="#3A2933"
        />
        <path
          d="M314.433 183.841C315.541 184.48 316.968 184.084 317.619 182.956C318.271 181.828 317.9 180.394 316.792 179.755C315.684 179.115 314.258 179.511 313.606 180.639C312.955 181.768 313.325 183.201 314.433 183.841Z"
          fill="#3A2933"
        />
        <path
          d="M309.715 192.013C310.823 192.653 312.25 192.256 312.901 191.128C313.553 190 313.182 188.566 312.074 187.927C310.966 187.287 309.54 187.683 308.888 188.811C308.237 189.94 308.607 191.373 309.715 192.013Z"
          fill="#3A2933"
        />
        <path
          d="M304.997 200.185C306.105 200.825 307.532 200.429 308.183 199.3C308.834 198.172 308.464 196.739 307.356 196.099C306.248 195.459 304.822 195.855 304.17 196.983C303.519 198.112 303.889 199.545 304.997 200.185Z"
          fill="#3A2933"
        />
        <path
          d="M300.279 208.357C301.387 208.997 302.813 208.601 303.465 207.472C304.116 206.344 303.746 204.911 302.638 204.271C301.53 203.631 300.103 204.027 299.452 205.155C298.801 206.284 299.171 207.717 300.279 208.357Z"
          fill="#3A2933"
        />
        <path
          d="M295.561 216.529C296.669 217.169 298.095 216.773 298.747 215.644C299.398 214.516 299.028 213.083 297.92 212.443C296.812 211.803 295.385 212.199 294.734 213.328C294.082 214.456 294.453 215.889 295.561 216.529Z"
          fill="#3A2933"
        />
        <path
          d="M290.843 224.701C291.951 225.341 293.377 224.945 294.029 223.816C294.68 222.688 294.31 221.255 293.202 220.615C292.094 219.975 290.667 220.371 290.016 221.5C289.364 222.628 289.734 224.061 290.843 224.701Z"
          fill="#3A2933"
        />
        <path
          d="M286.124 232.873C287.233 233.513 288.659 233.117 289.31 231.988C289.962 230.86 289.592 229.427 288.484 228.787C287.375 228.147 285.949 228.543 285.298 229.672C284.646 230.8 285.016 232.233 286.124 232.873Z"
          fill="#3A2933"
        />
        <path
          d="M281.406 241.045C282.514 241.685 283.941 241.289 284.592 240.161C285.244 239.032 284.874 237.599 283.765 236.959C282.657 236.319 281.231 236.715 280.579 237.844C279.928 238.972 280.298 240.405 281.406 241.045Z"
          fill="#3A2933"
        />
        <path
          d="M276.688 249.217C277.796 249.857 279.223 249.461 279.874 248.333C280.526 247.204 280.155 245.771 279.047 245.131C277.939 244.491 276.513 244.887 275.861 246.016C275.21 247.144 275.58 248.577 276.688 249.217Z"
          fill="#3A2933"
        />
        <path
          d="M271.97 257.389C273.078 258.029 274.505 257.633 275.156 256.505C275.807 255.376 275.437 253.943 274.329 253.303C273.221 252.663 271.795 253.06 271.143 254.188C270.492 255.316 270.862 256.749 271.97 257.389Z"
          fill="#3A2933"
        />
        <path
          d="M267.252 265.561C268.36 266.201 269.786 265.805 270.438 264.677C271.089 263.548 270.719 262.115 269.611 261.475C268.503 260.836 267.076 261.232 266.425 262.36C265.774 263.488 266.144 264.922 267.252 265.561Z"
          fill="#3A2933"
        />
        <path
          d="M262.534 273.733C263.642 274.373 265.068 273.977 265.72 272.849C266.371 271.72 266.001 270.287 264.893 269.647C263.785 269.008 262.358 269.404 261.707 270.532C261.055 271.66 261.426 273.094 262.534 273.733Z"
          fill="#3A2933"
        />
        <path
          d="M367.281 110.84C368.389 111.479 369.816 111.083 370.467 109.955C371.119 108.827 370.748 107.393 369.64 106.754C368.532 106.114 367.106 106.51 366.454 107.638C365.803 108.767 366.173 110.2 367.281 110.84Z"
          fill="#3A2933"
        />
        <path
          d="M371.999 102.668C373.108 103.307 374.534 102.911 375.185 101.783C375.837 100.655 375.467 99.2213 374.359 98.5815C373.25 97.9418 371.824 98.3378 371.173 99.4662C370.521 100.594 370.891 102.028 371.999 102.668Z"
          fill="#3A2933"
        />
        <path
          d="M362.563 119.012C363.671 119.651 365.098 119.255 365.749 118.127C366.401 116.999 366.03 115.565 364.922 114.926C363.814 114.286 362.388 114.682 361.736 115.81C361.085 116.939 361.455 118.372 362.563 119.012Z"
          fill="#3A2933"
        />
        <path
          d="M357.845 127.184C358.953 127.824 360.38 127.427 361.031 126.299C361.682 125.171 361.312 123.737 360.204 123.098C359.096 122.458 357.67 122.854 357.018 123.982C356.367 125.111 356.737 126.544 357.845 127.184Z"
          fill="#3A2933"
        />
        <path
          d="M353.127 135.356C354.235 135.996 355.661 135.6 356.313 134.471C356.964 133.343 356.594 131.91 355.486 131.27C354.378 130.63 352.951 131.026 352.3 132.154C351.649 133.283 352.019 134.716 353.127 135.356Z"
          fill="#3A2933"
        />
        <path
          d="M348.409 143.528C349.517 144.168 350.943 143.772 351.595 142.643C352.246 141.515 351.876 140.082 350.768 139.442C349.66 138.802 348.233 139.198 347.582 140.326C346.93 141.455 347.301 142.888 348.409 143.528Z"
          fill="#3A2933"
        />
        <path
          d="M343.691 151.7C344.799 152.34 346.225 151.944 346.877 150.815C347.528 149.687 347.158 148.254 346.05 147.614C344.942 146.974 343.515 147.37 342.864 148.499C342.212 149.627 342.582 151.06 343.691 151.7Z"
          fill="#3A2933"
        />
        <path
          d="M338.972 159.872C340.081 160.512 341.507 160.116 342.158 158.987C342.81 157.859 342.44 156.426 341.331 155.786C340.223 155.146 338.797 155.542 338.146 156.671C337.494 157.799 337.864 159.232 338.972 159.872Z"
          fill="#3A2933"
        />
        <path
          d="M334.254 168.044C335.362 168.684 336.789 168.288 337.44 167.159C338.092 166.031 337.721 164.598 336.613 163.958C335.505 163.318 334.079 163.714 333.427 164.843C332.776 165.971 333.146 167.404 334.254 168.044Z"
          fill="#3A2933"
        />
        <path
          d="M329.536 176.216C330.644 176.856 332.071 176.46 332.722 175.332C333.374 174.203 333.003 172.77 331.895 172.13C330.787 171.49 329.361 171.886 328.709 173.015C328.058 174.143 328.428 175.576 329.536 176.216Z"
          fill="#3A2933"
        />
        <path
          d="M324.818 184.388C325.926 185.028 327.353 184.632 328.004 183.504C328.655 182.375 328.285 180.942 327.177 180.302C326.069 179.662 324.643 180.058 323.991 181.187C323.34 182.315 323.71 183.748 324.818 184.388Z"
          fill="#3A2933"
        />
        <path
          d="M320.1 192.56C321.208 193.2 322.634 192.804 323.286 191.676C323.937 190.547 323.567 189.114 322.459 188.474C321.351 187.834 319.924 188.231 319.273 189.359C318.622 190.487 318.992 191.921 320.1 192.56Z"
          fill="#3A2933"
        />
        <path
          d="M315.382 200.732C316.49 201.372 317.916 200.976 318.568 199.848C319.219 198.719 318.849 197.286 317.741 196.646C316.633 196.007 315.206 196.403 314.555 197.531C313.903 198.659 314.274 200.093 315.382 200.732Z"
          fill="#3A2933"
        />
        <path
          d="M310.664 208.904C311.772 209.544 313.198 209.148 313.85 208.02C314.501 206.891 314.131 205.458 313.023 204.818C311.915 204.179 310.488 204.575 309.837 205.703C309.185 206.831 309.555 208.265 310.664 208.904Z"
          fill="#3A2933"
        />
        <path
          d="M305.945 217.076C307.054 217.716 308.48 217.32 309.131 216.192C309.783 215.064 309.413 213.63 308.304 212.99C307.196 212.351 305.77 212.747 305.119 213.875C304.467 215.003 304.837 216.437 305.945 217.076Z"
          fill="#3A2933"
        />
        <path
          d="M301.227 225.249C302.335 225.888 303.762 225.492 304.413 224.364C305.065 223.236 304.694 221.802 303.586 221.163C302.478 220.523 301.052 220.919 300.4 222.047C299.749 223.175 300.119 224.609 301.227 225.249Z"
          fill="#3A2933"
        />
        <path
          d="M296.509 233.421C297.617 234.06 299.044 233.664 299.695 232.536C300.347 231.408 299.976 229.974 298.868 229.335C297.76 228.695 296.334 229.091 295.682 230.219C295.031 231.348 295.401 232.781 296.509 233.421Z"
          fill="#3A2933"
        />
        <path
          d="M291.791 241.593C292.899 242.232 294.325 241.836 294.977 240.708C295.628 239.58 295.258 238.146 294.15 237.507C293.042 236.867 291.616 237.263 290.964 238.391C290.313 239.52 290.683 240.953 291.791 241.593Z"
          fill="#3A2933"
        />
        <path
          d="M287.073 249.765C288.181 250.405 289.607 250.008 290.259 248.88C290.91 247.752 290.54 246.318 289.432 245.679C288.324 245.039 286.897 245.435 286.246 246.563C285.595 247.692 285.965 249.125 287.073 249.765Z"
          fill="#3A2933"
        />
        <path
          d="M282.355 257.937C283.463 258.577 284.889 258.181 285.541 257.052C286.192 255.924 285.822 254.491 284.714 253.851C283.606 253.211 282.179 253.607 281.528 254.735C280.876 255.864 281.247 257.297 282.355 257.937Z"
          fill="#3A2933"
        />
        <path
          d="M277.637 266.109C278.745 266.749 280.171 266.353 280.823 265.224C281.474 264.096 281.104 262.663 279.996 262.023C278.888 261.383 277.461 261.779 276.81 262.907C276.158 264.036 276.528 265.469 277.637 266.109Z"
          fill="#3A2933"
        />
        <path
          d="M272.918 274.281C274.027 274.921 275.453 274.525 276.104 273.396C276.756 272.268 276.386 270.835 275.277 270.195C274.169 269.555 272.743 269.951 272.092 271.08C271.44 272.208 271.81 273.641 272.918 274.281Z"
          fill="#3A2933"
        />
        <path
          d="M268.2 282.453C269.308 283.093 270.735 282.697 271.386 281.568C272.038 280.44 271.667 279.007 270.559 278.367C269.451 277.727 268.025 278.123 267.373 279.252C266.722 280.38 267.092 281.813 268.2 282.453Z"
          fill="#3A2933"
        />
        <path
          d="M377.666 111.387C378.774 112.027 380.2 111.631 380.852 110.503C381.503 109.374 381.133 107.941 380.025 107.301C378.917 106.661 377.491 107.057 376.839 108.186C376.188 109.314 376.558 110.747 377.666 111.387Z"
          fill="#3A2933"
        />
        <path
          d="M383.333 120.107C384.441 120.747 385.867 120.351 386.518 119.222C387.17 118.094 386.8 116.661 385.692 116.021C384.583 115.381 383.157 115.777 382.506 116.905C381.854 118.034 382.224 119.467 383.333 120.107Z"
          fill="#3A2933"
        />
        <path
          d="M388.051 111.935C389.159 112.575 390.585 112.178 391.237 111.05C391.888 109.922 391.518 108.488 390.41 107.849C389.302 107.209 387.875 107.605 387.224 108.733C386.572 109.862 386.943 111.295 388.051 111.935Z"
          fill="#3A2933"
        />
        <path
          d="M372.948 119.559C374.056 120.199 375.482 119.803 376.134 118.675C376.785 117.546 376.415 116.113 375.307 115.473C374.199 114.833 372.772 115.23 372.121 116.358C371.47 117.486 371.84 118.919 372.948 119.559Z"
          fill="#3A2933"
        />
        <path
          d="M378.614 128.279C379.722 128.919 381.149 128.523 381.8 127.394C382.452 126.266 382.082 124.833 380.973 124.193C379.865 123.553 378.439 123.949 377.788 125.077C377.136 126.206 377.506 127.639 378.614 128.279Z"
          fill="#3A2933"
        />
        <path
          d="M368.23 127.731C369.338 128.371 370.764 127.975 371.416 126.847C372.067 125.718 371.697 124.285 370.589 123.645C369.481 123.006 368.054 123.402 367.403 124.53C366.751 125.658 367.122 127.092 368.23 127.731Z"
          fill="#3A2933"
        />
        <path
          d="M373.896 136.451C375.004 137.091 376.431 136.695 377.082 135.566C377.734 134.438 377.363 133.005 376.255 132.365C375.147 131.725 373.721 132.121 373.069 133.25C372.418 134.378 372.788 135.811 373.896 136.451Z"
          fill="#3A2933"
        />
        <path
          d="M369.178 144.623C370.286 145.263 371.713 144.867 372.364 143.738C373.015 142.61 372.645 141.177 371.537 140.537C370.429 139.897 369.003 140.293 368.351 141.422C367.7 142.55 368.07 143.983 369.178 144.623Z"
          fill="#3A2933"
        />
        <path
          d="M363.512 135.903C364.62 136.543 366.046 136.147 366.697 135.019C367.349 133.89 366.979 132.457 365.871 131.817C364.763 131.178 363.336 131.574 362.685 132.702C362.033 133.83 362.403 135.264 363.512 135.903Z"
          fill="#3A2933"
        />
        <path
          d="M358.793 144.075C359.902 144.715 361.328 144.319 361.979 143.191C362.631 142.063 362.261 140.629 361.152 139.989C360.044 139.35 358.618 139.746 357.967 140.874C357.315 142.002 357.685 143.436 358.793 144.075Z"
          fill="#3A2933"
        />
        <path
          d="M364.46 152.795C365.568 153.435 366.994 153.039 367.646 151.91C368.297 150.782 367.927 149.349 366.819 148.709C365.711 148.069 364.285 148.465 363.633 149.594C362.982 150.722 363.352 152.155 364.46 152.795Z"
          fill="#3A2933"
        />
        <path
          d="M354.075 152.248C355.183 152.887 356.61 152.491 357.261 151.363C357.913 150.235 357.542 148.801 356.434 148.161C355.326 147.522 353.9 147.918 353.248 149.046C352.597 150.174 352.967 151.608 354.075 152.248Z"
          fill="#3A2933"
        />
        <path
          d="M359.742 160.967C360.85 161.607 362.276 161.211 362.928 160.083C363.579 158.954 363.209 157.521 362.101 156.881C360.993 156.241 359.566 156.637 358.915 157.766C358.263 158.894 358.634 160.327 359.742 160.967Z"
          fill="#3A2933"
        />
        <path
          d="M349.357 160.42C350.465 161.059 351.892 160.663 352.543 159.535C353.194 158.407 352.824 156.973 351.716 156.334C350.608 155.694 349.182 156.09 348.53 157.218C347.879 158.347 348.249 159.78 349.357 160.42Z"
          fill="#3A2933"
        />
        <path
          d="M355.024 169.139C356.132 169.779 357.558 169.383 358.21 168.255C358.861 167.126 358.491 165.693 357.383 165.053C356.275 164.413 354.848 164.809 354.197 165.938C353.545 167.066 353.916 168.499 355.024 169.139Z"
          fill="#3A2933"
        />
        <path
          d="M350.306 177.311C351.414 177.951 352.84 177.555 353.491 176.427C354.143 175.298 353.773 173.865 352.665 173.225C351.556 172.585 350.13 172.982 349.479 174.11C348.827 175.238 349.197 176.672 350.306 177.311Z"
          fill="#3A2933"
        />
        <path
          d="M344.639 168.592C345.747 169.231 347.173 168.835 347.825 167.707C348.476 166.579 348.106 165.145 346.998 164.506C345.89 163.866 344.464 164.262 343.812 165.39C343.161 166.519 343.531 167.952 344.639 168.592Z"
          fill="#3A2933"
        />
        <path
          d="M339.921 176.764C341.029 177.403 342.455 177.007 343.107 175.879C343.758 174.751 343.388 173.317 342.28 172.678C341.172 172.038 339.745 172.434 339.094 173.562C338.443 174.691 338.813 176.124 339.921 176.764Z"
          fill="#3A2933"
        />
        <path
          d="M345.587 185.483C346.695 186.123 348.122 185.727 348.773 184.599C349.425 183.47 349.055 182.037 347.946 181.397C346.838 180.758 345.412 181.154 344.761 182.282C344.109 183.41 344.479 184.844 345.587 185.483Z"
          fill="#3A2933"
        />
        <path
          d="M335.203 184.936C336.311 185.576 337.737 185.179 338.389 184.051C339.04 182.923 338.67 181.49 337.562 180.85C336.454 180.21 335.027 180.606 334.376 181.734C333.724 182.863 334.095 184.296 335.203 184.936Z"
          fill="#3A2933"
        />
        <path
          d="M340.869 193.655C341.977 194.295 343.404 193.899 344.055 192.771C344.707 191.642 344.336 190.209 343.228 189.569C342.12 188.93 340.694 189.326 340.042 190.454C339.391 191.582 339.761 193.016 340.869 193.655Z"
          fill="#3A2933"
        />
        <path
          d="M336.151 201.827C337.259 202.467 338.686 202.071 339.337 200.943C339.988 199.815 339.618 198.381 338.51 197.741C337.402 197.102 335.976 197.498 335.324 198.626C334.673 199.754 335.043 201.188 336.151 201.827Z"
          fill="#3A2933"
        />
        <path
          d="M330.485 193.108C331.593 193.748 333.019 193.352 333.67 192.223C334.322 191.095 333.952 189.662 332.844 189.022C331.736 188.382 330.309 188.778 329.658 189.906C329.006 191.035 329.376 192.468 330.485 193.108Z"
          fill="#3A2933"
        />
        <path
          d="M325.766 201.28C326.875 201.92 328.301 201.524 328.952 200.395C329.604 199.267 329.234 197.834 328.125 197.194C327.017 196.554 325.591 196.95 324.94 198.079C324.288 199.207 324.658 200.64 325.766 201.28Z"
          fill="#3A2933"
        />
        <path
          d="M331.433 210C332.541 210.639 333.967 210.243 334.619 209.115C335.27 207.987 334.9 206.553 333.792 205.914C332.684 205.274 331.258 205.67 330.606 206.798C329.955 207.926 330.325 209.36 331.433 210Z"
          fill="#3A2933"
        />
        <path
          d="M321.048 209.452C322.156 210.092 323.583 209.696 324.234 208.567C324.886 207.439 324.515 206.006 323.407 205.366C322.299 204.726 320.873 205.122 320.221 206.251C319.57 207.379 319.94 208.812 321.048 209.452Z"
          fill="#3A2933"
        />
        <path
          d="M326.715 218.172C327.823 218.811 329.249 218.415 329.901 217.287C330.552 216.159 330.182 214.725 329.074 214.086C327.966 213.446 326.539 213.842 325.888 214.97C325.236 216.099 325.607 217.532 326.715 218.172Z"
          fill="#3A2933"
        />
        <path
          d="M316.33 217.624C317.438 218.264 318.865 217.868 319.516 216.739C320.167 215.611 319.797 214.178 318.689 213.538C317.581 212.898 316.155 213.294 315.503 214.423C314.852 215.551 315.222 216.984 316.33 217.624Z"
          fill="#3A2933"
        />
        <path
          d="M321.997 226.344C323.105 226.983 324.531 226.587 325.183 225.459C325.834 224.331 325.464 222.897 324.356 222.258C323.248 221.618 321.821 222.014 321.17 223.142C320.518 224.271 320.889 225.704 321.997 226.344Z"
          fill="#3A2933"
        />
        <path
          d="M317.279 234.516C318.387 235.155 319.813 234.759 320.464 233.631C321.116 232.503 320.746 231.069 319.638 230.43C318.529 229.79 317.103 230.186 316.452 231.314C315.8 232.443 316.17 233.876 317.279 234.516Z"
          fill="#3A2933"
        />
        <path
          d="M311.612 225.796C312.72 226.436 314.146 226.04 314.798 224.911C315.449 223.783 315.079 222.35 313.971 221.71C312.863 221.07 311.437 221.466 310.785 222.595C310.134 223.723 310.504 225.156 311.612 225.796Z"
          fill="#3A2933"
        />
        <path
          d="M306.894 233.968C308.002 234.608 309.428 234.212 310.08 233.084C310.731 231.955 310.361 230.522 309.253 229.882C308.145 229.242 306.718 229.638 306.067 230.767C305.416 231.895 305.786 233.328 306.894 233.968Z"
          fill="#3A2933"
        />
        <path
          d="M312.56 242.688C313.668 243.328 315.095 242.932 315.746 241.803C316.398 240.675 316.028 239.242 314.919 238.602C313.811 237.962 312.385 238.358 311.734 239.486C311.082 240.615 311.452 242.048 312.56 242.688Z"
          fill="#3A2933"
        />
        <path
          d="M302.176 242.14C303.284 242.78 304.71 242.384 305.362 241.256C306.013 240.127 305.643 238.694 304.535 238.054C303.427 237.414 302 237.811 301.349 238.939C300.697 240.067 301.068 241.5 302.176 242.14Z"
          fill="#3A2933"
        />
        <path
          d="M307.842 250.86C308.95 251.5 310.377 251.104 311.028 249.975C311.68 248.847 311.309 247.414 310.201 246.774C309.093 246.134 307.667 246.53 307.015 247.658C306.364 248.787 306.734 250.22 307.842 250.86Z"
          fill="#3A2933"
        />
        <path
          d="M297.458 250.312C298.566 250.952 299.992 250.556 300.643 249.428C301.295 248.299 300.925 246.866 299.817 246.226C298.709 245.586 297.282 245.983 296.631 247.111C295.979 248.239 296.349 249.673 297.458 250.312Z"
          fill="#3A2933"
        />
        <path
          d="M303.124 259.032C304.232 259.672 305.659 259.276 306.31 258.147C306.961 257.019 306.591 255.586 305.483 254.946C304.375 254.306 302.949 254.702 302.297 255.831C301.646 256.959 302.016 258.392 303.124 259.032Z"
          fill="#3A2933"
        />
        <path
          d="M298.406 267.204C299.514 267.844 300.94 267.448 301.592 266.319C302.243 265.191 301.873 263.758 300.765 263.118C299.657 262.478 298.231 262.874 297.579 264.003C296.928 265.131 297.298 266.564 298.406 267.204Z"
          fill="#3A2933"
        />
        <path
          d="M292.739 258.484C293.847 259.124 295.274 258.728 295.925 257.6C296.577 256.471 296.207 255.038 295.098 254.398C293.99 253.759 292.564 254.155 291.913 255.283C291.261 256.411 291.631 257.845 292.739 258.484Z"
          fill="#3A2933"
        />
        <path
          d="M288.021 266.656C289.129 267.296 290.556 266.9 291.207 265.772C291.859 264.643 291.488 263.21 290.38 262.57C289.272 261.931 287.846 262.327 287.194 263.455C286.543 264.583 286.913 266.017 288.021 266.656Z"
          fill="#3A2933"
        />
        <path
          d="M293.688 275.376C294.796 276.016 296.222 275.62 296.874 274.491C297.525 273.363 297.155 271.93 296.047 271.29C294.939 270.65 293.512 271.046 292.861 272.175C292.209 273.303 292.58 274.736 293.688 275.376Z"
          fill="#3A2933"
        />
        <path
          d="M283.303 274.829C284.411 275.468 285.838 275.072 286.489 273.944C287.14 272.816 286.77 271.382 285.662 270.742C284.554 270.103 283.128 270.499 282.476 271.627C281.825 272.755 282.195 274.189 283.303 274.829Z"
          fill="#3A2933"
        />
        <path
          d="M288.97 283.548C290.078 284.188 291.504 283.792 292.156 282.664C292.807 281.535 292.437 280.102 291.329 279.462C290.221 278.822 288.794 279.218 288.143 280.347C287.491 281.475 287.862 282.908 288.97 283.548Z"
          fill="#3A2933"
        />
        <path
          d="M284.252 291.72C285.36 292.36 286.786 291.964 287.437 290.836C288.089 289.707 287.719 288.274 286.611 287.634C285.502 286.994 284.076 287.39 283.425 288.519C282.773 289.647 283.143 291.08 284.252 291.72Z"
          fill="#3A2933"
        />
        <path
          d="M278.585 283.001C279.693 283.64 281.119 283.244 281.771 282.116C282.422 280.988 282.052 279.554 280.944 278.915C279.836 278.275 278.41 278.671 277.758 279.799C277.107 280.927 277.477 282.361 278.585 283.001Z"
          fill="#3A2933"
        />
        <path
          d="M393.717 120.654C394.825 121.294 396.252 120.898 396.903 119.77C397.555 118.641 397.184 117.208 396.076 116.568C394.968 115.929 393.542 116.325 392.89 117.453C392.239 118.581 392.609 120.015 393.717 120.654Z"
          fill="#3A2933"
        />
        <path
          d="M399.384 129.374C400.492 130.014 401.918 129.618 402.57 128.489C403.221 127.361 402.851 125.928 401.743 125.288C400.635 124.648 399.208 125.044 398.557 126.173C397.905 127.301 398.276 128.734 399.384 129.374Z"
          fill="#3A2933"
        />
        <path
          d="M404.102 121.202C405.21 121.842 406.636 121.446 407.288 120.317C407.939 119.189 407.569 117.756 406.461 117.116C405.353 116.476 403.926 116.872 403.275 118.001C402.624 119.129 402.994 120.562 404.102 121.202Z"
          fill="#3A2933"
        />
        <path
          d="M388.999 128.826C390.107 129.466 391.534 129.07 392.185 127.942C392.836 126.813 392.466 125.38 391.358 124.74C390.25 124.101 388.824 124.497 388.172 125.625C387.521 126.753 387.891 128.187 388.999 128.826Z"
          fill="#3A2933"
        />
        <path
          d="M394.666 137.546C395.774 138.186 397.2 137.79 397.852 136.661C398.503 135.533 398.133 134.1 397.025 133.46C395.917 132.82 394.49 133.216 393.839 134.345C393.187 135.473 393.557 136.906 394.666 137.546Z"
          fill="#3A2933"
        />
        <path
          d="M384.281 136.999C385.389 137.638 386.815 137.242 387.467 136.114C388.118 134.986 387.748 133.552 386.64 132.912C385.532 132.273 384.105 132.669 383.454 133.797C382.803 134.925 383.173 136.359 384.281 136.999Z"
          fill="#3A2933"
        />
        <path
          d="M389.947 145.718C391.056 146.358 392.482 145.962 393.133 144.834C393.785 143.705 393.415 142.272 392.307 141.632C391.198 140.992 389.772 141.388 389.121 142.517C388.469 143.645 388.839 145.078 389.947 145.718Z"
          fill="#3A2933"
        />
        <path
          d="M385.229 153.89C386.337 154.53 387.764 154.134 388.415 153.006C389.067 151.877 388.696 150.444 387.588 149.804C386.48 149.164 385.054 149.56 384.402 150.689C383.751 151.817 384.121 153.25 385.229 153.89Z"
          fill="#3A2933"
        />
        <path
          d="M379.563 145.171C380.671 145.81 382.097 145.414 382.749 144.286C383.4 143.158 383.03 141.724 381.922 141.085C380.814 140.445 379.387 140.841 378.736 141.969C378.084 143.097 378.455 144.531 379.563 145.171Z"
          fill="#3A2933"
        />
        <path
          d="M374.845 153.343C375.953 153.982 377.379 153.586 378.031 152.458C378.682 151.33 378.312 149.896 377.204 149.257C376.096 148.617 374.669 149.013 374.018 150.141C373.366 151.27 373.737 152.703 374.845 153.343Z"
          fill="#3A2933"
        />
        <path
          d="M380.511 162.062C381.619 162.702 383.046 162.306 383.697 161.178C384.349 160.049 383.978 158.616 382.87 157.976C381.762 157.336 380.336 157.733 379.684 158.861C379.033 159.989 379.403 161.422 380.511 162.062Z"
          fill="#3A2933"
        />
        <path
          d="M370.126 161.515C371.235 162.154 372.661 161.758 373.312 160.63C373.964 159.502 373.594 158.068 372.486 157.429C371.377 156.789 369.951 157.185 369.3 158.313C368.648 159.442 369.018 160.875 370.126 161.515Z"
          fill="#3A2933"
        />
        <path
          d="M375.793 170.234C376.901 170.874 378.328 170.478 378.979 169.35C379.63 168.221 379.26 166.788 378.152 166.148C377.044 165.509 375.618 165.905 374.966 167.033C374.315 168.161 374.685 169.595 375.793 170.234Z"
          fill="#3A2933"
        />
        <path
          d="M365.408 169.687C366.516 170.327 367.943 169.93 368.594 168.802C369.246 167.674 368.876 166.24 367.767 165.601C366.659 164.961 365.233 165.357 364.581 166.485C363.93 167.614 364.3 169.047 365.408 169.687Z"
          fill="#3A2933"
        />
        <path
          d="M371.075 178.406C372.183 179.046 373.609 178.65 374.261 177.522C374.912 176.393 374.542 174.96 373.434 174.32C372.326 173.681 370.899 174.077 370.248 175.205C369.597 176.333 369.967 177.767 371.075 178.406Z"
          fill="#3A2933"
        />
        <path
          d="M366.357 186.578C367.465 187.218 368.891 186.822 369.543 185.694C370.194 184.566 369.824 183.132 368.716 182.492C367.608 181.853 366.181 182.249 365.53 183.377C364.878 184.505 365.249 185.939 366.357 186.578Z"
          fill="#3A2933"
        />
        <path
          d="M360.69 177.859C361.798 178.499 363.225 178.103 363.876 176.974C364.528 175.846 364.157 174.413 363.049 173.773C361.941 173.133 360.515 173.529 359.863 174.657C359.212 175.786 359.582 177.219 360.69 177.859Z"
          fill="#3A2933"
        />
        <path
          d="M355.972 186.031C357.08 186.671 358.507 186.275 359.158 185.146C359.809 184.018 359.439 182.585 358.331 181.945C357.223 181.305 355.797 181.701 355.145 182.829C354.494 183.958 354.864 185.391 355.972 186.031Z"
          fill="#3A2933"
        />
        <path
          d="M361.639 194.751C362.747 195.39 364.173 194.994 364.825 193.866C365.476 192.738 365.106 191.304 363.998 190.664C362.89 190.025 361.463 190.421 360.812 191.549C360.16 192.677 360.53 194.111 361.639 194.751Z"
          fill="#3A2933"
        />
        <path
          d="M351.254 194.203C352.362 194.843 353.788 194.447 354.44 193.318C355.091 192.19 354.721 190.757 353.613 190.117C352.505 189.477 351.078 189.873 350.427 191.002C349.776 192.13 350.146 193.563 351.254 194.203Z"
          fill="#3A2933"
        />
        <path
          d="M356.92 202.923C358.029 203.562 359.455 203.166 360.106 202.038C360.758 200.91 360.388 199.476 359.28 198.837C358.171 198.197 356.745 198.593 356.094 199.721C355.442 200.849 355.812 202.283 356.92 202.923Z"
          fill="#3A2933"
        />
        <path
          d="M352.202 211.095C353.31 211.734 354.737 211.338 355.388 210.21C356.04 209.082 355.669 207.648 354.561 207.009C353.453 206.369 352.027 206.765 351.375 207.893C350.724 209.022 351.094 210.455 352.202 211.095Z"
          fill="#3A2933"
        />
        <path
          d="M346.536 202.375C347.644 203.015 349.07 202.619 349.722 201.49C350.373 200.362 350.003 198.929 348.895 198.289C347.787 197.649 346.36 198.045 345.709 199.174C345.057 200.302 345.428 201.735 346.536 202.375Z"
          fill="#3A2933"
        />
        <path
          d="M341.818 210.547C342.926 211.187 344.352 210.791 345.004 209.662C345.655 208.534 345.285 207.101 344.177 206.461C343.069 205.821 341.642 206.217 340.991 207.346C340.339 208.474 340.71 209.907 341.818 210.547Z"
          fill="#3A2933"
        />
        <path
          d="M347.484 219.267C348.592 219.906 350.019 219.51 350.67 218.382C351.322 217.254 350.951 215.82 349.843 215.181C348.735 214.541 347.309 214.937 346.657 216.065C346.006 217.194 346.376 218.627 347.484 219.267Z"
          fill="#3A2933"
        />
        <path
          d="M337.099 218.719C338.208 219.359 339.634 218.963 340.285 217.835C340.937 216.706 340.567 215.273 339.459 214.633C338.35 213.993 336.924 214.389 336.273 215.518C335.621 216.646 335.991 218.079 337.099 218.719Z"
          fill="#3A2933"
        />
        <path
          d="M342.766 227.439C343.874 228.079 345.301 227.682 345.952 226.554C346.603 225.426 346.233 223.993 345.125 223.353C344.017 222.713 342.591 223.109 341.939 224.237C341.288 225.366 341.658 226.799 342.766 227.439Z"
          fill="#3A2933"
        />
        <path
          d="M332.381 226.891C333.489 227.531 334.916 227.135 335.567 226.007C336.219 224.878 335.849 223.445 334.74 222.805C333.632 222.165 332.206 222.561 331.554 223.69C330.903 224.818 331.273 226.251 332.381 226.891Z"
          fill="#3A2933"
        />
        <path
          d="M338.048 235.611C339.156 236.251 340.582 235.855 341.234 234.726C341.885 233.598 341.515 232.165 340.407 231.525C339.299 230.885 337.872 231.281 337.221 232.409C336.57 233.538 336.94 234.971 338.048 235.611Z"
          fill="#3A2933"
        />
        <path
          d="M333.33 243.783C334.438 244.423 335.864 244.027 336.516 242.898C337.167 241.77 336.797 240.337 335.689 239.697C334.581 239.057 333.154 239.453 332.503 240.581C331.851 241.71 332.222 243.143 333.33 243.783Z"
          fill="#3A2933"
        />
        <path
          d="M327.663 235.063C328.771 235.703 330.198 235.307 330.849 234.179C331.501 233.05 331.13 231.617 330.022 230.977C328.914 230.338 327.488 230.734 326.836 231.862C326.185 232.99 326.555 234.424 327.663 235.063Z"
          fill="#3A2933"
        />
        <path
          d="M322.945 243.235C324.053 243.875 325.48 243.479 326.131 242.351C326.782 241.222 326.412 239.789 325.304 239.149C324.196 238.51 322.77 238.906 322.118 240.034C321.467 241.162 321.837 242.596 322.945 243.235Z"
          fill="#3A2933"
        />
        <path
          d="M328.612 251.955C329.72 252.595 331.146 252.199 331.798 251.07C332.449 249.942 332.079 248.509 330.971 247.869C329.863 247.229 328.436 247.625 327.785 248.754C327.133 249.882 327.503 251.315 328.612 251.955Z"
          fill="#3A2933"
        />
        <path
          d="M318.227 251.407C319.335 252.047 320.761 251.651 321.413 250.523C322.064 249.394 321.694 247.961 320.586 247.321C319.478 246.682 318.051 247.078 317.4 248.206C316.749 249.334 317.119 250.768 318.227 251.407Z"
          fill="#3A2933"
        />
        <path
          d="M323.893 260.127C325.002 260.767 326.428 260.371 327.079 259.242C327.731 258.114 327.361 256.681 326.253 256.041C325.144 255.401 323.718 255.797 323.067 256.926C322.415 258.054 322.785 259.487 323.893 260.127Z"
          fill="#3A2933"
        />
        <path
          d="M313.509 259.579C314.617 260.219 316.043 259.823 316.695 258.695C317.346 257.567 316.976 256.133 315.868 255.493C314.76 254.854 313.333 255.25 312.682 256.378C312.03 257.506 312.401 258.94 313.509 259.579Z"
          fill="#3A2933"
        />
        <path
          d="M319.175 268.299C320.283 268.939 321.71 268.543 322.361 267.414C323.013 266.286 322.642 264.853 321.534 264.213C320.426 263.573 319 263.969 318.348 265.098C317.697 266.226 318.067 267.659 319.175 268.299Z"
          fill="#3A2933"
        />
        <path
          d="M314.457 276.471C315.565 277.111 316.992 276.715 317.643 275.587C318.295 274.458 317.924 273.025 316.816 272.385C315.708 271.745 314.282 272.141 313.63 273.27C312.979 274.398 313.349 275.831 314.457 276.471Z"
          fill="#3A2933"
        />
        <path
          d="M308.791 267.752C309.899 268.391 311.325 267.995 311.977 266.867C312.628 265.739 312.258 264.305 311.15 263.666C310.042 263.026 308.615 263.422 307.964 264.55C307.312 265.678 307.683 267.112 308.791 267.752Z"
          fill="#3A2933"
        />
        <path
          d="M304.072 275.924C305.181 276.563 306.607 276.167 307.258 275.039C307.91 273.911 307.54 272.477 306.432 271.838C305.323 271.198 303.897 271.594 303.246 272.722C302.594 273.851 302.964 275.284 304.072 275.924Z"
          fill="#3A2933"
        />
        <path
          d="M309.739 284.643C310.847 285.283 312.274 284.887 312.925 283.759C313.576 282.63 313.206 281.197 312.098 280.557C310.99 279.917 309.564 280.313 308.912 281.442C308.261 282.57 308.631 284.003 309.739 284.643Z"
          fill="#3A2933"
        />
        <path
          d="M299.354 284.096C300.462 284.735 301.889 284.339 302.54 283.211C303.192 282.083 302.822 280.649 301.713 280.01C300.605 279.37 299.179 279.766 298.527 280.894C297.876 282.023 298.246 283.456 299.354 284.096Z"
          fill="#3A2933"
        />
        <path
          d="M305.021 292.815C306.129 293.455 307.555 293.059 308.207 291.931C308.858 290.802 308.488 289.369 307.38 288.729C306.272 288.09 304.845 288.486 304.194 289.614C303.543 290.742 303.913 292.176 305.021 292.815Z"
          fill="#3A2933"
        />
        <path
          d="M300.303 300.987C301.411 301.627 302.837 301.231 303.489 300.103C304.14 298.974 303.77 297.541 302.662 296.901C301.554 296.262 300.127 296.658 299.476 297.786C298.824 298.914 299.195 300.348 300.303 300.987Z"
          fill="#3A2933"
        />
        <path
          d="M294.636 292.268C295.744 292.908 297.171 292.511 297.822 291.383C298.474 290.255 298.103 288.821 296.995 288.182C295.887 287.542 294.461 287.938 293.809 289.066C293.158 290.195 293.528 291.628 294.636 292.268Z"
          fill="#3A2933"
        />
        <path
          d="M409.768 129.922C410.877 130.561 412.303 130.165 412.954 129.037C413.606 127.909 413.236 126.475 412.127 125.836C411.019 125.196 409.593 125.592 408.942 126.72C408.29 127.848 408.66 129.282 409.768 129.922Z"
          fill="#3A2933"
        />
        <path
          d="M415.435 138.641C416.543 139.281 417.969 138.885 418.621 137.757C419.272 136.628 418.902 135.195 417.794 134.555C416.686 133.915 415.26 134.311 414.608 135.44C413.957 136.568 414.327 138.001 415.435 138.641Z"
          fill="#3A2933"
        />
        <path
          d="M420.153 130.469C421.261 131.109 422.688 130.713 423.339 129.584C423.99 128.456 423.62 127.023 422.512 126.383C421.404 125.743 419.978 126.139 419.326 127.268C418.675 128.396 419.045 129.829 420.153 130.469Z"
          fill="#3A2933"
        />
        <path
          d="M405.05 138.094C406.158 138.733 407.585 138.337 408.236 137.209C408.888 136.081 408.517 134.647 407.409 134.008C406.301 133.368 404.875 133.764 404.223 134.892C403.572 136.021 403.942 137.454 405.05 138.094Z"
          fill="#3A2933"
        />
        <path
          d="M410.717 146.813C411.825 147.453 413.251 147.057 413.903 145.929C414.554 144.8 414.184 143.367 413.076 142.727C411.968 142.087 410.541 142.484 409.89 143.612C409.239 144.74 409.609 146.173 410.717 146.813Z"
          fill="#3A2933"
        />
        <path
          d="M400.332 146.266C401.44 146.905 402.867 146.509 403.518 145.381C404.17 144.253 403.799 142.819 402.691 142.18C401.583 141.54 400.157 141.936 399.505 143.064C398.854 144.193 399.224 145.626 400.332 146.266Z"
          fill="#3A2933"
        />
        <path
          d="M405.999 154.985C407.107 155.625 408.533 155.229 409.185 154.101C409.836 152.972 409.466 151.539 408.358 150.899C407.25 150.26 405.823 150.656 405.172 151.784C404.52 152.912 404.891 154.346 405.999 154.985Z"
          fill="#3A2933"
        />
        <path
          d="M401.281 163.157C402.389 163.797 403.815 163.401 404.466 162.273C405.118 161.144 404.748 159.711 403.64 159.071C402.532 158.432 401.105 158.828 400.454 159.956C399.802 161.084 400.172 162.518 401.281 163.157Z"
          fill="#3A2933"
        />
        <path
          d="M395.614 154.438C396.722 155.078 398.148 154.681 398.8 153.553C399.451 152.425 399.081 150.991 397.973 150.352C396.865 149.712 395.439 150.108 394.787 151.236C394.136 152.365 394.506 153.798 395.614 154.438Z"
          fill="#3A2933"
        />
        <path
          d="M390.896 162.61C392.004 163.25 393.43 162.854 394.082 161.725C394.733 160.597 394.363 159.164 393.255 158.524C392.147 157.884 390.72 158.28 390.069 159.408C389.418 160.537 389.788 161.97 390.896 162.61Z"
          fill="#3A2933"
        />
        <path
          d="M396.562 171.329C397.671 171.969 399.097 171.573 399.748 170.445C400.4 169.316 400.03 167.883 398.921 167.243C397.813 166.604 396.387 167 395.736 168.128C395.084 169.256 395.454 170.69 396.562 171.329Z"
          fill="#3A2933"
        />
        <path
          d="M386.178 170.782C387.286 171.422 388.712 171.026 389.364 169.897C390.015 168.769 389.645 167.336 388.537 166.696C387.429 166.056 386.002 166.452 385.351 167.58C384.699 168.709 385.07 170.142 386.178 170.782Z"
          fill="#3A2933"
        />
        <path
          d="M391.844 179.502C392.952 180.141 394.379 179.745 395.03 178.617C395.682 177.489 395.311 176.055 394.203 175.415C393.095 174.776 391.669 175.172 391.017 176.3C390.366 177.428 390.736 178.862 391.844 179.502Z"
          fill="#3A2933"
        />
        <path
          d="M381.46 178.954C382.568 179.594 383.994 179.198 384.646 178.069C385.297 176.941 384.927 175.508 383.819 174.868C382.711 174.228 381.284 174.624 380.633 175.753C379.981 176.881 380.351 178.314 381.46 178.954Z"
          fill="#3A2933"
        />
        <path
          d="M387.126 187.674C388.234 188.313 389.661 187.917 390.312 186.789C390.963 185.661 390.593 184.227 389.485 183.588C388.377 182.948 386.951 183.344 386.299 184.472C385.648 185.6 386.018 187.034 387.126 187.674Z"
          fill="#3A2933"
        />
        <path
          d="M382.408 195.846C383.516 196.485 384.942 196.089 385.594 194.961C386.245 193.833 385.875 192.399 384.767 191.76C383.659 191.12 382.233 191.516 381.581 192.644C380.93 193.773 381.3 195.206 382.408 195.846Z"
          fill="#3A2933"
        />
        <path
          d="M376.741 187.126C377.85 187.766 379.276 187.37 379.927 186.241C380.579 185.113 380.209 183.68 379.1 183.04C377.992 182.4 376.566 182.796 375.915 183.925C375.263 185.053 375.633 186.486 376.741 187.126Z"
          fill="#3A2933"
        />
        <path
          d="M372.023 195.298C373.131 195.938 374.558 195.542 375.209 194.413C375.861 193.285 375.49 191.852 374.382 191.212C373.274 190.572 371.848 190.968 371.196 192.097C370.545 193.225 370.915 194.658 372.023 195.298Z"
          fill="#3A2933"
        />
        <path
          d="M377.69 204.018C378.798 204.657 380.224 204.261 380.876 203.133C381.527 202.005 381.157 200.571 380.049 199.932C378.941 199.292 377.514 199.688 376.863 200.816C376.212 201.945 376.582 203.378 377.69 204.018Z"
          fill="#3A2933"
        />
        <path
          d="M367.305 203.47C368.413 204.11 369.84 203.714 370.491 202.586C371.143 201.457 370.772 200.024 369.664 199.384C368.556 198.744 367.13 199.14 366.478 200.269C365.827 201.397 366.197 202.83 367.305 203.47Z"
          fill="#3A2933"
        />
        <path
          d="M372.972 212.19C374.08 212.83 375.506 212.433 376.158 211.305C376.809 210.177 376.439 208.744 375.331 208.104C374.223 207.464 372.796 207.86 372.145 208.988C371.493 210.117 371.864 211.55 372.972 212.19Z"
          fill="#3A2933"
        />
        <path
          d="M368.254 220.362C369.362 221.002 370.788 220.606 371.439 219.477C372.091 218.349 371.721 216.916 370.613 216.276C369.505 215.636 368.078 216.032 367.427 217.16C366.775 218.289 367.145 219.722 368.254 220.362Z"
          fill="#3A2933"
        />
        <path
          d="M362.587 211.642C363.695 212.282 365.121 211.886 365.773 210.758C366.424 209.629 366.054 208.196 364.946 207.556C363.838 206.916 362.412 207.312 361.76 208.441C361.109 209.569 361.479 211.002 362.587 211.642Z"
          fill="#3A2933"
        />
        <path
          d="M357.869 219.814C358.977 220.454 360.403 220.058 361.055 218.93C361.706 217.801 361.336 216.368 360.228 215.728C359.12 215.088 357.693 215.485 357.042 216.613C356.391 217.741 356.761 219.174 357.869 219.814Z"
          fill="#3A2933"
        />
        <path
          d="M363.535 228.534C364.644 229.174 366.07 228.778 366.721 227.649C367.373 226.521 367.003 225.088 365.894 224.448C364.786 223.808 363.36 224.204 362.709 225.332C362.057 226.461 362.427 227.894 363.535 228.534Z"
          fill="#3A2933"
        />
        <path
          d="M353.151 227.986C354.259 228.626 355.685 228.23 356.337 227.102C356.988 225.973 356.618 224.54 355.51 223.9C354.402 223.261 352.975 223.657 352.324 224.785C351.672 225.913 352.043 227.347 353.151 227.986Z"
          fill="#3A2933"
        />
        <path
          d="M358.817 236.706C359.925 237.346 361.352 236.95 362.003 235.821C362.655 234.693 362.284 233.26 361.176 232.62C360.068 231.98 358.642 232.376 357.99 233.505C357.339 234.633 357.709 236.066 358.817 236.706Z"
          fill="#3A2933"
        />
        <path
          d="M348.433 236.158C349.541 236.798 350.967 236.402 351.618 235.274C352.27 234.145 351.9 232.712 350.792 232.072C349.684 231.433 348.257 231.829 347.606 232.957C346.954 234.085 347.324 235.519 348.433 236.158Z"
          fill="#3A2933"
        />
        <path
          d="M354.099 244.878C355.207 245.518 356.634 245.122 357.285 243.993C357.936 242.865 357.566 241.432 356.458 240.792C355.35 240.152 353.924 240.548 353.272 241.677C352.621 242.805 352.991 244.238 354.099 244.878Z"
          fill="#3A2933"
        />
        <path
          d="M349.381 253.05C350.489 253.69 351.915 253.294 352.567 252.165C353.218 251.037 352.848 249.604 351.74 248.964C350.632 248.324 349.206 248.72 348.554 249.849C347.903 250.977 348.273 252.41 349.381 253.05Z"
          fill="#3A2933"
        />
        <path
          d="M343.714 244.33C344.823 244.97 346.249 244.574 346.9 243.446C347.552 242.318 347.182 240.884 346.073 240.244C344.965 239.605 343.539 240.001 342.888 241.129C342.236 242.257 342.606 243.691 343.714 244.33Z"
          fill="#3A2933"
        />
        <path
          d="M338.996 252.503C340.104 253.142 341.531 252.746 342.182 251.618C342.834 250.49 342.463 249.056 341.355 248.416C340.247 247.777 338.821 248.173 338.169 249.301C337.518 250.429 337.888 251.863 338.996 252.503Z"
          fill="#3A2933"
        />
        <path
          d="M344.663 261.222C345.771 261.862 347.197 261.466 347.849 260.338C348.5 259.209 348.13 257.776 347.022 257.136C345.914 256.496 344.487 256.892 343.836 258.021C343.185 259.149 343.555 260.582 344.663 261.222Z"
          fill="#3A2933"
        />
        <path
          d="M334.278 260.675C335.386 261.314 336.813 260.918 337.464 259.79C338.116 258.662 337.745 257.228 336.637 256.589C335.529 255.949 334.103 256.345 333.451 257.473C332.8 258.602 333.17 260.035 334.278 260.675Z"
          fill="#3A2933"
        />
        <path
          d="M339.945 269.394C341.053 270.034 342.479 269.638 343.131 268.51C343.782 267.381 343.412 265.948 342.304 265.308C341.196 264.668 339.769 265.064 339.118 266.193C338.466 267.321 338.837 268.754 339.945 269.394Z"
          fill="#3A2933"
        />
        <path
          d="M329.56 268.847C330.668 269.486 332.094 269.09 332.746 267.962C333.397 266.834 333.027 265.4 331.919 264.761C330.811 264.121 329.385 264.517 328.733 265.645C328.082 266.774 328.452 268.207 329.56 268.847Z"
          fill="#3A2933"
        />
        <path
          d="M335.227 277.566C336.335 278.206 337.761 277.81 338.412 276.682C339.064 275.553 338.694 274.12 337.586 273.48C336.478 272.84 335.051 273.237 334.4 274.365C333.748 275.493 334.118 276.927 335.227 277.566Z"
          fill="#3A2933"
        />
        <path
          d="M330.508 285.738C331.617 286.378 333.043 285.982 333.694 284.854C334.346 283.725 333.976 282.292 332.867 281.652C331.759 281.013 330.333 281.409 329.682 282.537C329.03 283.665 329.4 285.099 330.508 285.738Z"
          fill="#3A2933"
        />
        <path
          d="M324.842 277.019C325.95 277.658 327.376 277.262 328.028 276.134C328.679 275.006 328.309 273.572 327.201 272.933C326.093 272.293 324.666 272.689 324.015 273.817C323.364 274.946 323.734 276.379 324.842 277.019Z"
          fill="#3A2933"
        />
        <path
          d="M320.124 285.191C321.232 285.831 322.658 285.435 323.31 284.306C323.961 283.178 323.591 281.745 322.483 281.105C321.375 280.465 319.948 280.861 319.297 281.989C318.645 283.118 319.016 284.551 320.124 285.191Z"
          fill="#3A2933"
        />
        <path
          d="M325.79 293.91C326.898 294.55 328.325 294.154 328.976 293.026C329.628 291.897 329.257 290.464 328.149 289.824C327.041 289.185 325.615 289.581 324.963 290.709C324.312 291.837 324.682 293.271 325.79 293.91Z"
          fill="#3A2933"
        />
        <path
          d="M315.406 293.363C316.514 294.003 317.94 293.607 318.591 292.478C319.243 291.35 318.873 289.917 317.765 289.277C316.657 288.637 315.23 289.033 314.579 290.161C313.927 291.29 314.297 292.723 315.406 293.363Z"
          fill="#3A2933"
        />
        <path
          d="M321.072 302.082C322.18 302.722 323.607 302.326 324.258 301.198C324.909 300.07 324.539 298.636 323.431 297.996C322.323 297.357 320.897 297.753 320.245 298.881C319.594 300.009 319.964 301.443 321.072 302.082Z"
          fill="#3A2933"
        />
        <path
          d="M316.354 310.255C317.462 310.894 318.888 310.498 319.54 309.37C320.191 308.242 319.821 306.808 318.713 306.169C317.605 305.529 316.179 305.925 315.527 307.053C314.876 308.181 315.246 309.615 316.354 310.255Z"
          fill="#3A2933"
        />
        <path
          d="M310.687 301.535C311.796 302.175 313.222 301.779 313.873 300.65C314.525 299.522 314.155 298.089 313.046 297.449C311.938 296.809 310.512 297.205 309.861 298.334C309.209 299.462 309.579 300.895 310.687 301.535Z"
          fill="#3A2933"
        />
        <path
          d="M425.82 139.189C426.928 139.828 428.354 139.432 429.006 138.304C429.657 137.176 429.287 135.742 428.179 135.103C427.071 134.463 425.644 134.859 424.993 135.987C424.341 137.116 424.712 138.549 425.82 139.189Z"
          fill="#3A2933"
        />
        <path
          d="M431.486 147.908C432.594 148.548 434.021 148.152 434.672 147.024C435.324 145.895 434.953 144.462 433.845 143.822C432.737 143.183 431.311 143.579 430.659 144.707C430.008 145.835 430.378 147.269 431.486 147.908Z"
          fill="#3A2933"
        />
        <path
          d="M436.204 139.736C437.312 140.376 438.739 139.98 439.39 138.852C440.042 137.723 439.672 136.29 438.563 135.65C437.455 135.01 436.029 135.407 435.377 136.535C434.726 137.663 435.096 139.097 436.204 139.736Z"
          fill="#3A2933"
        />
        <path
          d="M421.102 147.361C422.21 148.001 423.636 147.605 424.287 146.476C424.939 145.348 424.569 143.915 423.461 143.275C422.352 142.635 420.926 143.031 420.275 144.159C419.623 145.288 419.993 146.721 421.102 147.361Z"
          fill="#3A2933"
        />
        <path
          d="M426.768 156.08C427.876 156.72 429.303 156.324 429.954 155.196C430.605 154.067 430.235 152.634 429.127 151.994C428.019 151.355 426.593 151.751 425.941 152.879C425.29 154.007 425.66 155.441 426.768 156.08Z"
          fill="#3A2933"
        />
        <path
          d="M416.383 155.533C417.491 156.173 418.918 155.777 419.569 154.648C420.221 153.52 419.851 152.087 418.742 151.447C417.634 150.807 416.208 151.203 415.556 152.331C414.905 153.46 415.275 154.893 416.383 155.533Z"
          fill="#3A2933"
        />
        <path
          d="M422.05 164.252C423.158 164.892 424.584 164.496 425.236 163.368C425.887 162.24 425.517 160.806 424.409 160.166C423.301 159.527 421.874 159.923 421.223 161.051C420.572 162.179 420.942 163.613 422.05 164.252Z"
          fill="#3A2933"
        />
        <path
          d="M417.332 172.425C418.44 173.064 419.866 172.668 420.518 171.54C421.169 170.412 420.799 168.978 419.691 168.339C418.583 167.699 417.156 168.095 416.505 169.223C415.853 170.351 416.224 171.785 417.332 172.425Z"
          fill="#3A2933"
        />
        <path
          d="M411.665 163.705C412.773 164.345 414.2 163.949 414.851 162.82C415.503 161.692 415.132 160.259 414.024 159.619C412.916 158.979 411.49 159.375 410.838 160.504C410.187 161.632 410.557 163.065 411.665 163.705Z"
          fill="#3A2933"
        />
        <path
          d="M406.947 171.877C408.055 172.517 409.482 172.121 410.133 170.992C410.784 169.864 410.414 168.431 409.306 167.791C408.198 167.151 406.772 167.547 406.12 168.676C405.469 169.804 405.839 171.237 406.947 171.877Z"
          fill="#3A2933"
        />
        <path
          d="M412.614 180.597C413.722 181.236 415.148 180.84 415.8 179.712C416.451 178.584 416.081 177.15 414.973 176.511C413.865 175.871 412.438 176.267 411.787 177.395C411.135 178.524 411.506 179.957 412.614 180.597Z"
          fill="#3A2933"
        />
        <path
          d="M402.229 180.049C403.337 180.689 404.763 180.293 405.415 179.164C406.066 178.036 405.696 176.603 404.588 175.963C403.48 175.323 402.053 175.719 401.402 176.848C400.751 177.976 401.121 179.409 402.229 180.049Z"
          fill="#3A2933"
        />
        <path
          d="M407.895 188.769C409.004 189.408 410.43 189.012 411.081 187.884C411.733 186.756 411.363 185.322 410.255 184.683C409.146 184.043 407.72 184.439 407.069 185.567C406.417 186.696 406.787 188.129 407.895 188.769Z"
          fill="#3A2933"
        />
        <path
          d="M397.511 188.221C398.619 188.861 400.045 188.465 400.697 187.337C401.348 186.208 400.978 184.775 399.87 184.135C398.762 183.495 397.335 183.891 396.684 185.02C396.032 186.148 396.403 187.581 397.511 188.221Z"
          fill="#3A2933"
        />
        <path
          d="M403.177 196.941C404.285 197.581 405.712 197.184 406.363 196.056C407.015 194.928 406.645 193.494 405.536 192.855C404.428 192.215 403.002 192.611 402.35 193.739C401.699 194.868 402.069 196.301 403.177 196.941Z"
          fill="#3A2933"
        />
        <path
          d="M398.459 205.113C399.567 205.753 400.994 205.357 401.645 204.228C402.297 203.1 401.926 201.667 400.818 201.027C399.71 200.387 398.284 200.783 397.632 201.911C396.981 203.04 397.351 204.473 398.459 205.113Z"
          fill="#3A2933"
        />
        <path
          d="M392.793 196.393C393.901 197.033 395.327 196.637 395.979 195.509C396.63 194.38 396.26 192.947 395.152 192.307C394.044 191.667 392.617 192.063 391.966 193.192C391.314 194.32 391.685 195.753 392.793 196.393Z"
          fill="#3A2933"
        />
        <path
          d="M388.074 204.565C389.183 205.205 390.609 204.809 391.26 203.681C391.912 202.552 391.542 201.119 390.434 200.479C389.325 199.839 387.899 200.235 387.248 201.364C386.596 202.492 386.966 203.925 388.074 204.565Z"
          fill="#3A2933"
        />
        <path
          d="M393.741 213.285C394.849 213.925 396.276 213.529 396.927 212.4C397.578 211.272 397.208 209.839 396.1 209.199C394.992 208.559 393.566 208.955 392.914 210.083C392.263 211.212 392.633 212.645 393.741 213.285Z"
          fill="#3A2933"
        />
        <path
          d="M383.356 212.737C384.464 213.377 385.891 212.981 386.542 211.853C387.194 210.724 386.824 209.291 385.715 208.651C384.607 208.012 383.181 208.408 382.529 209.536C381.878 210.664 382.248 212.098 383.356 212.737Z"
          fill="#3A2933"
        />
        <path
          d="M389.023 221.457C390.131 222.097 391.557 221.701 392.209 220.572C392.86 219.444 392.49 218.011 391.382 217.371C390.274 216.731 388.847 217.127 388.196 218.256C387.545 219.384 387.915 220.817 389.023 221.457Z"
          fill="#3A2933"
        />
        <path
          d="M384.305 229.629C385.413 230.269 386.839 229.873 387.491 228.744C388.142 227.616 387.772 226.183 386.664 225.543C385.556 224.903 384.129 225.299 383.478 226.428C382.826 227.556 383.197 228.989 384.305 229.629Z"
          fill="#3A2933"
        />
        <path
          d="M378.638 220.909C379.746 221.549 381.173 221.153 381.824 220.025C382.476 218.896 382.105 217.463 380.997 216.823C379.889 216.184 378.463 216.58 377.811 217.708C377.16 218.836 377.53 220.27 378.638 220.909Z"
          fill="#3A2933"
        />
        <path
          d="M373.92 229.081C375.028 229.721 376.455 229.325 377.106 228.197C377.757 227.069 377.387 225.635 376.279 224.995C375.171 224.356 373.745 224.752 373.093 225.88C372.442 227.008 372.812 228.442 373.92 229.081Z"
          fill="#3A2933"
        />
        <path
          d="M379.587 237.801C380.695 238.441 382.121 238.045 382.773 236.916C383.424 235.788 383.054 234.355 381.946 233.715C380.838 233.075 379.411 233.471 378.76 234.6C378.108 235.728 378.479 237.161 379.587 237.801Z"
          fill="#3A2933"
        />
        <path
          d="M369.202 237.254C370.31 237.893 371.736 237.497 372.388 236.369C373.039 235.241 372.669 233.807 371.561 233.167C370.453 232.528 369.026 232.924 368.375 234.052C367.724 235.18 368.094 236.614 369.202 237.254Z"
          fill="#3A2933"
        />
        <path
          d="M374.868 245.973C375.977 246.613 377.403 246.217 378.054 245.089C378.706 243.96 378.336 242.527 377.228 241.887C376.119 241.247 374.693 241.643 374.042 242.772C373.39 243.9 373.76 245.333 374.868 245.973Z"
          fill="#3A2933"
        />
        <path
          d="M364.484 245.426C365.592 246.065 367.018 245.669 367.67 244.541C368.321 243.413 367.951 241.979 366.843 241.34C365.735 240.7 364.308 241.096 363.657 242.224C363.005 243.352 363.376 244.786 364.484 245.426Z"
          fill="#3A2933"
        />
        <path
          d="M370.15 254.145C371.258 254.785 372.685 254.389 373.336 253.261C373.988 252.132 373.617 250.699 372.509 250.059C371.401 249.419 369.975 249.815 369.323 250.944C368.672 252.072 369.042 253.505 370.15 254.145Z"
          fill="#3A2933"
        />
        <path
          d="M365.432 262.317C366.54 262.957 367.967 262.561 368.618 261.433C369.27 260.304 368.899 258.871 367.791 258.231C366.683 257.591 365.257 257.988 364.605 259.116C363.954 260.244 364.324 261.677 365.432 262.317Z"
          fill="#3A2933"
        />
        <path
          d="M359.766 253.598C360.874 254.237 362.3 253.841 362.952 252.713C363.603 251.585 363.233 250.151 362.125 249.512C361.017 248.872 359.59 249.268 358.939 250.396C358.287 251.525 358.658 252.958 359.766 253.598Z"
          fill="#3A2933"
        />
        <path
          d="M355.047 261.77C356.156 262.409 357.582 262.013 358.233 260.885C358.885 259.757 358.515 258.323 357.407 257.684C356.298 257.044 354.872 257.44 354.221 258.568C353.569 259.697 353.939 261.13 355.047 261.77Z"
          fill="#3A2933"
        />
        <path
          d="M360.714 270.489C361.822 271.129 363.249 270.733 363.9 269.605C364.551 268.476 364.181 267.043 363.073 266.403C361.965 265.764 360.539 266.16 359.887 267.288C359.236 268.416 359.606 269.85 360.714 270.489Z"
          fill="#3A2933"
        />
        <path
          d="M350.329 269.942C351.437 270.582 352.864 270.185 353.515 269.057C354.167 267.929 353.797 266.496 352.688 265.856C351.58 265.216 350.154 265.612 349.502 266.74C348.851 267.869 349.221 269.302 350.329 269.942Z"
          fill="#3A2933"
        />
        <path
          d="M355.996 278.661C357.104 279.301 358.53 278.905 359.182 277.777C359.833 276.648 359.463 275.215 358.355 274.575C357.247 273.936 355.82 274.332 355.169 275.46C354.518 276.588 354.888 278.022 355.996 278.661Z"
          fill="#3A2933"
        />
        <path
          d="M345.611 278.114C346.719 278.754 348.146 278.358 348.797 277.229C349.449 276.101 349.078 274.668 347.97 274.028C346.862 273.388 345.436 273.784 344.784 274.912C344.133 276.041 344.503 277.474 345.611 278.114Z"
          fill="#3A2933"
        />
        <path
          d="M351.278 286.833C352.386 287.473 353.812 287.077 354.464 285.949C355.115 284.821 354.745 283.387 353.637 282.747C352.529 282.108 351.102 282.504 350.451 283.632C349.799 284.76 350.17 286.194 351.278 286.833Z"
          fill="#3A2933"
        />
        <path
          d="M346.56 295.006C347.668 295.645 349.094 295.249 349.746 294.121C350.397 292.993 350.027 291.559 348.919 290.919C347.811 290.28 346.384 290.676 345.733 291.804C345.081 292.932 345.451 294.366 346.56 295.006Z"
          fill="#3A2933"
        />
        <path
          d="M340.893 286.286C342.001 286.926 343.428 286.53 344.079 285.401C344.73 284.273 344.36 282.84 343.252 282.2C342.144 281.56 340.718 281.956 340.066 283.084C339.415 284.213 339.785 285.646 340.893 286.286Z"
          fill="#3A2933"
        />
        <path
          d="M336.175 294.458C337.283 295.098 338.709 294.702 339.361 293.573C340.012 292.445 339.642 291.012 338.534 290.372C337.426 289.732 335.999 290.128 335.348 291.257C334.697 292.385 335.067 293.818 336.175 294.458Z"
          fill="#3A2933"
        />
        <path
          d="M341.841 303.178C342.95 303.817 344.376 303.421 345.027 302.293C345.679 301.165 345.309 299.731 344.201 299.092C343.092 298.452 341.666 298.848 341.015 299.976C340.363 301.104 340.733 302.538 341.841 303.178Z"
          fill="#3A2933"
        />
        <path
          d="M331.457 302.63C332.565 303.27 333.991 302.874 334.643 301.745C335.294 300.617 334.924 299.184 333.816 298.544C332.708 297.904 331.281 298.3 330.63 299.429C329.978 300.557 330.349 301.99 331.457 302.63Z"
          fill="#3A2933"
        />
        <path
          d="M337.123 311.35C338.231 311.989 339.658 311.593 340.309 310.465C340.961 309.337 340.59 307.903 339.482 307.264C338.374 306.624 336.948 307.02 336.296 308.148C335.645 309.277 336.015 310.71 337.123 311.35Z"
          fill="#3A2933"
        />
        <path
          d="M332.405 319.522C333.513 320.161 334.94 319.765 335.591 318.637C336.243 317.509 335.872 316.075 334.764 315.436C333.656 314.796 332.23 315.192 331.578 316.32C330.927 317.449 331.297 318.882 332.405 319.522Z"
          fill="#3A2933"
        />
        <path
          d="M326.739 310.802C327.847 311.442 329.273 311.046 329.925 309.917C330.576 308.789 330.206 307.356 329.098 306.716C327.99 306.076 326.563 306.472 325.912 307.601C325.26 308.729 325.631 310.162 326.739 310.802Z"
          fill="#3A2933"
        />
        <path
          d="M441.871 148.456C442.979 149.096 444.405 148.7 445.057 147.571C445.708 146.443 445.338 145.01 444.23 144.37C443.122 143.73 441.695 144.126 441.044 145.254C440.393 146.383 440.763 147.816 441.871 148.456Z"
          fill="#3A2933"
        />
        <path
          d="M447.537 157.176C448.646 157.815 450.072 157.419 450.723 156.291C451.375 155.163 451.005 153.729 449.896 153.089C448.788 152.45 447.362 152.846 446.711 153.974C446.059 155.102 446.429 156.536 447.537 157.176Z"
          fill="#3A2933"
        />
        <path
          d="M452.256 149.003C453.364 149.643 454.79 149.247 455.442 148.119C456.093 146.991 455.723 145.557 454.615 144.917C453.507 144.278 452.08 144.674 451.429 145.802C450.777 146.93 451.147 148.364 452.256 149.003Z"
          fill="#3A2933"
        />
        <path
          d="M437.153 156.628C438.261 157.268 439.687 156.872 440.339 155.743C440.99 154.615 440.62 153.182 439.512 152.542C438.404 151.902 436.977 152.298 436.326 153.427C435.674 154.555 436.045 155.988 437.153 156.628Z"
          fill="#3A2933"
        />
        <path
          d="M442.819 165.348C443.927 165.987 445.354 165.591 446.005 164.463C446.657 163.335 446.286 161.901 445.178 161.262C444.07 160.622 442.644 161.018 441.992 162.146C441.341 163.275 441.711 164.708 442.819 165.348Z"
          fill="#3A2933"
        />
        <path
          d="M432.435 164.8C433.543 165.44 434.969 165.044 435.621 163.915C436.272 162.787 435.902 161.354 434.794 160.714C433.686 160.074 432.259 160.47 431.608 161.599C430.956 162.727 431.326 164.16 432.435 164.8Z"
          fill="#3A2933"
        />
        <path
          d="M438.101 173.52C439.209 174.159 440.636 173.763 441.287 172.635C441.939 171.507 441.568 170.073 440.46 169.434C439.352 168.794 437.926 169.19 437.274 170.318C436.623 171.447 436.993 172.88 438.101 173.52Z"
          fill="#3A2933"
        />
        <path
          d="M433.383 181.692C434.491 182.331 435.917 181.935 436.569 180.807C437.22 179.679 436.85 178.245 435.742 177.606C434.634 176.966 433.208 177.362 432.556 178.49C431.905 179.619 432.275 181.052 433.383 181.692Z"
          fill="#3A2933"
        />
        <path
          d="M427.716 172.972C428.825 173.612 430.251 173.216 430.902 172.087C431.554 170.959 431.184 169.526 430.076 168.886C428.967 168.246 427.541 168.642 426.89 169.771C426.238 170.899 426.608 172.332 427.716 172.972Z"
          fill="#3A2933"
        />
        <path
          d="M422.998 181.144C424.106 181.784 425.533 181.388 426.184 180.26C426.836 179.131 426.465 177.698 425.357 177.058C424.249 176.418 422.823 176.814 422.171 177.943C421.52 179.071 421.89 180.504 422.998 181.144Z"
          fill="#3A2933"
        />
        <path
          d="M428.665 189.864C429.773 190.504 431.199 190.108 431.851 188.979C432.502 187.851 432.132 186.418 431.024 185.778C429.916 185.138 428.489 185.534 427.838 186.662C427.187 187.791 427.557 189.224 428.665 189.864Z"
          fill="#3A2933"
        />
        <path
          d="M418.28 189.316C419.388 189.956 420.815 189.56 421.466 188.432C422.118 187.303 421.747 185.87 420.639 185.23C419.531 184.59 418.105 184.986 417.453 186.115C416.802 187.243 417.172 188.676 418.28 189.316Z"
          fill="#3A2933"
        />
        <path
          d="M423.947 198.036C425.055 198.676 426.481 198.28 427.133 197.151C427.784 196.023 427.414 194.59 426.306 193.95C425.198 193.31 423.771 193.706 423.12 194.834C422.468 195.963 422.839 197.396 423.947 198.036Z"
          fill="#3A2933"
        />
        <path
          d="M413.562 197.488C414.67 198.128 416.097 197.732 416.748 196.604C417.399 195.475 417.029 194.042 415.921 193.402C414.813 192.762 413.387 193.159 412.735 194.287C412.084 195.415 412.454 196.849 413.562 197.488Z"
          fill="#3A2933"
        />
        <path
          d="M419.229 206.208C420.337 206.848 421.763 206.452 422.414 205.323C423.066 204.195 422.696 202.762 421.588 202.122C420.48 201.482 419.053 201.878 418.402 203.007C417.75 204.135 418.12 205.568 419.229 206.208Z"
          fill="#3A2933"
        />
        <path
          d="M414.51 214.38C415.619 215.02 417.045 214.624 417.696 213.495C418.348 212.367 417.978 210.934 416.869 210.294C415.761 209.654 414.335 210.05 413.684 211.179C413.032 212.307 413.402 213.74 414.51 214.38Z"
          fill="#3A2933"
        />
        <path
          d="M408.844 205.66C409.952 206.3 411.378 205.904 412.03 204.776C412.681 203.647 412.311 202.214 411.203 201.574C410.095 200.935 408.668 201.331 408.017 202.459C407.366 203.587 407.736 205.021 408.844 205.66Z"
          fill="#3A2933"
        />
        <path
          d="M404.126 213.832C405.234 214.472 406.66 214.076 407.312 212.948C407.963 211.819 407.593 210.386 406.485 209.746C405.377 209.107 403.95 209.503 403.299 210.631C402.647 211.759 403.018 213.193 404.126 213.832Z"
          fill="#3A2933"
        />
        <path
          d="M409.792 222.552C410.9 223.192 412.327 222.796 412.978 221.667C413.63 220.539 413.259 219.106 412.151 218.466C411.043 217.826 409.617 218.222 408.965 219.351C408.314 220.479 408.684 221.912 409.792 222.552Z"
          fill="#3A2933"
        />
        <path
          d="M399.408 222.004C400.516 222.644 401.942 222.248 402.594 221.12C403.245 219.992 402.875 218.558 401.767 217.918C400.659 217.279 399.232 217.675 398.581 218.803C397.929 219.931 398.299 221.365 399.408 222.004Z"
          fill="#3A2933"
        />
        <path
          d="M405.074 230.724C406.182 231.364 407.609 230.968 408.26 229.84C408.912 228.711 408.541 227.278 407.433 226.638C406.325 225.998 404.899 226.394 404.247 227.523C403.596 228.651 403.966 230.084 405.074 230.724Z"
          fill="#3A2933"
        />
        <path
          d="M400.356 238.896C401.464 239.536 402.89 239.14 403.542 238.012C404.193 236.883 403.823 235.45 402.715 234.81C401.607 234.17 400.181 234.566 399.529 235.695C398.878 236.823 399.248 238.256 400.356 238.896Z"
          fill="#3A2933"
        />
        <path
          d="M394.689 230.177C395.798 230.816 397.224 230.42 397.875 229.292C398.527 228.164 398.157 226.73 397.049 226.091C395.94 225.451 394.514 225.847 393.863 226.975C393.211 228.103 393.581 229.537 394.689 230.177Z"
          fill="#3A2933"
        />
        <path
          d="M389.971 238.349C391.079 238.988 392.506 238.592 393.157 237.464C393.809 236.336 393.438 234.902 392.33 234.263C391.222 233.623 389.796 234.019 389.144 235.147C388.493 236.276 388.863 237.709 389.971 238.349Z"
          fill="#3A2933"
        />
        <path
          d="M395.638 247.068C396.746 247.708 398.172 247.312 398.824 246.184C399.475 245.055 399.105 243.622 397.997 242.982C396.889 242.342 395.462 242.739 394.811 243.867C394.16 244.995 394.53 246.428 395.638 247.068Z"
          fill="#3A2933"
        />
        <path
          d="M385.253 246.521C386.361 247.16 387.788 246.764 388.439 245.636C389.091 244.508 388.72 243.074 387.612 242.435C386.504 241.795 385.078 242.191 384.426 243.319C383.775 244.448 384.145 245.881 385.253 246.521Z"
          fill="#3A2933"
        />
        <path
          d="M390.92 255.24C392.028 255.88 393.454 255.484 394.106 254.356C394.757 253.227 394.387 251.794 393.279 251.154C392.171 250.515 390.744 250.911 390.093 252.039C389.441 253.167 389.812 254.601 390.92 255.24Z"
          fill="#3A2933"
        />
        <path
          d="M380.535 254.693C381.643 255.333 383.07 254.936 383.721 253.808C384.372 252.68 384.002 251.246 382.894 250.607C381.786 249.967 380.36 250.363 379.708 251.491C379.057 252.62 379.427 254.053 380.535 254.693Z"
          fill="#3A2933"
        />
        <path
          d="M386.202 263.412C387.31 264.052 388.736 263.656 389.387 262.528C390.039 261.399 389.669 259.966 388.561 259.326C387.453 258.687 386.026 259.083 385.375 260.211C384.723 261.339 385.093 262.773 386.202 263.412Z"
          fill="#3A2933"
        />
        <path
          d="M381.483 271.584C382.592 272.224 384.018 271.828 384.669 270.7C385.321 269.571 384.951 268.138 383.842 267.498C382.734 266.859 381.308 267.255 380.657 268.383C380.005 269.511 380.375 270.945 381.483 271.584Z"
          fill="#3A2933"
        />
        <path
          d="M375.817 262.865C376.925 263.505 378.351 263.109 379.003 261.98C379.654 260.852 379.284 259.419 378.176 258.779C377.068 258.139 375.641 258.535 374.99 259.663C374.339 260.792 374.709 262.225 375.817 262.865Z"
          fill="#3A2933"
        />
        <path
          d="M371.099 271.037C372.207 271.677 373.633 271.281 374.285 270.152C374.936 269.024 374.566 267.591 373.458 266.951C372.35 266.311 370.923 266.707 370.272 267.835C369.62 268.964 369.991 270.397 371.099 271.037Z"
          fill="#3A2933"
        />
        <path
          d="M376.765 279.757C377.873 280.396 379.3 280 379.951 278.872C380.603 277.744 380.232 276.31 379.124 275.67C378.016 275.031 376.59 275.427 375.938 276.555C375.287 277.683 375.657 279.117 376.765 279.757Z"
          fill="#3A2933"
        />
        <path
          d="M366.381 279.209C367.489 279.849 368.915 279.453 369.567 278.324C370.218 277.196 369.848 275.763 368.74 275.123C367.632 274.483 366.205 274.879 365.554 276.008C364.902 277.136 365.272 278.569 366.381 279.209Z"
          fill="#3A2933"
        />
        <path
          d="M372.047 287.929C373.155 288.568 374.582 288.172 375.233 287.044C375.885 285.916 375.514 284.482 374.406 283.843C373.298 283.203 371.872 283.599 371.22 284.727C370.569 285.856 370.939 287.289 372.047 287.929Z"
          fill="#3A2933"
        />
        <path
          d="M361.662 287.381C362.771 288.021 364.197 287.625 364.848 286.496C365.5 285.368 365.13 283.935 364.022 283.295C362.913 282.655 361.487 283.051 360.836 284.18C360.184 285.308 360.554 286.741 361.662 287.381Z"
          fill="#3A2933"
        />
        <path
          d="M367.329 296.101C368.437 296.74 369.863 296.344 370.515 295.216C371.166 294.088 370.796 292.654 369.688 292.015C368.58 291.375 367.154 291.771 366.502 292.899C365.851 294.028 366.221 295.461 367.329 296.101Z"
          fill="#3A2933"
        />
        <path
          d="M362.611 304.273C363.719 304.912 365.145 304.516 365.797 303.388C366.448 302.26 366.078 300.826 364.97 300.187C363.862 299.547 362.435 299.943 361.784 301.071C361.133 302.2 361.503 303.633 362.611 304.273Z"
          fill="#3A2933"
        />
        <path
          d="M356.944 295.553C358.052 296.193 359.479 295.797 360.13 294.668C360.782 293.54 360.411 292.107 359.303 291.467C358.195 290.827 356.769 291.223 356.117 292.352C355.466 293.48 355.836 294.913 356.944 295.553Z"
          fill="#3A2933"
        />
        <path
          d="M352.226 303.725C353.334 304.365 354.761 303.969 355.412 302.841C356.064 301.712 355.693 300.279 354.585 299.639C353.477 298.999 352.051 299.395 351.399 300.524C350.748 301.652 351.118 303.085 352.226 303.725Z"
          fill="#3A2933"
        />
        <path
          d="M357.893 312.445C359.001 313.085 360.427 312.688 361.079 311.56C361.73 310.432 361.36 308.999 360.252 308.359C359.144 307.719 357.717 308.115 357.066 309.243C356.414 310.372 356.785 311.805 357.893 312.445Z"
          fill="#3A2933"
        />
        <path
          d="M347.508 311.897C348.616 312.537 350.043 312.141 350.694 311.013C351.345 309.884 350.975 308.451 349.867 307.811C348.759 307.171 347.333 307.567 346.681 308.696C346.03 309.824 346.4 311.257 347.508 311.897Z"
          fill="#3A2933"
        />
        <path
          d="M353.175 320.617C354.283 321.257 355.709 320.861 356.36 319.732C357.012 318.604 356.642 317.171 355.534 316.531C354.426 315.891 352.999 316.287 352.348 317.415C351.696 318.544 352.066 319.977 353.175 320.617Z"
          fill="#3A2933"
        />
        <path
          d="M348.456 328.789C349.565 329.429 350.991 329.033 351.642 327.904C352.294 326.776 351.924 325.343 350.815 324.703C349.707 324.063 348.281 324.459 347.63 325.588C346.978 326.716 347.348 328.149 348.456 328.789Z"
          fill="#3A2933"
        />
        <path
          d="M342.79 320.069C343.898 320.709 345.324 320.313 345.976 319.185C346.627 318.056 346.257 316.623 345.149 315.983C344.041 315.343 342.614 315.74 341.963 316.868C341.312 317.996 341.682 319.43 342.79 320.069Z"
          fill="#3A2933"
        />
        <path
          d="M457.922 157.723C459.03 158.363 460.457 157.967 461.108 156.838C461.759 155.71 461.389 154.277 460.281 153.637C459.173 152.997 457.747 153.393 457.095 154.522C456.444 155.65 456.814 157.083 457.922 157.723Z"
          fill="#3A2933"
        />
        <path
          d="M463.589 166.443C464.697 167.082 466.123 166.686 466.775 165.558C467.426 164.43 467.056 162.996 465.948 162.357C464.84 161.717 463.413 162.113 462.762 163.241C462.11 164.37 462.481 165.803 463.589 166.443Z"
          fill="#3A2933"
        />
        <path
          d="M468.307 158.271C469.415 158.91 470.841 158.514 471.493 157.386C472.144 156.258 471.774 154.824 470.666 154.185C469.558 153.545 468.131 153.941 467.48 155.069C466.828 156.198 467.199 157.631 468.307 158.271Z"
          fill="#3A2933"
        />
        <path
          d="M453.204 165.895C454.312 166.535 455.738 166.139 456.39 165.011C457.041 163.882 456.671 162.449 455.563 161.809C454.455 161.169 453.029 161.565 452.377 162.694C451.726 163.822 452.096 165.255 453.204 165.895Z"
          fill="#3A2933"
        />
        <path
          d="M458.871 174.615C459.979 175.255 461.405 174.858 462.056 173.73C462.708 172.602 462.338 171.169 461.23 170.529C460.121 169.889 458.695 170.285 458.044 171.413C457.392 172.542 457.762 173.975 458.871 174.615Z"
          fill="#3A2933"
        />
        <path
          d="M448.486 174.067C449.594 174.707 451.02 174.311 451.672 173.183C452.323 172.054 451.953 170.621 450.845 169.981C449.737 169.341 448.31 169.737 447.659 170.866C447.008 171.994 447.378 173.427 448.486 174.067Z"
          fill="#3A2933"
        />
        <path
          d="M454.152 182.787C455.26 183.427 456.687 183.031 457.338 181.902C457.99 180.774 457.62 179.341 456.511 178.701C455.403 178.061 453.977 178.457 453.325 179.585C452.674 180.714 453.044 182.147 454.152 182.787Z"
          fill="#3A2933"
        />
        <path
          d="M449.434 190.959C450.542 191.599 451.969 191.203 452.62 190.074C453.272 188.946 452.901 187.513 451.793 186.873C450.685 186.233 449.259 186.629 448.607 187.757C447.956 188.886 448.326 190.319 449.434 190.959Z"
          fill="#3A2933"
        />
        <path
          d="M443.768 182.239C444.876 182.879 446.302 182.483 446.954 181.355C447.605 180.226 447.235 178.793 446.127 178.153C445.019 177.514 443.592 177.91 442.941 179.038C442.289 180.166 442.66 181.6 443.768 182.239Z"
          fill="#3A2933"
        />
        <path
          d="M439.05 190.411C440.158 191.051 441.584 190.655 442.235 189.527C442.887 188.398 442.517 186.965 441.409 186.325C440.301 185.686 438.874 186.082 438.223 187.21C437.571 188.338 437.941 189.772 439.05 190.411Z"
          fill="#3A2933"
        />
        <path
          d="M444.716 199.131C445.824 199.771 447.251 199.375 447.902 198.246C448.553 197.118 448.183 195.685 447.075 195.045C445.967 194.405 444.541 194.801 443.889 195.93C443.238 197.058 443.608 198.491 444.716 199.131Z"
          fill="#3A2933"
        />
        <path
          d="M434.331 198.583C435.44 199.223 436.866 198.827 437.517 197.699C438.169 196.57 437.799 195.137 436.69 194.497C435.582 193.858 434.156 194.254 433.505 195.382C432.853 196.51 433.223 197.944 434.331 198.583Z"
          fill="#3A2933"
        />
        <path
          d="M439.998 207.303C441.106 207.943 442.532 207.547 443.184 206.418C443.835 205.29 443.465 203.857 442.357 203.217C441.249 202.577 439.822 202.973 439.171 204.102C438.52 205.23 438.89 206.663 439.998 207.303Z"
          fill="#3A2933"
        />
        <path
          d="M429.613 206.755C430.721 207.395 432.148 206.999 432.799 205.871C433.451 204.743 433.08 203.309 431.972 202.669C430.864 202.03 429.438 202.426 428.786 203.554C428.135 204.682 428.505 206.116 429.613 206.755Z"
          fill="#3A2933"
        />
        <path
          d="M435.28 215.475C436.388 216.115 437.814 215.719 438.466 214.59C439.117 213.462 438.747 212.029 437.639 211.389C436.531 210.749 435.104 211.145 434.453 212.274C433.801 213.402 434.172 214.835 435.28 215.475Z"
          fill="#3A2933"
        />
        <path
          d="M430.562 223.647C431.67 224.287 433.096 223.891 433.748 222.763C434.399 221.634 434.029 220.201 432.921 219.561C431.813 218.921 430.386 219.317 429.735 220.446C429.083 221.574 429.454 223.007 430.562 223.647Z"
          fill="#3A2933"
        />
        <path
          d="M424.895 214.928C426.003 215.567 427.43 215.171 428.081 214.043C428.732 212.915 428.362 211.481 427.254 210.842C426.146 210.202 424.72 210.598 424.068 211.726C423.417 212.854 423.787 214.288 424.895 214.928Z"
          fill="#3A2933"
        />
        <path
          d="M420.177 223.1C421.285 223.739 422.711 223.343 423.363 222.215C424.014 221.087 423.644 219.653 422.536 219.014C421.428 218.374 420.002 218.77 419.35 219.898C418.699 221.027 419.069 222.46 420.177 223.1Z"
          fill="#3A2933"
        />
        <path
          d="M425.843 231.819C426.952 232.459 428.378 232.063 429.029 230.935C429.681 229.806 429.311 228.373 428.203 227.733C427.094 227.093 425.668 227.489 425.017 228.618C424.365 229.746 424.735 231.179 425.843 231.819Z"
          fill="#3A2933"
        />
        <path
          d="M415.459 231.272C416.567 231.911 417.993 231.515 418.645 230.387C419.296 229.259 418.926 227.825 417.818 227.186C416.71 226.546 415.283 226.942 414.632 228.07C413.981 229.199 414.351 230.632 415.459 231.272Z"
          fill="#3A2933"
        />
        <path
          d="M421.125 239.991C422.233 240.631 423.66 240.235 424.311 239.107C424.963 237.978 424.593 236.545 423.484 235.905C422.376 235.265 420.95 235.662 420.298 236.79C419.647 237.918 420.017 239.352 421.125 239.991Z"
          fill="#3A2933"
        />
        <path
          d="M416.407 248.163C417.515 248.803 418.942 248.407 419.593 247.279C420.245 246.15 419.874 244.717 418.766 244.077C417.658 243.438 416.232 243.834 415.58 244.962C414.929 246.09 415.299 247.524 416.407 248.163Z"
          fill="#3A2933"
        />
        <path
          d="M410.741 239.444C411.849 240.084 413.275 239.687 413.927 238.559C414.578 237.431 414.208 235.997 413.1 235.358C411.992 234.718 410.565 235.114 409.914 236.242C409.262 237.371 409.633 238.804 410.741 239.444Z"
          fill="#3A2933"
        />
        <path
          d="M406.023 247.616C407.131 248.256 408.557 247.86 409.208 246.731C409.86 245.603 409.49 244.17 408.382 243.53C407.274 242.89 405.847 243.286 405.196 244.414C404.544 245.543 404.914 246.976 406.023 247.616Z"
          fill="#3A2933"
        />
        <path
          d="M411.689 256.335C412.797 256.975 414.224 256.579 414.875 255.451C415.526 254.322 415.156 252.889 414.048 252.249C412.94 251.61 411.514 252.006 410.862 253.134C410.211 254.262 410.581 255.696 411.689 256.335Z"
          fill="#3A2933"
        />
        <path
          d="M401.304 255.788C402.413 256.428 403.839 256.032 404.49 254.903C405.142 253.775 404.772 252.342 403.663 251.702C402.555 251.062 401.129 251.458 400.478 252.586C399.826 253.715 400.196 255.148 401.304 255.788Z"
          fill="#3A2933"
        />
        <path
          d="M406.971 264.507C408.079 265.147 409.505 264.751 410.157 263.623C410.808 262.495 410.438 261.061 409.33 260.421C408.222 259.782 406.795 260.178 406.144 261.306C405.493 262.434 405.863 263.868 406.971 264.507Z"
          fill="#3A2933"
        />
        <path
          d="M396.586 263.96C397.694 264.6 399.121 264.204 399.772 263.075C400.424 261.947 400.053 260.514 398.945 259.874C397.837 259.234 396.411 259.63 395.759 260.759C395.108 261.887 395.478 263.32 396.586 263.96Z"
          fill="#3A2933"
        />
        <path
          d="M402.253 272.68C403.361 273.319 404.787 272.923 405.439 271.795C406.09 270.667 405.72 269.233 404.612 268.594C403.504 267.954 402.077 268.35 401.426 269.478C400.774 270.606 401.145 272.04 402.253 272.68Z"
          fill="#3A2933"
        />
        <path
          d="M397.535 280.852C398.643 281.491 400.069 281.095 400.721 279.967C401.372 278.839 401.002 277.405 399.894 276.766C398.786 276.126 397.359 276.522 396.708 277.65C396.056 278.779 396.427 280.212 397.535 280.852Z"
          fill="#3A2933"
        />
        <path
          d="M391.868 272.132C392.976 272.772 394.403 272.376 395.054 271.247C395.705 270.119 395.335 268.686 394.227 268.046C393.119 267.406 391.693 267.802 391.041 268.931C390.39 270.059 390.76 271.492 391.868 272.132Z"
          fill="#3A2933"
        />
        <path
          d="M387.15 280.304C388.258 280.944 389.684 280.548 390.336 279.419C390.987 278.291 390.617 276.858 389.509 276.218C388.401 275.578 386.975 275.974 386.323 277.103C385.672 278.231 386.042 279.664 387.15 280.304Z"
          fill="#3A2933"
        />
        <path
          d="M392.816 289.024C393.925 289.663 395.351 289.267 396.002 288.139C396.654 287.011 396.284 285.577 395.176 284.938C394.067 284.298 392.641 284.694 391.99 285.822C391.338 286.951 391.708 288.384 392.816 289.024Z"
          fill="#3A2933"
        />
        <path
          d="M382.432 288.476C383.54 289.116 384.966 288.72 385.618 287.592C386.269 286.463 385.899 285.03 384.791 284.39C383.683 283.75 382.256 284.146 381.605 285.275C380.954 286.403 381.324 287.836 382.432 288.476Z"
          fill="#3A2933"
        />
        <path
          d="M388.098 297.196C389.206 297.836 390.633 297.439 391.284 296.311C391.936 295.183 391.566 293.749 390.457 293.11C389.349 292.47 387.923 292.866 387.271 293.994C386.62 295.123 386.99 296.556 388.098 297.196Z"
          fill="#3A2933"
        />
        <path
          d="M377.714 296.648C378.822 297.288 380.248 296.892 380.9 295.764C381.551 294.635 381.181 293.202 380.073 292.562C378.965 291.922 377.538 292.318 376.887 293.447C376.235 294.575 376.606 296.008 377.714 296.648Z"
          fill="#3A2933"
        />
        <path
          d="M383.38 305.368C384.488 306.008 385.915 305.612 386.566 304.483C387.218 303.355 386.847 301.922 385.739 301.282C384.631 300.642 383.205 301.038 382.553 302.166C381.902 303.295 382.272 304.728 383.38 305.368Z"
          fill="#3A2933"
        />
        <path
          d="M378.662 313.54C379.77 314.18 381.197 313.784 381.848 312.655C382.499 311.527 382.129 310.094 381.021 309.454C379.913 308.814 378.487 309.21 377.835 310.338C377.184 311.467 377.554 312.9 378.662 313.54Z"
          fill="#3A2933"
        />
        <path
          d="M372.996 304.82C374.104 305.46 375.53 305.064 376.181 303.936C376.833 302.807 376.463 301.374 375.355 300.734C374.247 300.094 372.82 300.491 372.169 301.619C371.517 302.747 371.887 304.181 372.996 304.82Z"
          fill="#3A2933"
        />
        <path
          d="M368.277 312.992C369.386 313.632 370.812 313.236 371.463 312.108C372.115 310.979 371.745 309.546 370.636 308.906C369.528 308.267 368.102 308.663 367.451 309.791C366.799 310.919 367.169 312.353 368.277 312.992Z"
          fill="#3A2933"
        />
        <path
          d="M373.944 321.712C375.052 322.352 376.478 321.956 377.13 320.827C377.781 319.699 377.411 318.266 376.303 317.626C375.195 316.986 373.768 317.382 373.117 318.511C372.466 319.639 372.836 321.072 373.944 321.712Z"
          fill="#3A2933"
        />
        <path
          d="M363.559 321.164C364.667 321.804 366.094 321.408 366.745 320.28C367.397 319.151 367.026 317.718 365.918 317.078C364.81 316.439 363.384 316.835 362.732 317.963C362.081 319.091 362.451 320.525 363.559 321.164Z"
          fill="#3A2933"
        />
        <path
          d="M369.226 329.884C370.334 330.524 371.76 330.128 372.412 328.999C373.063 327.871 372.693 326.438 371.585 325.798C370.477 325.158 369.05 325.554 368.399 326.683C367.747 327.811 368.118 329.244 369.226 329.884Z"
          fill="#3A2933"
        />
        <path
          d="M364.508 338.056C365.616 338.696 367.042 338.3 367.694 337.171C368.345 336.043 367.975 334.61 366.867 333.97C365.759 333.33 364.332 333.726 363.681 334.855C363.029 335.983 363.4 337.416 364.508 338.056Z"
          fill="#3A2933"
        />
        <path
          d="M358.841 329.336C359.949 329.976 361.376 329.58 362.027 328.452C362.678 327.324 362.308 325.89 361.2 325.25C360.092 324.611 358.666 325.007 358.014 326.135C357.363 327.263 357.733 328.697 358.841 329.336Z"
          fill="#3A2933"
        />
        <path
          d="M473.973 166.99C475.081 167.63 476.508 167.234 477.159 166.106C477.811 164.977 477.441 163.544 476.332 162.904C475.224 162.264 473.798 162.661 473.146 163.789C472.495 164.917 472.865 166.351 473.973 166.99Z"
          fill="#3A2933"
        />
        <path
          d="M479.64 175.71C480.748 176.35 482.174 175.954 482.826 174.825C483.477 173.697 483.107 172.264 481.999 171.624C480.891 170.984 479.464 171.38 478.813 172.508C478.162 173.637 478.532 175.07 479.64 175.71Z"
          fill="#3A2933"
        />
        <path
          d="M484.358 167.538C485.466 168.178 486.893 167.782 487.544 166.653C488.195 165.525 487.825 164.092 486.717 163.452C485.609 162.812 484.183 163.208 483.531 164.336C482.88 165.465 483.25 166.898 484.358 167.538Z"
          fill="#3A2933"
        />
        <path
          d="M469.255 175.162C470.363 175.802 471.79 175.406 472.441 174.278C473.093 173.149 472.722 171.716 471.614 171.076C470.506 170.437 469.08 170.833 468.428 171.961C467.777 173.089 468.147 174.523 469.255 175.162Z"
          fill="#3A2933"
        />
        <path
          d="M474.922 183.882C476.03 184.522 477.456 184.126 478.108 182.997C478.759 181.869 478.389 180.436 477.281 179.796C476.173 179.156 474.746 179.552 474.095 180.681C473.443 181.809 473.814 183.242 474.922 183.882Z"
          fill="#3A2933"
        />
        <path
          d="M464.537 183.334C465.645 183.974 467.072 183.578 467.723 182.45C468.374 181.321 468.004 179.888 466.896 179.248C465.788 178.609 464.362 179.005 463.71 180.133C463.059 181.261 463.429 182.695 464.537 183.334Z"
          fill="#3A2933"
        />
        <path
          d="M470.204 192.054C471.312 192.694 472.738 192.298 473.39 191.169C474.041 190.041 473.671 188.608 472.563 187.968C471.455 187.328 470.028 187.724 469.377 188.853C468.725 189.981 469.095 191.414 470.204 192.054Z"
          fill="#3A2933"
        />
        <path
          d="M465.485 200.226C466.594 200.866 468.02 200.47 468.671 199.341C469.323 198.213 468.953 196.78 467.845 196.14C466.736 195.5 465.31 195.896 464.659 197.025C464.007 198.153 464.377 199.586 465.485 200.226Z"
          fill="#3A2933"
        />
        <path
          d="M459.819 191.506C460.927 192.146 462.353 191.75 463.005 190.622C463.656 189.494 463.286 188.06 462.178 187.42C461.07 186.781 459.643 187.177 458.992 188.305C458.341 189.433 458.711 190.867 459.819 191.506Z"
          fill="#3A2933"
        />
        <path
          d="M455.101 199.679C456.209 200.318 457.635 199.922 458.287 198.794C458.938 197.666 458.568 196.232 457.46 195.592C456.352 194.953 454.925 195.349 454.274 196.477C453.622 197.605 453.993 199.039 455.101 199.679Z"
          fill="#3A2933"
        />
        <path
          d="M460.767 208.398C461.875 209.038 463.302 208.642 463.953 207.514C464.605 206.385 464.234 204.952 463.126 204.312C462.018 203.672 460.592 204.068 459.94 205.197C459.289 206.325 459.659 207.758 460.767 208.398Z"
          fill="#3A2933"
        />
        <path
          d="M450.383 207.851C451.491 208.49 452.917 208.094 453.569 206.966C454.22 205.838 453.85 204.404 452.742 203.765C451.634 203.125 450.207 203.521 449.556 204.649C448.904 205.778 449.275 207.211 450.383 207.851Z"
          fill="#3A2933"
        />
        <path
          d="M456.049 216.57C457.157 217.21 458.584 216.814 459.235 215.686C459.887 214.557 459.516 213.124 458.408 212.484C457.3 211.844 455.874 212.24 455.222 213.369C454.571 214.497 454.941 215.93 456.049 216.57Z"
          fill="#3A2933"
        />
        <path
          d="M445.664 216.023C446.773 216.662 448.199 216.266 448.85 215.138C449.502 214.01 449.132 212.576 448.024 211.937C446.915 211.297 445.489 211.693 444.838 212.821C444.186 213.95 444.556 215.383 445.664 216.023Z"
          fill="#3A2933"
        />
        <path
          d="M451.331 224.742C452.439 225.382 453.866 224.986 454.517 223.858C455.168 222.729 454.798 221.296 453.69 220.656C452.582 220.016 451.156 220.413 450.504 221.541C449.853 222.669 450.223 224.103 451.331 224.742Z"
          fill="#3A2933"
        />
        <path
          d="M446.613 232.914C447.721 233.554 449.147 233.158 449.799 232.03C450.45 230.901 450.08 229.468 448.972 228.828C447.864 228.189 446.437 228.585 445.786 229.713C445.135 230.841 445.505 232.275 446.613 232.914Z"
          fill="#3A2933"
        />
        <path
          d="M440.946 224.195C442.054 224.834 443.481 224.438 444.132 223.31C444.784 222.182 444.414 220.748 443.305 220.109C442.197 219.469 440.771 219.865 440.119 220.993C439.468 222.122 439.838 223.555 440.946 224.195Z"
          fill="#3A2933"
        />
        <path
          d="M436.228 232.367C437.336 233.007 438.763 232.61 439.414 231.482C440.066 230.354 439.695 228.921 438.587 228.281C437.479 227.641 436.053 228.037 435.401 229.165C434.75 230.294 435.12 231.727 436.228 232.367Z"
          fill="#3A2933"
        />
        <path
          d="M441.895 241.086C443.003 241.726 444.429 241.33 445.081 240.202C445.732 239.073 445.362 237.64 444.254 237C443.146 236.361 441.719 236.757 441.068 237.885C440.416 239.013 440.787 240.447 441.895 241.086Z"
          fill="#3A2933"
        />
        <path
          d="M431.51 240.539C432.618 241.179 434.045 240.783 434.696 239.654C435.347 238.526 434.977 237.093 433.869 236.453C432.761 235.813 431.335 236.209 430.683 237.337C430.032 238.466 430.402 239.899 431.51 240.539Z"
          fill="#3A2933"
        />
        <path
          d="M437.177 249.258C438.285 249.898 439.711 249.502 440.363 248.374C441.014 247.246 440.644 245.812 439.536 245.172C438.428 244.533 437.001 244.929 436.35 246.057C435.698 247.185 436.068 248.619 437.177 249.258Z"
          fill="#3A2933"
        />
        <path
          d="M432.458 257.431C433.567 258.07 434.993 257.674 435.644 256.546C436.296 255.418 435.926 253.984 434.818 253.345C433.709 252.705 432.283 253.101 431.632 254.229C430.98 255.357 431.35 256.791 432.458 257.431Z"
          fill="#3A2933"
        />
        <path
          d="M426.792 248.711C427.9 249.351 429.326 248.955 429.978 247.826C430.629 246.698 430.259 245.265 429.151 244.625C428.043 243.985 426.616 244.381 425.965 245.51C425.314 246.638 425.684 248.071 426.792 248.711Z"
          fill="#3A2933"
        />
        <path
          d="M422.074 256.883C423.182 257.523 424.608 257.127 425.26 255.998C425.911 254.87 425.541 253.437 424.433 252.797C423.325 252.157 421.898 252.553 421.247 253.682C420.595 254.81 420.966 256.243 422.074 256.883Z"
          fill="#3A2933"
        />
        <path
          d="M427.74 265.603C428.848 266.242 430.275 265.846 430.926 264.718C431.578 263.59 431.207 262.156 430.099 261.517C428.991 260.877 427.565 261.273 426.913 262.401C426.262 263.53 426.632 264.963 427.74 265.603Z"
          fill="#3A2933"
        />
        <path
          d="M417.356 265.055C418.464 265.695 419.89 265.299 420.542 264.17C421.193 263.042 420.823 261.609 419.715 260.969C418.607 260.329 417.18 260.725 416.529 261.854C415.877 262.982 416.248 264.415 417.356 265.055Z"
          fill="#3A2933"
        />
        <path
          d="M423.022 273.775C424.13 274.414 425.557 274.018 426.208 272.89C426.86 271.762 426.489 270.328 425.381 269.689C424.273 269.049 422.847 269.445 422.195 270.573C421.544 271.702 421.914 273.135 423.022 273.775Z"
          fill="#3A2933"
        />
        <path
          d="M412.637 273.227C413.746 273.867 415.172 273.471 415.823 272.343C416.475 271.214 416.105 269.781 414.997 269.141C413.888 268.501 412.462 268.897 411.811 270.026C411.159 271.154 411.529 272.587 412.637 273.227Z"
          fill="#3A2933"
        />
        <path
          d="M418.304 281.947C419.412 282.587 420.839 282.19 421.49 281.062C422.141 279.934 421.771 278.5 420.663 277.861C419.555 277.221 418.129 277.617 417.477 278.745C416.826 279.874 417.196 281.307 418.304 281.947Z"
          fill="#3A2933"
        />
        <path
          d="M413.586 290.119C414.694 290.759 416.12 290.363 416.772 289.234C417.423 288.106 417.053 286.673 415.945 286.033C414.837 285.393 413.41 285.789 412.759 286.917C412.108 288.046 412.478 289.479 413.586 290.119Z"
          fill="#3A2933"
        />
        <path
          d="M407.919 281.399C409.027 282.039 410.454 281.643 411.105 280.515C411.757 279.386 411.386 277.953 410.278 277.313C409.17 276.673 407.744 277.069 407.092 278.198C406.441 279.326 406.811 280.759 407.919 281.399Z"
          fill="#3A2933"
        />
        <path
          d="M403.201 289.571C404.309 290.211 405.736 289.815 406.387 288.687C407.039 287.558 406.668 286.125 405.56 285.485C404.452 284.845 403.026 285.242 402.374 286.37C401.723 287.498 402.093 288.931 403.201 289.571Z"
          fill="#3A2933"
        />
        <path
          d="M408.868 298.291C409.976 298.931 411.402 298.535 412.054 297.406C412.705 296.278 412.335 294.845 411.227 294.205C410.119 293.565 408.692 293.961 408.041 295.089C407.389 296.218 407.76 297.651 408.868 298.291Z"
          fill="#3A2933"
        />
        <path
          d="M398.483 297.743C399.591 298.383 401.018 297.987 401.669 296.859C402.32 295.73 401.95 294.297 400.842 293.657C399.734 293.018 398.308 293.414 397.656 294.542C397.005 295.67 397.375 297.104 398.483 297.743Z"
          fill="#3A2933"
        />
        <path
          d="M404.15 306.463C405.258 307.103 406.684 306.707 407.336 305.578C407.987 304.45 407.617 303.017 406.509 302.377C405.401 301.737 403.974 302.133 403.323 303.262C402.671 304.39 403.041 305.823 404.15 306.463Z"
          fill="#3A2933"
        />
        <path
          d="M393.765 305.915C394.873 306.555 396.299 306.159 396.951 305.031C397.602 303.902 397.232 302.469 396.124 301.829C395.016 301.19 393.589 301.586 392.938 302.714C392.287 303.842 392.657 305.276 393.765 305.915Z"
          fill="#3A2933"
        />
        <path
          d="M399.431 314.635C400.54 315.275 401.966 314.879 402.617 313.75C403.269 312.622 402.899 311.189 401.791 310.549C400.682 309.909 399.256 310.305 398.605 311.434C397.953 312.562 398.323 313.995 399.431 314.635Z"
          fill="#3A2933"
        />
        <path
          d="M394.713 322.807C395.821 323.447 397.248 323.051 397.899 321.922C398.551 320.794 398.18 319.361 397.072 318.721C395.964 318.081 394.538 318.477 393.886 319.606C393.235 320.734 393.605 322.167 394.713 322.807Z"
          fill="#3A2933"
        />
        <path
          d="M389.047 314.087C390.155 314.727 391.581 314.331 392.233 313.203C392.884 312.074 392.514 310.641 391.406 310.001C390.298 309.362 388.871 309.758 388.22 310.886C387.568 312.014 387.939 313.448 389.047 314.087Z"
          fill="#3A2933"
        />
        <path
          d="M384.329 322.26C385.437 322.899 386.863 322.503 387.515 321.375C388.166 320.247 387.796 318.813 386.688 318.173C385.58 317.534 384.153 317.93 383.502 319.058C382.85 320.186 383.221 321.62 384.329 322.26Z"
          fill="#3A2933"
        />
        <path
          d="M389.995 330.979C391.103 331.619 392.53 331.223 393.181 330.095C393.833 328.966 393.462 327.533 392.354 326.893C391.246 326.253 389.82 326.649 389.168 327.778C388.517 328.906 388.887 330.339 389.995 330.979Z"
          fill="#3A2933"
        />
        <path
          d="M379.61 330.432C380.719 331.071 382.145 330.675 382.796 329.547C383.448 328.419 383.078 326.985 381.97 326.346C380.861 325.706 379.435 326.102 378.784 327.23C378.132 328.358 378.502 329.792 379.61 330.432Z"
          fill="#3A2933"
        />
        <path
          d="M385.277 339.151C386.385 339.791 387.812 339.395 388.463 338.267C389.114 337.138 388.744 335.705 387.636 335.065C386.528 334.425 385.102 334.821 384.45 335.95C383.799 337.078 384.169 338.511 385.277 339.151Z"
          fill="#3A2933"
        />
        <path
          d="M380.559 347.323C381.667 347.963 383.093 347.567 383.745 346.439C384.396 345.31 384.026 343.877 382.918 343.237C381.81 342.597 380.383 342.994 379.732 344.122C379.081 345.25 379.451 346.684 380.559 347.323Z"
          fill="#3A2933"
        />
        <path
          d="M374.892 338.604C376 339.243 377.427 338.847 378.078 337.719C378.73 336.591 378.359 335.157 377.251 334.518C376.143 333.878 374.717 334.274 374.065 335.402C373.414 336.531 373.784 337.964 374.892 338.604Z"
          fill="#3A2933"
        />
        <path
          d="M490.025 176.257C491.133 176.897 492.559 176.501 493.211 175.373C493.862 174.245 493.492 172.811 492.384 172.171C491.276 171.532 489.849 171.928 489.198 173.056C488.546 174.184 488.916 175.618 490.025 176.257Z"
          fill="#3A2933"
        />
        <path
          d="M495.691 184.977C496.799 185.617 498.226 185.221 498.877 184.092C499.528 182.964 499.158 181.531 498.05 180.891C496.942 180.251 495.516 180.647 494.864 181.776C494.213 182.904 494.583 184.337 495.691 184.977Z"
          fill="#3A2933"
        />
        <path
          d="M500.409 176.805C501.517 177.445 502.944 177.049 503.595 175.92C504.247 174.792 503.876 173.359 502.768 172.719C501.66 172.079 500.234 172.475 499.582 173.604C498.931 174.732 499.301 176.165 500.409 176.805Z"
          fill="#3A2933"
        />
        <path
          d="M485.306 184.43C486.415 185.069 487.841 184.673 488.492 183.545C489.144 182.417 488.774 180.983 487.665 180.343C486.557 179.704 485.131 180.1 484.48 181.228C483.828 182.356 484.198 183.79 485.306 184.43Z"
          fill="#3A2933"
        />
        <path
          d="M490.973 193.149C492.081 193.789 493.507 193.393 494.159 192.265C494.81 191.136 494.44 189.703 493.332 189.063C492.224 188.423 490.798 188.819 490.146 189.948C489.495 191.076 489.865 192.509 490.973 193.149Z"
          fill="#3A2933"
        />
        <path
          d="M480.588 192.602C481.696 193.241 483.123 192.845 483.774 191.717C484.426 190.589 484.055 189.155 482.947 188.516C481.839 187.876 480.413 188.272 479.761 189.4C479.11 190.528 479.48 191.962 480.588 192.602Z"
          fill="#3A2933"
        />
        <path
          d="M486.255 201.321C487.363 201.961 488.789 201.565 489.441 200.437C490.092 199.308 489.722 197.875 488.614 197.235C487.506 196.595 486.079 196.991 485.428 198.12C484.777 199.248 485.147 200.681 486.255 201.321Z"
          fill="#3A2933"
        />
        <path
          d="M481.537 209.493C482.645 210.133 484.071 209.737 484.723 208.609C485.374 207.48 485.004 206.047 483.896 205.407C482.788 204.767 481.361 205.164 480.71 206.292C480.058 207.42 480.429 208.854 481.537 209.493Z"
          fill="#3A2933"
        />
        <path
          d="M475.87 200.774C476.978 201.413 478.405 201.017 479.056 199.889C479.708 198.761 479.337 197.327 478.229 196.688C477.121 196.048 475.695 196.444 475.043 197.572C474.392 198.701 474.762 200.134 475.87 200.774Z"
          fill="#3A2933"
        />
        <path
          d="M471.152 208.946C472.26 209.585 473.686 209.189 474.338 208.061C474.989 206.933 474.619 205.499 473.511 204.86C472.403 204.22 470.977 204.616 470.325 205.744C469.674 206.873 470.044 208.306 471.152 208.946Z"
          fill="#3A2933"
        />
        <path
          d="M476.819 217.665C477.927 218.305 479.353 217.909 480.004 216.781C480.656 215.652 480.286 214.219 479.178 213.579C478.069 212.94 476.643 213.336 475.992 214.464C475.34 215.592 475.71 217.026 476.819 217.665Z"
          fill="#3A2933"
        />
        <path
          d="M466.434 217.118C467.542 217.758 468.968 217.361 469.62 216.233C470.271 215.105 469.901 213.672 468.793 213.032C467.685 212.392 466.258 212.788 465.607 213.916C464.956 215.045 465.326 216.478 466.434 217.118Z"
          fill="#3A2933"
        />
        <path
          d="M472.1 225.837C473.208 226.477 474.635 226.081 475.286 224.953C475.938 223.824 475.568 222.391 474.459 221.751C473.351 221.112 471.925 221.508 471.274 222.636C470.622 223.764 470.992 225.198 472.1 225.837Z"
          fill="#3A2933"
        />
        <path
          d="M461.716 225.29C462.824 225.93 464.25 225.534 464.902 224.405C465.553 223.277 465.183 221.844 464.075 221.204C462.967 220.564 461.54 220.96 460.889 222.088C460.237 223.217 460.608 224.65 461.716 225.29Z"
          fill="#3A2933"
        />
        <path
          d="M467.382 234.009C468.49 234.649 469.917 234.253 470.568 233.125C471.22 231.997 470.849 230.563 469.741 229.923C468.633 229.284 467.207 229.68 466.555 230.808C465.904 231.936 466.274 233.37 467.382 234.009Z"
          fill="#3A2933"
        />
        <path
          d="M462.664 242.182C463.772 242.821 465.199 242.425 465.85 241.297C466.501 240.169 466.131 238.735 465.023 238.095C463.915 237.456 462.489 237.852 461.837 238.98C461.186 240.108 461.556 241.542 462.664 242.182Z"
          fill="#3A2933"
        />
        <path
          d="M456.998 233.462C458.106 234.102 459.532 233.706 460.184 232.577C460.835 231.449 460.465 230.016 459.357 229.376C458.249 228.736 456.822 229.132 456.171 230.26C455.519 231.389 455.889 232.822 456.998 233.462Z"
          fill="#3A2933"
        />
        <path
          d="M452.279 241.634C453.388 242.274 454.814 241.878 455.465 240.749C456.117 239.621 455.747 238.188 454.638 237.548C453.53 236.908 452.104 237.304 451.453 238.433C450.801 239.561 451.171 240.994 452.279 241.634Z"
          fill="#3A2933"
        />
        <path
          d="M457.946 250.354C459.054 250.993 460.48 250.597 461.132 249.469C461.783 248.341 461.413 246.907 460.305 246.268C459.197 245.628 457.771 246.024 457.119 247.152C456.468 248.281 456.838 249.714 457.946 250.354Z"
          fill="#3A2933"
        />
        <path
          d="M447.561 249.806C448.669 250.446 450.096 250.05 450.747 248.921C451.399 247.793 451.028 246.36 449.92 245.72C448.812 245.08 447.386 245.476 446.734 246.605C446.083 247.733 446.453 249.166 447.561 249.806Z"
          fill="#3A2933"
        />
        <path
          d="M453.228 258.526C454.336 259.165 455.762 258.769 456.414 257.641C457.065 256.513 456.695 255.079 455.587 254.44C454.479 253.8 453.052 254.196 452.401 255.324C451.75 256.453 452.12 257.886 453.228 258.526Z"
          fill="#3A2933"
        />
        <path
          d="M448.51 266.698C449.618 267.337 451.044 266.941 451.696 265.813C452.347 264.685 451.977 263.251 450.869 262.612C449.761 261.972 448.334 262.368 447.683 263.496C447.031 264.625 447.402 266.058 448.51 266.698Z"
          fill="#3A2933"
        />
        <path
          d="M442.843 257.978C443.951 258.618 445.378 258.222 446.029 257.093C446.681 255.965 446.31 254.532 445.202 253.892C444.094 253.252 442.668 253.648 442.016 254.777C441.365 255.905 441.735 257.338 442.843 257.978Z"
          fill="#3A2933"
        />
        <path
          d="M438.125 266.15C439.233 266.79 440.659 266.394 441.311 265.266C441.962 264.137 441.592 262.704 440.484 262.064C439.376 261.424 437.95 261.82 437.298 262.949C436.647 264.077 437.017 265.51 438.125 266.15Z"
          fill="#3A2933"
        />
        <path
          d="M443.792 274.87C444.9 275.51 446.326 275.114 446.977 273.985C447.629 272.857 447.259 271.424 446.151 270.784C445.042 270.144 443.616 270.54 442.965 271.668C442.313 272.797 442.683 274.23 443.792 274.87Z"
          fill="#3A2933"
        />
        <path
          d="M433.407 274.322C434.515 274.962 435.941 274.566 436.593 273.438C437.244 272.309 436.874 270.876 435.766 270.236C434.658 269.596 433.231 269.992 432.58 271.121C431.929 272.249 432.299 273.682 433.407 274.322Z"
          fill="#3A2933"
        />
        <path
          d="M439.073 283.042C440.181 283.682 441.608 283.286 442.259 282.157C442.911 281.029 442.541 279.596 441.432 278.956C440.324 278.316 438.898 278.712 438.247 279.84C437.595 280.969 437.965 282.402 439.073 283.042Z"
          fill="#3A2933"
        />
        <path
          d="M428.689 282.494C429.797 283.134 431.223 282.738 431.875 281.61C432.526 280.481 432.156 279.048 431.048 278.408C429.94 277.768 428.513 278.165 427.862 279.293C427.21 280.421 427.581 281.855 428.689 282.494Z"
          fill="#3A2933"
        />
        <path
          d="M434.355 291.214C435.463 291.854 436.89 291.458 437.541 290.329C438.193 289.201 437.822 287.768 436.714 287.128C435.606 286.488 434.18 286.884 433.528 288.013C432.877 289.141 433.247 290.574 434.355 291.214Z"
          fill="#3A2933"
        />
        <path
          d="M429.637 299.386C430.745 300.026 432.172 299.63 432.823 298.501C433.474 297.373 433.104 295.94 431.996 295.3C430.888 294.66 429.462 295.056 428.81 296.185C428.159 297.313 428.529 298.746 429.637 299.386Z"
          fill="#3A2933"
        />
        <path
          d="M423.971 290.666C425.079 291.306 426.505 290.91 427.157 289.782C427.808 288.653 427.438 287.22 426.33 286.58C425.222 285.941 423.795 286.337 423.144 287.465C422.492 288.593 422.862 290.027 423.971 290.666Z"
          fill="#3A2933"
        />
        <path
          d="M419.252 298.838C420.361 299.478 421.787 299.082 422.438 297.954C423.09 296.825 422.72 295.392 421.611 294.752C420.503 294.113 419.077 294.509 418.426 295.637C417.774 296.765 418.144 298.199 419.252 298.838Z"
          fill="#3A2933"
        />
        <path
          d="M424.919 307.558C426.027 308.198 427.453 307.802 428.105 306.673C428.756 305.545 428.386 304.112 427.278 303.472C426.17 302.832 424.744 303.228 424.092 304.357C423.441 305.485 423.811 306.918 424.919 307.558Z"
          fill="#3A2933"
        />
        <path
          d="M414.534 307.011C415.642 307.65 417.069 307.254 417.72 306.126C418.372 304.998 418.001 303.564 416.893 302.924C415.785 302.285 414.359 302.681 413.707 303.809C413.056 304.937 413.426 306.371 414.534 307.011Z"
          fill="#3A2933"
        />
        <path
          d="M420.201 315.73C421.309 316.37 422.735 315.974 423.387 314.846C424.038 313.717 423.668 312.284 422.56 311.644C421.452 311.004 420.025 311.4 419.374 312.529C418.722 313.657 419.093 315.09 420.201 315.73Z"
          fill="#3A2933"
        />
        <path
          d="M409.816 315.183C410.924 315.822 412.351 315.426 413.002 314.298C413.654 313.17 413.283 311.736 412.175 311.097C411.067 310.457 409.641 310.853 408.989 311.981C408.338 313.109 408.708 314.543 409.816 315.183Z"
          fill="#3A2933"
        />
        <path
          d="M415.483 323.902C416.591 324.542 418.017 324.146 418.669 323.018C419.32 321.889 418.95 320.456 417.842 319.816C416.734 319.176 415.307 319.572 414.656 320.701C414.004 321.829 414.375 323.262 415.483 323.902Z"
          fill="#3A2933"
        />
        <path
          d="M410.765 332.074C411.873 332.714 413.299 332.318 413.95 331.19C414.602 330.061 414.232 328.628 413.124 327.988C412.015 327.348 410.589 327.745 409.938 328.873C409.286 330.001 409.656 331.434 410.765 332.074Z"
          fill="#3A2933"
        />
        <path
          d="M405.098 323.355C406.206 323.994 407.632 323.598 408.284 322.47C408.935 321.342 408.565 319.908 407.457 319.269C406.349 318.629 404.923 319.025 404.271 320.153C403.62 321.282 403.99 322.715 405.098 323.355Z"
          fill="#3A2933"
        />
        <path
          d="M400.38 331.527C401.488 332.166 402.914 331.77 403.566 330.642C404.217 329.514 403.847 328.08 402.739 327.441C401.631 326.801 400.204 327.197 399.553 328.325C398.902 329.454 399.272 330.887 400.38 331.527Z"
          fill="#3A2933"
        />
        <path
          d="M406.046 340.246C407.154 340.886 408.581 340.49 409.232 339.362C409.884 338.233 409.514 336.8 408.405 336.16C407.297 335.521 405.871 335.917 405.22 337.045C404.568 338.173 404.938 339.607 406.046 340.246Z"
          fill="#3A2933"
        />
        <path
          d="M395.662 339.699C396.77 340.339 398.196 339.942 398.848 338.814C399.499 337.686 399.129 336.252 398.021 335.613C396.913 334.973 395.486 335.369 394.835 336.497C394.183 337.626 394.554 339.059 395.662 339.699Z"
          fill="#3A2933"
        />
        <path
          d="M401.328 348.418C402.436 349.058 403.863 348.662 404.514 347.534C405.166 346.405 404.795 344.972 403.687 344.332C402.579 343.693 401.153 344.089 400.501 345.217C399.85 346.345 400.22 347.779 401.328 348.418Z"
          fill="#3A2933"
        />
        <path
          d="M396.61 356.59C397.718 357.23 399.145 356.834 399.796 355.706C400.447 354.578 400.077 353.144 398.969 352.504C397.861 351.865 396.435 352.261 395.783 353.389C395.132 354.517 395.502 355.951 396.61 356.59Z"
          fill="#3A2933"
        />
        <path
          d="M390.944 347.871C392.052 348.511 393.478 348.115 394.129 346.986C394.781 345.858 394.411 344.425 393.303 343.785C392.195 343.145 390.768 343.541 390.117 344.669C389.465 345.798 389.835 347.231 390.944 347.871Z"
          fill="#3A2933"
        />
        <path
          d="M506.076 185.525C507.184 186.164 508.61 185.768 509.262 184.64C509.913 183.512 509.543 182.078 508.435 181.439C507.327 180.799 505.9 181.195 505.249 182.323C504.597 183.452 504.968 184.885 506.076 185.525Z"
          fill="#3A2933"
        />
        <path
          d="M511.742 194.244C512.85 194.884 514.277 194.488 514.928 193.36C515.58 192.231 515.209 190.798 514.101 190.158C512.993 189.518 511.567 189.915 510.915 191.043C510.264 192.171 510.634 193.604 511.742 194.244Z"
          fill="#3A2933"
        />
        <path
          d="M516.46 186.072C517.569 186.712 518.995 186.316 519.646 185.188C520.298 184.059 519.928 182.626 518.82 181.986C517.711 181.346 516.285 181.742 515.634 182.871C514.982 183.999 515.352 185.432 516.46 186.072Z"
          fill="#3A2933"
        />
        <path
          d="M501.358 193.697C502.466 194.336 503.892 193.94 504.544 192.812C505.195 191.684 504.825 190.25 503.717 189.611C502.609 188.971 501.182 189.367 500.531 190.495C499.879 191.624 500.25 193.057 501.358 193.697Z"
          fill="#3A2933"
        />
        <path
          d="M507.024 202.416C508.132 203.056 509.559 202.66 510.21 201.532C510.862 200.403 510.491 198.97 509.383 198.33C508.275 197.691 506.849 198.087 506.197 199.215C505.546 200.343 505.916 201.777 507.024 202.416Z"
          fill="#3A2933"
        />
        <path
          d="M496.639 201.869C497.748 202.509 499.174 202.112 499.825 200.984C500.477 199.856 500.107 198.422 498.999 197.783C497.89 197.143 496.464 197.539 495.813 198.667C495.161 199.796 495.531 201.229 496.639 201.869Z"
          fill="#3A2933"
        />
        <path
          d="M502.306 210.588C503.414 211.228 504.841 210.832 505.492 209.704C506.143 208.575 505.773 207.142 504.665 206.502C503.557 205.863 502.131 206.259 501.479 207.387C500.828 208.515 501.198 209.949 502.306 210.588Z"
          fill="#3A2933"
        />
        <path
          d="M497.588 218.76C498.696 219.4 500.122 219.004 500.774 217.876C501.425 216.747 501.055 215.314 499.947 214.674C498.839 214.035 497.412 214.431 496.761 215.559C496.11 216.687 496.48 218.121 497.588 218.76Z"
          fill="#3A2933"
        />
        <path
          d="M491.921 210.041C493.029 210.681 494.456 210.285 495.107 209.156C495.759 208.028 495.389 206.595 494.28 205.955C493.172 205.315 491.746 205.711 491.094 206.839C490.443 207.968 490.813 209.401 491.921 210.041Z"
          fill="#3A2933"
        />
        <path
          d="M487.203 218.213C488.311 218.853 489.738 218.457 490.389 217.328C491.041 216.2 490.67 214.767 489.562 214.127C488.454 213.487 487.028 213.883 486.376 215.011C485.725 216.14 486.095 217.573 487.203 218.213Z"
          fill="#3A2933"
        />
        <path
          d="M492.87 226.932C493.978 227.572 495.404 227.176 496.056 226.048C496.707 224.92 496.337 223.486 495.229 222.846C494.121 222.207 492.694 222.603 492.043 223.731C491.391 224.859 491.762 226.293 492.87 226.932Z"
          fill="#3A2933"
        />
        <path
          d="M482.485 226.385C483.593 227.025 485.02 226.629 485.671 225.5C486.322 224.372 485.952 222.939 484.844 222.299C483.736 221.659 482.31 222.055 481.658 223.184C481.007 224.312 481.377 225.745 482.485 226.385Z"
          fill="#3A2933"
        />
        <path
          d="M488.152 235.105C489.26 235.744 490.686 235.348 491.338 234.22C491.989 233.092 491.619 231.658 490.511 231.019C489.403 230.379 487.976 230.775 487.325 231.903C486.673 233.031 487.043 234.465 488.152 235.105Z"
          fill="#3A2933"
        />
        <path
          d="M477.767 234.557C478.875 235.197 480.301 234.801 480.953 233.672C481.604 232.544 481.234 231.111 480.126 230.471C479.018 229.831 477.591 230.227 476.94 231.356C476.289 232.484 476.659 233.917 477.767 234.557Z"
          fill="#3A2933"
        />
        <path
          d="M483.433 243.277C484.542 243.916 485.968 243.52 486.619 242.392C487.271 241.264 486.901 239.83 485.793 239.191C484.684 238.551 483.258 238.947 482.607 240.075C481.955 241.204 482.325 242.637 483.433 243.277Z"
          fill="#3A2933"
        />
        <path
          d="M478.715 251.449C479.823 252.088 481.25 251.692 481.901 250.564C482.553 249.436 482.182 248.002 481.074 247.363C479.966 246.723 478.54 247.119 477.888 248.247C477.237 249.376 477.607 250.809 478.715 251.449Z"
          fill="#3A2933"
        />
        <path
          d="M473.049 242.729C474.157 243.369 475.583 242.973 476.235 241.844C476.886 240.716 476.516 239.283 475.408 238.643C474.3 238.003 472.873 238.399 472.222 239.528C471.57 240.656 471.941 242.089 473.049 242.729Z"
          fill="#3A2933"
        />
        <path
          d="M468.331 250.901C469.439 251.541 470.865 251.145 471.517 250.017C472.168 248.888 471.798 247.455 470.69 246.815C469.582 246.175 468.155 246.571 467.504 247.7C466.852 248.828 467.223 250.261 468.331 250.901Z"
          fill="#3A2933"
        />
        <path
          d="M473.997 259.621C475.105 260.261 476.532 259.864 477.183 258.736C477.835 257.608 477.464 256.174 476.356 255.535C475.248 254.895 473.822 255.291 473.17 256.419C472.519 257.548 472.889 258.981 473.997 259.621Z"
          fill="#3A2933"
        />
        <path
          d="M463.612 259.073C464.721 259.713 466.147 259.317 466.798 258.189C467.45 257.06 467.08 255.627 465.972 254.987C464.863 254.347 463.437 254.743 462.786 255.872C462.134 257 462.504 258.433 463.612 259.073Z"
          fill="#3A2933"
        />
        <path
          d="M469.279 267.793C470.387 268.433 471.814 268.037 472.465 266.908C473.116 265.78 472.746 264.347 471.638 263.707C470.53 263.067 469.104 263.463 468.452 264.591C467.801 265.72 468.171 267.153 469.279 267.793Z"
          fill="#3A2933"
        />
        <path
          d="M464.561 275.965C465.669 276.605 467.095 276.209 467.747 275.08C468.398 273.952 468.028 272.519 466.92 271.879C465.812 271.239 464.385 271.635 463.734 272.763C463.083 273.892 463.453 275.325 464.561 275.965Z"
          fill="#3A2933"
        />
        <path
          d="M458.894 267.245C460.002 267.885 461.429 267.489 462.08 266.361C462.732 265.232 462.362 263.799 461.253 263.159C460.145 262.519 458.719 262.916 458.067 264.044C457.416 265.172 457.786 266.606 458.894 267.245Z"
          fill="#3A2933"
        />
        <path
          d="M454.176 275.417C455.284 276.057 456.711 275.661 457.362 274.533C458.014 273.404 457.643 271.971 456.535 271.331C455.427 270.692 454.001 271.088 453.349 272.216C452.698 273.344 453.068 274.778 454.176 275.417Z"
          fill="#3A2933"
        />
        <path
          d="M459.843 284.137C460.951 284.777 462.377 284.381 463.029 283.252C463.68 282.124 463.31 280.691 462.202 280.051C461.094 279.411 459.667 279.807 459.016 280.936C458.364 282.064 458.735 283.497 459.843 284.137Z"
          fill="#3A2933"
        />
        <path
          d="M449.458 283.589C450.566 284.229 451.993 283.833 452.644 282.705C453.295 281.576 452.925 280.143 451.817 279.503C450.709 278.864 449.283 279.26 448.631 280.388C447.98 281.516 448.35 282.95 449.458 283.589Z"
          fill="#3A2933"
        />
        <path
          d="M455.125 292.309C456.233 292.949 457.659 292.553 458.311 291.424C458.962 290.296 458.592 288.863 457.484 288.223C456.376 287.583 454.949 287.979 454.298 289.108C453.646 290.236 454.016 291.669 455.125 292.309Z"
          fill="#3A2933"
        />
        <path
          d="M444.74 291.761C445.848 292.401 447.274 292.005 447.926 290.877C448.577 289.749 448.207 288.315 447.099 287.675C445.991 287.036 444.564 287.432 443.913 288.56C443.262 289.688 443.632 291.122 444.74 291.761Z"
          fill="#3A2933"
        />
        <path
          d="M450.406 300.481C451.515 301.121 452.941 300.725 453.592 299.596C454.244 298.468 453.874 297.035 452.766 296.395C451.657 295.755 450.231 296.151 449.58 297.28C448.928 298.408 449.298 299.841 450.406 300.481Z"
          fill="#3A2933"
        />
        <path
          d="M445.688 308.653C446.796 309.293 448.223 308.897 448.874 307.769C449.526 306.64 449.155 305.207 448.047 304.567C446.939 303.927 445.513 304.323 444.861 305.452C444.21 306.58 444.58 308.013 445.688 308.653Z"
          fill="#3A2933"
        />
        <path
          d="M440.022 299.934C441.13 300.573 442.556 300.177 443.208 299.049C443.859 297.921 443.489 296.487 442.381 295.848C441.273 295.208 439.846 295.604 439.195 296.732C438.543 297.86 438.914 299.294 440.022 299.934Z"
          fill="#3A2933"
        />
        <path
          d="M435.304 308.106C436.412 308.745 437.838 308.349 438.49 307.221C439.141 306.093 438.771 304.659 437.663 304.02C436.555 303.38 435.128 303.776 434.477 304.904C433.825 306.033 434.196 307.466 435.304 308.106Z"
          fill="#3A2933"
        />
        <path
          d="M440.97 316.825C442.078 317.465 443.505 317.069 444.156 315.941C444.808 314.812 444.437 313.379 443.329 312.739C442.221 312.099 440.795 312.495 440.143 313.624C439.492 314.752 439.862 316.185 440.97 316.825Z"
          fill="#3A2933"
        />
        <path
          d="M430.585 316.278C431.694 316.917 433.12 316.521 433.771 315.393C434.423 314.265 434.053 312.831 432.945 312.192C431.836 311.552 430.41 311.948 429.759 313.076C429.107 314.205 429.477 315.638 430.585 316.278Z"
          fill="#3A2933"
        />
        <path
          d="M436.252 324.997C437.36 325.637 438.787 325.241 439.438 324.113C440.089 322.984 439.719 321.551 438.611 320.911C437.503 320.271 436.077 320.668 435.425 321.796C434.774 322.924 435.144 324.358 436.252 324.997Z"
          fill="#3A2933"
        />
        <path
          d="M425.867 324.45C426.975 325.089 428.402 324.693 429.053 323.565C429.705 322.437 429.335 321.003 428.226 320.364C427.118 319.724 425.692 320.12 425.04 321.248C424.389 322.377 424.759 323.81 425.867 324.45Z"
          fill="#3A2933"
        />
        <path
          d="M431.534 333.169C432.642 333.809 434.068 333.413 434.72 332.285C435.371 331.156 435.001 329.723 433.893 329.083C432.785 328.444 431.358 328.84 430.707 329.968C430.056 331.096 430.426 332.53 431.534 333.169Z"
          fill="#3A2933"
        />
        <path
          d="M426.816 341.341C427.924 341.981 429.35 341.585 430.002 340.457C430.653 339.328 430.283 337.895 429.175 337.255C428.067 336.616 426.64 337.012 425.989 338.14C425.337 339.268 425.708 340.702 426.816 341.341Z"
          fill="#3A2933"
        />
        <path
          d="M421.149 332.622C422.257 333.262 423.684 332.865 424.335 331.737C424.987 330.609 424.616 329.176 423.508 328.536C422.4 327.896 420.974 328.292 420.322 329.42C419.671 330.549 420.041 331.982 421.149 332.622Z"
          fill="#3A2933"
        />
        <path
          d="M416.431 340.794C417.539 341.434 418.966 341.038 419.617 339.909C420.268 338.781 419.898 337.348 418.79 336.708C417.682 336.068 416.256 336.464 415.604 337.592C414.953 338.721 415.323 340.154 416.431 340.794Z"
          fill="#3A2933"
        />
        <path
          d="M422.098 349.513C423.206 350.153 424.632 349.757 425.284 348.629C425.935 347.501 425.565 346.067 424.457 345.427C423.349 344.788 421.922 345.184 421.271 346.312C420.619 347.44 420.989 348.874 422.098 349.513Z"
          fill="#3A2933"
        />
        <path
          d="M411.713 348.966C412.821 349.606 414.247 349.21 414.899 348.081C415.55 346.953 415.18 345.52 414.072 344.88C412.964 344.24 411.537 344.636 410.886 345.765C410.235 346.893 410.605 348.326 411.713 348.966Z"
          fill="#3A2933"
        />
        <path
          d="M417.379 357.686C418.488 358.325 419.914 357.929 420.565 356.801C421.217 355.673 420.847 354.239 419.739 353.6C418.63 352.96 417.204 353.356 416.553 354.484C415.901 355.612 416.271 357.046 417.379 357.686Z"
          fill="#3A2933"
        />
        <path
          d="M412.661 365.858C413.769 366.497 415.196 366.101 415.847 364.973C416.499 363.845 416.128 362.411 415.02 361.772C413.912 361.132 412.486 361.528 411.834 362.656C411.183 363.785 411.553 365.218 412.661 365.858Z"
          fill="#3A2933"
        />
        <path
          d="M406.995 357.138C408.103 357.778 409.529 357.382 410.181 356.253C410.832 355.125 410.462 353.692 409.354 353.052C408.246 352.412 406.819 352.808 406.168 353.937C405.516 355.065 405.887 356.498 406.995 357.138Z"
          fill="#3A2933"
        />
        <path
          d="M522.127 194.792C523.235 195.432 524.662 195.036 525.313 193.907C525.964 192.779 525.594 191.346 524.486 190.706C523.378 190.066 521.952 190.462 521.3 191.59C520.649 192.719 521.019 194.152 522.127 194.792Z"
          fill="#3A2933"
        />
        <path
          d="M527.794 203.511C528.902 204.151 530.328 203.755 530.98 202.627C531.631 201.498 531.261 200.065 530.153 199.425C529.045 198.786 527.618 199.182 526.967 200.31C526.315 201.438 526.685 202.872 527.794 203.511Z"
          fill="#3A2933"
        />
        <path
          d="M532.512 195.339C533.62 195.979 535.046 195.583 535.698 194.455C536.349 193.326 535.979 191.893 534.871 191.253C533.763 190.614 532.336 191.01 531.685 192.138C531.033 193.266 531.404 194.7 532.512 195.339Z"
          fill="#3A2933"
        />
        <path
          d="M517.409 202.964C518.517 203.604 519.943 203.208 520.595 202.079C521.246 200.951 520.876 199.518 519.768 198.878C518.66 198.238 517.233 198.634 516.582 199.762C515.931 200.891 516.301 202.324 517.409 202.964Z"
          fill="#3A2933"
        />
        <path
          d="M523.075 211.683C524.184 212.323 525.61 211.927 526.261 210.799C526.913 209.671 526.543 208.237 525.434 207.597C524.326 206.958 522.9 207.354 522.249 208.482C521.597 209.61 521.967 211.044 523.075 211.683Z"
          fill="#3A2933"
        />
        <path
          d="M512.691 211.136C513.799 211.776 515.225 211.38 515.877 210.251C516.528 209.123 516.158 207.69 515.05 207.05C513.942 206.41 512.515 206.806 511.864 207.935C511.212 209.063 511.583 210.496 512.691 211.136Z"
          fill="#3A2933"
        />
        <path
          d="M518.357 219.856C519.465 220.495 520.892 220.099 521.543 218.971C522.195 217.843 521.824 216.409 520.716 215.77C519.608 215.13 518.182 215.526 517.53 216.654C516.879 217.782 517.249 219.216 518.357 219.856Z"
          fill="#3A2933"
        />
        <path
          d="M513.639 228.028C514.747 228.667 516.174 228.271 516.825 227.143C517.477 226.015 517.106 224.581 515.998 223.942C514.89 223.302 513.464 223.698 512.812 224.826C512.161 225.955 512.531 227.388 513.639 228.028Z"
          fill="#3A2933"
        />
        <path
          d="M507.973 219.308C509.081 219.948 510.507 219.552 511.159 218.423C511.81 217.295 511.44 215.862 510.332 215.222C509.224 214.582 507.797 214.978 507.146 216.107C506.494 217.235 506.864 218.668 507.973 219.308Z"
          fill="#3A2933"
        />
        <path
          d="M503.254 227.48C504.363 228.12 505.789 227.724 506.44 226.595C507.092 225.467 506.722 224.034 505.614 223.394C504.505 222.754 503.079 223.15 502.428 224.279C501.776 225.407 502.146 226.84 503.254 227.48Z"
          fill="#3A2933"
        />
        <path
          d="M508.921 236.2C510.029 236.839 511.455 236.443 512.107 235.315C512.758 234.187 512.388 232.753 511.28 232.114C510.172 231.474 508.746 231.87 508.094 232.998C507.443 234.127 507.813 235.56 508.921 236.2Z"
          fill="#3A2933"
        />
        <path
          d="M498.536 235.652C499.644 236.292 501.071 235.896 501.722 234.768C502.374 233.639 502.003 232.206 500.895 231.566C499.787 230.926 498.361 231.322 497.709 232.451C497.058 233.579 497.428 235.012 498.536 235.652Z"
          fill="#3A2933"
        />
        <path
          d="M504.203 244.372C505.311 245.012 506.737 244.615 507.389 243.487C508.04 242.359 507.67 240.925 506.562 240.286C505.454 239.646 504.027 240.042 503.376 241.17C502.725 242.299 503.095 243.732 504.203 244.372Z"
          fill="#3A2933"
        />
        <path
          d="M493.818 243.824C494.926 244.464 496.353 244.068 497.004 242.94C497.656 241.811 497.285 240.378 496.177 239.738C495.069 239.098 493.643 239.494 492.991 240.623C492.34 241.751 492.71 243.184 493.818 243.824Z"
          fill="#3A2933"
        />
        <path
          d="M499.485 252.544C500.593 253.184 502.019 252.788 502.671 251.659C503.322 250.531 502.952 249.098 501.844 248.458C500.736 247.818 499.309 248.214 498.658 249.342C498.006 250.471 498.377 251.904 499.485 252.544Z"
          fill="#3A2933"
        />
        <path
          d="M494.767 260.716C495.875 261.356 497.301 260.96 497.953 259.831C498.604 258.703 498.234 257.27 497.126 256.63C496.018 255.99 494.591 256.386 493.94 257.514C493.288 258.643 493.658 260.076 494.767 260.716Z"
          fill="#3A2933"
        />
        <path
          d="M489.1 251.996C490.208 252.636 491.634 252.24 492.286 251.112C492.937 249.983 492.567 248.55 491.459 247.91C490.351 247.27 488.925 247.667 488.273 248.795C487.622 249.923 487.992 251.357 489.1 251.996Z"
          fill="#3A2933"
        />
        <path
          d="M484.382 260.168C485.49 260.808 486.916 260.412 487.568 259.284C488.219 258.155 487.849 256.722 486.741 256.082C485.633 255.443 484.206 255.839 483.555 256.967C482.904 258.095 483.274 259.529 484.382 260.168Z"
          fill="#3A2933"
        />
        <path
          d="M490.048 268.888C491.157 269.528 492.583 269.132 493.234 268.003C493.886 266.875 493.516 265.442 492.407 264.802C491.299 264.162 489.873 264.558 489.222 265.687C488.57 266.815 488.94 268.248 490.048 268.888Z"
          fill="#3A2933"
        />
        <path
          d="M479.664 268.34C480.772 268.98 482.198 268.584 482.85 267.456C483.501 266.327 483.131 264.894 482.023 264.254C480.915 263.615 479.488 264.011 478.837 265.139C478.185 266.267 478.556 267.701 479.664 268.34Z"
          fill="#3A2933"
        />
        <path
          d="M485.33 277.06C486.438 277.7 487.865 277.304 488.516 276.175C489.168 275.047 488.797 273.614 487.689 272.974C486.581 272.334 485.155 272.73 484.503 273.859C483.852 274.987 484.222 276.42 485.33 277.06Z"
          fill="#3A2933"
        />
        <path
          d="M480.612 285.232C481.72 285.872 483.147 285.476 483.798 284.347C484.45 283.219 484.079 281.786 482.971 281.146C481.863 280.506 480.437 280.902 479.785 282.031C479.134 283.159 479.504 284.592 480.612 285.232Z"
          fill="#3A2933"
        />
        <path
          d="M474.946 276.512C476.054 277.152 477.48 276.756 478.132 275.628C478.783 274.5 478.413 273.066 477.305 272.426C476.197 271.787 474.77 272.183 474.119 273.311C473.467 274.439 473.837 275.873 474.946 276.512Z"
          fill="#3A2933"
        />
        <path
          d="M470.227 284.685C471.336 285.324 472.762 284.928 473.413 283.8C474.065 282.672 473.695 281.238 472.587 280.598C471.478 279.959 470.052 280.355 469.401 281.483C468.749 282.611 469.119 284.045 470.227 284.685Z"
          fill="#3A2933"
        />
        <path
          d="M475.894 293.404C477.002 294.044 478.428 293.648 479.08 292.52C479.731 291.391 479.361 289.958 478.253 289.318C477.145 288.678 475.719 289.074 475.067 290.203C474.416 291.331 474.786 292.764 475.894 293.404Z"
          fill="#3A2933"
        />
        <path
          d="M465.509 292.857C466.617 293.496 468.044 293.1 468.695 291.972C469.347 290.844 468.976 289.41 467.868 288.771C466.76 288.131 465.334 288.527 464.682 289.655C464.031 290.784 464.401 292.217 465.509 292.857Z"
          fill="#3A2933"
        />
        <path
          d="M471.176 301.576C472.284 302.216 473.71 301.82 474.362 300.692C475.013 299.563 474.643 298.13 473.535 297.49C472.427 296.85 471 297.246 470.349 298.375C469.698 299.503 470.068 300.936 471.176 301.576Z"
          fill="#3A2933"
        />
        <path
          d="M460.791 301.029C461.899 301.668 463.326 301.272 463.977 300.144C464.629 299.016 464.258 297.582 463.15 296.943C462.042 296.303 460.616 296.699 459.964 297.827C459.313 298.956 459.683 300.389 460.791 301.029Z"
          fill="#3A2933"
        />
        <path
          d="M466.458 309.748C467.566 310.388 468.992 309.992 469.644 308.864C470.295 307.735 469.925 306.302 468.817 305.662C467.709 305.022 466.282 305.419 465.631 306.547C464.979 307.675 465.35 309.109 466.458 309.748Z"
          fill="#3A2933"
        />
        <path
          d="M461.74 317.92C462.848 318.56 464.274 318.164 464.926 317.036C465.577 315.907 465.207 314.474 464.099 313.834C462.991 313.195 461.564 313.591 460.913 314.719C460.261 315.847 460.631 317.281 461.74 317.92Z"
          fill="#3A2933"
        />
        <path
          d="M456.073 309.201C457.181 309.84 458.607 309.444 459.259 308.316C459.91 307.188 459.54 305.754 458.432 305.115C457.324 304.475 455.898 304.871 455.246 305.999C454.595 307.128 454.965 308.561 456.073 309.201Z"
          fill="#3A2933"
        />
        <path
          d="M451.355 317.373C452.463 318.013 453.889 317.616 454.541 316.488C455.192 315.36 454.822 313.927 453.714 313.287C452.606 312.647 451.179 313.043 450.528 314.171C449.877 315.3 450.247 316.733 451.355 317.373Z"
          fill="#3A2933"
        />
        <path
          d="M457.021 326.092C458.13 326.732 459.556 326.336 460.207 325.208C460.859 324.079 460.489 322.646 459.38 322.006C458.272 321.367 456.846 321.763 456.195 322.891C455.543 324.019 455.913 325.453 457.021 326.092Z"
          fill="#3A2933"
        />
        <path
          d="M446.637 325.545C447.745 326.185 449.171 325.789 449.823 324.66C450.474 323.532 450.104 322.099 448.996 321.459C447.888 320.819 446.461 321.215 445.81 322.343C445.158 323.472 445.529 324.905 446.637 325.545Z"
          fill="#3A2933"
        />
        <path
          d="M452.303 334.264C453.411 334.904 454.838 334.508 455.489 333.38C456.141 332.252 455.77 330.818 454.662 330.178C453.554 329.539 452.128 329.935 451.476 331.063C450.825 332.191 451.195 333.625 452.303 334.264Z"
          fill="#3A2933"
        />
        <path
          d="M441.919 333.717C443.027 334.357 444.453 333.961 445.104 332.832C445.756 331.704 445.386 330.271 444.278 329.631C443.17 328.991 441.743 329.387 441.092 330.516C440.44 331.644 440.81 333.077 441.919 333.717Z"
          fill="#3A2933"
        />
        <path
          d="M447.585 342.437C448.693 343.076 450.12 342.68 450.771 341.552C451.423 340.424 451.052 338.99 449.944 338.351C448.836 337.711 447.41 338.107 446.758 339.235C446.107 340.363 446.477 341.797 447.585 342.437Z"
          fill="#3A2933"
        />
        <path
          d="M442.867 350.609C443.975 351.248 445.401 350.852 446.053 349.724C446.704 348.596 446.334 347.162 445.226 346.523C444.118 345.883 442.692 346.279 442.04 347.407C441.389 348.536 441.759 349.969 442.867 350.609Z"
          fill="#3A2933"
        />
        <path
          d="M437.2 341.889C438.309 342.529 439.735 342.133 440.386 341.004C441.038 339.876 440.668 338.443 439.56 337.803C438.451 337.163 437.025 337.559 436.374 338.688C435.722 339.816 436.092 341.249 437.2 341.889Z"
          fill="#3A2933"
        />
        <path
          d="M432.482 350.061C433.59 350.701 435.017 350.305 435.668 349.176C436.32 348.048 435.949 346.615 434.841 345.975C433.733 345.335 432.307 345.731 431.655 346.86C431.004 347.988 431.374 349.421 432.482 350.061Z"
          fill="#3A2933"
        />
        <path
          d="M438.149 358.781C439.257 359.42 440.683 359.024 441.335 357.896C441.986 356.768 441.616 355.334 440.508 354.695C439.4 354.055 437.973 354.451 437.322 355.579C436.671 356.708 437.041 358.141 438.149 358.781Z"
          fill="#3A2933"
        />
        <path
          d="M427.764 358.233C428.872 358.873 430.299 358.477 430.95 357.348C431.602 356.22 431.231 354.787 430.123 354.147C429.015 353.507 427.589 353.903 426.937 355.032C426.286 356.16 426.656 357.593 427.764 358.233Z"
          fill="#3A2933"
        />
        <path
          d="M433.431 366.953C434.539 367.593 435.965 367.196 436.617 366.068C437.268 364.94 436.898 363.506 435.79 362.867C434.682 362.227 433.255 362.623 432.604 363.751C431.952 364.88 432.323 366.313 433.431 366.953Z"
          fill="#3A2933"
        />
        <path
          d="M428.713 375.125C429.821 375.765 431.247 375.369 431.898 374.24C432.55 373.112 432.18 371.679 431.072 371.039C429.964 370.399 428.537 370.795 427.886 371.923C427.234 373.052 427.604 374.485 428.713 375.125Z"
          fill="#3A2933"
        />
        <path
          d="M423.046 366.405C424.154 367.045 425.58 366.649 426.232 365.521C426.883 364.392 426.513 362.959 425.405 362.319C424.297 361.679 422.871 362.075 422.219 363.204C421.568 364.332 421.938 365.765 423.046 366.405Z"
          fill="#3A2933"
        />
        <path
          d="M538.178 204.059C539.286 204.699 540.713 204.303 541.364 203.174C542.016 202.046 541.645 200.613 540.537 199.973C539.429 199.333 538.003 199.729 537.351 200.858C536.7 201.986 537.07 203.419 538.178 204.059Z"
          fill="#3A2933"
        />
        <path
          d="M533.46 212.231C534.568 212.871 535.995 212.475 536.646 211.346C537.297 210.218 536.927 208.785 535.819 208.145C534.711 207.505 533.285 207.901 532.633 209.03C531.982 210.158 532.352 211.591 533.46 212.231Z"
          fill="#3A2933"
        />
        <path
          d="M528.742 220.403C529.85 221.043 531.276 220.647 531.928 219.519C532.579 218.39 532.209 216.957 531.101 216.317C529.993 215.677 528.567 216.073 527.915 217.202C527.264 218.33 527.634 219.763 528.742 220.403Z"
          fill="#3A2933"
        />
        <path
          d="M524.024 228.575C525.132 229.215 526.558 228.819 527.21 227.691C527.861 226.562 527.491 225.129 526.383 224.489C525.275 223.849 523.848 224.245 523.197 225.374C522.546 226.502 522.916 227.935 524.024 228.575Z"
          fill="#3A2933"
        />
        <path
          d="M519.306 236.747C520.414 237.387 521.84 236.991 522.492 235.863C523.143 234.734 522.773 233.301 521.665 232.661C520.557 232.021 519.13 232.418 518.479 233.546C517.827 234.674 518.198 236.107 519.306 236.747Z"
          fill="#3A2933"
        />
        <path
          d="M514.588 244.919C515.696 245.559 517.122 245.163 517.773 244.035C518.425 242.906 518.055 241.473 516.947 240.833C515.838 240.194 514.412 240.59 513.761 241.718C513.109 242.846 513.479 244.28 514.588 244.919Z"
          fill="#3A2933"
        />
        <path
          d="M509.869 253.091C510.977 253.731 512.404 253.335 513.055 252.207C513.707 251.078 513.337 249.645 512.228 249.005C511.12 248.366 509.694 248.762 509.043 249.89C508.391 251.018 508.761 252.452 509.869 253.091Z"
          fill="#3A2933"
        />
        <path
          d="M505.151 261.263C506.259 261.903 507.686 261.507 508.337 260.379C508.989 259.251 508.618 257.817 507.51 257.177C506.402 256.538 504.976 256.934 504.324 258.062C503.673 259.19 504.043 260.624 505.151 261.263Z"
          fill="#3A2933"
        />
        <path
          d="M500.433 269.436C501.541 270.075 502.968 269.679 503.619 268.551C504.27 267.423 503.9 265.989 502.792 265.349C501.684 264.71 500.258 265.106 499.606 266.234C498.955 267.362 499.325 268.796 500.433 269.436Z"
          fill="#3A2933"
        />
        <path
          d="M495.715 277.608C496.823 278.247 498.249 277.851 498.901 276.723C499.552 275.595 499.182 274.161 498.074 273.522C496.966 272.882 495.54 273.278 494.888 274.406C494.237 275.534 494.607 276.968 495.715 277.608Z"
          fill="#3A2933"
        />
        <path
          d="M490.997 285.78C492.105 286.419 493.531 286.023 494.183 284.895C494.834 283.767 494.464 282.333 493.356 281.694C492.248 281.054 490.821 281.45 490.17 282.578C489.518 283.707 489.889 285.14 490.997 285.78Z"
          fill="#3A2933"
        />
        <path
          d="M486.279 293.952C487.387 294.591 488.813 294.195 489.465 293.067C490.116 291.939 489.746 290.505 488.638 289.866C487.53 289.226 486.103 289.622 485.452 290.75C484.8 291.879 485.171 293.312 486.279 293.952Z"
          fill="#3A2933"
        />
        <path
          d="M481.561 302.124C482.669 302.764 484.095 302.367 484.746 301.239C485.398 300.111 485.028 298.678 483.92 298.038C482.811 297.398 481.385 297.794 480.734 298.922C480.082 300.051 480.452 301.484 481.561 302.124Z"
          fill="#3A2933"
        />
        <path
          d="M476.842 310.296C477.95 310.936 479.377 310.54 480.028 309.411C480.68 308.283 480.31 306.85 479.201 306.21C478.093 305.57 476.667 305.966 476.016 307.094C475.364 308.223 475.734 309.656 476.842 310.296Z"
          fill="#3A2933"
        />
        <path
          d="M472.124 318.468C473.232 319.108 474.659 318.712 475.31 317.583C475.962 316.455 475.591 315.022 474.483 314.382C473.375 313.742 471.949 314.138 471.297 315.266C470.646 316.395 471.016 317.828 472.124 318.468Z"
          fill="#3A2933"
        />
        <path
          d="M467.406 326.64C468.514 327.28 469.941 326.884 470.592 325.755C471.243 324.627 470.873 323.194 469.765 322.554C468.657 321.914 467.231 322.31 466.579 323.439C465.928 324.567 466.298 326 467.406 326.64Z"
          fill="#3A2933"
        />
        <path
          d="M462.688 334.812C463.796 335.452 465.222 335.056 465.874 333.927C466.525 332.799 466.155 331.366 465.047 330.726C463.939 330.086 462.513 330.482 461.861 331.611C461.21 332.739 461.58 334.172 462.688 334.812Z"
          fill="#3A2933"
        />
        <path
          d="M457.97 342.984C459.078 343.624 460.504 343.228 461.156 342.099C461.807 340.971 461.437 339.538 460.329 338.898C459.221 338.258 457.794 338.654 457.143 339.783C456.491 340.911 456.862 342.344 457.97 342.984Z"
          fill="#3A2933"
        />
        <path
          d="M453.252 351.156C454.36 351.796 455.786 351.4 456.438 350.272C457.089 349.143 456.719 347.71 455.611 347.07C454.503 346.43 453.076 346.826 452.425 347.955C451.773 349.083 452.144 350.516 453.252 351.156Z"
          fill="#3A2933"
        />
        <path
          d="M448.534 359.328C449.642 359.968 451.068 359.572 451.719 358.444C452.371 357.315 452.001 355.882 450.893 355.242C449.784 354.602 448.358 354.998 447.707 356.127C447.055 357.255 447.425 358.688 448.534 359.328Z"
          fill="#3A2933"
        />
        <path
          d="M443.815 367.5C444.923 368.14 446.35 367.744 447.001 366.616C447.653 365.487 447.283 364.054 446.174 363.414C445.066 362.774 443.64 363.171 442.989 364.299C442.337 365.427 442.707 366.861 443.815 367.5Z"
          fill="#3A2933"
        />
        <path
          d="M439.097 375.672C440.205 376.312 441.632 375.916 442.283 374.788C442.935 373.659 442.564 372.226 441.456 371.586C440.348 370.947 438.922 371.343 438.27 372.471C437.619 373.599 437.989 375.033 439.097 375.672Z"
          fill="#3A2933"
        />
        <path
          d="M81.2521 179.966C82.3602 180.606 83.7866 180.21 84.438 179.082C85.0895 177.954 84.7193 176.52 83.6112 175.88C82.5031 175.241 81.0767 175.637 80.4252 176.765C79.7738 177.893 80.144 179.327 81.2521 179.966Z"
          fill="#3A2933"
        />
        <path
          d="M86.9186 188.686C88.0267 189.326 89.4531 188.93 90.1046 187.801C90.756 186.673 90.3858 185.24 89.2777 184.6C88.1696 183.96 86.7432 184.356 86.0918 185.485C85.4403 186.613 85.8105 188.046 86.9186 188.686Z"
          fill="#3A2933"
        />
        <path
          d="M76.534 188.139C77.6421 188.778 79.0685 188.382 79.7199 187.254C80.3713 186.126 80.0011 184.692 78.893 184.053C77.7849 183.413 76.3585 183.809 75.7071 184.937C75.0557 186.065 75.4259 187.499 76.534 188.139Z"
          fill="#3A2933"
        />
        <path
          d="M82.2005 196.858C83.3086 197.498 84.735 197.102 85.3864 195.974C86.0379 194.845 85.6677 193.412 84.5596 192.772C83.4515 192.132 82.0251 192.528 81.3736 193.657C80.7222 194.785 81.0924 196.218 82.2005 196.858Z"
          fill="#3A2933"
        />
        <path
          d="M71.8158 196.311C72.9239 196.95 74.3503 196.554 75.0018 195.426C75.6532 194.298 75.283 192.864 74.1749 192.225C73.0668 191.585 71.6404 191.981 70.9889 193.109C70.3375 194.238 70.7077 195.671 71.8158 196.311Z"
          fill="#3A2933"
        />
        <path
          d="M77.4824 205.03C78.5905 205.67 80.0168 205.274 80.6683 204.146C81.3197 203.017 80.9495 201.584 79.8414 200.944C78.7333 200.304 77.3069 200.701 76.6555 201.829C76.004 202.957 76.3743 204.39 77.4824 205.03Z"
          fill="#3A2933"
        />
        <path
          d="M72.7642 213.202C73.8723 213.842 75.2987 213.446 75.9502 212.318C76.6016 211.189 76.2314 209.756 75.1233 209.116C74.0152 208.477 72.5888 208.873 71.9373 210.001C71.2859 211.129 71.6561 212.563 72.7642 213.202Z"
          fill="#3A2933"
        />
        <path
          d="M67.0977 204.483C68.2058 205.122 69.6322 204.726 70.2836 203.598C70.9351 202.47 70.5648 201.036 69.4567 200.397C68.3486 199.757 66.9222 200.153 66.2708 201.281C65.6194 202.41 65.9896 203.843 67.0977 204.483Z"
          fill="#3A2933"
        />
        <path
          d="M62.3795 212.655C63.4876 213.295 64.914 212.898 65.5655 211.77C66.2169 210.642 65.8467 209.208 64.7386 208.569C63.6305 207.929 62.2041 208.325 61.5527 209.453C60.9012 210.582 61.2714 212.015 62.3795 212.655Z"
          fill="#3A2933"
        />
        <path
          d="M68.0461 221.374C69.1542 222.014 70.5806 221.618 71.232 220.49C71.8834 219.361 71.5132 217.928 70.4051 217.288C69.297 216.649 67.8706 217.045 67.2192 218.173C66.5678 219.301 66.938 220.735 68.0461 221.374Z"
          fill="#3A2933"
        />
        <path
          d="M57.6614 220.827C58.7695 221.467 60.1959 221.071 60.8473 219.942C61.4988 218.814 61.1286 217.381 60.0204 216.741C58.9123 216.101 57.486 216.497 56.8345 217.625C56.1831 218.754 56.5533 220.187 57.6614 220.827Z"
          fill="#3A2933"
        />
        <path
          d="M63.3279 229.546C64.436 230.186 65.8624 229.79 66.5139 228.662C67.1653 227.533 66.7951 226.1 65.687 225.46C64.5789 224.821 63.1525 225.217 62.5011 226.345C61.8496 227.473 62.2198 228.907 63.3279 229.546Z"
          fill="#3A2933"
        />
        <path
          d="M52.9432 228.999C54.0513 229.639 55.4777 229.243 56.1292 228.114C56.7806 226.986 56.4104 225.553 55.3023 224.913C54.1942 224.273 52.7678 224.669 52.1164 225.797C51.4649 226.926 51.8351 228.359 52.9432 228.999Z"
          fill="#3A2933"
        />
        <path
          d="M58.6098 237.718C59.7179 238.358 61.1443 237.962 61.7957 236.834C62.4471 235.706 62.0769 234.272 60.9688 233.632C59.8607 232.993 58.4343 233.389 57.7829 234.517C57.1315 235.645 57.5017 237.079 58.6098 237.718Z"
          fill="#3A2933"
        />
        <path
          d="M53.8916 245.891C54.9998 246.53 56.4261 246.134 57.0776 245.006C57.729 243.878 57.3588 242.444 56.2507 241.805C55.1426 241.165 53.7162 241.561 53.0648 242.689C52.4133 243.817 52.7835 245.251 53.8916 245.891Z"
          fill="#3A2933"
        />
        <path
          d="M48.2251 237.171C49.3332 237.811 50.7596 237.415 51.411 236.286C52.0625 235.158 51.6923 233.725 50.5842 233.085C49.4761 232.445 48.0497 232.841 47.3982 233.97C46.7468 235.098 47.117 236.531 48.2251 237.171Z"
          fill="#3A2933"
        />
        <path
          d="M43.507 245.343C44.6151 245.983 46.0415 245.587 46.6929 244.458C47.3443 243.33 46.9741 241.897 45.866 241.257C44.7579 240.617 43.3315 241.013 42.6801 242.142C42.0287 243.27 42.3989 244.703 43.507 245.343Z"
          fill="#3A2933"
        />
        <path
          d="M49.1735 254.063C50.2816 254.702 51.708 254.306 52.3594 253.178C53.0109 252.05 52.6407 250.616 51.5326 249.977C50.4245 249.337 48.9981 249.733 48.3466 250.861C47.6952 251.99 48.0654 253.423 49.1735 254.063Z"
          fill="#3A2933"
        />
        <path
          d="M38.7888 253.515C39.8969 254.155 41.3233 253.759 41.9747 252.63C42.6262 251.502 42.256 250.069 41.1479 249.429C40.0398 248.789 38.6134 249.185 37.9619 250.314C37.3105 251.442 37.6807 252.875 38.7888 253.515Z"
          fill="#3A2933"
        />
        <path
          d="M44.4554 262.235C45.5635 262.874 46.9898 262.478 47.6413 261.35C48.2927 260.222 47.9225 258.788 46.8144 258.149C45.7063 257.509 44.2799 257.905 43.6285 259.033C42.977 260.162 43.3472 261.595 44.4554 262.235Z"
          fill="#3A2933"
        />
        <path
          d="M39.7372 270.407C40.8453 271.047 42.2717 270.65 42.9231 269.522C43.5746 268.394 43.2044 266.96 42.0963 266.321C40.9882 265.681 39.5618 266.077 38.9103 267.205C38.2589 268.334 38.6291 269.767 39.7372 270.407Z"
          fill="#3A2933"
        />
        <path
          d="M34.0707 261.687C35.1788 262.327 36.6052 261.931 37.2566 260.803C37.908 259.674 37.5378 258.241 36.4297 257.601C35.3216 256.961 33.8952 257.357 33.2438 258.486C32.5924 259.614 32.9626 261.047 34.0707 261.687Z"
          fill="#3A2933"
        />
        <path
          d="M29.3525 269.859C30.4606 270.499 31.887 270.103 32.5385 268.975C33.1899 267.846 32.8197 266.413 31.7116 265.773C30.6035 265.133 29.1771 265.529 28.5256 266.658C27.8742 267.786 28.2444 269.219 29.3525 269.859Z"
          fill="#3A2933"
        />
        <path
          d="M35.0191 278.579C36.1272 279.219 37.5536 278.823 38.205 277.694C38.8564 276.566 38.4862 275.133 37.3781 274.493C36.27 273.853 34.8436 274.249 34.1922 275.377C33.5407 276.506 33.911 277.939 35.0191 278.579Z"
          fill="#3A2933"
        />
        <path
          d="M24.6344 278.031C25.7425 278.671 27.1689 278.275 27.8203 277.147C28.4718 276.018 28.1015 274.585 26.9934 273.945C25.8853 273.305 24.459 273.702 23.8075 274.83C23.1561 275.958 23.5263 277.391 24.6344 278.031Z"
          fill="#3A2933"
        />
        <path
          d="M30.3009 286.751C31.409 287.391 32.8354 286.995 33.4869 285.866C34.1383 284.738 33.7681 283.305 32.66 282.665C31.5519 282.025 30.1255 282.421 29.4741 283.549C28.8226 284.678 29.1928 286.111 30.3009 286.751Z"
          fill="#3A2933"
        />
        <path
          d="M19.9162 286.203C21.0243 286.843 22.4507 286.447 23.1022 285.319C23.7536 284.19 23.3834 282.757 22.2753 282.117C21.1672 281.478 19.7408 281.874 19.0894 283.002C18.4379 284.13 18.8081 285.564 19.9162 286.203Z"
          fill="#3A2933"
        />
        <path
          d="M25.5828 294.923C26.6909 295.563 28.1173 295.167 28.7687 294.038C29.4202 292.91 29.05 291.477 27.9418 290.837C26.8337 290.197 25.4073 290.593 24.7559 291.722C24.1045 292.85 24.4747 294.283 25.5828 294.923Z"
          fill="#3A2933"
        />
        <path
          d="M20.8646 303.095C21.9727 303.735 23.3991 303.339 24.0506 302.21C24.702 301.082 24.3318 299.649 23.2237 299.009C22.1156 298.369 20.6892 298.765 20.0378 299.894C19.3863 301.022 19.7565 302.455 20.8646 303.095Z"
          fill="#3A2933"
        />
        <path
          d="M15.1981 294.375C16.3062 295.015 17.7326 294.619 18.384 293.491C19.0355 292.362 18.6653 290.929 17.5572 290.289C16.4491 289.65 15.0227 290.046 14.3712 291.174C13.7198 292.302 14.09 293.736 15.1981 294.375Z"
          fill="#3A2933"
        />
        <path
          d="M10.4799 302.547C11.588 303.187 13.0144 302.791 13.6659 301.663C14.3173 300.535 13.9471 299.101 12.839 298.461C11.7309 297.822 10.3045 298.218 9.65307 299.346C9.00163 300.474 9.37183 301.908 10.4799 302.547Z"
          fill="#3A2933"
        />
        <path
          d="M16.1465 311.267C17.2546 311.907 18.681 311.511 19.3324 310.382C19.9839 309.254 19.6137 307.821 18.5056 307.181C17.3974 306.541 15.9711 306.937 15.3196 308.066C14.6682 309.194 15.0384 310.627 16.1465 311.267Z"
          fill="#3A2933"
        />
        <path
          d="M5.7618 310.72C6.86991 311.359 8.2963 310.963 8.94774 309.835C9.59918 308.707 9.22898 307.273 8.12087 306.634C7.01276 305.994 5.58637 306.39 4.93493 307.518C4.28349 308.646 4.65369 310.08 5.7618 310.72Z"
          fill="#3A2933"
        />
        <path
          d="M11.4283 319.439C12.5365 320.079 13.9628 319.683 14.6143 318.555C15.2657 317.426 14.8955 315.993 13.7874 315.353C12.6793 314.713 11.2529 315.109 10.6015 316.238C9.95004 317.366 10.3202 318.799 11.4283 319.439Z"
          fill="#3A2933"
        />
        <path
          d="M1.04366 318.892C2.15177 319.531 3.57814 319.135 4.22958 318.007C4.88102 316.879 4.51084 315.445 3.40273 314.806C2.29462 314.166 0.868217 314.562 0.216778 315.69C-0.434662 316.819 -0.0644449 318.252 1.04366 318.892Z"
          fill="#3A2933"
        />
        <path
          d="M6.7102 327.611C7.81831 328.251 9.2447 327.855 9.89614 326.727C10.5476 325.598 10.1774 324.165 9.06927 323.525C7.96117 322.885 6.53478 323.281 5.88334 324.41C5.2319 325.538 5.6021 326.971 6.7102 327.611Z"
          fill="#3A2933"
        />
        <path
          d="M1.99207 335.783C3.10017 336.423 4.52656 336.027 5.178 334.899C5.82944 333.77 5.45924 332.337 4.35113 331.697C3.24303 331.057 1.81664 331.454 1.1652 332.582C0.513757 333.71 0.883959 335.144 1.99207 335.783Z"
          fill="#3A2933"
        />
        <path
          d="M-3.67448 327.064C-2.56637 327.703 -1.13998 327.307 -0.48854 326.179C0.1629 325.051 -0.207303 323.617 -1.31541 322.978C-2.42351 322.338 -3.84991 322.734 -4.50135 323.862C-5.15279 324.991 -4.78258 326.424 -3.67448 327.064Z"
          fill="#3A2933"
        />
        <path
          d="M-8.39263 335.236C-7.28453 335.876 -5.85812 335.479 -5.20668 334.351C-4.55524 333.223 -4.92544 331.789 -6.03355 331.15C-7.14165 330.51 -8.56805 330.906 -9.21949 332.034C-9.87093 333.163 -9.50074 334.596 -8.39263 335.236Z"
          fill="#3A2933"
        />
        <path
          d="M-2.72609 343.955C-1.61798 344.595 -0.191591 344.199 0.459849 343.071C1.11129 341.942 0.741086 340.509 -0.36702 339.869C-1.47513 339.23 -2.90152 339.626 -3.55296 340.754C-4.2044 341.882 -3.8342 343.316 -2.72609 343.955Z"
          fill="#3A2933"
        />
        <path
          d="M-13.1108 343.408C-12.0027 344.048 -10.5763 343.652 -9.92483 342.523C-9.27339 341.395 -9.6436 339.962 -10.7517 339.322C-11.8598 338.682 -13.2862 339.078 -13.9376 340.206C-14.5891 341.335 -14.2189 342.768 -13.1108 343.408Z"
          fill="#3A2933"
        />
        <path
          d="M-7.44423 352.127C-6.33612 352.767 -4.90973 352.371 -4.25829 351.243C-3.60685 350.114 -3.97705 348.681 -5.08516 348.041C-6.19327 347.402 -7.61966 347.798 -8.2711 348.926C-8.92254 350.054 -8.55233 351.488 -7.44423 352.127Z"
          fill="#3A2933"
        />
        <path
          d="M-12.1624 360.299C-11.0543 360.939 -9.62788 360.543 -8.97644 359.415C-8.32501 358.287 -8.69521 356.853 -9.80331 356.213C-10.9114 355.574 -12.3378 355.97 -12.9893 357.098C-13.6407 358.226 -13.2705 359.66 -12.1624 360.299Z"
          fill="#3A2933"
        />
        <path
          d="M-17.8289 351.58C-16.7208 352.22 -15.2944 351.824 -14.643 350.695C-13.9915 349.567 -14.3617 348.134 -15.4698 347.494C-16.5779 346.854 -18.0043 347.25 -18.6558 348.378C-19.3072 349.507 -18.937 350.94 -17.8289 351.58Z"
          fill="#3A2933"
        />
        <path
          d="M97.3033 189.234C98.4114 189.873 99.8378 189.477 100.489 188.349C101.141 187.221 100.771 185.787 99.6624 185.148C98.5543 184.508 97.1279 184.904 96.4765 186.032C95.825 187.161 96.1952 188.594 97.3033 189.234Z"
          fill="#3A2933"
        />
        <path
          d="M102.97 197.953C104.078 198.593 105.504 198.197 106.156 197.069C106.807 195.94 106.437 194.507 105.329 193.867C104.221 193.227 102.794 193.624 102.143 194.752C101.492 195.88 101.862 197.314 102.97 197.953Z"
          fill="#3A2933"
        />
        <path
          d="M92.5852 197.406C93.6933 198.045 95.1197 197.649 95.7711 196.521C96.4226 195.393 96.0524 193.959 94.9443 193.32C93.8361 192.68 92.4098 193.076 91.7583 194.204C91.1069 195.333 91.4771 196.766 92.5852 197.406Z"
          fill="#3A2933"
        />
        <path
          d="M98.2517 206.125C99.3598 206.765 100.786 206.369 101.438 205.241C102.089 204.112 101.719 202.679 100.611 202.039C99.5027 201.4 98.0763 201.796 97.4249 202.924C96.7734 204.052 97.1436 205.486 98.2517 206.125Z"
          fill="#3A2933"
        />
        <path
          d="M87.867 205.578C88.9751 206.218 90.4015 205.822 91.053 204.693C91.7044 203.565 91.3342 202.132 90.2261 201.492C89.118 200.852 87.6916 201.248 87.0402 202.376C86.3887 203.505 86.7589 204.938 87.867 205.578Z"
          fill="#3A2933"
        />
        <path
          d="M93.5336 214.297C94.6417 214.937 96.0681 214.541 96.7195 213.413C97.371 212.284 97.0008 210.851 95.8927 210.211C94.7845 209.572 93.3581 209.968 92.7067 211.096C92.0553 212.224 92.4255 213.658 93.5336 214.297Z"
          fill="#3A2933"
        />
        <path
          d="M88.8154 222.469C89.9235 223.109 91.3499 222.713 92.0014 221.585C92.6528 220.457 92.2826 219.023 91.1745 218.383C90.0664 217.744 88.64 218.14 87.9886 219.268C87.3371 220.396 87.7073 221.83 88.8154 222.469Z"
          fill="#3A2933"
        />
        <path
          d="M83.1489 213.75C84.257 214.39 85.6834 213.994 86.3348 212.865C86.9863 211.737 86.6161 210.304 85.508 209.664C84.3999 209.024 82.9735 209.42 82.322 210.548C81.6706 211.677 82.0408 213.11 83.1489 213.75Z"
          fill="#3A2933"
        />
        <path
          d="M78.4308 221.922C79.5389 222.562 80.9653 222.166 81.6167 221.037C82.2681 219.909 81.8979 218.476 80.7898 217.836C79.6817 217.196 78.2553 217.592 77.6039 218.721C76.9524 219.849 77.3226 221.282 78.4308 221.922Z"
          fill="#3A2933"
        />
        <path
          d="M84.0973 230.642C85.2054 231.281 86.6318 230.885 87.2832 229.757C87.9347 228.629 87.5645 227.195 86.4564 226.556C85.3483 225.916 83.9219 226.312 83.2704 227.44C82.619 228.568 82.9892 230.002 84.0973 230.642Z"
          fill="#3A2933"
        />
        <path
          d="M73.7126 230.094C74.8207 230.734 76.2471 230.338 76.8985 229.209C77.55 228.081 77.1798 226.648 76.0717 226.008C74.9636 225.368 73.5372 225.764 72.8857 226.893C72.2343 228.021 72.6045 229.454 73.7126 230.094Z"
          fill="#3A2933"
        />
        <path
          d="M79.3791 238.814C80.4873 239.453 81.9136 239.057 82.5651 237.929C83.2165 236.801 82.8463 235.367 81.7382 234.728C80.6301 234.088 79.2037 234.484 78.5523 235.612C77.9008 236.741 78.271 238.174 79.3791 238.814Z"
          fill="#3A2933"
        />
        <path
          d="M68.9945 238.266C70.1026 238.906 71.529 238.51 72.1804 237.381C72.8318 236.253 72.4616 234.82 71.3535 234.18C70.2454 233.54 68.819 233.936 68.1676 235.065C67.5162 236.193 67.8863 237.626 68.9945 238.266Z"
          fill="#3A2933"
        />
        <path
          d="M74.661 246.986C75.7691 247.625 77.1955 247.229 77.8469 246.101C78.4984 244.973 78.1282 243.539 77.0201 242.9C75.912 242.26 74.4856 242.656 73.8341 243.784C73.1827 244.913 73.5529 246.346 74.661 246.986Z"
          fill="#3A2933"
        />
        <path
          d="M69.9429 255.158C71.051 255.797 72.4774 255.401 73.1288 254.273C73.7802 253.145 73.41 251.711 72.3019 251.072C71.1938 250.432 69.7674 250.828 69.116 251.956C68.4646 253.085 68.8348 254.518 69.9429 255.158Z"
          fill="#3A2933"
        />
        <path
          d="M64.2763 246.438C65.3844 247.078 66.8108 246.682 67.4623 245.553C68.1137 244.425 67.7435 242.992 66.6354 242.352C65.5273 241.712 64.1009 242.108 63.4495 243.237C62.798 244.365 63.1682 245.798 64.2763 246.438Z"
          fill="#3A2933"
        />
        <path
          d="M59.5582 254.61C60.6663 255.25 62.0927 254.854 62.7441 253.726C63.3956 252.597 63.0254 251.164 61.9173 250.524C60.8092 249.884 59.3828 250.28 58.7313 251.409C58.0799 252.537 58.4501 253.97 59.5582 254.61Z"
          fill="#3A2933"
        />
        <path
          d="M65.2247 263.33C66.3328 263.97 67.7592 263.574 68.4107 262.445C69.0621 261.317 68.6919 259.884 67.5838 259.244C66.4757 258.604 65.0493 259 64.3978 260.128C63.7464 261.257 64.1166 262.69 65.2247 263.33Z"
          fill="#3A2933"
        />
        <path
          d="M54.84 262.782C55.9481 263.422 57.3745 263.026 58.026 261.898C58.6774 260.769 58.3072 259.336 57.1991 258.696C56.091 258.056 54.6646 258.453 54.0132 259.581C53.3617 260.709 53.7319 262.142 54.84 262.782Z"
          fill="#3A2933"
        />
        <path
          d="M60.5066 271.502C61.6147 272.142 63.0411 271.746 63.6925 270.617C64.344 269.489 63.9738 268.056 62.8656 267.416C61.7575 266.776 60.3311 267.172 59.6797 268.3C59.0283 269.429 59.3985 270.862 60.5066 271.502Z"
          fill="#3A2933"
        />
        <path
          d="M55.7884 279.674C56.8965 280.314 58.3229 279.918 58.9744 278.789C59.6258 277.661 59.2556 276.228 58.1475 275.588C57.0394 274.948 55.613 275.344 54.9616 276.473C54.3101 277.601 54.6803 279.034 55.7884 279.674Z"
          fill="#3A2933"
        />
        <path
          d="M50.1219 270.954C51.23 271.594 52.6564 271.198 53.3078 270.07C53.9593 268.941 53.5891 267.508 52.481 266.868C51.3729 266.229 49.9465 266.625 49.295 267.753C48.6436 268.881 49.0138 270.315 50.1219 270.954Z"
          fill="#3A2933"
        />
        <path
          d="M45.4037 279.126C46.5118 279.766 47.9382 279.37 48.5897 278.242C49.2411 277.113 48.8709 275.68 47.7628 275.04C46.6547 274.401 45.2283 274.797 44.5769 275.925C43.9254 277.053 44.2956 278.487 45.4037 279.126Z"
          fill="#3A2933"
        />
        <path
          d="M51.0703 287.846C52.1784 288.486 53.6048 288.09 54.2562 286.961C54.9077 285.833 54.5375 284.4 53.4294 283.76C52.3212 283.12 50.8949 283.516 50.2434 284.645C49.592 285.773 49.9622 287.206 51.0703 287.846Z"
          fill="#3A2933"
        />
        <path
          d="M40.6856 287.298C41.7937 287.938 43.2201 287.542 43.8716 286.414C44.523 285.285 44.1528 283.852 43.0447 283.212C41.9366 282.573 40.5102 282.969 39.8587 284.097C39.2073 285.225 39.5775 286.659 40.6856 287.298Z"
          fill="#3A2933"
        />
        <path
          d="M46.3521 296.018C47.4602 296.658 48.8867 296.262 49.5381 295.133C50.1895 294.005 49.8193 292.572 48.7112 291.932C47.6031 291.292 46.1767 291.688 45.5253 292.817C44.8739 293.945 45.244 295.378 46.3521 296.018Z"
          fill="#3A2933"
        />
        <path
          d="M35.9675 295.471C37.0756 296.11 38.502 295.714 39.1534 294.586C39.8048 293.458 39.4346 292.024 38.3265 291.384C37.2184 290.745 35.792 291.141 35.1406 292.269C34.4892 293.397 34.8594 294.831 35.9675 295.471Z"
          fill="#3A2933"
        />
        <path
          d="M41.634 304.19C42.7421 304.83 44.1685 304.434 44.8199 303.306C45.4714 302.177 45.1012 300.744 43.9931 300.104C42.885 299.464 41.4586 299.86 40.8071 300.989C40.1557 302.117 40.5259 303.55 41.634 304.19Z"
          fill="#3A2933"
        />
        <path
          d="M36.9159 312.362C38.024 313.002 39.4504 312.606 40.1018 311.478C40.7532 310.349 40.383 308.916 39.2749 308.276C38.1668 307.636 36.7404 308.032 36.089 309.161C35.4376 310.289 35.8078 311.722 36.9159 312.362Z"
          fill="#3A2933"
        />
        <path
          d="M31.2493 303.643C32.3574 304.282 33.7838 303.886 34.4353 302.758C35.0867 301.63 34.7165 300.196 33.6084 299.557C32.5003 298.917 31.0739 299.313 30.4225 300.441C29.771 301.569 30.1412 303.003 31.2493 303.643Z"
          fill="#3A2933"
        />
        <path
          d="M26.5312 311.815C27.6393 312.454 29.0657 312.058 29.7171 310.93C30.3685 309.802 29.9984 308.368 28.8903 307.729C27.7821 307.089 26.3557 307.485 25.7043 308.613C25.0529 309.742 25.4231 311.175 26.5312 311.815Z"
          fill="#3A2933"
        />
        <path
          d="M32.1977 320.534C33.3058 321.174 34.7322 320.778 35.3836 319.65C36.0351 318.521 35.6649 317.088 34.5568 316.448C33.4487 315.808 32.0223 316.205 31.3708 317.333C30.7194 318.461 31.0896 319.895 32.1977 320.534Z"
          fill="#3A2933"
        />
        <path
          d="M21.813 319.987C22.9211 320.626 24.3475 320.23 24.999 319.102C25.6504 317.974 25.2802 316.54 24.1721 315.901C23.064 315.261 21.6376 315.657 20.9862 316.785C20.3347 317.914 20.7049 319.347 21.813 319.987Z"
          fill="#3A2933"
        />
        <path
          d="M27.4796 328.706C28.5877 329.346 30.0141 328.95 30.6655 327.822C31.3169 326.693 30.9467 325.26 29.8386 324.62C28.7305 323.981 27.3041 324.377 26.6527 325.505C26.0013 326.633 26.3715 328.067 27.4796 328.706Z"
          fill="#3A2933"
        />
        <path
          d="M17.0949 328.159C18.203 328.799 19.6294 328.403 20.2808 327.274C20.9323 326.146 20.5621 324.713 19.454 324.073C18.3459 323.433 16.9194 323.829 16.268 324.957C15.6166 326.086 15.9868 327.519 17.0949 328.159Z"
          fill="#3A2933"
        />
        <path
          d="M22.7614 336.878C23.8695 337.518 25.2959 337.122 25.9474 335.994C26.5988 334.865 26.2286 333.432 25.1205 332.792C24.0124 332.153 22.586 332.549 21.9346 333.677C21.2831 334.805 21.6533 336.239 22.7614 336.878Z"
          fill="#3A2933"
        />
        <path
          d="M18.0433 345.05C19.1514 345.69 20.5778 345.294 21.2292 344.166C21.8807 343.038 21.5105 341.604 20.4024 340.964C19.2943 340.325 17.8679 340.721 17.2164 341.849C16.565 342.977 16.9352 344.411 18.0433 345.05Z"
          fill="#3A2933"
        />
        <path
          d="M12.3767 336.331C13.4849 336.971 14.9112 336.575 15.5627 335.446C16.2141 334.318 15.8439 332.885 14.7358 332.245C13.6277 331.605 12.2013 332.001 11.5499 333.129C10.8984 334.258 11.2686 335.691 12.3767 336.331Z"
          fill="#3A2933"
        />
        <path
          d="M7.65859 344.503C8.7667 345.143 10.1931 344.747 10.8445 343.618C11.496 342.49 11.1258 341.057 10.0177 340.417C8.90957 339.777 7.48318 340.173 6.83174 341.301C6.1803 342.43 6.55049 343.863 7.65859 344.503Z"
          fill="#3A2933"
        />
        <path
          d="M13.3251 353.223C14.4332 353.862 15.8596 353.466 16.5111 352.338C17.1625 351.21 16.7923 349.776 15.6842 349.137C14.5761 348.497 13.1497 348.893 12.4983 350.021C11.8468 351.149 12.217 352.583 13.3251 353.223Z"
          fill="#3A2933"
        />
        <path
          d="M2.94045 352.675C4.04856 353.315 5.47495 352.919 6.12639 351.79C6.77783 350.662 6.40763 349.229 5.29952 348.589C4.19142 347.949 2.76502 348.345 2.11359 349.474C1.46215 350.602 1.83235 352.035 2.94045 352.675Z"
          fill="#3A2933"
        />
        <path
          d="M8.607 361.395C9.7151 362.034 11.1415 361.638 11.7929 360.51C12.4444 359.382 12.0742 357.948 10.9661 357.309C9.85796 356.669 8.43157 357.065 7.78013 358.193C7.12869 359.322 7.49889 360.755 8.607 361.395Z"
          fill="#3A2933"
        />
        <path
          d="M3.88884 369.567C4.99695 370.206 6.42334 369.81 7.07478 368.682C7.72622 367.554 7.35602 366.12 6.24791 365.481C5.13981 364.841 3.71341 365.237 3.06198 366.365C2.41054 367.494 2.78074 368.927 3.88884 369.567Z"
          fill="#3A2933"
        />
        <path
          d="M-1.7777 360.847C-0.669595 361.487 0.756813 361.091 1.40825 359.962C2.05969 358.834 1.68949 357.401 0.581384 356.761C-0.526722 356.121 -1.95311 356.517 -2.60455 357.646C-3.25599 358.774 -2.88581 360.207 -1.7777 360.847Z"
          fill="#3A2933"
        />
        <path
          d="M113.355 198.501C114.463 199.141 115.889 198.745 116.54 197.616C117.192 196.488 116.822 195.055 115.714 194.415C114.606 193.775 113.179 194.171 112.528 195.299C111.876 196.428 112.246 197.861 113.355 198.501Z"
          fill="#3A2933"
        />
        <path
          d="M119.021 207.22C120.129 207.86 121.556 207.464 122.207 206.336C122.858 205.208 122.488 203.774 121.38 203.134C120.272 202.495 118.846 202.891 118.194 204.019C117.543 205.147 117.913 206.581 119.021 207.22Z"
          fill="#3A2933"
        />
        <path
          d="M108.636 206.673C109.745 207.313 111.171 206.917 111.822 205.788C112.474 204.66 112.104 203.227 110.995 202.587C109.887 201.947 108.461 202.343 107.81 203.471C107.158 204.6 107.528 206.033 108.636 206.673Z"
          fill="#3A2933"
        />
        <path
          d="M114.303 215.393C115.411 216.032 116.837 215.636 117.489 214.508C118.14 213.38 117.77 211.946 116.662 211.306C115.554 210.667 114.128 211.063 113.476 212.191C112.825 213.319 113.195 214.753 114.303 215.393Z"
          fill="#3A2933"
        />
        <path
          d="M103.918 214.845C105.026 215.485 106.453 215.089 107.104 213.96C107.756 212.832 107.385 211.399 106.277 210.759C105.169 210.119 103.743 210.515 103.091 211.644C102.44 212.772 102.81 214.205 103.918 214.845Z"
          fill="#3A2933"
        />
        <path
          d="M109.585 223.565C110.693 224.204 112.119 223.808 112.771 222.68C113.422 221.552 113.052 220.118 111.944 219.479C110.836 218.839 109.409 219.235 108.758 220.363C108.106 221.492 108.477 222.925 109.585 223.565Z"
          fill="#3A2933"
        />
        <path
          d="M104.867 231.737C105.975 232.376 107.401 231.98 108.053 230.852C108.704 229.724 108.334 228.29 107.226 227.651C106.118 227.011 104.691 227.407 104.04 228.535C103.388 229.664 103.759 231.097 104.867 231.737Z"
          fill="#3A2933"
        />
        <path
          d="M99.2001 223.017C100.308 223.657 101.735 223.261 102.386 222.132C103.038 221.004 102.667 219.571 101.559 218.931C100.451 218.291 99.0247 218.687 98.3733 219.816C97.7218 220.944 98.092 222.377 99.2001 223.017Z"
          fill="#3A2933"
        />
        <path
          d="M94.482 231.189C95.5901 231.829 97.0165 231.433 97.6679 230.304C98.3194 229.176 97.9492 227.743 96.8411 227.103C95.7329 226.463 94.3065 226.859 93.6551 227.988C93.0037 229.116 93.3739 230.549 94.482 231.189Z"
          fill="#3A2933"
        />
        <path
          d="M100.149 239.909C101.257 240.549 102.683 240.152 103.334 239.024C103.986 237.896 103.616 236.462 102.508 235.823C101.399 235.183 99.9731 235.579 99.3216 236.707C98.6702 237.836 99.0404 239.269 100.149 239.909Z"
          fill="#3A2933"
        />
        <path
          d="M89.7638 239.361C90.8719 240.001 92.2983 239.605 92.9498 238.477C93.6012 237.348 93.231 235.915 92.1229 235.275C91.0148 234.635 89.5884 235.031 88.937 236.16C88.2855 237.288 88.6557 238.721 89.7638 239.361Z"
          fill="#3A2933"
        />
        <path
          d="M95.4304 248.081C96.5385 248.721 97.9649 248.325 98.6163 247.196C99.2678 246.068 98.8976 244.635 97.7894 243.995C96.6813 243.355 95.2549 243.751 94.6035 244.879C93.9521 246.008 94.3223 247.441 95.4304 248.081Z"
          fill="#3A2933"
        />
        <path
          d="M85.0457 247.533C86.1538 248.173 87.5802 247.777 88.2316 246.649C88.8831 245.52 88.5129 244.087 87.4048 243.447C86.2967 242.807 84.8703 243.203 84.2188 244.332C83.5674 245.46 83.9376 246.893 85.0457 247.533Z"
          fill="#3A2933"
        />
        <path
          d="M90.7122 256.253C91.8203 256.893 93.2467 256.497 93.8982 255.368C94.5496 254.24 94.1794 252.807 93.0713 252.167C91.9632 251.527 90.5368 251.923 89.8854 253.051C89.2339 254.18 89.6041 255.613 90.7122 256.253Z"
          fill="#3A2933"
        />
        <path
          d="M85.9941 264.425C87.1022 265.065 88.5286 264.669 89.18 263.54C89.8315 262.412 89.4613 260.979 88.3532 260.339C87.2451 259.699 85.8187 260.095 85.1672 261.223C84.5158 262.352 84.886 263.785 85.9941 264.425Z"
          fill="#3A2933"
        />
        <path
          d="M80.3276 255.705C81.4357 256.345 82.8621 255.949 83.5135 254.821C84.1649 253.692 83.7947 252.259 82.6866 251.619C81.5785 250.979 80.1521 251.376 79.5007 252.504C78.8492 253.632 79.2194 255.066 80.3276 255.705Z"
          fill="#3A2933"
        />
        <path
          d="M75.6094 263.877C76.7175 264.517 78.1439 264.121 78.7954 262.993C79.4468 261.864 79.0766 260.431 77.9685 259.791C76.8604 259.152 75.434 259.548 74.7825 260.676C74.1311 261.804 74.5013 263.238 75.6094 263.877Z"
          fill="#3A2933"
        />
        <path
          d="M81.2759 272.597C82.384 273.237 83.8104 272.841 84.4619 271.712C85.1133 270.584 84.7431 269.151 83.635 268.511C82.5269 267.871 81.1005 268.267 80.4491 269.396C79.7976 270.524 80.1678 271.957 81.2759 272.597Z"
          fill="#3A2933"
        />
        <path
          d="M70.8913 272.049C71.9994 272.689 73.4258 272.293 74.0772 271.165C74.7286 270.036 74.3584 268.603 73.2503 267.963C72.1422 267.324 70.7158 267.72 70.0644 268.848C69.4129 269.976 69.7832 271.41 70.8913 272.049Z"
          fill="#3A2933"
        />
        <path
          d="M76.5578 280.769C77.6659 281.409 79.0923 281.013 79.7437 279.884C80.3952 278.756 80.025 277.323 78.9169 276.683C77.8088 276.043 76.3824 276.439 75.7309 277.568C75.0795 278.696 75.4497 280.129 76.5578 280.769Z"
          fill="#3A2933"
        />
        <path
          d="M71.8396 288.941C72.9478 289.581 74.3741 289.185 75.0256 288.057C75.677 286.928 75.3068 285.495 74.1987 284.855C73.0906 284.215 71.6642 284.611 71.0128 285.74C70.3613 286.868 70.7315 288.301 71.8396 288.941Z"
          fill="#3A2933"
        />
        <path
          d="M66.1731 280.221C67.2812 280.861 68.7076 280.465 69.3591 279.337C70.0105 278.209 69.6403 276.775 68.5322 276.135C67.4241 275.496 65.9977 275.892 65.3463 277.02C64.6948 278.148 65.065 279.582 66.1731 280.221Z"
          fill="#3A2933"
        />
        <path
          d="M61.455 288.394C62.5631 289.033 63.9895 288.637 64.6409 287.509C65.2923 286.381 64.9221 284.947 63.814 284.308C62.7059 283.668 61.2795 284.064 60.6281 285.192C59.9767 286.32 60.3469 287.754 61.455 288.394Z"
          fill="#3A2933"
        />
        <path
          d="M67.1215 297.113C68.2296 297.753 69.656 297.357 70.3074 296.229C70.9589 295.1 70.5887 293.667 69.4806 293.027C68.3725 292.387 66.9461 292.783 66.2946 293.912C65.6432 295.04 66.0134 296.473 67.1215 297.113Z"
          fill="#3A2933"
        />
        <path
          d="M56.7368 296.566C57.8449 297.205 59.2713 296.809 59.9228 295.681C60.5742 294.553 60.204 293.119 59.0959 292.48C57.9878 291.84 56.5614 292.236 55.91 293.364C55.2585 294.493 55.6287 295.926 56.7368 296.566Z"
          fill="#3A2933"
        />
        <path
          d="M62.4034 305.285C63.5115 305.925 64.9379 305.529 65.5893 304.401C66.2408 303.272 65.8706 301.839 64.7625 301.199C63.6543 300.559 62.228 300.955 61.5765 302.084C60.9251 303.212 61.2953 304.645 62.4034 305.285Z"
          fill="#3A2933"
        />
        <path
          d="M52.0187 304.738C53.1268 305.377 54.5532 304.981 55.2046 303.853C55.8561 302.725 55.4859 301.291 54.3778 300.652C53.2697 300.012 51.8433 300.408 51.1918 301.536C50.5404 302.665 50.9106 304.098 52.0187 304.738Z"
          fill="#3A2933"
        />
        <path
          d="M57.6852 313.457C58.7933 314.097 60.2197 313.701 60.8712 312.573C61.5226 311.444 61.1524 310.011 60.0443 309.371C58.9362 308.732 57.5098 309.128 56.8584 310.256C56.2069 311.384 56.5771 312.818 57.6852 313.457Z"
          fill="#3A2933"
        />
        <path
          d="M52.9671 321.629C54.0752 322.269 55.5016 321.873 56.153 320.745C56.8045 319.616 56.4343 318.183 55.3262 317.543C54.2181 316.904 52.7917 317.3 52.1402 318.428C51.4888 319.556 51.859 320.99 52.9671 321.629Z"
          fill="#3A2933"
        />
        <path
          d="M47.3005 312.91C48.4087 313.55 49.835 313.153 50.4865 312.025C51.1379 310.897 50.7677 309.463 49.6596 308.824C48.5515 308.184 47.1251 308.58 46.4737 309.708C45.8222 310.837 46.1924 312.27 47.3005 312.91Z"
          fill="#3A2933"
        />
        <path
          d="M42.5824 321.082C43.6905 321.722 45.1169 321.326 45.7683 320.197C46.4198 319.069 46.0496 317.636 44.9415 316.996C43.8334 316.356 42.407 316.752 41.7555 317.88C41.1041 319.009 41.4743 320.442 42.5824 321.082Z"
          fill="#3A2933"
        />
        <path
          d="M48.2489 329.801C49.357 330.441 50.7834 330.045 51.4349 328.917C52.0863 327.789 51.7161 326.355 50.608 325.715C49.4999 325.076 48.0735 325.472 47.4221 326.6C46.7706 327.728 47.1408 329.162 48.2489 329.801Z"
          fill="#3A2933"
        />
        <path
          d="M37.8643 329.254C38.9724 329.894 40.3988 329.498 41.0502 328.369C41.7016 327.241 41.3314 325.808 40.2233 325.168C39.1152 324.528 37.6888 324.924 37.0374 326.052C36.3859 327.181 36.7561 328.614 37.8643 329.254Z"
          fill="#3A2933"
        />
        <path
          d="M43.5308 337.974C44.6389 338.613 46.0653 338.217 46.7167 337.089C47.3682 335.961 46.998 334.527 45.8899 333.887C44.7818 333.248 43.3554 333.644 42.7039 334.772C42.0525 335.9 42.4227 337.334 43.5308 337.974Z"
          fill="#3A2933"
        />
        <path
          d="M33.1461 337.426C34.2542 338.066 35.6806 337.67 36.332 336.541C36.9835 335.413 36.6133 333.98 35.5052 333.34C34.3971 332.7 32.9707 333.096 32.3192 334.225C31.6678 335.353 32.038 336.786 33.1461 337.426Z"
          fill="#3A2933"
        />
        <path
          d="M38.8127 346.146C39.9208 346.785 41.3472 346.389 41.9986 345.261C42.65 344.133 42.2798 342.699 41.1717 342.06C40.0636 341.42 38.6372 341.816 37.9858 342.944C37.3343 344.072 37.7046 345.506 38.8127 346.146Z"
          fill="#3A2933"
        />
        <path
          d="M34.0945 354.318C35.2026 354.957 36.629 354.561 37.2805 353.433C37.9319 352.305 37.5617 350.871 36.4536 350.232C35.3455 349.592 33.9191 349.988 33.2676 351.116C32.6162 352.245 32.9864 353.678 34.0945 354.318Z"
          fill="#3A2933"
        />
        <path
          d="M28.428 345.598C29.5361 346.238 30.9625 345.842 31.6139 344.713C32.2654 343.585 31.8952 342.152 30.787 341.512C29.6789 340.872 28.2525 341.268 27.6011 342.397C26.9497 343.525 27.3199 344.958 28.428 345.598Z"
          fill="#3A2933"
        />
        <path
          d="M23.7098 353.77C24.8179 354.41 26.2443 354.014 26.8958 352.885C27.5472 351.757 27.177 350.324 26.0689 349.684C24.9608 349.044 23.5344 349.44 22.883 350.569C22.2315 351.697 22.6017 353.13 23.7098 353.77Z"
          fill="#3A2933"
        />
        <path
          d="M29.3764 362.49C30.4845 363.129 31.9109 362.733 32.5623 361.605C33.2137 360.477 32.8435 359.043 31.7354 358.404C30.6273 357.764 29.2009 358.16 28.5495 359.288C27.8981 360.417 28.2683 361.85 29.3764 362.49Z"
          fill="#3A2933"
        />
        <path
          d="M18.9917 361.942C20.0998 362.582 21.5262 362.186 22.1776 361.058C22.8291 359.929 22.4589 358.496 21.3508 357.856C20.2426 357.216 18.8163 357.612 18.1648 358.741C17.5134 359.869 17.8836 361.302 18.9917 361.942Z"
          fill="#3A2933"
        />
        <path
          d="M24.6582 370.662C25.7663 371.302 27.1927 370.905 27.8442 369.777C28.4956 368.649 28.1254 367.216 27.0173 366.576C25.9092 365.936 24.4828 366.332 23.8314 367.46C23.1799 368.589 23.5501 370.022 24.6582 370.662Z"
          fill="#3A2933"
        />
        <path
          d="M19.9401 378.834C21.0482 379.474 22.4746 379.078 23.126 377.949C23.7774 376.821 23.4072 375.388 22.2991 374.748C21.191 374.108 19.7646 374.504 19.1132 375.632C18.4618 376.761 18.832 378.194 19.9401 378.834Z"
          fill="#3A2933"
        />
        <path
          d="M14.2735 370.114C15.3816 370.754 16.808 370.358 17.4595 369.23C18.1109 368.101 17.7407 366.668 16.6326 366.028C15.5245 365.388 14.0981 365.784 13.4467 366.913C12.7952 368.041 13.1654 369.474 14.2735 370.114Z"
          fill="#3A2933"
        />
        <path
          d="M129.406 207.768C130.514 208.408 131.94 208.012 132.592 206.883C133.243 205.755 132.873 204.322 131.765 203.682C130.657 203.042 129.23 203.438 128.579 204.567C127.927 205.695 128.298 207.128 129.406 207.768Z"
          fill="#3A2933"
        />
        <path
          d="M135.072 216.488C136.18 217.127 137.607 216.731 138.258 215.603C138.91 214.475 138.54 213.041 137.431 212.402C136.323 211.762 134.897 212.158 134.245 213.286C133.594 214.415 133.964 215.848 135.072 216.488Z"
          fill="#3A2933"
        />
        <path
          d="M124.688 215.94C125.796 216.58 127.222 216.184 127.874 215.055C128.525 213.927 128.155 212.494 127.047 211.854C125.939 211.214 124.512 211.61 123.861 212.739C123.209 213.867 123.58 215.3 124.688 215.94Z"
          fill="#3A2933"
        />
        <path
          d="M130.354 224.66C131.462 225.299 132.889 224.903 133.54 223.775C134.192 222.647 133.821 221.213 132.713 220.574C131.605 219.934 130.179 220.33 129.527 221.458C128.876 222.587 129.246 224.02 130.354 224.66Z"
          fill="#3A2933"
        />
        <path
          d="M119.969 224.112C121.078 224.752 122.504 224.356 123.155 223.228C123.807 222.099 123.437 220.666 122.329 220.026C121.22 219.386 119.794 219.782 119.143 220.911C118.491 222.039 118.861 223.472 119.969 224.112Z"
          fill="#3A2933"
        />
        <path
          d="M125.636 232.832C126.744 233.472 128.171 233.075 128.822 231.947C129.473 230.819 129.103 229.386 127.995 228.746C126.887 228.106 125.461 228.502 124.809 229.63C124.158 230.759 124.528 232.192 125.636 232.832Z"
          fill="#3A2933"
        />
        <path
          d="M120.918 241.004C122.026 241.644 123.452 241.248 124.104 240.119C124.755 238.991 124.385 237.558 123.277 236.918C122.169 236.278 120.742 236.674 120.091 237.802C119.44 238.931 119.81 240.364 120.918 241.004Z"
          fill="#3A2933"
        />
        <path
          d="M115.251 232.284C116.359 232.924 117.786 232.528 118.437 231.4C119.089 230.271 118.719 228.838 117.61 228.198C116.502 227.558 115.076 227.954 114.424 229.083C113.773 230.211 114.143 231.644 115.251 232.284Z"
          fill="#3A2933"
        />
        <path
          d="M110.533 240.456C111.641 241.096 113.068 240.7 113.719 239.572C114.371 238.443 114 237.01 112.892 236.37C111.784 235.73 110.358 236.127 109.706 237.255C109.055 238.383 109.425 239.817 110.533 240.456Z"
          fill="#3A2933"
        />
        <path
          d="M116.2 249.176C117.308 249.816 118.734 249.42 119.386 248.291C120.037 247.163 119.667 245.73 118.559 245.09C117.451 244.45 116.024 244.846 115.373 245.975C114.721 247.103 115.092 248.536 116.2 249.176Z"
          fill="#3A2933"
        />
        <path
          d="M105.815 248.628C106.923 249.268 108.35 248.872 109.001 247.744C109.652 246.615 109.282 245.182 108.174 244.542C107.066 243.903 105.64 244.299 104.988 245.427C104.337 246.555 104.707 247.989 105.815 248.628Z"
          fill="#3A2933"
        />
        <path
          d="M111.482 257.348C112.59 257.988 114.016 257.592 114.668 256.463C115.319 255.335 114.949 253.902 113.841 253.262C112.733 252.622 111.306 253.018 110.655 254.147C110.003 255.275 110.373 256.708 111.482 257.348Z"
          fill="#3A2933"
        />
        <path
          d="M101.097 256.8C102.205 257.44 103.631 257.044 104.283 255.916C104.934 254.787 104.564 253.354 103.456 252.714C102.348 252.075 100.921 252.471 100.27 253.599C99.6186 254.727 99.9888 256.161 101.097 256.8Z"
          fill="#3A2933"
        />
        <path
          d="M106.763 265.52C107.872 266.16 109.298 265.764 109.949 264.635C110.601 263.507 110.231 262.074 109.123 261.434C108.014 260.794 106.588 261.19 105.937 262.319C105.285 263.447 105.655 264.88 106.763 265.52Z"
          fill="#3A2933"
        />
        <path
          d="M102.045 273.692C103.153 274.332 104.58 273.936 105.231 272.807C105.883 271.679 105.513 270.246 104.404 269.606C103.296 268.966 101.87 269.362 101.218 270.491C100.567 271.619 100.937 273.052 102.045 273.692Z"
          fill="#3A2933"
        />
        <path
          d="M96.3788 264.972C97.4869 265.612 98.9133 265.216 99.5647 264.088C100.216 262.96 99.846 261.526 98.7379 260.886C97.6297 260.247 96.2034 260.643 95.5519 261.771C94.9005 262.899 95.2707 264.333 96.3788 264.972Z"
          fill="#3A2933"
        />
        <path
          d="M91.6606 273.145C92.7687 273.784 94.1951 273.388 94.8466 272.26C95.498 271.132 95.1278 269.698 94.0197 269.059C92.9116 268.419 91.4852 268.815 90.8338 269.943C90.1823 271.071 90.5525 272.505 91.6606 273.145Z"
          fill="#3A2933"
        />
        <path
          d="M97.3272 281.864C98.4353 282.504 99.8617 282.108 100.513 280.98C101.165 279.851 100.794 278.418 99.6863 277.778C98.5782 277.138 97.1517 277.534 96.5003 278.663C95.8489 279.791 96.2191 281.224 97.3272 281.864Z"
          fill="#3A2933"
        />
        <path
          d="M86.9425 281.317C88.0506 281.956 89.477 281.56 90.1284 280.432C90.7799 279.304 90.4097 277.87 89.3016 277.231C88.1935 276.591 86.7671 276.987 86.1156 278.115C85.4642 279.244 85.8344 280.677 86.9425 281.317Z"
          fill="#3A2933"
        />
        <path
          d="M92.609 290.036C93.7171 290.676 95.1435 290.28 95.795 289.152C96.4464 288.023 96.0762 286.59 94.9681 285.95C93.86 285.31 92.4336 285.706 91.7822 286.835C91.1307 287.963 91.5009 289.396 92.609 290.036Z"
          fill="#3A2933"
        />
        <path
          d="M87.8909 298.208C88.999 298.848 90.4254 298.452 91.0768 297.324C91.7282 296.195 91.3581 294.762 90.25 294.122C89.1419 293.482 87.7154 293.879 87.064 295.007C86.4126 296.135 86.7828 297.569 87.8909 298.208Z"
          fill="#3A2933"
        />
        <path
          d="M82.2243 289.489C83.3325 290.128 84.7588 289.732 85.4103 288.604C86.0617 287.476 85.6915 286.042 84.5834 285.403C83.4753 284.763 82.0489 285.159 81.3975 286.287C80.746 287.416 81.1162 288.849 82.2243 289.489Z"
          fill="#3A2933"
        />
        <path
          d="M77.5062 297.661C78.6143 298.301 80.0407 297.904 80.6921 296.776C81.3436 295.648 80.9734 294.214 79.8653 293.575C78.7572 292.935 77.3308 293.331 76.6793 294.459C76.0279 295.588 76.3981 297.021 77.5062 297.661Z"
          fill="#3A2933"
        />
        <path
          d="M83.1727 306.38C84.2808 307.02 85.7072 306.624 86.3587 305.496C87.0101 304.367 86.6399 302.934 85.5318 302.294C84.4237 301.655 82.9973 302.051 82.3459 303.179C81.6944 304.307 82.0646 305.741 83.1727 306.38Z"
          fill="#3A2933"
        />
        <path
          d="M72.7881 305.833C73.8962 306.473 75.3226 306.076 75.974 304.948C76.6254 303.82 76.2552 302.387 75.1471 301.747C74.039 301.107 72.6126 301.503 71.9612 302.631C71.3098 303.76 71.68 305.193 72.7881 305.833Z"
          fill="#3A2933"
        />
        <path
          d="M78.4546 314.552C79.5627 315.192 80.9891 314.796 81.6405 313.668C82.292 312.539 81.9218 311.106 80.8137 310.466C79.7056 309.827 78.2792 310.223 77.6277 311.351C76.9763 312.479 77.3465 313.913 78.4546 314.552Z"
          fill="#3A2933"
        />
        <path
          d="M68.0699 314.005C69.178 314.645 70.6044 314.249 71.2558 313.12C71.9073 311.992 71.5371 310.559 70.429 309.919C69.3209 309.279 67.8945 309.675 67.243 310.803C66.5916 311.932 66.9618 313.365 68.0699 314.005Z"
          fill="#3A2933"
        />
        <path
          d="M73.7365 322.724C74.8446 323.364 76.271 322.968 76.9224 321.84C77.5738 320.712 77.2036 319.278 76.0955 318.638C74.9874 317.999 73.561 318.395 72.9096 319.523C72.2582 320.651 72.6284 322.085 73.7365 322.724Z"
          fill="#3A2933"
        />
        <path
          d="M69.0183 330.897C70.1264 331.536 71.5528 331.14 72.2043 330.012C72.8557 328.884 72.4855 327.45 71.3774 326.811C70.2693 326.171 68.8429 326.567 68.1915 327.695C67.54 328.823 67.9102 330.257 69.0183 330.897Z"
          fill="#3A2933"
        />
        <path
          d="M63.3518 322.177C64.4599 322.817 65.8863 322.421 66.5377 321.292C67.1891 320.164 66.819 318.731 65.7108 318.091C64.6027 317.451 63.1763 317.847 62.5249 318.976C61.8735 320.104 62.2437 321.537 63.3518 322.177Z"
          fill="#3A2933"
        />
        <path
          d="M58.6336 330.349C59.7417 330.989 61.1681 330.593 61.8196 329.464C62.471 328.336 62.1008 326.903 60.9927 326.263C59.8846 325.623 58.4582 326.019 57.8068 327.148C57.1553 328.276 57.5255 329.709 58.6336 330.349Z"
          fill="#3A2933"
        />
        <path
          d="M64.3002 339.069C65.4083 339.708 66.8347 339.312 67.4861 338.184C68.1375 337.056 67.7673 335.622 66.6592 334.983C65.5511 334.343 64.1247 334.739 63.4733 335.867C62.8219 336.996 63.1921 338.429 64.3002 339.069Z"
          fill="#3A2933"
        />
        <path
          d="M53.9155 338.521C55.0236 339.161 56.45 338.765 57.1014 337.636C57.7529 336.508 57.3827 335.075 56.2746 334.435C55.1664 333.795 53.7401 334.191 53.0886 335.32C52.4372 336.448 52.8074 337.881 53.9155 338.521Z"
          fill="#3A2933"
        />
        <path
          d="M59.582 347.241C60.6901 347.88 62.1165 347.484 62.768 346.356C63.4194 345.228 63.0492 343.794 61.9411 343.155C60.833 342.515 59.4066 342.911 58.7552 344.039C58.1037 345.168 58.4739 346.601 59.582 347.241Z"
          fill="#3A2933"
        />
        <path
          d="M49.1973 346.693C50.3054 347.333 51.7318 346.937 52.3833 345.809C53.0347 344.68 52.6645 343.247 51.5564 342.607C50.4483 341.967 49.0219 342.363 48.3705 343.492C47.719 344.62 48.0892 346.053 49.1973 346.693Z"
          fill="#3A2933"
        />
        <path
          d="M54.8639 355.413C55.972 356.053 57.3984 355.656 58.0498 354.528C58.7013 353.4 58.3311 351.966 57.223 351.327C56.1149 350.687 54.6885 351.083 54.037 352.211C53.3856 353.34 53.7558 354.773 54.8639 355.413Z"
          fill="#3A2933"
        />
        <path
          d="M50.1457 363.585C51.2539 364.225 52.6802 363.829 53.3317 362.7C53.9831 361.572 53.6129 360.139 52.5048 359.499C51.3967 358.859 49.9703 359.255 49.3189 360.383C48.6674 361.512 49.0376 362.945 50.1457 363.585Z"
          fill="#3A2933"
        />
        <path
          d="M44.4792 354.865C45.5873 355.505 47.0137 355.109 47.6651 353.981C48.3166 352.852 47.9464 351.419 46.8383 350.779C45.7302 350.139 44.3038 350.535 43.6523 351.664C43.0009 352.792 43.3711 354.225 44.4792 354.865Z"
          fill="#3A2933"
        />
        <path
          d="M39.761 363.037C40.8692 363.677 42.2956 363.281 42.947 362.153C43.5984 361.024 43.2282 359.591 42.1201 358.951C41.012 358.311 39.5856 358.708 38.9342 359.836C38.2828 360.964 38.6529 362.398 39.761 363.037Z"
          fill="#3A2933"
        />
        <path
          d="M45.4276 371.757C46.5357 372.397 47.9621 372.001 48.6135 370.872C49.265 369.744 48.8948 368.311 47.7867 367.671C46.6786 367.031 45.2522 367.427 44.6007 368.555C43.9493 369.684 44.3195 371.117 45.4276 371.757Z"
          fill="#3A2933"
        />
        <path
          d="M35.0429 371.209C36.151 371.849 37.5774 371.453 38.2288 370.325C38.8803 369.196 38.5101 367.763 37.402 367.123C36.2939 366.484 34.8675 366.88 34.216 368.008C33.5646 369.136 33.9348 370.57 35.0429 371.209Z"
          fill="#3A2933"
        />
        <path
          d="M40.7095 379.929C41.8176 380.569 43.2439 380.173 43.8954 379.044C44.5468 377.916 44.1766 376.483 43.0685 375.843C41.9604 375.203 40.534 375.599 39.8826 376.728C39.2311 377.856 39.6013 379.289 40.7095 379.929Z"
          fill="#3A2933"
        />
        <path
          d="M35.9913 388.101C37.0994 388.741 38.5258 388.345 39.1772 387.216C39.8287 386.088 39.4585 384.655 38.3504 384.015C37.2423 383.375 35.8159 383.771 35.1644 384.9C34.513 386.028 34.8832 387.461 35.9913 388.101Z"
          fill="#3A2933"
        />
        <path
          d="M30.3248 379.381C31.4329 380.021 32.8593 379.625 33.5107 378.497C34.1621 377.368 33.7919 375.935 32.6838 375.295C31.5757 374.656 30.1493 375.052 29.4979 376.18C28.8465 377.308 29.2166 378.742 30.3248 379.381Z"
          fill="#3A2933"
        />
        <path
          d="M145.457 217.035C146.565 217.675 147.992 217.279 148.643 216.151C149.294 215.022 148.924 213.589 147.816 212.949C146.708 212.309 145.282 212.705 144.63 213.834C143.979 214.962 144.349 216.395 145.457 217.035Z"
          fill="#3A2933"
        />
        <path
          d="M151.124 225.755C152.232 226.395 153.658 225.999 154.309 224.87C154.961 223.742 154.591 222.309 153.483 221.669C152.375 221.029 150.948 221.425 150.297 222.553C149.645 223.682 150.015 225.115 151.124 225.755Z"
          fill="#3A2933"
        />
        <path
          d="M140.739 225.207C141.847 225.847 143.273 225.451 143.925 224.323C144.576 223.194 144.206 221.761 143.098 221.121C141.99 220.481 140.563 220.878 139.912 222.006C139.261 223.134 139.631 224.567 140.739 225.207Z"
          fill="#3A2933"
        />
        <path
          d="M146.405 233.927C147.514 234.567 148.94 234.171 149.591 233.042C150.243 231.914 149.873 230.481 148.764 229.841C147.656 229.201 146.23 229.597 145.579 230.725C144.927 231.854 145.297 233.287 146.405 233.927Z"
          fill="#3A2933"
        />
        <path
          d="M136.021 233.379C137.129 234.019 138.555 233.623 139.207 232.495C139.858 231.366 139.488 229.933 138.38 229.293C137.272 228.654 135.845 229.05 135.194 230.178C134.542 231.306 134.913 232.74 136.021 233.379Z"
          fill="#3A2933"
        />
        <path
          d="M141.687 242.099C142.795 242.739 144.222 242.343 144.873 241.214C145.525 240.086 145.154 238.653 144.046 238.013C142.938 237.373 141.512 237.769 140.86 238.898C140.209 240.026 140.579 241.459 141.687 242.099Z"
          fill="#3A2933"
        />
        <path
          d="M136.969 250.271C138.077 250.911 139.504 250.515 140.155 249.386C140.806 248.258 140.436 246.825 139.328 246.185C138.22 245.545 136.794 245.941 136.142 247.07C135.491 248.198 135.861 249.631 136.969 250.271Z"
          fill="#3A2933"
        />
        <path
          d="M131.303 241.551C132.411 242.191 133.837 241.795 134.489 240.667C135.14 239.538 134.77 238.105 133.662 237.465C132.554 236.826 131.127 237.222 130.476 238.35C129.824 239.478 130.194 240.912 131.303 241.551Z"
          fill="#3A2933"
        />
        <path
          d="M126.584 249.723C127.693 250.363 129.119 249.967 129.77 248.839C130.422 247.711 130.052 246.277 128.944 245.637C127.835 244.998 126.409 245.394 125.758 246.522C125.106 247.65 125.476 249.084 126.584 249.723Z"
          fill="#3A2933"
        />
        <path
          d="M132.251 258.443C133.359 259.083 134.785 258.687 135.437 257.558C136.088 256.43 135.718 254.997 134.61 254.357C133.502 253.717 132.076 254.113 131.424 255.242C130.773 256.37 131.143 257.803 132.251 258.443Z"
          fill="#3A2933"
        />
        <path
          d="M121.866 257.896C122.974 258.535 124.401 258.139 125.052 257.011C125.704 255.883 125.333 254.449 124.225 253.81C123.117 253.17 121.691 253.566 121.039 254.694C120.388 255.822 120.758 257.256 121.866 257.896Z"
          fill="#3A2933"
        />
        <path
          d="M127.533 266.615C128.641 267.255 130.067 266.859 130.719 265.731C131.37 264.602 131 263.169 129.892 262.529C128.784 261.889 127.357 262.285 126.706 263.414C126.055 264.542 126.425 265.975 127.533 266.615Z"
          fill="#3A2933"
        />
        <path
          d="M117.148 266.068C118.256 266.707 119.683 266.311 120.334 265.183C120.986 264.055 120.615 262.621 119.507 261.982C118.399 261.342 116.973 261.738 116.321 262.866C115.67 263.995 116.04 265.428 117.148 266.068Z"
          fill="#3A2933"
        />
        <path
          d="M122.815 274.787C123.923 275.427 125.349 275.031 126.001 273.903C126.652 272.774 126.282 271.341 125.174 270.701C124.066 270.061 122.639 270.457 121.988 271.586C121.336 272.714 121.707 274.147 122.815 274.787Z"
          fill="#3A2933"
        />
        <path
          d="M118.097 282.959C119.205 283.599 120.631 283.203 121.282 282.075C121.934 280.946 121.564 279.513 120.456 278.873C119.348 278.233 117.921 278.63 117.27 279.758C116.618 280.886 116.988 282.32 118.097 282.959Z"
          fill="#3A2933"
        />
        <path
          d="M112.43 274.24C113.538 274.879 114.965 274.483 115.616 273.355C116.267 272.227 115.897 270.793 114.789 270.154C113.681 269.514 112.255 269.91 111.603 271.038C110.952 272.167 111.322 273.6 112.43 274.24Z"
          fill="#3A2933"
        />
        <path
          d="M107.712 282.412C108.82 283.051 110.246 282.655 110.898 281.527C111.549 280.399 111.179 278.965 110.071 278.326C108.963 277.686 107.536 278.082 106.885 279.21C106.234 280.339 106.604 281.772 107.712 282.412Z"
          fill="#3A2933"
        />
        <path
          d="M113.378 291.131C114.486 291.771 115.913 291.375 116.564 290.247C117.216 289.118 116.846 287.685 115.737 287.045C114.629 286.406 113.203 286.802 112.552 287.93C111.9 289.058 112.27 290.492 113.378 291.131Z"
          fill="#3A2933"
        />
        <path
          d="M102.994 290.584C104.102 291.224 105.528 290.828 106.18 289.699C106.831 288.571 106.461 287.138 105.353 286.498C104.245 285.858 102.818 286.254 102.167 287.382C101.515 288.511 101.886 289.944 102.994 290.584Z"
          fill="#3A2933"
        />
        <path
          d="M108.66 299.303C109.768 299.943 111.195 299.547 111.846 298.419C112.498 297.29 112.127 295.857 111.019 295.217C109.911 294.578 108.485 294.974 107.833 296.102C107.182 297.23 107.552 298.664 108.66 299.303Z"
          fill="#3A2933"
        />
        <path
          d="M103.942 307.475C105.05 308.115 106.477 307.719 107.128 306.591C107.779 305.463 107.409 304.029 106.301 303.389C105.193 302.75 103.767 303.146 103.115 304.274C102.464 305.402 102.834 306.836 103.942 307.475Z"
          fill="#3A2933"
        />
        <path
          d="M98.2756 298.756C99.3837 299.396 100.81 299 101.462 297.871C102.113 296.743 101.743 295.31 100.635 294.67C99.5265 294.03 98.1001 294.426 97.4487 295.554C96.7973 296.683 97.1675 298.116 98.2756 298.756Z"
          fill="#3A2933"
        />
        <path
          d="M93.5574 306.928C94.6655 307.568 96.0919 307.172 96.7434 306.043C97.3948 304.915 97.0246 303.482 95.9165 302.842C94.8084 302.202 93.382 302.598 92.7305 303.727C92.0791 304.855 92.4493 306.288 93.5574 306.928Z"
          fill="#3A2933"
        />
        <path
          d="M99.224 315.648C100.332 316.287 101.758 315.891 102.41 314.763C103.061 313.635 102.691 312.201 101.583 311.562C100.475 310.922 99.0485 311.318 98.3971 312.446C97.7457 313.574 98.1159 315.008 99.224 315.648Z"
          fill="#3A2933"
        />
        <path
          d="M88.8393 315.1C89.9474 315.74 91.3738 315.344 92.0252 314.215C92.6767 313.087 92.3065 311.654 91.1984 311.014C90.0902 310.374 88.6639 310.77 88.0124 311.899C87.361 313.027 87.7312 314.46 88.8393 315.1Z"
          fill="#3A2933"
        />
        <path
          d="M94.5058 323.82C95.6139 324.459 97.0403 324.063 97.6918 322.935C98.3432 321.807 97.973 320.373 96.8649 319.734C95.7568 319.094 94.3304 319.49 93.679 320.618C93.0275 321.746 93.3977 323.18 94.5058 323.82Z"
          fill="#3A2933"
        />
        <path
          d="M84.1211 323.272C85.2292 323.912 86.6556 323.516 87.3071 322.387C87.9585 321.259 87.5883 319.826 86.4802 319.186C85.3721 318.546 83.9457 318.942 83.2943 320.071C82.6428 321.199 83.013 322.632 84.1211 323.272Z"
          fill="#3A2933"
        />
        <path
          d="M89.7877 331.992C90.8958 332.631 92.3222 332.235 92.9736 331.107C93.6251 329.979 93.2549 328.545 92.1468 327.906C91.0386 327.266 89.6123 327.662 88.9608 328.79C88.3094 329.919 88.6796 331.352 89.7877 331.992Z"
          fill="#3A2933"
        />
        <path
          d="M85.0695 340.164C86.1776 340.803 87.604 340.407 88.2555 339.279C88.9069 338.151 88.5367 336.717 87.4286 336.078C86.3205 335.438 84.8941 335.834 84.2427 336.962C83.5912 338.091 83.9614 339.524 85.0695 340.164Z"
          fill="#3A2933"
        />
        <path
          d="M79.403 331.444C80.5111 332.084 81.9375 331.688 82.5889 330.559C83.2404 329.431 82.8702 327.998 81.7621 327.358C80.654 326.718 79.2276 327.114 78.5761 328.243C77.9247 329.371 78.2949 330.804 79.403 331.444Z"
          fill="#3A2933"
        />
        <path
          d="M74.6848 339.616C75.793 340.256 77.2193 339.86 77.8708 338.732C78.5222 337.603 78.152 336.17 77.0439 335.53C75.9358 334.89 74.5094 335.286 73.858 336.415C73.2065 337.543 73.5767 338.976 74.6848 339.616Z"
          fill="#3A2933"
        />
        <path
          d="M80.3514 348.336C81.4595 348.976 82.8859 348.58 83.5373 347.451C84.1888 346.323 83.8186 344.89 82.7105 344.25C81.6024 343.61 80.176 344.006 79.5245 345.134C78.8731 346.263 79.2433 347.696 80.3514 348.336Z"
          fill="#3A2933"
        />
        <path
          d="M69.9667 347.788C71.0748 348.428 72.5012 348.032 73.1526 346.904C73.8041 345.775 73.4339 344.342 72.3258 343.702C71.2177 343.062 69.7913 343.459 69.1398 344.587C68.4884 345.715 68.8586 347.148 69.9667 347.788Z"
          fill="#3A2933"
        />
        <path
          d="M75.6332 356.508C76.7414 357.148 78.1677 356.752 78.8192 355.623C79.4706 354.495 79.1004 353.062 77.9923 352.422C76.8842 351.782 75.4578 352.178 74.8064 353.306C74.1549 354.435 74.5251 355.868 75.6332 356.508Z"
          fill="#3A2933"
        />
        <path
          d="M65.2486 355.96C66.3567 356.6 67.7831 356.204 68.4345 355.076C69.0859 353.947 68.7157 352.514 67.6076 351.874C66.4995 351.235 65.0731 351.631 64.4217 352.759C63.7702 353.887 64.1405 355.321 65.2486 355.96Z"
          fill="#3A2933"
        />
        <path
          d="M70.9151 364.68C72.0232 365.32 73.4496 364.924 74.101 363.795C74.7525 362.667 74.3823 361.234 73.2742 360.594C72.1661 359.954 70.7397 360.35 70.0882 361.479C69.4368 362.607 69.807 364.04 70.9151 364.68Z"
          fill="#3A2933"
        />
        <path
          d="M66.197 372.852C67.3051 373.492 68.7315 373.096 69.3829 371.967C70.0343 370.839 69.6641 369.406 68.556 368.766C67.4479 368.126 66.0215 368.522 65.3701 369.651C64.7187 370.779 65.0889 372.212 66.197 372.852Z"
          fill="#3A2933"
        />
        <path
          d="M60.5304 364.132C61.6385 364.772 63.0649 364.376 63.7164 363.248C64.3678 362.119 63.9976 360.686 62.8895 360.046C61.7814 359.407 60.355 359.803 59.7036 360.931C59.0521 362.059 59.4223 363.493 60.5304 364.132Z"
          fill="#3A2933"
        />
        <path
          d="M55.8123 372.304C56.9204 372.944 58.3468 372.548 58.9982 371.42C59.6497 370.291 59.2795 368.858 58.1714 368.218C57.0633 367.579 55.6369 367.975 54.9854 369.103C54.334 370.231 54.7042 371.665 55.8123 372.304Z"
          fill="#3A2933"
        />
        <path
          d="M61.4788 381.024C62.5869 381.664 64.0133 381.268 64.6648 380.139C65.3162 379.011 64.946 377.578 63.8379 376.938C62.7298 376.298 61.3034 376.694 60.6519 377.823C60.0005 378.951 60.3707 380.384 61.4788 381.024Z"
          fill="#3A2933"
        />
        <path
          d="M51.0941 380.477C52.2022 381.116 53.6286 380.72 54.2801 379.592C54.9315 378.464 54.5613 377.03 53.4532 376.39C52.3451 375.751 50.9187 376.147 50.2673 377.275C49.6158 378.403 49.986 379.837 51.0941 380.477Z"
          fill="#3A2933"
        />
        <path
          d="M56.7607 389.196C57.8688 389.836 59.2952 389.44 59.9466 388.312C60.5981 387.183 60.2279 385.75 59.1197 385.11C58.0116 384.47 56.5852 384.866 55.9338 385.995C55.2824 387.123 55.6526 388.556 56.7607 389.196Z"
          fill="#3A2933"
        />
        <path
          d="M52.0425 397.368C53.1506 398.008 54.577 397.612 55.2285 396.484C55.8799 395.355 55.5097 393.922 54.4016 393.282C53.2935 392.642 51.8671 393.038 51.2157 394.167C50.5642 395.295 50.9344 396.728 52.0425 397.368Z"
          fill="#3A2933"
        />
        <path
          d="M46.376 388.649C47.4841 389.288 48.9105 388.892 49.5619 387.764C50.2134 386.636 49.8432 385.202 48.7351 384.563C47.627 383.923 46.2006 384.319 45.5491 385.447C44.8977 386.575 45.2679 388.009 46.376 388.649Z"
          fill="#3A2933"
        />
        <path
          d="M161.508 226.302C162.616 226.942 164.043 226.546 164.694 225.418C165.346 224.289 164.975 222.856 163.867 222.216C162.759 221.577 161.333 221.973 160.681 223.101C160.03 224.229 160.4 225.663 161.508 226.302Z"
          fill="#3A2933"
        />
        <path
          d="M167.175 235.022C168.283 235.662 169.709 235.266 170.361 234.137C171.012 233.009 170.642 231.576 169.534 230.936C168.426 230.296 166.999 230.692 166.348 231.821C165.696 232.949 166.067 234.382 167.175 235.022Z"
          fill="#3A2933"
        />
        <path
          d="M156.79 234.474C157.898 235.114 159.325 234.718 159.976 233.59C160.627 232.461 160.257 231.028 159.149 230.388C158.041 229.749 156.615 230.145 155.963 231.273C155.312 232.401 155.682 233.835 156.79 234.474Z"
          fill="#3A2933"
        />
        <path
          d="M162.457 243.194C163.565 243.834 164.991 243.438 165.643 242.309C166.294 241.181 165.924 239.748 164.816 239.108C163.708 238.468 162.281 238.864 161.63 239.993C160.978 241.121 161.349 242.554 162.457 243.194Z"
          fill="#3A2933"
        />
        <path
          d="M152.072 242.647C153.18 243.286 154.606 242.89 155.258 241.762C155.909 240.634 155.539 239.2 154.431 238.56C153.323 237.921 151.897 238.317 151.245 239.445C150.594 240.573 150.964 242.007 152.072 242.647Z"
          fill="#3A2933"
        />
        <path
          d="M157.738 251.366C158.847 252.006 160.273 251.61 160.924 250.482C161.576 249.353 161.206 247.92 160.098 247.28C158.989 246.64 157.563 247.036 156.912 248.165C156.26 249.293 156.63 250.726 157.738 251.366Z"
          fill="#3A2933"
        />
        <path
          d="M153.02 259.538C154.128 260.178 155.555 259.782 156.206 258.654C156.858 257.525 156.488 256.092 155.379 255.452C154.271 254.812 152.845 255.208 152.193 256.337C151.542 257.465 151.912 258.898 153.02 259.538Z"
          fill="#3A2933"
        />
        <path
          d="M147.354 250.819C148.462 251.458 149.888 251.062 150.54 249.934C151.191 248.806 150.821 247.372 149.713 246.733C148.605 246.093 147.178 246.489 146.527 247.617C145.875 248.745 146.246 250.179 147.354 250.819Z"
          fill="#3A2933"
        />
        <path
          d="M142.636 258.991C143.744 259.63 145.17 259.234 145.822 258.106C146.473 256.978 146.103 255.544 144.995 254.905C143.887 254.265 142.46 254.661 141.809 255.789C141.157 256.918 141.528 258.351 142.636 258.991Z"
          fill="#3A2933"
        />
        <path
          d="M148.302 267.71C149.41 268.35 150.837 267.954 151.488 266.826C152.14 265.697 151.769 264.264 150.661 263.624C149.553 262.984 148.127 263.381 147.475 264.509C146.824 265.637 147.194 267.071 148.302 267.71Z"
          fill="#3A2933"
        />
        <path
          d="M137.918 267.163C139.026 267.802 140.452 267.406 141.103 266.278C141.755 265.15 141.385 263.716 140.277 263.077C139.168 262.437 137.742 262.833 137.091 263.961C136.439 265.09 136.809 266.523 137.918 267.163Z"
          fill="#3A2933"
        />
        <path
          d="M143.584 275.882C144.692 276.522 146.119 276.126 146.77 274.998C147.421 273.869 147.051 272.436 145.943 271.796C144.835 271.157 143.409 271.553 142.757 272.681C142.106 273.809 142.476 275.243 143.584 275.882Z"
          fill="#3A2933"
        />
        <path
          d="M133.199 275.335C134.307 275.975 135.734 275.578 136.385 274.45C137.037 273.322 136.667 271.889 135.558 271.249C134.45 270.609 133.024 271.005 132.373 272.133C131.721 273.262 132.091 274.695 133.199 275.335Z"
          fill="#3A2933"
        />
        <path
          d="M138.866 284.054C139.974 284.694 141.4 284.298 142.052 283.17C142.703 282.041 142.333 280.608 141.225 279.968C140.117 279.329 138.69 279.725 138.039 280.853C137.388 281.981 137.758 283.415 138.866 284.054Z"
          fill="#3A2933"
        />
        <path
          d="M134.148 292.226C135.256 292.866 136.682 292.47 137.334 291.342C137.985 290.214 137.615 288.78 136.507 288.14C135.399 287.501 133.972 287.897 133.321 289.025C132.669 290.153 133.04 291.587 134.148 292.226Z"
          fill="#3A2933"
        />
        <path
          d="M128.481 283.507C129.589 284.147 131.016 283.751 131.667 282.622C132.319 281.494 131.948 280.061 130.84 279.421C129.732 278.781 128.306 279.177 127.654 280.305C127.003 281.434 127.373 282.867 128.481 283.507Z"
          fill="#3A2933"
        />
        <path
          d="M123.763 291.679C124.871 292.319 126.298 291.923 126.949 290.794C127.6 289.666 127.23 288.233 126.122 287.593C125.014 286.953 123.588 287.349 122.936 288.477C122.285 289.606 122.655 291.039 123.763 291.679Z"
          fill="#3A2933"
        />
        <path
          d="M129.43 300.399C130.538 301.038 131.964 300.642 132.616 299.514C133.267 298.386 132.897 296.952 131.789 296.312C130.681 295.673 129.254 296.069 128.603 297.197C127.951 298.325 128.322 299.759 129.43 300.399Z"
          fill="#3A2933"
        />
        <path
          d="M119.045 299.851C120.153 300.491 121.579 300.095 122.231 298.966C122.882 297.838 122.512 296.405 121.404 295.765C120.296 295.125 118.87 295.521 118.218 296.65C117.567 297.778 117.937 299.211 119.045 299.851Z"
          fill="#3A2933"
        />
        <path
          d="M124.711 308.571C125.82 309.21 127.246 308.814 127.897 307.686C128.549 306.558 128.179 305.124 127.071 304.485C125.962 303.845 124.536 304.241 123.885 305.369C123.233 306.498 123.603 307.931 124.711 308.571Z"
          fill="#3A2933"
        />
        <path
          d="M119.993 316.743C121.101 317.382 122.528 316.986 123.179 315.858C123.831 314.73 123.461 313.296 122.352 312.657C121.244 312.017 119.818 312.413 119.166 313.541C118.515 314.67 118.885 316.103 119.993 316.743Z"
          fill="#3A2933"
        />
        <path
          d="M114.327 308.023C115.435 308.663 116.861 308.267 117.513 307.138C118.164 306.01 117.794 304.577 116.686 303.937C115.578 303.297 114.151 303.693 113.5 304.822C112.848 305.95 113.219 307.383 114.327 308.023Z"
          fill="#3A2933"
        />
        <path
          d="M109.609 316.195C110.717 316.835 112.143 316.439 112.795 315.31C113.446 314.182 113.076 312.749 111.968 312.109C110.86 311.469 109.433 311.865 108.782 312.994C108.13 314.122 108.501 315.555 109.609 316.195Z"
          fill="#3A2933"
        />
        <path
          d="M115.275 324.915C116.383 325.554 117.81 325.158 118.461 324.03C119.113 322.902 118.742 321.468 117.634 320.829C116.526 320.189 115.1 320.585 114.448 321.713C113.797 322.842 114.167 324.275 115.275 324.915Z"
          fill="#3A2933"
        />
        <path
          d="M104.891 324.367C105.999 325.007 107.425 324.611 108.076 323.483C108.728 322.354 108.358 320.921 107.25 320.281C106.141 319.641 104.715 320.037 104.064 321.166C103.412 322.294 103.782 323.727 104.891 324.367Z"
          fill="#3A2933"
        />
        <path
          d="M110.557 333.087C111.665 333.727 113.092 333.33 113.743 332.202C114.394 331.074 114.024 329.641 112.916 329.001C111.808 328.361 110.382 328.757 109.73 329.885C109.079 331.014 109.449 332.447 110.557 333.087Z"
          fill="#3A2933"
        />
        <path
          d="M100.172 332.539C101.28 333.179 102.707 332.783 103.358 331.655C104.01 330.526 103.64 329.093 102.531 328.453C101.423 327.813 99.9969 328.209 99.3455 329.338C98.6941 330.466 99.0643 331.899 100.172 332.539Z"
          fill="#3A2933"
        />
        <path
          d="M105.839 341.259C106.947 341.899 108.373 341.503 109.025 340.374C109.676 339.246 109.306 337.813 108.198 337.173C107.09 336.533 105.663 336.929 105.012 338.057C104.361 339.186 104.731 340.619 105.839 341.259Z"
          fill="#3A2933"
        />
        <path
          d="M101.121 349.431C102.229 350.071 103.655 349.675 104.307 348.546C104.958 347.418 104.588 345.985 103.48 345.345C102.372 344.705 100.945 345.101 100.294 346.229C99.6425 347.358 100.013 348.791 101.121 349.431Z"
          fill="#3A2933"
        />
        <path
          d="M95.4542 340.711C96.5623 341.351 97.9887 340.955 98.6402 339.827C99.2916 338.698 98.9214 337.265 97.8133 336.625C96.7052 335.985 95.2788 336.382 94.6274 337.51C93.9759 338.638 94.3461 340.072 95.4542 340.711Z"
          fill="#3A2933"
        />
        <path
          d="M90.7361 348.883C91.8442 349.523 93.2706 349.127 93.922 347.999C94.5734 346.87 94.2033 345.437 93.0952 344.797C91.9871 344.158 90.5606 344.554 89.9092 345.682C89.2578 346.81 89.628 348.244 90.7361 348.883Z"
          fill="#3A2933"
        />
        <path
          d="M96.4026 357.603C97.5107 358.243 98.9371 357.847 99.5885 356.718C100.24 355.59 99.8698 354.157 98.7617 353.517C97.6536 352.877 96.2272 353.273 95.5757 354.402C94.9243 355.53 95.2945 356.963 96.4026 357.603Z"
          fill="#3A2933"
        />
        <path
          d="M86.0179 357.055C87.126 357.695 88.5524 357.299 89.2039 356.171C89.8553 355.042 89.4851 353.609 88.377 352.969C87.2689 352.33 85.8425 352.726 85.1911 353.854C84.5396 354.982 84.9098 356.416 86.0179 357.055Z"
          fill="#3A2933"
        />
        <path
          d="M91.6845 365.775C92.7926 366.415 94.219 366.019 94.8704 364.89C95.5218 363.762 95.1517 362.329 94.0435 361.689C92.9354 361.049 91.509 361.445 90.8576 362.574C90.2062 363.702 90.5764 365.135 91.6845 365.775Z"
          fill="#3A2933"
        />
        <path
          d="M81.2998 365.227C82.4079 365.867 83.8343 365.471 84.4857 364.343C85.1372 363.215 84.767 361.781 83.6589 361.141C82.5508 360.502 81.1243 360.898 80.4729 362.026C79.8215 363.154 80.1917 364.588 81.2998 365.227Z"
          fill="#3A2933"
        />
        <path
          d="M86.9663 373.947C88.0744 374.587 89.5008 374.191 90.1523 373.062C90.8037 371.934 90.4335 370.501 89.3254 369.861C88.2173 369.221 86.7909 369.617 86.1395 370.746C85.488 371.874 85.8582 373.307 86.9663 373.947Z"
          fill="#3A2933"
        />
        <path
          d="M82.2482 382.119C83.3563 382.759 84.7827 382.363 85.4341 381.235C86.0856 380.106 85.7154 378.673 84.6073 378.033C83.4992 377.393 82.0728 377.789 81.4213 378.918C80.7699 380.046 81.1401 381.479 82.2482 382.119Z"
          fill="#3A2933"
        />
        <path
          d="M76.5817 373.4C77.6898 374.039 79.1162 373.643 79.7676 372.515C80.419 371.387 80.0488 369.953 78.9407 369.314C77.8326 368.674 76.4062 369.07 75.7548 370.198C75.1033 371.326 75.4735 372.76 76.5817 373.4Z"
          fill="#3A2933"
        />
        <path
          d="M71.8635 381.572C72.9716 382.211 74.398 381.815 75.0495 380.687C75.7009 379.559 75.3307 378.125 74.2226 377.486C73.1145 376.846 71.6881 377.242 71.0366 378.37C70.3852 379.499 70.7554 380.932 71.8635 381.572Z"
          fill="#3A2933"
        />
        <path
          d="M77.53 390.291C78.6381 390.931 80.0645 390.535 80.716 389.407C81.3674 388.278 80.9972 386.845 79.8891 386.205C78.781 385.565 77.3546 385.962 76.7032 387.09C76.0517 388.218 76.4219 389.651 77.53 390.291Z"
          fill="#3A2933"
        />
        <path
          d="M67.1454 389.744C68.2535 390.383 69.6799 389.987 70.3313 388.859C70.9827 387.731 70.6125 386.297 69.5044 385.658C68.3963 385.018 66.9699 385.414 66.3185 386.542C65.6671 387.671 66.0373 389.104 67.1454 389.744Z"
          fill="#3A2933"
        />
        <path
          d="M72.8119 398.463C73.92 399.103 75.3464 398.707 75.9978 397.579C76.6493 396.45 76.2791 395.017 75.171 394.377C74.0629 393.738 72.6365 394.134 71.985 395.262C71.3336 396.39 71.7038 397.824 72.8119 398.463Z"
          fill="#3A2933"
        />
        <path
          d="M68.0937 406.635C69.2019 407.275 70.6282 406.879 71.2797 405.751C71.9311 404.622 71.5609 403.189 70.4528 402.549C69.3447 401.91 67.9183 402.306 67.2669 403.434C66.6154 404.562 66.9856 405.996 68.0937 406.635Z"
          fill="#3A2933"
        />
        <path
          d="M62.4272 397.916C63.5353 398.556 64.9617 398.159 65.6132 397.031C66.2646 395.903 65.8944 394.469 64.7863 393.83C63.6782 393.19 62.2518 393.586 61.6004 394.714C60.9489 395.843 61.3191 397.276 62.4272 397.916Z"
          fill="#3A2933"
        />
        <path
          d="M177.559 235.57C178.668 236.209 180.094 235.813 180.745 234.685C181.397 233.557 181.027 232.123 179.919 231.484C178.81 230.844 177.384 231.24 176.733 232.368C176.081 233.496 176.451 234.93 177.559 235.57Z"
          fill="#3A2933"
        />
        <path
          d="M183.226 244.289C184.334 244.929 185.76 244.533 186.412 243.405C187.063 242.276 186.693 240.843 185.585 240.203C184.477 239.563 183.051 239.959 182.399 241.088C181.748 242.216 182.118 243.649 183.226 244.289Z"
          fill="#3A2933"
        />
        <path
          d="M172.841 243.742C173.949 244.381 175.376 243.985 176.027 242.857C176.679 241.729 176.308 240.295 175.2 239.656C174.092 239.016 172.666 239.412 172.014 240.54C171.363 241.669 171.733 243.102 172.841 243.742Z"
          fill="#3A2933"
        />
        <path
          d="M178.508 252.461C179.616 253.101 181.042 252.705 181.694 251.577C182.345 250.448 181.975 249.015 180.867 248.375C179.759 247.735 178.332 248.132 177.681 249.26C177.03 250.388 177.4 251.821 178.508 252.461Z"
          fill="#3A2933"
        />
        <path
          d="M168.123 251.914C169.231 252.553 170.658 252.157 171.309 251.029C171.961 249.901 171.59 248.467 170.482 247.828C169.374 247.188 167.948 247.584 167.296 248.712C166.645 249.841 167.015 251.274 168.123 251.914Z"
          fill="#3A2933"
        />
        <path
          d="M173.79 260.633C174.898 261.273 176.324 260.877 176.976 259.749C177.627 258.62 177.257 257.187 176.149 256.547C175.041 255.908 173.614 256.304 172.963 257.432C172.311 258.56 172.682 259.994 173.79 260.633Z"
          fill="#3A2933"
        />
        <path
          d="M169.072 268.805C170.18 269.445 171.606 269.049 172.258 267.921C172.909 266.792 172.539 265.359 171.431 264.719C170.323 264.08 168.896 264.476 168.245 265.604C167.593 266.732 167.963 268.166 169.072 268.805Z"
          fill="#3A2933"
        />
        <path
          d="M163.405 260.086C164.513 260.726 165.94 260.329 166.591 259.201C167.242 258.073 166.872 256.639 165.764 256C164.656 255.36 163.23 255.756 162.578 256.884C161.927 258.013 162.297 259.446 163.405 260.086Z"
          fill="#3A2933"
        />
        <path
          d="M158.687 268.258C159.795 268.898 161.221 268.502 161.873 267.373C162.524 266.245 162.154 264.812 161.046 264.172C159.938 263.532 158.511 263.928 157.86 265.056C157.209 266.185 157.579 267.618 158.687 268.258Z"
          fill="#3A2933"
        />
        <path
          d="M164.353 276.977C165.462 277.617 166.888 277.221 167.539 276.093C168.191 274.965 167.821 273.531 166.712 272.891C165.604 272.252 164.178 272.648 163.527 273.776C162.875 274.904 163.245 276.338 164.353 276.977Z"
          fill="#3A2933"
        />
        <path
          d="M153.969 276.43C155.077 277.07 156.503 276.674 157.155 275.545C157.806 274.417 157.436 272.984 156.328 272.344C155.22 271.704 153.793 272.1 153.142 273.228C152.49 274.357 152.861 275.79 153.969 276.43Z"
          fill="#3A2933"
        />
        <path
          d="M159.635 285.15C160.743 285.789 162.17 285.393 162.821 284.265C163.473 283.137 163.102 281.703 161.994 281.063C160.886 280.424 159.46 280.82 158.808 281.948C158.157 283.076 158.527 284.51 159.635 285.15Z"
          fill="#3A2933"
        />
        <path
          d="M149.251 284.602C150.359 285.242 151.785 284.846 152.437 283.717C153.088 282.589 152.718 281.156 151.61 280.516C150.502 279.876 149.075 280.272 148.424 281.401C147.772 282.529 148.142 283.962 149.251 284.602Z"
          fill="#3A2933"
        />
        <path
          d="M154.917 293.322C156.025 293.961 157.452 293.565 158.103 292.437C158.755 291.309 158.384 289.875 157.276 289.236C156.168 288.596 154.742 288.992 154.09 290.12C153.439 291.249 153.809 292.682 154.917 293.322Z"
          fill="#3A2933"
        />
        <path
          d="M150.199 301.494C151.307 302.133 152.733 301.737 153.385 300.609C154.036 299.481 153.666 298.047 152.558 297.408C151.45 296.768 150.024 297.164 149.372 298.292C148.721 299.421 149.091 300.854 150.199 301.494Z"
          fill="#3A2933"
        />
        <path
          d="M144.532 292.774C145.641 293.414 147.067 293.018 147.718 291.889C148.37 290.761 148 289.328 146.892 288.688C145.783 288.048 144.357 288.444 143.706 289.573C143.054 290.701 143.424 292.134 144.532 292.774Z"
          fill="#3A2933"
        />
        <path
          d="M139.814 300.946C140.922 301.586 142.349 301.19 143 300.061C143.652 298.933 143.281 297.5 142.173 296.86C141.065 296.22 139.639 296.616 138.987 297.745C138.336 298.873 138.706 300.306 139.814 300.946Z"
          fill="#3A2933"
        />
        <path
          d="M145.481 309.666C146.589 310.305 148.015 309.909 148.667 308.781C149.318 307.653 148.948 306.219 147.84 305.58C146.732 304.94 145.305 305.336 144.654 306.464C144.003 307.593 144.373 309.026 145.481 309.666Z"
          fill="#3A2933"
        />
        <path
          d="M135.096 309.118C136.204 309.758 137.631 309.362 138.282 308.234C138.934 307.105 138.563 305.672 137.455 305.032C136.347 304.392 134.921 304.788 134.269 305.917C133.618 307.045 133.988 308.478 135.096 309.118Z"
          fill="#3A2933"
        />
        <path
          d="M140.763 317.838C141.871 318.478 143.297 318.081 143.949 316.953C144.6 315.825 144.23 314.392 143.122 313.752C142.014 313.112 140.587 313.508 139.936 314.636C139.284 315.765 139.655 317.198 140.763 317.838Z"
          fill="#3A2933"
        />
        <path
          d="M136.045 326.01C137.153 326.65 138.579 326.254 139.23 325.125C139.882 323.997 139.512 322.564 138.404 321.924C137.296 321.284 135.869 321.68 135.218 322.808C134.566 323.937 134.936 325.37 136.045 326.01Z"
          fill="#3A2933"
        />
        <path
          d="M130.378 317.29C131.486 317.93 132.913 317.534 133.564 316.406C134.215 315.277 133.845 313.844 132.737 313.204C131.629 312.564 130.203 312.96 129.551 314.089C128.9 315.217 129.27 316.65 130.378 317.29Z"
          fill="#3A2933"
        />
        <path
          d="M125.66 325.462C126.768 326.102 128.194 325.706 128.846 324.578C129.497 323.449 129.127 322.016 128.019 321.376C126.911 320.736 125.484 321.133 124.833 322.261C124.182 323.389 124.552 324.823 125.66 325.462Z"
          fill="#3A2933"
        />
        <path
          d="M131.326 334.182C132.435 334.822 133.861 334.426 134.512 333.297C135.164 332.169 134.794 330.736 133.685 330.096C132.577 329.456 131.151 329.852 130.5 330.98C129.848 332.109 130.218 333.542 131.326 334.182Z"
          fill="#3A2933"
        />
        <path
          d="M120.942 333.634C122.05 334.274 123.476 333.878 124.128 332.75C124.779 331.621 124.409 330.188 123.301 329.548C122.193 328.909 120.766 329.305 120.115 330.433C119.463 331.561 119.834 332.995 120.942 333.634Z"
          fill="#3A2933"
        />
        <path
          d="M126.608 342.354C127.716 342.994 129.143 342.598 129.794 341.469C130.446 340.341 130.075 338.908 128.967 338.268C127.859 337.628 126.433 338.024 125.781 339.153C125.13 340.281 125.5 341.714 126.608 342.354Z"
          fill="#3A2933"
        />
        <path
          d="M116.224 341.806C117.332 342.446 118.758 342.05 119.41 340.922C120.061 339.793 119.691 338.36 118.583 337.72C117.475 337.081 116.048 337.477 115.397 338.605C114.745 339.733 115.115 341.167 116.224 341.806Z"
          fill="#3A2933"
        />
        <path
          d="M121.89 350.526C122.998 351.166 124.425 350.77 125.076 349.641C125.728 348.513 125.357 347.08 124.249 346.44C123.141 345.8 121.715 346.196 121.063 347.325C120.412 348.453 120.782 349.886 121.89 350.526Z"
          fill="#3A2933"
        />
        <path
          d="M117.172 358.698C118.28 359.338 119.706 358.942 120.358 357.813C121.009 356.685 120.639 355.252 119.531 354.612C118.423 353.972 116.997 354.368 116.345 355.497C115.694 356.625 116.064 358.058 117.172 358.698Z"
          fill="#3A2933"
        />
        <path
          d="M111.505 349.978C112.614 350.618 114.04 350.222 114.691 349.094C115.343 347.966 114.973 346.532 113.865 345.892C112.756 345.253 111.33 345.649 110.679 346.777C110.027 347.905 110.397 349.339 111.505 349.978Z"
          fill="#3A2933"
        />
        <path
          d="M106.787 358.151C107.895 358.79 109.322 358.394 109.973 357.266C110.625 356.138 110.254 354.704 109.146 354.064C108.038 353.425 106.612 353.821 105.96 354.949C105.309 356.077 105.679 357.511 106.787 358.151Z"
          fill="#3A2933"
        />
        <path
          d="M112.454 366.87C113.562 367.51 114.988 367.114 115.64 365.986C116.291 364.857 115.921 363.424 114.813 362.784C113.705 362.144 112.278 362.54 111.627 363.669C110.976 364.797 111.346 366.23 112.454 366.87Z"
          fill="#3A2933"
        />
        <path
          d="M102.069 366.323C103.177 366.962 104.604 366.566 105.255 365.438C105.907 364.31 105.536 362.876 104.428 362.237C103.32 361.597 101.894 361.993 101.242 363.121C100.591 364.25 100.961 365.683 102.069 366.323Z"
          fill="#3A2933"
        />
        <path
          d="M107.736 375.042C108.844 375.682 110.27 375.286 110.922 374.158C111.573 373.029 111.203 371.596 110.095 370.956C108.987 370.316 107.56 370.712 106.909 371.841C106.257 372.969 106.628 374.402 107.736 375.042Z"
          fill="#3A2933"
        />
        <path
          d="M97.351 374.495C98.4591 375.134 99.8855 374.738 100.537 373.61C101.188 372.482 100.818 371.048 99.7101 370.409C98.602 369.769 97.1756 370.165 96.5241 371.293C95.8727 372.422 96.2429 373.855 97.351 374.495Z"
          fill="#3A2933"
        />
        <path
          d="M103.018 383.214C104.126 383.854 105.552 383.458 106.203 382.33C106.855 381.201 106.485 379.768 105.377 379.128C104.269 378.488 102.842 378.885 102.191 380.013C101.539 381.141 101.909 382.575 103.018 383.214Z"
          fill="#3A2933"
        />
        <path
          d="M98.2994 391.386C99.4075 392.026 100.834 391.63 101.485 390.502C102.137 389.373 101.767 387.94 100.658 387.3C99.5504 386.661 98.124 387.057 97.4726 388.185C96.8211 389.313 97.1913 390.747 98.2994 391.386Z"
          fill="#3A2933"
        />
        <path
          d="M92.6329 382.667C93.741 383.306 95.1674 382.91 95.8188 381.782C96.4703 380.654 96.1001 379.22 94.992 378.581C93.8838 377.941 92.4575 378.337 91.806 379.465C91.1546 380.594 91.5248 382.027 92.6329 382.667Z"
          fill="#3A2933"
        />
        <path
          d="M87.9147 390.839C89.0228 391.479 90.4492 391.082 91.1007 389.954C91.7521 388.826 91.3819 387.393 90.2738 386.753C89.1657 386.113 87.7393 386.509 87.0879 387.637C86.4364 388.766 86.8066 390.199 87.9147 390.839Z"
          fill="#3A2933"
        />
        <path
          d="M93.5813 399.558C94.6894 400.198 96.1158 399.802 96.7672 398.674C97.4186 397.545 97.0484 396.112 95.9403 395.472C94.8322 394.833 93.4058 395.229 92.7544 396.357C92.103 397.485 92.4732 398.919 93.5813 399.558Z"
          fill="#3A2933"
        />
        <path
          d="M83.1966 399.011C84.3047 399.651 85.7311 399.255 86.3825 398.126C87.034 396.998 86.6638 395.565 85.5557 394.925C84.4476 394.285 83.0212 394.681 82.3697 395.809C81.7183 396.938 82.0885 398.371 83.1966 399.011Z"
          fill="#3A2933"
        />
        <path
          d="M88.8631 407.73C89.9712 408.37 91.3976 407.974 92.0491 406.846C92.7005 405.718 92.3303 404.284 91.2222 403.644C90.1141 403.005 88.6877 403.401 88.0363 404.529C87.3848 405.657 87.755 407.091 88.8631 407.73Z"
          fill="#3A2933"
        />
        <path
          d="M84.145 415.903C85.2531 416.542 86.6795 416.146 87.3309 415.018C87.9824 413.89 87.6121 412.456 86.504 411.817C85.3959 411.177 83.9695 411.573 83.3181 412.701C82.6667 413.829 83.0369 415.263 84.145 415.903Z"
          fill="#3A2933"
        />
        <path
          d="M78.4784 407.183C79.5865 407.823 81.0129 407.427 81.6644 406.298C82.3158 405.17 81.9456 403.737 80.8375 403.097C79.7294 402.457 78.303 402.853 77.6516 403.982C77.0001 405.11 77.3703 406.543 78.4784 407.183Z"
          fill="#3A2933"
        />
        <path
          d="M193.611 244.837C194.719 245.476 196.145 245.08 196.797 243.952C197.448 242.824 197.078 241.39 195.97 240.751C194.862 240.111 193.435 240.507 192.784 241.635C192.132 242.764 192.503 244.197 193.611 244.837Z"
          fill="#3A2933"
        />
        <path
          d="M199.277 253.556C200.385 254.196 201.812 253.8 202.463 252.672C203.115 251.543 202.744 250.11 201.636 249.47C200.528 248.831 199.102 249.227 198.45 250.355C197.799 251.483 198.169 252.917 199.277 253.556Z"
          fill="#3A2933"
        />
        <path
          d="M188.893 253.009C190.001 253.649 191.427 253.253 192.078 252.124C192.73 250.996 192.36 249.563 191.252 248.923C190.144 248.283 188.717 248.679 188.066 249.807C187.414 250.936 187.784 252.369 188.893 253.009Z"
          fill="#3A2933"
        />
        <path
          d="M194.559 261.728C195.667 262.368 197.094 261.972 197.745 260.844C198.396 259.715 198.026 258.282 196.918 257.642C195.81 257.003 194.384 257.399 193.732 258.527C193.081 259.655 193.451 261.089 194.559 261.728Z"
          fill="#3A2933"
        />
        <path
          d="M184.174 261.181C185.283 261.821 186.709 261.425 187.36 260.296C188.012 259.168 187.642 257.735 186.533 257.095C185.425 256.455 183.999 256.851 183.348 257.979C182.696 259.108 183.066 260.541 184.174 261.181Z"
          fill="#3A2933"
        />
        <path
          d="M189.841 269.9C190.949 270.54 192.375 270.144 193.027 269.016C193.678 267.888 193.308 266.454 192.2 265.814C191.092 265.175 189.665 265.571 189.014 266.699C188.363 267.827 188.733 269.261 189.841 269.9Z"
          fill="#3A2933"
        />
        <path
          d="M185.123 278.073C186.231 278.712 187.657 278.316 188.309 277.188C188.96 276.06 188.59 274.626 187.482 273.987C186.374 273.347 184.947 273.743 184.296 274.871C183.644 275.999 184.015 277.433 185.123 278.073Z"
          fill="#3A2933"
        />
        <path
          d="M179.456 269.353C180.564 269.993 181.991 269.597 182.642 268.468C183.294 267.34 182.923 265.907 181.815 265.267C180.707 264.627 179.281 265.023 178.629 266.152C177.978 267.28 178.348 268.713 179.456 269.353Z"
          fill="#3A2933"
        />
        <path
          d="M174.738 277.525C175.846 278.165 177.273 277.769 177.924 276.64C178.575 275.512 178.205 274.079 177.097 273.439C175.989 272.799 174.563 273.195 173.911 274.324C173.26 275.452 173.63 276.885 174.738 277.525Z"
          fill="#3A2933"
        />
        <path
          d="M180.405 286.245C181.513 286.884 182.939 286.488 183.591 285.36C184.242 284.232 183.872 282.798 182.764 282.159C181.656 281.519 180.229 281.915 179.578 283.043C178.926 284.172 179.297 285.605 180.405 286.245Z"
          fill="#3A2933"
        />
        <path
          d="M170.02 285.697C171.128 286.337 172.554 285.941 173.206 284.812C173.857 283.684 173.487 282.251 172.379 281.611C171.271 280.971 169.845 281.367 169.193 282.496C168.542 283.624 168.912 285.057 170.02 285.697Z"
          fill="#3A2933"
        />
        <path
          d="M175.687 294.417C176.795 295.056 178.221 294.66 178.872 293.532C179.524 292.404 179.154 290.97 178.046 290.331C176.937 289.691 175.511 290.087 174.86 291.215C174.208 292.344 174.578 293.777 175.687 294.417Z"
          fill="#3A2933"
        />
        <path
          d="M165.302 293.869C166.41 294.509 167.836 294.113 168.488 292.985C169.139 291.856 168.769 290.423 167.661 289.783C166.553 289.143 165.126 289.539 164.475 290.668C163.824 291.796 164.194 293.229 165.302 293.869Z"
          fill="#3A2933"
        />
        <path
          d="M170.968 302.589C172.076 303.229 173.503 302.832 174.154 301.704C174.806 300.576 174.436 299.143 173.327 298.503C172.219 297.863 170.793 298.259 170.141 299.387C169.49 300.516 169.86 301.949 170.968 302.589Z"
          fill="#3A2933"
        />
        <path
          d="M166.25 310.761C167.358 311.401 168.785 311.005 169.436 309.876C170.088 308.748 169.717 307.315 168.609 306.675C167.501 306.035 166.075 306.431 165.423 307.559C164.772 308.688 165.142 310.121 166.25 310.761Z"
          fill="#3A2933"
        />
        <path
          d="M160.584 302.041C161.692 302.681 163.118 302.285 163.77 301.157C164.421 300.028 164.051 298.595 162.943 297.955C161.835 297.315 160.408 297.711 159.757 298.84C159.105 299.968 159.476 301.401 160.584 302.041Z"
          fill="#3A2933"
        />
        <path
          d="M155.866 310.213C156.974 310.853 158.4 310.457 159.051 309.329C159.703 308.2 159.333 306.767 158.225 306.127C157.117 305.487 155.69 305.884 155.039 307.012C154.387 308.14 154.757 309.573 155.866 310.213Z"
          fill="#3A2933"
        />
        <path
          d="M161.532 318.933C162.64 319.573 164.067 319.177 164.718 318.048C165.369 316.92 164.999 315.487 163.891 314.847C162.783 314.207 161.357 314.603 160.705 315.731C160.054 316.86 160.424 318.293 161.532 318.933Z"
          fill="#3A2933"
        />
        <path
          d="M151.147 318.385C152.255 319.025 153.682 318.629 154.333 317.501C154.985 316.372 154.615 314.939 153.506 314.299C152.398 313.66 150.972 314.056 150.321 315.184C149.669 316.312 150.039 317.746 151.147 318.385Z"
          fill="#3A2933"
        />
        <path
          d="M156.814 327.105C157.922 327.745 159.348 327.349 160 326.22C160.651 325.092 160.281 323.659 159.173 323.019C158.065 322.379 156.638 322.775 155.987 323.904C155.336 325.032 155.706 326.465 156.814 327.105Z"
          fill="#3A2933"
        />
        <path
          d="M152.096 335.277C153.204 335.917 154.63 335.521 155.282 334.392C155.933 333.264 155.563 331.831 154.455 331.191C153.347 330.551 151.92 330.947 151.269 332.076C150.617 333.204 150.988 334.637 152.096 335.277Z"
          fill="#3A2933"
        />
        <path
          d="M146.429 326.557C147.537 327.197 148.964 326.801 149.615 325.673C150.267 324.544 149.896 323.111 148.788 322.471C147.68 321.832 146.254 322.228 145.602 323.356C144.951 324.484 145.321 325.918 146.429 326.557Z"
          fill="#3A2933"
        />
        <path
          d="M141.711 334.729C142.819 335.369 144.246 334.973 144.897 333.845C145.548 332.717 145.178 331.283 144.07 330.643C142.962 330.004 141.536 330.4 140.884 331.528C140.233 332.656 140.603 334.09 141.711 334.729Z"
          fill="#3A2933"
        />
        <path
          d="M147.378 343.449C148.486 344.089 149.912 343.693 150.564 342.564C151.215 341.436 150.845 340.003 149.737 339.363C148.629 338.723 147.202 339.119 146.551 340.248C145.899 341.376 146.27 342.809 147.378 343.449Z"
          fill="#3A2933"
        />
        <path
          d="M136.993 342.902C138.101 343.541 139.527 343.145 140.179 342.017C140.83 340.889 140.46 339.455 139.352 338.815C138.244 338.176 136.818 338.572 136.166 339.7C135.515 340.828 135.885 342.262 136.993 342.902Z"
          fill="#3A2933"
        />
        <path
          d="M142.66 351.621C143.768 352.261 145.194 351.865 145.845 350.737C146.497 349.608 146.127 348.175 145.019 347.535C143.91 346.895 142.484 347.291 141.833 348.42C141.181 349.548 141.551 350.981 142.66 351.621Z"
          fill="#3A2933"
        />
        <path
          d="M132.275 351.074C133.383 351.713 134.809 351.317 135.461 350.189C136.112 349.061 135.742 347.627 134.634 346.988C133.526 346.348 132.099 346.744 131.448 347.872C130.797 349.001 131.167 350.434 132.275 351.074Z"
          fill="#3A2933"
        />
        <path
          d="M137.941 359.793C139.049 360.433 140.476 360.037 141.127 358.909C141.779 357.78 141.409 356.347 140.3 355.707C139.192 355.067 137.766 355.463 137.114 356.592C136.463 357.72 136.833 359.153 137.941 359.793Z"
          fill="#3A2933"
        />
        <path
          d="M133.223 367.965C134.331 368.605 135.758 368.209 136.409 367.081C137.061 365.952 136.69 364.519 135.582 363.879C134.474 363.239 133.048 363.636 132.396 364.764C131.745 365.892 132.115 367.325 133.223 367.965Z"
          fill="#3A2933"
        />
        <path
          d="M127.557 359.246C128.665 359.885 130.091 359.489 130.743 358.361C131.394 357.233 131.024 355.799 129.916 355.16C128.808 354.52 127.381 354.916 126.73 356.044C126.078 357.173 126.449 358.606 127.557 359.246Z"
          fill="#3A2933"
        />
        <path
          d="M122.839 367.418C123.947 368.057 125.373 367.661 126.024 366.533C126.676 365.405 126.306 363.971 125.198 363.332C124.09 362.692 122.663 363.088 122.012 364.216C121.36 365.345 121.73 366.778 122.839 367.418Z"
          fill="#3A2933"
        />
        <path
          d="M128.505 376.137C129.613 376.777 131.04 376.381 131.691 375.253C132.342 374.124 131.972 372.691 130.864 372.051C129.756 371.412 128.33 371.808 127.678 372.936C127.027 374.064 127.397 375.498 128.505 376.137Z"
          fill="#3A2933"
        />
        <path
          d="M118.12 375.59C119.228 376.23 120.655 375.834 121.306 374.705C121.958 373.577 121.588 372.144 120.479 371.504C119.371 370.864 117.945 371.26 117.294 372.388C116.642 373.517 117.012 374.95 118.12 375.59Z"
          fill="#3A2933"
        />
        <path
          d="M123.787 384.309C124.895 384.949 126.321 384.553 126.973 383.425C127.624 382.296 127.254 380.863 126.146 380.223C125.038 379.584 123.611 379.98 122.96 381.108C122.309 382.236 122.679 383.67 123.787 384.309Z"
          fill="#3A2933"
        />
        <path
          d="M113.402 383.762C114.51 384.402 115.937 384.006 116.588 382.877C117.24 381.749 116.869 380.316 115.761 379.676C114.653 379.036 113.227 379.432 112.575 380.56C111.924 381.689 112.294 383.122 113.402 383.762Z"
          fill="#3A2933"
        />
        <path
          d="M119.069 392.481C120.177 393.121 121.603 392.725 122.255 391.597C122.906 390.469 122.536 389.035 121.428 388.395C120.32 387.756 118.893 388.152 118.242 389.28C117.59 390.408 117.961 391.842 119.069 392.481Z"
          fill="#3A2933"
        />
        <path
          d="M114.351 400.654C115.459 401.293 116.885 400.897 117.537 399.769C118.188 398.641 117.818 397.207 116.71 396.567C115.602 395.928 114.175 396.324 113.524 397.452C112.872 398.58 113.243 400.014 114.351 400.654Z"
          fill="#3A2933"
        />
        <path
          d="M108.684 391.934C109.792 392.574 111.219 392.178 111.87 391.049C112.521 389.921 112.151 388.488 111.043 387.848C109.935 387.208 108.509 387.604 107.857 388.732C107.206 389.861 107.576 391.294 108.684 391.934Z"
          fill="#3A2933"
        />
        <path
          d="M103.966 400.106C105.074 400.746 106.5 400.35 107.152 399.221C107.803 398.093 107.433 396.66 106.325 396.02C105.217 395.38 103.791 395.776 103.139 396.905C102.488 398.033 102.858 399.466 103.966 400.106Z"
          fill="#3A2933"
        />
        <path
          d="M109.632 408.826C110.741 409.465 112.167 409.069 112.818 407.941C113.47 406.813 113.1 405.379 111.992 404.74C110.883 404.1 109.457 404.496 108.806 405.624C108.154 406.753 108.524 408.186 109.632 408.826Z"
          fill="#3A2933"
        />
        <path
          d="M99.2478 408.278C100.356 408.918 101.782 408.522 102.434 407.393C103.085 406.265 102.715 404.832 101.607 404.192C100.499 403.552 99.0724 403.948 98.4209 405.077C97.7695 406.205 98.1397 407.638 99.2478 408.278Z"
          fill="#3A2933"
        />
        <path
          d="M104.914 416.998C106.022 417.637 107.449 417.241 108.1 416.113C108.752 414.985 108.382 413.551 107.273 412.912C106.165 412.272 104.739 412.668 104.087 413.796C103.436 414.925 103.806 416.358 104.914 416.998Z"
          fill="#3A2933"
        />
        <path
          d="M100.196 425.17C101.304 425.81 102.731 425.413 103.382 424.285C104.034 423.157 103.663 421.723 102.555 421.084C101.447 420.444 100.021 420.84 99.3693 421.968C98.7179 423.097 99.0881 424.53 100.196 425.17Z"
          fill="#3A2933"
        />
        <path
          d="M94.5297 416.45C95.6378 417.09 97.0642 416.694 97.7156 415.565C98.3671 414.437 97.9968 413.004 96.8887 412.364C95.7806 411.724 94.3542 412.12 93.7028 413.249C93.0514 414.377 93.4215 415.81 94.5297 416.45Z"
          fill="#3A2933"
        />
        <path
          d="M209.662 254.104C210.77 254.744 212.196 254.348 212.848 253.219C213.499 252.091 213.129 250.658 212.021 250.018C210.913 249.378 209.486 249.774 208.835 250.902C208.184 252.031 208.554 253.464 209.662 254.104Z"
          fill="#3A2933"
        />
        <path
          d="M215.328 262.824C216.437 263.463 217.863 263.067 218.514 261.939C219.166 260.811 218.796 259.377 217.688 258.737C216.579 258.098 215.153 258.494 214.502 259.622C213.85 260.75 214.22 262.184 215.328 262.824Z"
          fill="#3A2933"
        />
        <path
          d="M204.944 262.276C206.052 262.916 207.478 262.52 208.13 261.391C208.781 260.263 208.411 258.83 207.303 258.19C206.195 257.55 204.768 257.946 204.117 259.075C203.465 260.203 203.836 261.636 204.944 262.276Z"
          fill="#3A2933"
        />
        <path
          d="M210.61 270.996C211.718 271.635 213.145 271.239 213.796 270.111C214.448 268.983 214.077 267.549 212.969 266.91C211.861 266.27 210.435 266.666 209.783 267.794C209.132 268.923 209.502 270.356 210.61 270.996Z"
          fill="#3A2933"
        />
        <path
          d="M200.226 270.448C201.334 271.088 202.76 270.692 203.412 269.563C204.063 268.435 203.693 267.002 202.585 266.362C201.477 265.722 200.05 266.118 199.399 267.247C198.747 268.375 199.118 269.808 200.226 270.448Z"
          fill="#3A2933"
        />
        <path
          d="M205.892 279.168C207 279.807 208.427 279.411 209.078 278.283C209.73 277.155 209.359 275.721 208.251 275.082C207.143 274.442 205.717 274.838 205.065 275.966C204.414 277.095 204.784 278.528 205.892 279.168Z"
          fill="#3A2933"
        />
        <path
          d="M201.174 287.34C202.282 287.98 203.709 287.583 204.36 286.455C205.011 285.327 204.641 283.893 203.533 283.254C202.425 282.614 200.999 283.01 200.347 284.138C199.696 285.267 200.066 286.7 201.174 287.34Z"
          fill="#3A2933"
        />
        <path
          d="M195.507 278.62C196.616 279.26 198.042 278.864 198.693 277.735C199.345 276.607 198.975 275.174 197.867 274.534C196.758 273.894 195.332 274.29 194.681 275.419C194.029 276.547 194.399 277.98 195.507 278.62Z"
          fill="#3A2933"
        />
        <path
          d="M190.789 286.792C191.897 287.432 193.324 287.036 193.975 285.908C194.627 284.779 194.257 283.346 193.148 282.706C192.04 282.066 190.614 282.462 189.962 283.591C189.311 284.719 189.681 286.152 190.789 286.792Z"
          fill="#3A2933"
        />
        <path
          d="M196.456 295.512C197.564 296.152 198.99 295.756 199.642 294.627C200.293 293.499 199.923 292.066 198.815 291.426C197.707 290.786 196.28 291.182 195.629 292.31C194.978 293.439 195.348 294.872 196.456 295.512Z"
          fill="#3A2933"
        />
        <path
          d="M186.071 294.964C187.179 295.604 188.606 295.208 189.257 294.08C189.909 292.951 189.538 291.518 188.43 290.878C187.322 290.238 185.896 290.635 185.244 291.763C184.593 292.891 184.963 294.324 186.071 294.964Z"
          fill="#3A2933"
        />
        <path
          d="M191.738 303.684C192.846 304.324 194.272 303.928 194.924 302.799C195.575 301.671 195.205 300.238 194.097 299.598C192.989 298.958 191.562 299.354 190.911 300.482C190.259 301.611 190.63 303.044 191.738 303.684Z"
          fill="#3A2933"
        />
        <path
          d="M181.353 303.136C182.461 303.776 183.888 303.38 184.539 302.252C185.19 301.123 184.82 299.69 183.712 299.05C182.604 298.411 181.178 298.807 180.526 299.935C179.875 301.063 180.245 302.497 181.353 303.136Z"
          fill="#3A2933"
        />
        <path
          d="M187.02 311.856C188.128 312.496 189.554 312.1 190.206 310.971C190.857 309.843 190.487 308.41 189.379 307.77C188.271 307.13 186.844 307.526 186.193 308.655C185.541 309.783 185.911 311.216 187.02 311.856Z"
          fill="#3A2933"
        />
        <path
          d="M182.301 320.028C183.41 320.668 184.836 320.272 185.487 319.143C186.139 318.015 185.769 316.582 184.661 315.942C183.552 315.302 182.126 315.698 181.475 316.827C180.823 317.955 181.193 319.388 182.301 320.028Z"
          fill="#3A2933"
        />
        <path
          d="M176.635 311.308C177.743 311.948 179.169 311.552 179.821 310.424C180.472 309.295 180.102 307.862 178.994 307.222C177.886 306.583 176.459 306.979 175.808 308.107C175.157 309.235 175.527 310.669 176.635 311.308Z"
          fill="#3A2933"
        />
        <path
          d="M171.917 319.48C173.025 320.12 174.451 319.724 175.103 318.596C175.754 317.467 175.384 316.034 174.276 315.394C173.168 314.755 171.741 315.151 171.09 316.279C170.438 317.407 170.809 318.841 171.917 319.48Z"
          fill="#3A2933"
        />
        <path
          d="M177.583 328.2C178.691 328.84 180.118 328.444 180.769 327.315C181.421 326.187 181.05 324.754 179.942 324.114C178.834 323.474 177.408 323.87 176.756 324.999C176.105 326.127 176.475 327.56 177.583 328.2Z"
          fill="#3A2933"
        />
        <path
          d="M167.199 327.653C168.307 328.292 169.733 327.896 170.385 326.768C171.036 325.64 170.666 324.206 169.558 323.566C168.45 322.927 167.023 323.323 166.372 324.451C165.72 325.579 166.091 327.013 167.199 327.653Z"
          fill="#3A2933"
        />
        <path
          d="M172.865 336.372C173.973 337.012 175.4 336.616 176.051 335.488C176.703 334.359 176.332 332.926 175.224 332.286C174.116 331.646 172.69 332.042 172.038 333.171C171.387 334.299 171.757 335.732 172.865 336.372Z"
          fill="#3A2933"
        />
        <path
          d="M168.147 344.544C169.255 345.184 170.682 344.788 171.333 343.66C171.984 342.531 171.614 341.098 170.506 340.458C169.398 339.818 167.972 340.214 167.32 341.343C166.669 342.471 167.039 343.904 168.147 344.544Z"
          fill="#3A2933"
        />
        <path
          d="M162.48 335.825C163.589 336.464 165.015 336.068 165.666 334.94C166.318 333.812 165.948 332.378 164.84 331.739C163.731 331.099 162.305 331.495 161.654 332.623C161.002 333.751 161.372 335.185 162.48 335.825Z"
          fill="#3A2933"
        />
        <path
          d="M157.762 343.997C158.87 344.636 160.297 344.24 160.948 343.112C161.6 341.984 161.229 340.55 160.121 339.911C159.013 339.271 157.587 339.667 156.935 340.795C156.284 341.924 156.654 343.357 157.762 343.997Z"
          fill="#3A2933"
        />
        <path
          d="M163.429 352.716C164.537 353.356 165.963 352.96 166.615 351.832C167.266 350.703 166.896 349.27 165.788 348.63C164.68 347.99 163.253 348.387 162.602 349.515C161.951 350.643 162.321 352.077 163.429 352.716Z"
          fill="#3A2933"
        />
        <path
          d="M153.044 352.169C154.152 352.808 155.579 352.412 156.23 351.284C156.882 350.156 156.511 348.722 155.403 348.083C154.295 347.443 152.869 347.839 152.217 348.967C151.566 350.096 151.936 351.529 153.044 352.169Z"
          fill="#3A2933"
        />
        <path
          d="M158.711 360.888C159.819 361.528 161.245 361.132 161.897 360.004C162.548 358.875 162.178 357.442 161.07 356.802C159.962 356.163 158.535 356.559 157.884 357.687C157.232 358.815 157.603 360.249 158.711 360.888Z"
          fill="#3A2933"
        />
        <path
          d="M148.326 360.341C149.434 360.981 150.861 360.584 151.512 359.456C152.163 358.328 151.793 356.895 150.685 356.255C149.577 355.615 148.151 356.011 147.499 357.139C146.848 358.268 147.218 359.701 148.326 360.341Z"
          fill="#3A2933"
        />
        <path
          d="M153.993 369.06C155.101 369.7 156.527 369.304 157.179 368.176C157.83 367.047 157.46 365.614 156.352 364.974C155.244 364.335 153.817 364.731 153.166 365.859C152.514 366.987 152.884 368.421 153.993 369.06Z"
          fill="#3A2933"
        />
        <path
          d="M149.274 377.232C150.383 377.872 151.809 377.476 152.46 376.348C153.112 375.219 152.742 373.786 151.634 373.146C150.525 372.507 149.099 372.903 148.448 374.031C147.796 375.159 148.166 376.593 149.274 377.232Z"
          fill="#3A2933"
        />
        <path
          d="M143.608 368.513C144.716 369.153 146.142 368.757 146.794 367.628C147.445 366.5 147.075 365.067 145.967 364.427C144.859 363.787 143.432 364.183 142.781 365.311C142.13 366.44 142.5 367.873 143.608 368.513Z"
          fill="#3A2933"
        />
        <path
          d="M138.89 376.685C139.998 377.325 141.424 376.929 142.076 375.8C142.727 374.672 142.357 373.239 141.249 372.599C140.141 371.959 138.714 372.355 138.063 373.483C137.411 374.612 137.782 376.045 138.89 376.685Z"
          fill="#3A2933"
        />
        <path
          d="M144.556 385.405C145.664 386.044 147.091 385.648 147.742 384.52C148.394 383.392 148.023 381.958 146.915 381.318C145.807 380.679 144.381 381.075 143.729 382.203C143.078 383.331 143.448 384.765 144.556 385.405Z"
          fill="#3A2933"
        />
        <path
          d="M134.172 384.857C135.28 385.497 136.706 385.101 137.358 383.972C138.009 382.844 137.639 381.411 136.531 380.771C135.423 380.131 133.996 380.527 133.345 381.656C132.693 382.784 133.064 384.217 134.172 384.857Z"
          fill="#3A2933"
        />
        <path
          d="M139.838 393.577C140.946 394.216 142.373 393.82 143.024 392.692C143.676 391.564 143.305 390.13 142.197 389.491C141.089 388.851 139.663 389.247 139.011 390.375C138.36 391.504 138.73 392.937 139.838 393.577Z"
          fill="#3A2933"
        />
        <path
          d="M129.453 393.029C130.562 393.669 131.988 393.273 132.639 392.144C133.291 391.016 132.921 389.583 131.813 388.943C130.704 388.303 129.278 388.699 128.627 389.828C127.975 390.956 128.345 392.389 129.453 393.029Z"
          fill="#3A2933"
        />
        <path
          d="M135.12 401.749C136.228 402.388 137.655 401.992 138.306 400.864C138.957 399.736 138.587 398.302 137.479 397.663C136.371 397.023 134.945 397.419 134.293 398.547C133.642 399.676 134.012 401.109 135.12 401.749Z"
          fill="#3A2933"
        />
        <path
          d="M130.402 409.921C131.51 410.56 132.936 410.164 133.588 409.036C134.239 407.908 133.869 406.474 132.761 405.835C131.653 405.195 130.226 405.591 129.575 406.719C128.924 407.848 129.294 409.281 130.402 409.921Z"
          fill="#3A2933"
        />
        <path
          d="M124.735 401.201C125.843 401.841 127.27 401.445 127.921 400.316C128.573 399.188 128.203 397.755 127.094 397.115C125.986 396.475 124.56 396.871 123.908 398C123.257 399.128 123.627 400.561 124.735 401.201Z"
          fill="#3A2933"
        />
        <path
          d="M120.017 409.373C121.125 410.013 122.552 409.617 123.203 408.489C123.855 407.36 123.484 405.927 122.376 405.287C121.268 404.647 119.842 405.043 119.19 406.172C118.539 407.3 118.909 408.733 120.017 409.373Z"
          fill="#3A2933"
        />
        <path
          d="M125.684 418.093C126.792 418.733 128.218 418.336 128.87 417.208C129.521 416.08 129.151 414.647 128.043 414.007C126.935 413.367 125.508 413.763 124.857 414.891C124.205 416.02 124.576 417.453 125.684 418.093Z"
          fill="#3A2933"
        />
        <path
          d="M115.299 417.545C116.407 418.185 117.834 417.789 118.485 416.661C119.136 415.532 118.766 414.099 117.658 413.459C116.55 412.819 115.124 413.215 114.472 414.344C113.821 415.472 114.191 416.905 115.299 417.545Z"
          fill="#3A2933"
        />
        <path
          d="M120.966 426.265C122.074 426.905 123.5 426.509 124.152 425.38C124.803 424.252 124.433 422.819 123.325 422.179C122.217 421.539 120.79 421.935 120.139 423.063C119.487 424.192 119.857 425.625 120.966 426.265Z"
          fill="#3A2933"
        />
        <path
          d="M116.247 434.437C117.356 435.077 118.782 434.681 119.433 433.552C120.085 432.424 119.715 430.991 118.606 430.351C117.498 429.711 116.072 430.107 115.421 431.236C114.769 432.364 115.139 433.797 116.247 434.437Z"
          fill="#3A2933"
        />
        <path
          d="M110.581 425.717C111.689 426.357 113.115 425.961 113.767 424.833C114.418 423.704 114.048 422.271 112.94 421.631C111.832 420.991 110.405 421.388 109.754 422.516C109.103 423.644 109.473 425.078 110.581 425.717Z"
          fill="#3A2933"
        />
        <path
          d="M225.713 263.371C226.821 264.011 228.248 263.615 228.899 262.486C229.551 261.358 229.18 259.925 228.072 259.285C226.964 258.645 225.538 259.041 224.886 260.17C224.235 261.298 224.605 262.731 225.713 263.371Z"
          fill="#3A2933"
        />
        <path
          d="M231.38 272.091C232.488 272.73 233.914 272.334 234.566 271.206C235.217 270.078 234.847 268.644 233.739 268.005C232.631 267.365 231.204 267.761 230.553 268.889C229.901 270.018 230.272 271.451 231.38 272.091Z"
          fill="#3A2933"
        />
        <path
          d="M220.995 271.543C222.103 272.183 223.529 271.787 224.181 270.659C224.832 269.53 224.462 268.097 223.354 267.457C222.246 266.817 220.82 267.213 220.168 268.342C219.517 269.47 219.887 270.903 220.995 271.543Z"
          fill="#3A2933"
        />
        <path
          d="M226.662 280.263C227.77 280.903 229.196 280.506 229.847 279.378C230.499 278.25 230.129 276.817 229.021 276.177C227.913 275.537 226.486 275.933 225.835 277.061C225.183 278.19 225.553 279.623 226.662 280.263Z"
          fill="#3A2933"
        />
        <path
          d="M216.277 279.715C217.385 280.355 218.811 279.959 219.463 278.831C220.114 277.702 219.744 276.269 218.636 275.629C217.528 274.989 216.101 275.385 215.45 276.514C214.799 277.642 215.169 279.075 216.277 279.715Z"
          fill="#3A2933"
        />
        <path
          d="M221.943 288.435C223.052 289.075 224.478 288.679 225.129 287.55C225.781 286.422 225.411 284.989 224.302 284.349C223.194 283.709 221.768 284.105 221.117 285.233C220.465 286.362 220.835 287.795 221.943 288.435Z"
          fill="#3A2933"
        />
        <path
          d="M217.225 296.607C218.333 297.247 219.76 296.851 220.411 295.722C221.063 294.594 220.692 293.161 219.584 292.521C218.476 291.881 217.05 292.277 216.398 293.405C215.747 294.534 216.117 295.967 217.225 296.607Z"
          fill="#3A2933"
        />
        <path
          d="M211.559 287.887C212.667 288.527 214.093 288.131 214.745 287.003C215.396 285.874 215.026 284.441 213.918 283.801C212.81 283.161 211.383 283.558 210.732 284.686C210.08 285.814 210.451 287.248 211.559 287.887Z"
          fill="#3A2933"
        />
        <path
          d="M206.841 296.059C207.949 296.699 209.375 296.303 210.026 295.175C210.678 294.046 210.308 292.613 209.2 291.973C208.092 291.334 206.665 291.73 206.014 292.858C205.362 293.986 205.732 295.42 206.841 296.059Z"
          fill="#3A2933"
        />
        <path
          d="M212.507 304.779C213.615 305.419 215.042 305.023 215.693 303.894C216.344 302.766 215.974 301.333 214.866 300.693C213.758 300.053 212.332 300.449 211.68 301.578C211.029 302.706 211.399 304.139 212.507 304.779Z"
          fill="#3A2933"
        />
        <path
          d="M202.122 304.231C203.231 304.871 204.657 304.475 205.308 303.347C205.96 302.218 205.59 300.785 204.481 300.145C203.373 299.506 201.947 299.902 201.296 301.03C200.644 302.158 201.014 303.592 202.122 304.231Z"
          fill="#3A2933"
        />
        <path
          d="M207.789 312.951C208.897 313.591 210.323 313.195 210.975 312.066C211.626 310.938 211.256 309.505 210.148 308.865C209.04 308.225 207.614 308.621 206.962 309.75C206.311 310.878 206.681 312.311 207.789 312.951Z"
          fill="#3A2933"
        />
        <path
          d="M197.404 312.404C198.512 313.043 199.939 312.647 200.59 311.519C201.242 310.391 200.871 308.957 199.763 308.317C198.655 307.678 197.229 308.074 196.577 309.202C195.926 310.33 196.296 311.764 197.404 312.404Z"
          fill="#3A2933"
        />
        <path
          d="M203.071 321.123C204.179 321.763 205.605 321.367 206.257 320.239C206.908 319.11 206.538 317.677 205.43 317.037C204.322 316.397 202.895 316.793 202.244 317.922C201.592 319.05 201.963 320.483 203.071 321.123Z"
          fill="#3A2933"
        />
        <path
          d="M198.353 329.295C199.461 329.935 200.887 329.539 201.539 328.411C202.19 327.282 201.82 325.849 200.712 325.209C199.604 324.569 198.177 324.965 197.526 326.094C196.874 327.222 197.245 328.655 198.353 329.295Z"
          fill="#3A2933"
        />
        <path
          d="M192.686 320.576C193.794 321.215 195.221 320.819 195.872 319.691C196.524 318.563 196.153 317.129 195.045 316.49C193.937 315.85 192.511 316.246 191.859 317.374C191.208 318.502 191.578 319.936 192.686 320.576Z"
          fill="#3A2933"
        />
        <path
          d="M187.968 328.748C189.076 329.387 190.502 328.991 191.154 327.863C191.805 326.735 191.435 325.301 190.327 324.662C189.219 324.022 187.793 324.418 187.141 325.546C186.49 326.675 186.86 328.108 187.968 328.748Z"
          fill="#3A2933"
        />
        <path
          d="M193.635 337.467C194.743 338.107 196.169 337.711 196.82 336.583C197.472 335.454 197.102 334.021 195.994 333.381C194.886 332.741 193.459 333.138 192.808 334.266C192.156 335.394 192.526 336.827 193.635 337.467Z"
          fill="#3A2933"
        />
        <path
          d="M183.25 336.92C184.358 337.559 185.784 337.163 186.436 336.035C187.087 334.907 186.717 333.473 185.609 332.834C184.501 332.194 183.074 332.59 182.423 333.718C181.772 334.847 182.142 336.28 183.25 336.92Z"
          fill="#3A2933"
        />
        <path
          d="M188.916 345.639C190.024 346.279 191.451 345.883 192.102 344.755C192.754 343.626 192.384 342.193 191.275 341.553C190.167 340.914 188.741 341.31 188.09 342.438C187.438 343.566 187.808 345 188.916 345.639Z"
          fill="#3A2933"
        />
        <path
          d="M184.198 353.811C185.306 354.451 186.733 354.055 187.384 352.927C188.036 351.798 187.665 350.365 186.557 349.725C185.449 349.086 184.023 349.482 183.371 350.61C182.72 351.738 183.09 353.172 184.198 353.811Z"
          fill="#3A2933"
        />
        <path
          d="M178.532 345.092C179.64 345.732 181.066 345.335 181.718 344.207C182.369 343.079 181.999 341.645 180.891 341.006C179.783 340.366 178.356 340.762 177.705 341.89C177.053 343.019 177.424 344.452 178.532 345.092Z"
          fill="#3A2933"
        />
        <path
          d="M173.814 353.264C174.922 353.904 176.348 353.508 176.999 352.379C177.651 351.251 177.281 349.818 176.173 349.178C175.065 348.538 173.638 348.934 172.987 350.062C172.335 351.191 172.705 352.624 173.814 353.264Z"
          fill="#3A2933"
        />
        <path
          d="M179.48 361.983C180.588 362.623 182.015 362.227 182.666 361.099C183.317 359.971 182.947 358.537 181.839 357.897C180.731 357.258 179.305 357.654 178.653 358.782C178.002 359.91 178.372 361.344 179.48 361.983Z"
          fill="#3A2933"
        />
        <path
          d="M169.095 361.436C170.204 362.076 171.63 361.68 172.281 360.551C172.933 359.423 172.563 357.99 171.454 357.35C170.346 356.71 168.92 357.106 168.269 358.234C167.617 359.363 167.987 360.796 169.095 361.436Z"
          fill="#3A2933"
        />
        <path
          d="M174.762 370.156C175.87 370.795 177.296 370.399 177.948 369.271C178.599 368.143 178.229 366.709 177.121 366.069C176.013 365.43 174.587 365.826 173.935 366.954C173.284 368.082 173.654 369.516 174.762 370.156Z"
          fill="#3A2933"
        />
        <path
          d="M164.377 369.608C165.485 370.248 166.912 369.852 167.563 368.723C168.215 367.595 167.844 366.162 166.736 365.522C165.628 364.882 164.202 365.278 163.55 366.407C162.899 367.535 163.269 368.968 164.377 369.608Z"
          fill="#3A2933"
        />
        <path
          d="M170.044 378.328C171.152 378.967 172.578 378.571 173.23 377.443C173.881 376.315 173.511 374.881 172.403 374.242C171.295 373.602 169.868 373.998 169.217 375.126C168.566 376.254 168.936 377.688 170.044 378.328Z"
          fill="#3A2933"
        />
        <path
          d="M165.326 386.5C166.434 387.139 167.86 386.743 168.512 385.615C169.163 384.487 168.793 383.053 167.685 382.414C166.577 381.774 165.15 382.17 164.499 383.298C163.847 384.427 164.218 385.86 165.326 386.5Z"
          fill="#3A2933"
        />
        <path
          d="M159.659 377.78C160.767 378.42 162.194 378.024 162.845 376.895C163.497 375.767 163.126 374.334 162.018 373.694C160.91 373.054 159.484 373.45 158.832 374.579C158.181 375.707 158.551 377.14 159.659 377.78Z"
          fill="#3A2933"
        />
        <path
          d="M154.941 385.952C156.049 386.592 157.475 386.196 158.127 385.067C158.778 383.939 158.408 382.506 157.3 381.866C156.192 381.226 154.766 381.622 154.114 382.751C153.463 383.879 153.833 385.312 154.941 385.952Z"
          fill="#3A2933"
        />
        <path
          d="M160.608 394.672C161.716 395.311 163.142 394.915 163.793 393.787C164.445 392.659 164.075 391.225 162.967 390.586C161.858 389.946 160.432 390.342 159.781 391.47C159.129 392.599 159.499 394.032 160.608 394.672Z"
          fill="#3A2933"
        />
        <path
          d="M150.223 394.124C151.331 394.764 152.757 394.368 153.409 393.24C154.06 392.111 153.69 390.678 152.582 390.038C151.474 389.398 150.047 389.794 149.396 390.923C148.745 392.051 149.115 393.484 150.223 394.124Z"
          fill="#3A2933"
        />
        <path
          d="M155.889 402.844C156.997 403.484 158.424 403.087 159.075 401.959C159.727 400.831 159.357 399.398 158.248 398.758C157.14 398.118 155.714 398.514 155.063 399.642C154.411 400.771 154.781 402.204 155.889 402.844Z"
          fill="#3A2933"
        />
        <path
          d="M145.505 402.296C146.613 402.936 148.039 402.54 148.691 401.412C149.342 400.283 148.972 398.85 147.864 398.21C146.756 397.57 145.329 397.966 144.678 399.095C144.026 400.223 144.397 401.656 145.505 402.296Z"
          fill="#3A2933"
        />
        <path
          d="M151.171 411.016C152.279 411.656 153.706 411.26 154.357 410.131C155.009 409.003 154.638 407.57 153.53 406.93C152.422 406.29 150.996 406.686 150.344 407.814C149.693 408.943 150.063 410.376 151.171 411.016Z"
          fill="#3A2933"
        />
        <path
          d="M146.453 419.188C147.561 419.828 148.988 419.432 149.639 418.303C150.29 417.175 149.92 415.742 148.812 415.102C147.704 414.462 146.278 414.858 145.626 415.986C144.975 417.115 145.345 418.548 146.453 419.188Z"
          fill="#3A2933"
        />
        <path
          d="M140.787 410.468C141.895 411.108 143.321 410.712 143.972 409.584C144.624 408.455 144.254 407.022 143.146 406.382C142.038 405.742 140.611 406.139 139.96 407.267C139.308 408.395 139.678 409.828 140.787 410.468Z"
          fill="#3A2933"
        />
        <path
          d="M136.068 418.64C137.177 419.28 138.603 418.884 139.254 417.756C139.906 416.627 139.536 415.194 138.427 414.554C137.319 413.915 135.893 414.311 135.242 415.439C134.59 416.567 134.96 418.001 136.068 418.64Z"
          fill="#3A2933"
        />
        <path
          d="M141.735 427.36C142.843 428 144.269 427.604 144.921 426.475C145.572 425.347 145.202 423.914 144.094 423.274C142.986 422.634 141.56 423.03 140.908 424.159C140.257 425.287 140.627 426.72 141.735 427.36Z"
          fill="#3A2933"
        />
        <path
          d="M131.35 426.812C132.458 427.452 133.885 427.056 134.536 425.928C135.188 424.799 134.817 423.366 133.709 422.726C132.601 422.087 131.175 422.483 130.523 423.611C129.872 424.739 130.242 426.173 131.35 426.812Z"
          fill="#3A2933"
        />
        <path
          d="M137.017 435.532C138.125 436.172 139.551 435.776 140.203 434.647C140.854 433.519 140.484 432.086 139.376 431.446C138.268 430.806 136.841 431.202 136.19 432.331C135.538 433.459 135.909 434.892 137.017 435.532Z"
          fill="#3A2933"
        />
        <path
          d="M132.299 443.704C133.407 444.344 134.833 443.948 135.485 442.819C136.136 441.691 135.766 440.258 134.658 439.618C133.55 438.978 132.123 439.374 131.472 440.503C130.82 441.631 131.191 443.064 132.299 443.704Z"
          fill="#3A2933"
        />
        <path
          d="M126.632 434.984C127.74 435.624 129.167 435.228 129.818 434.1C130.47 432.972 130.099 431.538 128.991 430.898C127.883 430.259 126.457 430.655 125.805 431.783C125.154 432.911 125.524 434.345 126.632 434.984Z"
          fill="#3A2933"
        />
        <path
          d="M241.764 272.638C242.872 273.278 244.299 272.882 244.95 271.754C245.602 270.625 245.232 269.192 244.123 268.552C243.015 267.912 241.589 268.309 240.938 269.437C240.286 270.565 240.656 271.998 241.764 272.638Z"
          fill="#3A2933"
        />
        <path
          d="M247.431 281.358C248.539 281.998 249.965 281.602 250.617 280.473C251.268 279.345 250.898 277.912 249.79 277.272C248.682 276.632 247.255 277.028 246.604 278.156C245.953 279.285 246.323 280.718 247.431 281.358Z"
          fill="#3A2933"
        />
        <path
          d="M237.046 280.81C238.154 281.45 239.581 281.054 240.232 279.926C240.884 278.797 240.513 277.364 239.405 276.724C238.297 276.085 236.871 276.481 236.219 277.609C235.568 278.737 235.938 280.171 237.046 280.81Z"
          fill="#3A2933"
        />
        <path
          d="M242.713 289.53C243.821 290.17 245.247 289.774 245.899 288.645C246.55 287.517 246.18 286.084 245.072 285.444C243.964 284.804 242.537 285.2 241.886 286.329C241.234 287.457 241.605 288.89 242.713 289.53Z"
          fill="#3A2933"
        />
        <path
          d="M232.328 288.982C233.436 289.622 234.863 289.226 235.514 288.098C236.165 286.969 235.795 285.536 234.687 284.896C233.579 284.257 232.153 284.653 231.501 285.781C230.85 286.909 231.22 288.343 232.328 288.982Z"
          fill="#3A2933"
        />
        <path
          d="M237.995 297.702C239.103 298.342 240.529 297.946 241.181 296.817C241.832 295.689 241.462 294.256 240.354 293.616C239.246 292.976 237.819 293.372 237.168 294.501C236.516 295.629 236.887 297.062 237.995 297.702Z"
          fill="#3A2933"
        />
        <path
          d="M233.276 305.874C234.385 306.514 235.811 306.118 236.462 304.989C237.114 303.861 236.744 302.428 235.636 301.788C234.527 301.148 233.101 301.544 232.45 302.673C231.798 303.801 232.168 305.234 233.276 305.874Z"
          fill="#3A2933"
        />
        <path
          d="M227.61 297.154C228.718 297.794 230.144 297.398 230.796 296.27C231.447 295.142 231.077 293.708 229.969 293.068C228.861 292.429 227.435 292.825 226.783 293.953C226.132 295.081 226.502 296.515 227.61 297.154Z"
          fill="#3A2933"
        />
        <path
          d="M222.892 305.327C224 305.966 225.426 305.57 226.078 304.442C226.729 303.314 226.359 301.88 225.251 301.241C224.143 300.601 222.716 300.997 222.065 302.125C221.413 303.253 221.784 304.687 222.892 305.327Z"
          fill="#3A2933"
        />
        <path
          d="M228.558 314.046C229.666 314.686 231.093 314.29 231.744 313.162C232.396 312.033 232.026 310.6 230.917 309.96C229.809 309.32 228.383 309.716 227.731 310.845C227.08 311.973 227.45 313.406 228.558 314.046Z"
          fill="#3A2933"
        />
        <path
          d="M218.174 313.499C219.282 314.138 220.708 313.742 221.36 312.614C222.011 311.486 221.641 310.052 220.533 309.413C219.425 308.773 217.998 309.169 217.347 310.297C216.695 311.426 217.066 312.859 218.174 313.499Z"
          fill="#3A2933"
        />
        <path
          d="M223.84 322.218C224.948 322.858 226.375 322.462 227.026 321.334C227.678 320.205 227.307 318.772 226.199 318.132C225.091 317.492 223.665 317.888 223.013 319.017C222.362 320.145 222.732 321.578 223.84 322.218Z"
          fill="#3A2933"
        />
        <path
          d="M213.455 321.671C214.564 322.31 215.99 321.914 216.641 320.786C217.293 319.658 216.923 318.224 215.815 317.585C214.706 316.945 213.28 317.341 212.629 318.469C211.977 319.598 212.347 321.031 213.455 321.671Z"
          fill="#3A2933"
        />
        <path
          d="M219.122 330.39C220.23 331.03 221.657 330.634 222.308 329.506C222.959 328.377 222.589 326.944 221.481 326.304C220.373 325.665 218.947 326.061 218.295 327.189C217.644 328.317 218.014 329.751 219.122 330.39Z"
          fill="#3A2933"
        />
        <path
          d="M214.404 338.562C215.512 339.202 216.938 338.806 217.59 337.678C218.241 336.549 217.871 335.116 216.763 334.476C215.655 333.837 214.228 334.233 213.577 335.361C212.926 336.489 213.296 337.923 214.404 338.562Z"
          fill="#3A2933"
        />
        <path
          d="M208.737 329.843C209.845 330.482 211.272 330.086 211.923 328.958C212.575 327.83 212.205 326.396 211.096 325.757C209.988 325.117 208.562 325.513 207.91 326.641C207.259 327.77 207.629 329.203 208.737 329.843Z"
          fill="#3A2933"
        />
        <path
          d="M204.019 338.015C205.127 338.655 206.554 338.258 207.205 337.13C207.857 336.002 207.486 334.569 206.378 333.929C205.27 333.289 203.844 333.685 203.192 334.813C202.541 335.942 202.911 337.375 204.019 338.015Z"
          fill="#3A2933"
        />
        <path
          d="M209.686 346.734C210.794 347.374 212.22 346.978 212.872 345.85C213.523 344.721 213.153 343.288 212.045 342.648C210.937 342.009 209.51 342.405 208.859 343.533C208.207 344.661 208.578 346.095 209.686 346.734Z"
          fill="#3A2933"
        />
        <path
          d="M199.301 346.187C200.409 346.827 201.836 346.431 202.487 345.302C203.138 344.174 202.768 342.741 201.66 342.101C200.552 341.461 199.126 341.857 198.474 342.985C197.823 344.114 198.193 345.547 199.301 346.187Z"
          fill="#3A2933"
        />
        <path
          d="M204.968 354.906C206.076 355.546 207.502 355.15 208.154 354.022C208.805 352.894 208.435 351.46 207.327 350.82C206.219 350.181 204.792 350.577 204.141 351.705C203.489 352.833 203.86 354.267 204.968 354.906Z"
          fill="#3A2933"
        />
        <path
          d="M200.249 363.079C201.358 363.718 202.784 363.322 203.435 362.194C204.087 361.066 203.717 359.632 202.609 358.993C201.5 358.353 200.074 358.749 199.423 359.877C198.771 361.005 199.141 362.439 200.249 363.079Z"
          fill="#3A2933"
        />
        <path
          d="M194.583 354.359C195.691 354.999 197.117 354.603 197.769 353.474C198.42 352.346 198.05 350.913 196.942 350.273C195.834 349.633 194.408 350.029 193.756 351.158C193.105 352.286 193.475 353.719 194.583 354.359Z"
          fill="#3A2933"
        />
        <path
          d="M189.865 362.531C190.973 363.171 192.399 362.775 193.051 361.646C193.702 360.518 193.332 359.085 192.224 358.445C191.116 357.805 189.689 358.201 189.038 359.33C188.386 360.458 188.757 361.891 189.865 362.531Z"
          fill="#3A2933"
        />
        <path
          d="M195.531 371.251C196.639 371.89 198.066 371.494 198.717 370.366C199.369 369.238 198.998 367.804 197.89 367.165C196.782 366.525 195.356 366.921 194.704 368.049C194.053 369.178 194.423 370.611 195.531 371.251Z"
          fill="#3A2933"
        />
        <path
          d="M185.147 370.703C186.255 371.343 187.681 370.947 188.333 369.818C188.984 368.69 188.614 367.257 187.506 366.617C186.398 365.977 184.971 366.373 184.32 367.502C183.668 368.63 184.039 370.063 185.147 370.703Z"
          fill="#3A2933"
        />
        <path
          d="M190.813 379.423C191.921 380.062 193.348 379.666 193.999 378.538C194.651 377.41 194.28 375.976 193.172 375.337C192.064 374.697 190.638 375.093 189.986 376.221C189.335 377.35 189.705 378.783 190.813 379.423Z"
          fill="#3A2933"
        />
        <path
          d="M180.428 378.875C181.537 379.515 182.963 379.119 183.614 377.991C184.266 376.862 183.896 375.429 182.788 374.789C181.679 374.149 180.253 374.545 179.602 375.674C178.95 376.802 179.32 378.235 180.428 378.875Z"
          fill="#3A2933"
        />
        <path
          d="M186.095 387.595C187.203 388.235 188.63 387.838 189.281 386.71C189.932 385.582 189.562 384.148 188.454 383.509C187.346 382.869 185.92 383.265 185.268 384.393C184.617 385.522 184.987 386.955 186.095 387.595Z"
          fill="#3A2933"
        />
        <path
          d="M181.377 395.767C182.485 396.407 183.911 396.011 184.563 394.882C185.214 393.754 184.844 392.321 183.736 391.681C182.628 391.041 181.201 391.437 180.55 392.565C179.899 393.694 180.269 395.127 181.377 395.767Z"
          fill="#3A2933"
        />
        <path
          d="M175.71 387.047C176.818 387.687 178.245 387.291 178.896 386.163C179.548 385.034 179.178 383.601 178.069 382.961C176.961 382.321 175.535 382.717 174.883 383.846C174.232 384.974 174.602 386.407 175.71 387.047Z"
          fill="#3A2933"
        />
        <path
          d="M170.992 395.219C172.1 395.859 173.527 395.463 174.178 394.335C174.83 393.206 174.459 391.773 173.351 391.133C172.243 390.493 170.817 390.89 170.165 392.018C169.514 393.146 169.884 394.579 170.992 395.219Z"
          fill="#3A2933"
        />
        <path
          d="M176.659 403.939C177.767 404.579 179.193 404.183 179.845 403.054C180.496 401.926 180.126 400.493 179.018 399.853C177.91 399.213 176.483 399.609 175.832 400.737C175.18 401.866 175.551 403.299 176.659 403.939Z"
          fill="#3A2933"
        />
        <path
          d="M166.274 403.391C167.382 404.031 168.809 403.635 169.46 402.507C170.111 401.378 169.741 399.945 168.633 399.305C167.525 398.666 166.099 399.062 165.447 400.19C164.796 401.318 165.166 402.752 166.274 403.391Z"
          fill="#3A2933"
        />
        <path
          d="M171.941 412.111C173.049 412.751 174.475 412.355 175.127 411.226C175.778 410.098 175.408 408.665 174.3 408.025C173.192 407.385 171.765 407.781 171.114 408.91C170.462 410.038 170.832 411.471 171.941 412.111Z"
          fill="#3A2933"
        />
        <path
          d="M161.556 411.563C162.664 412.203 164.09 411.807 164.742 410.679C165.393 409.55 165.023 408.117 163.915 407.477C162.807 406.838 161.38 407.234 160.729 408.362C160.078 409.49 160.448 410.924 161.556 411.563Z"
          fill="#3A2933"
        />
        <path
          d="M167.222 420.283C168.331 420.923 169.757 420.527 170.408 419.398C171.06 418.27 170.69 416.837 169.582 416.197C168.473 415.557 167.047 415.953 166.396 417.082C165.744 418.21 166.114 419.643 167.222 420.283Z"
          fill="#3A2933"
        />
        <path
          d="M162.504 428.455C163.612 429.095 165.039 428.699 165.69 427.57C166.342 426.442 165.971 425.009 164.863 424.369C163.755 423.729 162.329 424.125 161.677 425.254C161.026 426.382 161.396 427.815 162.504 428.455Z"
          fill="#3A2933"
        />
        <path
          d="M156.838 419.735C157.946 420.375 159.372 419.979 160.024 418.851C160.675 417.722 160.305 416.289 159.197 415.649C158.089 415.01 156.662 415.406 156.011 416.534C155.359 417.662 155.73 419.096 156.838 419.735Z"
          fill="#3A2933"
        />
        <path
          d="M152.12 427.908C153.228 428.547 154.654 428.151 155.306 427.023C155.957 425.895 155.587 424.461 154.479 423.821C153.371 423.182 151.944 423.578 151.293 424.706C150.641 425.834 151.012 427.268 152.12 427.908Z"
          fill="#3A2933"
        />
        <path
          d="M157.786 436.627C158.894 437.267 160.321 436.871 160.972 435.743C161.624 434.614 161.253 433.181 160.145 432.541C159.037 431.901 157.611 432.297 156.959 433.426C156.308 434.554 156.678 435.987 157.786 436.627Z"
          fill="#3A2933"
        />
        <path
          d="M147.401 436.08C148.51 436.719 149.936 436.323 150.587 435.195C151.239 434.067 150.869 432.633 149.761 431.994C148.652 431.354 147.226 431.75 146.575 432.878C145.923 434.006 146.293 435.44 147.401 436.08Z"
          fill="#3A2933"
        />
        <path
          d="M153.068 444.799C154.176 445.439 155.603 445.043 156.254 443.915C156.905 442.786 156.535 441.353 155.427 440.713C154.319 440.073 152.893 440.469 152.241 441.598C151.59 442.726 151.96 444.159 153.068 444.799Z"
          fill="#3A2933"
        />
        <path
          d="M148.35 452.971C149.458 453.611 150.884 453.215 151.536 452.087C152.187 450.958 151.817 449.525 150.709 448.885C149.601 448.245 148.174 448.642 147.523 449.77C146.872 450.898 147.242 452.332 148.35 452.971Z"
          fill="#3A2933"
        />
        <path
          d="M142.683 444.252C143.791 444.891 145.218 444.495 145.869 443.367C146.521 442.239 146.151 440.805 145.042 440.166C143.934 439.526 142.508 439.922 141.856 441.05C141.205 442.179 141.575 443.612 142.683 444.252Z"
          fill="#3A2933"
        />
        <path
          d="M257.816 281.905C258.924 282.545 260.35 282.149 261.002 281.021C261.653 279.893 261.283 278.459 260.175 277.819C259.067 277.18 257.64 277.576 256.989 278.704C256.337 279.832 256.707 281.266 257.816 281.905Z"
          fill="#3A2933"
        />
        <path
          d="M253.097 290.078C254.206 290.717 255.632 290.321 256.283 289.193C256.935 288.065 256.565 286.631 255.457 285.991C254.348 285.352 252.922 285.748 252.271 286.876C251.619 288.004 251.989 289.438 253.097 290.078Z"
          fill="#3A2933"
        />
        <path
          d="M248.379 298.25C249.487 298.889 250.914 298.493 251.565 297.365C252.217 296.237 251.846 294.803 250.738 294.164C249.63 293.524 248.204 293.92 247.552 295.048C246.901 296.177 247.271 297.61 248.379 298.25Z"
          fill="#3A2933"
        />
        <path
          d="M243.661 306.422C244.769 307.061 246.196 306.665 246.847 305.537C247.499 304.409 247.128 302.975 246.02 302.336C244.912 301.696 243.486 302.092 242.834 303.22C242.183 304.349 242.553 305.782 243.661 306.422Z"
          fill="#3A2933"
        />
        <path
          d="M238.943 314.594C240.051 315.233 241.478 314.837 242.129 313.709C242.78 312.581 242.41 311.147 241.302 310.508C240.194 309.868 238.768 310.264 238.116 311.392C237.465 312.521 237.835 313.954 238.943 314.594Z"
          fill="#3A2933"
        />
        <path
          d="M234.225 322.766C235.333 323.406 236.759 323.009 237.411 321.881C238.062 320.753 237.692 319.32 236.584 318.68C235.476 318.04 234.049 318.436 233.398 319.564C232.747 320.693 233.117 322.126 234.225 322.766Z"
          fill="#3A2933"
        />
        <path
          d="M229.507 330.938C230.615 331.578 232.041 331.182 232.693 330.053C233.344 328.925 232.974 327.492 231.866 326.852C230.758 326.212 229.331 326.608 228.68 327.736C228.028 328.865 228.399 330.298 229.507 330.938Z"
          fill="#3A2933"
        />
        <path
          d="M224.789 339.11C225.897 339.75 227.323 339.354 227.975 338.225C228.626 337.097 228.256 335.664 227.148 335.024C226.04 334.384 224.613 334.78 223.962 335.908C223.31 337.037 223.68 338.47 224.789 339.11Z"
          fill="#3A2933"
        />
        <path
          d="M220.07 347.282C221.179 347.922 222.605 347.526 223.256 346.397C223.908 345.269 223.538 343.836 222.43 343.196C221.321 342.556 219.895 342.952 219.244 344.081C218.592 345.209 218.962 346.642 220.07 347.282Z"
          fill="#3A2933"
        />
        <path
          d="M215.352 355.454C216.46 356.094 217.887 355.698 218.538 354.569C219.19 353.441 218.819 352.008 217.711 351.368C216.603 350.728 215.177 351.124 214.525 352.253C213.874 353.381 214.244 354.814 215.352 355.454Z"
          fill="#3A2933"
        />
        <path
          d="M210.634 363.626C211.742 364.266 213.169 363.87 213.82 362.741C214.472 361.613 214.101 360.18 212.993 359.54C211.885 358.9 210.459 359.296 209.807 360.425C209.156 361.553 209.526 362.986 210.634 363.626Z"
          fill="#3A2933"
        />
        <path
          d="M205.916 371.798C207.024 372.438 208.451 372.042 209.102 370.914C209.753 369.785 209.383 368.352 208.275 367.712C207.167 367.072 205.741 367.468 205.089 368.597C204.438 369.725 204.808 371.158 205.916 371.798Z"
          fill="#3A2933"
        />
        <path
          d="M201.198 379.97C202.306 380.61 203.732 380.214 204.384 379.086C205.035 377.957 204.665 376.524 203.557 375.884C202.449 375.244 201.022 375.64 200.371 376.769C199.72 377.897 200.09 379.33 201.198 379.97Z"
          fill="#3A2933"
        />
        <path
          d="M196.48 388.142C197.588 388.782 199.014 388.386 199.666 387.258C200.317 386.129 199.947 384.696 198.839 384.056C197.731 383.417 196.304 383.813 195.653 384.941C195.001 386.069 195.372 387.503 196.48 388.142Z"
          fill="#3A2933"
        />
        <path
          d="M191.762 396.314C192.87 396.954 194.296 396.558 194.948 395.43C195.599 394.301 195.229 392.868 194.121 392.228C193.013 391.589 191.586 391.985 190.935 393.113C190.283 394.241 190.653 395.675 191.762 396.314Z"
          fill="#3A2933"
        />
        <path
          d="M187.043 404.486C188.152 405.126 189.578 404.73 190.229 403.602C190.881 402.474 190.511 401.04 189.403 400.4C188.294 399.761 186.868 400.157 186.217 401.285C185.565 402.413 185.935 403.847 187.043 404.486Z"
          fill="#3A2933"
        />
        <path
          d="M182.325 412.659C183.433 413.298 184.86 412.902 185.511 411.774C186.163 410.646 185.792 409.212 184.684 408.572C183.576 407.933 182.15 408.329 181.498 409.457C180.847 410.585 181.217 412.019 182.325 412.659Z"
          fill="#3A2933"
        />
        <path
          d="M177.607 420.831C178.715 421.47 180.142 421.074 180.793 419.946C181.445 418.818 181.074 417.384 179.966 416.745C178.858 416.105 177.432 416.501 176.78 417.629C176.129 418.758 176.499 420.191 177.607 420.831Z"
          fill="#3A2933"
        />
        <path
          d="M172.889 429.003C173.997 429.642 175.424 429.246 176.075 428.118C176.726 426.99 176.356 425.556 175.248 424.917C174.14 424.277 172.714 424.673 172.062 425.801C171.411 426.93 171.781 428.363 172.889 429.003Z"
          fill="#3A2933"
        />
        <path
          d="M168.171 437.175C169.279 437.814 170.705 437.418 171.357 436.29C172.008 435.162 171.638 433.728 170.53 433.089C169.422 432.449 167.995 432.845 167.344 433.973C166.693 435.102 167.063 436.535 168.171 437.175Z"
          fill="#3A2933"
        />
        <path
          d="M163.453 445.347C164.561 445.987 165.987 445.59 166.639 444.462C167.29 443.334 166.92 441.901 165.812 441.261C164.704 440.621 163.277 441.017 162.626 442.145C161.974 443.274 162.345 444.707 163.453 445.347Z"
          fill="#3A2933"
        />
        <path
          d="M158.735 453.519C159.843 454.159 161.269 453.763 161.921 452.634C162.572 451.506 162.202 450.073 161.094 449.433C159.986 448.793 158.559 449.189 157.908 450.317C157.256 451.446 157.626 452.879 158.735 453.519Z"
          fill="#3A2933"
        />
        <path
          d="M263.482 290.625C264.59 291.265 266.017 290.869 266.668 289.74C267.32 288.612 266.949 287.179 265.841 286.539C264.733 285.899 263.307 286.295 262.655 287.424C262.004 288.552 262.374 289.985 263.482 290.625Z"
          fill="#3A2933"
        />
        <path
          d="M258.764 298.797C259.872 299.437 261.298 299.041 261.95 297.913C262.601 296.784 262.231 295.351 261.123 294.711C260.015 294.071 258.589 294.467 257.937 295.596C257.286 296.724 257.656 298.157 258.764 298.797Z"
          fill="#3A2933"
        />
        <path
          d="M254.046 306.969C255.154 307.609 256.58 307.213 257.232 306.085C257.883 304.956 257.513 303.523 256.405 302.883C255.297 302.243 253.87 302.639 253.219 303.768C252.568 304.896 252.938 306.329 254.046 306.969Z"
          fill="#3A2933"
        />
        <path
          d="M249.328 315.141C250.436 315.781 251.862 315.385 252.514 314.257C253.165 313.128 252.795 311.695 251.687 311.055C250.579 310.415 249.152 310.812 248.501 311.94C247.849 313.068 248.22 314.502 249.328 315.141Z"
          fill="#3A2933"
        />
        <path
          d="M244.61 323.313C245.718 323.953 247.144 323.557 247.795 322.429C248.447 321.3 248.077 319.867 246.969 319.227C245.861 318.588 244.434 318.984 243.783 320.112C243.131 321.24 243.501 322.674 244.61 323.313Z"
          fill="#3A2933"
        />
        <path
          d="M239.891 331.485C241 332.125 242.426 331.729 243.077 330.601C243.729 329.472 243.359 328.039 242.25 327.399C241.142 326.76 239.716 327.156 239.065 328.284C238.413 329.412 238.783 330.846 239.891 331.485Z"
          fill="#3A2933"
        />
        <path
          d="M235.173 339.657C236.281 340.297 237.708 339.901 238.359 338.773C239.011 337.645 238.64 336.211 237.532 335.571C236.424 334.932 234.998 335.328 234.346 336.456C233.695 337.584 234.065 339.018 235.173 339.657Z"
          fill="#3A2933"
        />
        <path
          d="M230.455 347.83C231.563 348.469 232.99 348.073 233.641 346.945C234.293 345.817 233.922 344.383 232.814 343.743C231.706 343.104 230.28 343.5 229.628 344.628C228.977 345.756 229.347 347.19 230.455 347.83Z"
          fill="#3A2933"
        />
        <path
          d="M225.737 356.002C226.845 356.641 228.271 356.245 228.923 355.117C229.574 353.989 229.204 352.555 228.096 351.916C226.988 351.276 225.562 351.672 224.91 352.8C224.259 353.929 224.629 355.362 225.737 356.002Z"
          fill="#3A2933"
        />
        <path
          d="M221.019 364.174C222.127 364.813 223.553 364.417 224.205 363.289C224.856 362.161 224.486 360.727 223.378 360.088C222.27 359.448 220.843 359.844 220.192 360.972C219.541 362.101 219.911 363.534 221.019 364.174Z"
          fill="#3A2933"
        />
        <path
          d="M216.301 372.346C217.409 372.986 218.835 372.589 219.487 371.461C220.138 370.333 219.768 368.899 218.66 368.26C217.552 367.62 216.125 368.016 215.474 369.144C214.822 370.273 215.193 371.706 216.301 372.346Z"
          fill="#3A2933"
        />
        <path
          d="M211.583 380.518C212.691 381.158 214.117 380.762 214.768 379.633C215.42 378.505 215.05 377.072 213.942 376.432C212.834 375.792 211.407 376.188 210.756 377.316C210.104 378.445 210.474 379.878 211.583 380.518Z"
          fill="#3A2933"
        />
        <path
          d="M206.864 388.69C207.973 389.33 209.399 388.934 210.05 387.805C210.702 386.677 210.332 385.244 209.223 384.604C208.115 383.964 206.689 384.36 206.038 385.488C205.386 386.617 205.756 388.05 206.864 388.69Z"
          fill="#3A2933"
        />
        <path
          d="M202.146 396.862C203.254 397.502 204.681 397.106 205.332 395.977C205.984 394.849 205.613 393.416 204.505 392.776C203.397 392.136 201.971 392.532 201.319 393.661C200.668 394.789 201.038 396.222 202.146 396.862Z"
          fill="#3A2933"
        />
        <path
          d="M197.428 405.034C198.536 405.674 199.963 405.278 200.614 404.149C201.266 403.021 200.895 401.588 199.787 400.948C198.679 400.308 197.253 400.704 196.601 401.833C195.95 402.961 196.32 404.394 197.428 405.034Z"
          fill="#3A2933"
        />
        <path
          d="M192.71 413.206C193.818 413.846 195.244 413.45 195.896 412.321C196.547 411.193 196.177 409.76 195.069 409.12C193.961 408.48 192.535 408.876 191.883 410.005C191.232 411.133 191.602 412.566 192.71 413.206Z"
          fill="#3A2933"
        />
        <path
          d="M187.992 421.378C189.1 422.018 190.526 421.622 191.178 420.494C191.829 419.365 191.459 417.932 190.351 417.292C189.243 416.652 187.816 417.048 187.165 418.177C186.514 419.305 186.884 420.738 187.992 421.378Z"
          fill="#3A2933"
        />
        <path
          d="M183.274 429.55C184.382 430.19 185.808 429.794 186.46 428.666C187.111 427.537 186.741 426.104 185.633 425.464C184.525 424.824 183.098 425.22 182.447 426.349C181.795 427.477 182.166 428.91 183.274 429.55Z"
          fill="#3A2933"
        />
        <path
          d="M178.556 437.722C179.664 438.362 181.09 437.966 181.741 436.838C182.393 435.709 182.023 434.276 180.915 433.636C179.807 432.996 178.38 433.392 177.729 434.521C177.077 435.649 177.447 437.082 178.556 437.722Z"
          fill="#3A2933"
        />
        <path
          d="M173.837 445.894C174.946 446.534 176.372 446.138 177.023 445.01C177.675 443.881 177.305 442.448 176.196 441.808C175.088 441.169 173.662 441.565 173.011 442.693C172.359 443.821 172.729 445.255 173.837 445.894Z"
          fill="#3A2933"
        />
        <path
          d="M169.119 454.066C170.227 454.706 171.654 454.31 172.305 453.182C172.957 452.053 172.586 450.62 171.478 449.98C170.37 449.341 168.944 449.737 168.292 450.865C167.641 451.993 168.011 453.427 169.119 454.066Z"
          fill="#3A2933"
        />
        <path
          d="M164.401 462.238C165.509 462.878 166.936 462.482 167.587 461.354C168.238 460.226 167.868 458.792 166.76 458.152C165.652 457.513 164.226 457.909 163.574 459.037C162.923 460.165 163.293 461.599 164.401 462.238Z"
          fill="#3A2933"
        />
        <path
          d="M273.867 291.173C274.975 291.812 276.401 291.416 277.053 290.288C277.704 289.16 277.334 287.726 276.226 287.087C275.118 286.447 273.691 286.843 273.04 287.971C272.389 289.1 272.759 290.533 273.867 291.173Z"
          fill="#3A2933"
        />
        <path
          d="M279.533 299.892C280.641 300.532 282.068 300.136 282.719 299.008C283.371 297.879 283.001 296.446 281.892 295.806C280.784 295.166 279.358 295.563 278.706 296.691C278.055 297.819 278.425 299.252 279.533 299.892Z"
          fill="#3A2933"
        />
        <path
          d="M269.149 299.345C270.257 299.984 271.683 299.588 272.335 298.46C272.986 297.332 272.616 295.898 271.508 295.259C270.4 294.619 268.973 295.015 268.322 296.143C267.67 297.272 268.041 298.705 269.149 299.345Z"
          fill="#3A2933"
        />
        <path
          d="M274.815 308.064C275.923 308.704 277.35 308.308 278.001 307.18C278.653 306.051 278.282 304.618 277.174 303.978C276.066 303.339 274.64 303.735 273.988 304.863C273.337 305.991 273.707 307.425 274.815 308.064Z"
          fill="#3A2933"
        />
        <path
          d="M264.431 307.517C265.539 308.157 266.965 307.76 267.616 306.632C268.268 305.504 267.898 304.07 266.79 303.431C265.681 302.791 264.255 303.187 263.604 304.315C262.952 305.444 263.322 306.877 264.431 307.517Z"
          fill="#3A2933"
        />
        <path
          d="M270.097 316.236C271.205 316.876 272.632 316.48 273.283 315.352C273.934 314.223 273.564 312.79 272.456 312.15C271.348 311.511 269.922 311.907 269.27 313.035C268.619 314.163 268.989 315.597 270.097 316.236Z"
          fill="#3A2933"
        />
        <path
          d="M265.379 324.408C266.487 325.048 267.913 324.652 268.565 323.524C269.216 322.395 268.846 320.962 267.738 320.322C266.63 319.683 265.204 320.079 264.552 321.207C263.901 322.335 264.271 323.769 265.379 324.408Z"
          fill="#3A2933"
        />
        <path
          d="M259.712 315.689C260.82 316.329 262.247 315.933 262.898 314.804C263.55 313.676 263.18 312.243 262.071 311.603C260.963 310.963 259.537 311.359 258.886 312.487C258.234 313.616 258.604 315.049 259.712 315.689Z"
          fill="#3A2933"
        />
        <path
          d="M254.994 323.861C256.102 324.501 257.529 324.105 258.18 322.976C258.832 321.848 258.461 320.415 257.353 319.775C256.245 319.135 254.819 319.531 254.167 320.659C253.516 321.788 253.886 323.221 254.994 323.861Z"
          fill="#3A2933"
        />
        <path
          d="M260.661 332.581C261.769 333.22 263.195 332.824 263.847 331.696C264.498 330.568 264.128 329.134 263.02 328.494C261.912 327.855 260.485 328.251 259.834 329.379C259.182 330.507 259.553 331.941 260.661 332.581Z"
          fill="#3A2933"
        />
        <path
          d="M250.276 332.033C251.384 332.673 252.811 332.277 253.462 331.148C254.113 330.02 253.743 328.587 252.635 327.947C251.527 327.307 250.101 327.703 249.449 328.832C248.798 329.96 249.168 331.393 250.276 332.033Z"
          fill="#3A2933"
        />
        <path
          d="M255.943 340.753C257.051 341.392 258.477 340.996 259.129 339.868C259.78 338.74 259.41 337.306 258.302 336.667C257.194 336.027 255.767 336.423 255.116 337.551C254.464 338.68 254.835 340.113 255.943 340.753Z"
          fill="#3A2933"
        />
        <path
          d="M245.558 340.205C246.666 340.845 248.092 340.449 248.744 339.32C249.395 338.192 249.025 336.759 247.917 336.119C246.809 335.479 245.383 335.875 244.731 337.004C244.08 338.132 244.45 339.565 245.558 340.205Z"
          fill="#3A2933"
        />
        <path
          d="M251.225 348.925C252.333 349.564 253.759 349.168 254.41 348.04C255.062 346.912 254.692 345.478 253.584 344.839C252.475 344.199 251.049 344.595 250.398 345.723C249.746 346.852 250.116 348.285 251.225 348.925Z"
          fill="#3A2933"
        />
        <path
          d="M246.506 357.097C247.614 357.736 249.041 357.34 249.692 356.212C250.344 355.084 249.974 353.65 248.865 353.011C247.757 352.371 246.331 352.767 245.679 353.895C245.028 355.024 245.398 356.457 246.506 357.097Z"
          fill="#3A2933"
        />
        <path
          d="M240.84 348.377C241.948 349.017 243.374 348.621 244.026 347.492C244.677 346.364 244.307 344.931 243.199 344.291C242.091 343.651 240.664 344.047 240.013 345.176C239.362 346.304 239.732 347.737 240.84 348.377Z"
          fill="#3A2933"
        />
        <path
          d="M236.122 356.549C237.23 357.189 238.656 356.793 239.308 355.665C239.959 354.536 239.589 353.103 238.481 352.463C237.373 351.823 235.946 352.219 235.295 353.348C234.643 354.476 235.014 355.909 236.122 356.549Z"
          fill="#3A2933"
        />
        <path
          d="M241.788 365.269C242.896 365.909 244.323 365.512 244.974 364.384C245.626 363.256 245.255 361.823 244.147 361.183C243.039 360.543 241.613 360.939 240.961 362.067C240.31 363.196 240.68 364.629 241.788 365.269Z"
          fill="#3A2933"
        />
        <path
          d="M231.404 364.721C232.512 365.361 233.938 364.965 234.589 363.837C235.241 362.708 234.871 361.275 233.763 360.635C232.654 359.995 231.228 360.391 230.577 361.52C229.925 362.648 230.295 364.081 231.404 364.721Z"
          fill="#3A2933"
        />
        <path
          d="M237.07 373.441C238.178 374.081 239.605 373.685 240.256 372.556C240.907 371.428 240.537 369.995 239.429 369.355C238.321 368.715 236.895 369.111 236.243 370.239C235.592 371.368 235.962 372.801 237.07 373.441Z"
          fill="#3A2933"
        />
        <path
          d="M232.352 381.613C233.46 382.253 234.886 381.857 235.538 380.728C236.189 379.6 235.819 378.167 234.711 377.527C233.603 376.887 232.176 377.283 231.525 378.412C230.874 379.54 231.244 380.973 232.352 381.613Z"
          fill="#3A2933"
        />
        <path
          d="M226.685 372.893C227.793 373.533 229.22 373.137 229.871 372.009C230.523 370.88 230.153 369.447 229.044 368.807C227.936 368.167 226.51 368.564 225.859 369.692C225.207 370.82 225.577 372.254 226.685 372.893Z"
          fill="#3A2933"
        />
        <path
          d="M221.967 381.065C223.075 381.705 224.502 381.309 225.153 380.181C225.805 379.052 225.434 377.619 224.326 376.979C223.218 376.34 221.792 376.736 221.14 377.864C220.489 378.992 220.859 380.426 221.967 381.065Z"
          fill="#3A2933"
        />
        <path
          d="M227.634 389.785C228.742 390.425 230.168 390.029 230.82 388.9C231.471 387.772 231.101 386.339 229.993 385.699C228.885 385.059 227.458 385.455 226.807 386.584C226.155 387.712 226.526 389.145 227.634 389.785Z"
          fill="#3A2933"
        />
        <path
          d="M217.249 389.237C218.357 389.877 219.784 389.481 220.435 388.353C221.086 387.224 220.716 385.791 219.608 385.151C218.5 384.512 217.074 384.908 216.422 386.036C215.771 387.164 216.141 388.598 217.249 389.237Z"
          fill="#3A2933"
        />
        <path
          d="M222.916 397.957C224.024 398.597 225.45 398.201 226.102 397.072C226.753 395.944 226.383 394.511 225.275 393.871C224.167 393.231 222.74 393.627 222.089 394.756C221.437 395.884 221.808 397.317 222.916 397.957Z"
          fill="#3A2933"
        />
        <path
          d="M212.531 397.409C213.639 398.049 215.065 397.653 215.717 396.525C216.368 395.397 215.998 393.963 214.89 393.323C213.782 392.684 212.356 393.08 211.704 394.208C211.053 395.336 211.423 396.77 212.531 397.409Z"
          fill="#3A2933"
        />
        <path
          d="M218.198 406.129C219.306 406.769 220.732 406.373 221.383 405.244C222.035 404.116 221.665 402.683 220.557 402.043C219.448 401.403 218.022 401.799 217.371 402.928C216.719 404.056 217.089 405.489 218.198 406.129Z"
          fill="#3A2933"
        />
        <path
          d="M213.479 414.301C214.587 414.941 216.014 414.545 216.665 413.417C217.317 412.288 216.947 410.855 215.838 410.215C214.73 409.575 213.304 409.971 212.652 411.1C212.001 412.228 212.371 413.661 213.479 414.301Z"
          fill="#3A2933"
        />
        <path
          d="M207.813 405.582C208.921 406.221 210.347 405.825 210.999 404.697C211.65 403.569 211.28 402.135 210.172 401.496C209.064 400.856 207.637 401.252 206.986 402.38C206.335 403.508 206.705 404.942 207.813 405.582Z"
          fill="#3A2933"
        />
        <path
          d="M203.095 413.754C204.203 414.393 205.629 413.997 206.281 412.869C206.932 411.741 206.562 410.307 205.454 409.668C204.346 409.028 202.919 409.424 202.268 410.552C201.616 411.681 201.987 413.114 203.095 413.754Z"
          fill="#3A2933"
        />
        <path
          d="M208.761 422.473C209.869 423.113 211.296 422.717 211.947 421.589C212.599 420.46 212.228 419.027 211.12 418.387C210.012 417.747 208.586 418.144 207.934 419.272C207.283 420.4 207.653 421.833 208.761 422.473Z"
          fill="#3A2933"
        />
        <path
          d="M198.377 421.926C199.485 422.565 200.911 422.169 201.562 421.041C202.214 419.913 201.844 418.479 200.736 417.84C199.627 417.2 198.201 417.596 197.55 418.724C196.898 419.853 197.268 421.286 198.377 421.926Z"
          fill="#3A2933"
        />
        <path
          d="M204.043 430.645C205.151 431.285 206.578 430.889 207.229 429.761C207.88 428.632 207.51 427.199 206.402 426.559C205.294 425.92 203.868 426.316 203.216 427.444C202.565 428.572 202.935 430.006 204.043 430.645Z"
          fill="#3A2933"
        />
        <path
          d="M193.658 430.098C194.766 430.738 196.193 430.341 196.844 429.213C197.496 428.085 197.126 426.651 196.017 426.012C194.909 425.372 193.483 425.768 192.831 426.896C192.18 428.025 192.55 429.458 193.658 430.098Z"
          fill="#3A2933"
        />
        <path
          d="M199.325 438.817C200.433 439.457 201.859 439.061 202.511 437.933C203.162 436.804 202.792 435.371 201.684 434.731C200.576 434.092 199.149 434.488 198.498 435.616C197.847 436.744 198.217 438.178 199.325 438.817Z"
          fill="#3A2933"
        />
        <path
          d="M194.607 446.989C195.715 447.629 197.141 447.233 197.793 446.105C198.444 444.976 198.074 443.543 196.966 442.903C195.858 442.264 194.431 442.66 193.78 443.788C193.128 444.916 193.499 446.35 194.607 446.989Z"
          fill="#3A2933"
        />
        <path
          d="M188.94 438.27C190.048 438.91 191.475 438.514 192.126 437.385C192.778 436.257 192.407 434.824 191.299 434.184C190.191 433.544 188.765 433.94 188.113 435.068C187.462 436.197 187.832 437.63 188.94 438.27Z"
          fill="#3A2933"
        />
        <path
          d="M184.222 446.442C185.33 447.082 186.757 446.686 187.408 445.557C188.059 444.429 187.689 442.996 186.581 442.356C185.473 441.716 184.047 442.112 183.395 443.24C182.744 444.369 183.114 445.802 184.222 446.442Z"
          fill="#3A2933"
        />
        <path
          d="M189.889 455.162C190.997 455.801 192.423 455.405 193.075 454.277C193.726 453.149 193.356 451.715 192.248 451.075C191.14 450.436 189.713 450.832 189.062 451.96C188.41 453.088 188.781 454.522 189.889 455.162Z"
          fill="#3A2933"
        />
        <path
          d="M179.504 454.614C180.612 455.254 182.038 454.858 182.69 453.729C183.341 452.601 182.971 451.168 181.863 450.528C180.755 449.888 179.329 450.284 178.677 451.413C178.026 452.541 178.396 453.974 179.504 454.614Z"
          fill="#3A2933"
        />
        <path
          d="M185.17 463.334C186.279 463.973 187.705 463.577 188.356 462.449C189.008 461.321 188.638 459.887 187.53 459.248C186.421 458.608 184.995 459.004 184.344 460.132C183.692 461.26 184.062 462.694 185.17 463.334Z"
          fill="#3A2933"
        />
        <path
          d="M180.452 471.506C181.56 472.145 182.987 471.749 183.638 470.621C184.29 469.493 183.92 468.059 182.811 467.42C181.703 466.78 180.277 467.176 179.625 468.304C178.974 469.433 179.344 470.866 180.452 471.506Z"
          fill="#3A2933"
        />
        <path
          d="M174.786 462.786C175.894 463.426 177.32 463.03 177.972 461.901C178.623 460.773 178.253 459.34 177.145 458.7C176.037 458.06 174.61 458.456 173.959 459.585C173.308 460.713 173.678 462.146 174.786 462.786Z"
          fill="#3A2933"
        />
        <path
          d="M289.918 300.44C291.026 301.08 292.453 300.684 293.104 299.555C293.755 298.427 293.385 296.994 292.277 296.354C291.169 295.714 289.743 296.11 289.091 297.238C288.44 298.367 288.81 299.8 289.918 300.44Z"
          fill="#3A2933"
        />
        <path
          d="M295.585 309.159C296.693 309.799 298.119 309.403 298.771 308.275C299.422 307.146 299.052 305.713 297.944 305.073C296.836 304.434 295.409 304.83 294.758 305.958C294.106 307.086 294.476 308.52 295.585 309.159Z"
          fill="#3A2933"
        />
        <path
          d="M285.2 308.612C286.308 309.252 287.734 308.856 288.386 307.727C289.037 306.599 288.667 305.166 287.559 304.526C286.451 303.886 285.024 304.282 284.373 305.41C283.722 306.539 284.092 307.972 285.2 308.612Z"
          fill="#3A2933"
        />
        <path
          d="M290.866 317.332C291.975 317.971 293.401 317.575 294.052 316.447C294.704 315.319 294.334 313.885 293.226 313.245C292.117 312.606 290.691 313.002 290.04 314.13C289.388 315.258 289.758 316.692 290.866 317.332Z"
          fill="#3A2933"
        />
        <path
          d="M280.482 316.784C281.59 317.424 283.016 317.028 283.668 315.899C284.319 314.771 283.949 313.338 282.841 312.698C281.733 312.058 280.306 312.454 279.655 313.583C279.003 314.711 279.374 316.144 280.482 316.784Z"
          fill="#3A2933"
        />
        <path
          d="M286.148 325.504C287.256 326.143 288.683 325.747 289.334 324.619C289.986 323.491 289.615 322.057 288.507 321.418C287.399 320.778 285.973 321.174 285.321 322.302C284.67 323.43 285.04 324.864 286.148 325.504Z"
          fill="#3A2933"
        />
        <path
          d="M281.43 333.676C282.538 334.315 283.965 333.919 284.616 332.791C285.268 331.663 284.897 330.229 283.789 329.59C282.681 328.95 281.255 329.346 280.603 330.474C279.952 331.603 280.322 333.036 281.43 333.676Z"
          fill="#3A2933"
        />
        <path
          d="M275.764 324.956C276.872 325.596 278.298 325.2 278.95 324.071C279.601 322.943 279.231 321.51 278.123 320.87C277.015 320.23 275.588 320.626 274.937 321.755C274.285 322.883 274.656 324.316 275.764 324.956Z"
          fill="#3A2933"
        />
        <path
          d="M271.045 333.128C272.154 333.768 273.58 333.372 274.231 332.243C274.883 331.115 274.513 329.682 273.405 329.042C272.296 328.402 270.87 328.798 270.219 329.927C269.567 331.055 269.937 332.488 271.045 333.128Z"
          fill="#3A2933"
        />
        <path
          d="M276.712 341.848C277.82 342.487 279.247 342.091 279.898 340.963C280.549 339.835 280.179 338.401 279.071 337.762C277.963 337.122 276.537 337.518 275.885 338.646C275.234 339.775 275.604 341.208 276.712 341.848Z"
          fill="#3A2933"
        />
        <path
          d="M266.327 341.3C267.435 341.94 268.862 341.544 269.513 340.416C270.165 339.287 269.794 337.854 268.686 337.214C267.578 336.574 266.152 336.97 265.5 338.099C264.849 339.227 265.219 340.66 266.327 341.3Z"
          fill="#3A2933"
        />
        <path
          d="M271.994 350.02C273.102 350.66 274.528 350.263 275.18 349.135C275.831 348.007 275.461 346.573 274.353 345.934C273.245 345.294 271.818 345.69 271.167 346.818C270.516 347.947 270.886 349.38 271.994 350.02Z"
          fill="#3A2933"
        />
        <path
          d="M261.609 349.472C262.717 350.112 264.144 349.716 264.795 348.588C265.447 347.459 265.076 346.026 263.968 345.386C262.86 344.746 261.434 345.142 260.782 346.271C260.131 347.399 260.501 348.832 261.609 349.472Z"
          fill="#3A2933"
        />
        <path
          d="M267.276 358.192C268.384 358.832 269.81 358.436 270.462 357.307C271.113 356.179 270.743 354.746 269.635 354.106C268.527 353.466 267.1 353.862 266.449 354.99C265.797 356.119 266.168 357.552 267.276 358.192Z"
          fill="#3A2933"
        />
        <path
          d="M262.558 366.364C263.666 367.004 265.092 366.608 265.744 365.479C266.395 364.351 266.025 362.918 264.917 362.278C263.809 361.638 262.382 362.034 261.731 363.162C261.079 364.291 261.449 365.724 262.558 366.364Z"
          fill="#3A2933"
        />
        <path
          d="M256.891 357.644C257.999 358.284 259.426 357.888 260.077 356.76C260.728 355.631 260.358 354.198 259.25 353.558C258.142 352.918 256.716 353.315 256.064 354.443C255.413 355.571 255.783 357.004 256.891 357.644Z"
          fill="#3A2933"
        />
        <path
          d="M252.173 365.816C253.281 366.456 254.707 366.06 255.359 364.932C256.01 363.803 255.64 362.37 254.532 361.73C253.424 361.091 251.997 361.487 251.346 362.615C250.695 363.743 251.065 365.177 252.173 365.816Z"
          fill="#3A2933"
        />
        <path
          d="M257.839 374.536C258.948 375.176 260.374 374.78 261.025 373.651C261.677 372.523 261.307 371.09 260.199 370.45C259.09 369.81 257.664 370.206 257.013 371.335C256.361 372.463 256.731 373.896 257.839 374.536Z"
          fill="#3A2933"
        />
        <path
          d="M247.455 373.988C248.563 374.628 249.989 374.232 250.641 373.104C251.292 371.975 250.922 370.542 249.814 369.902C248.706 369.263 247.279 369.659 246.628 370.787C245.976 371.915 246.347 373.349 247.455 373.988Z"
          fill="#3A2933"
        />
        <path
          d="M253.121 382.708C254.229 383.348 255.656 382.952 256.307 381.823C256.959 380.695 256.588 379.262 255.48 378.622C254.372 377.982 252.946 378.378 252.294 379.507C251.643 380.635 252.013 382.068 253.121 382.708Z"
          fill="#3A2933"
        />
        <path
          d="M248.403 390.88C249.511 391.52 250.938 391.124 251.589 389.995C252.241 388.867 251.87 387.434 250.762 386.794C249.654 386.154 248.228 386.55 247.576 387.679C246.925 388.807 247.295 390.24 248.403 390.88Z"
          fill="#3A2933"
        />
        <path
          d="M242.737 382.16C243.845 382.8 245.271 382.404 245.923 381.276C246.574 380.148 246.204 378.714 245.096 378.074C243.988 377.435 242.561 377.831 241.91 378.959C241.258 380.087 241.629 381.521 242.737 382.16Z"
          fill="#3A2933"
        />
        <path
          d="M238.018 390.333C239.127 390.972 240.553 390.576 241.204 389.448C241.856 388.32 241.486 386.886 240.378 386.247C239.269 385.607 237.843 386.003 237.192 387.131C236.54 388.259 236.91 389.693 238.018 390.333Z"
          fill="#3A2933"
        />
        <path
          d="M243.685 399.052C244.793 399.692 246.22 399.296 246.871 398.168C247.522 397.039 247.152 395.606 246.044 394.966C244.936 394.326 243.51 394.722 242.858 395.851C242.207 396.979 242.577 398.412 243.685 399.052Z"
          fill="#3A2933"
        />
        <path
          d="M233.3 398.505C234.408 399.144 235.835 398.748 236.486 397.62C237.138 396.492 236.767 395.058 235.659 394.419C234.551 393.779 233.125 394.175 232.473 395.303C231.822 396.431 232.192 397.865 233.3 398.505Z"
          fill="#3A2933"
        />
        <path
          d="M238.967 407.224C240.075 407.864 241.501 407.468 242.153 406.34C242.804 405.211 242.434 403.778 241.326 403.138C240.218 402.498 238.791 402.894 238.14 404.023C237.489 405.151 237.859 406.584 238.967 407.224Z"
          fill="#3A2933"
        />
        <path
          d="M228.582 406.677C229.69 407.316 231.117 406.92 231.768 405.792C232.42 404.664 232.049 403.23 230.941 402.591C229.833 401.951 228.407 402.347 227.755 403.475C227.104 404.604 227.474 406.037 228.582 406.677Z"
          fill="#3A2933"
        />
        <path
          d="M234.249 415.396C235.357 416.036 236.783 415.64 237.435 414.512C238.086 413.383 237.716 411.95 236.608 411.31C235.5 410.67 234.073 411.067 233.422 412.195C232.77 413.323 233.141 414.757 234.249 415.396Z"
          fill="#3A2933"
        />
        <path
          d="M229.531 423.568C230.639 424.208 232.065 423.812 232.717 422.684C233.368 421.555 232.998 420.122 231.89 419.482C230.782 418.843 229.355 419.239 228.704 420.367C228.052 421.495 228.422 422.929 229.531 423.568Z"
          fill="#3A2933"
        />
        <path
          d="M223.864 414.849C224.972 415.488 226.399 415.092 227.05 413.964C227.701 412.836 227.331 411.402 226.223 410.763C225.115 410.123 223.689 410.519 223.037 411.647C222.386 412.776 222.756 414.209 223.864 414.849Z"
          fill="#3A2933"
        />
        <path
          d="M219.146 423.021C220.254 423.661 221.68 423.265 222.332 422.136C222.983 421.008 222.613 419.575 221.505 418.935C220.397 418.295 218.97 418.691 218.319 419.819C217.668 420.948 218.038 422.381 219.146 423.021Z"
          fill="#3A2933"
        />
        <path
          d="M224.812 431.74C225.921 432.38 227.347 431.984 227.998 430.856C228.65 429.727 228.28 428.294 227.171 427.654C226.063 427.015 224.637 427.411 223.986 428.539C223.334 429.667 223.704 431.101 224.812 431.74Z"
          fill="#3A2933"
        />
        <path
          d="M214.428 431.193C215.536 431.833 216.962 431.437 217.614 430.308C218.265 429.18 217.895 427.747 216.787 427.107C215.679 426.467 214.252 426.863 213.601 427.991C212.949 429.12 213.32 430.553 214.428 431.193Z"
          fill="#3A2933"
        />
        <path
          d="M220.094 439.912C221.202 440.552 222.629 440.156 223.28 439.028C223.932 437.9 223.561 436.466 222.453 435.826C221.345 435.187 219.919 435.583 219.267 436.711C218.616 437.839 218.986 439.273 220.094 439.912Z"
          fill="#3A2933"
        />
        <path
          d="M209.71 439.365C210.818 440.005 212.244 439.609 212.896 438.48C213.547 437.352 213.177 435.919 212.069 435.279C210.961 434.639 209.534 435.035 208.883 436.164C208.231 437.292 208.601 438.725 209.71 439.365Z"
          fill="#3A2933"
        />
        <path
          d="M215.376 448.085C216.484 448.724 217.911 448.328 218.562 447.2C219.214 446.072 218.843 444.638 217.735 443.999C216.627 443.359 215.201 443.755 214.549 444.883C213.898 446.011 214.268 447.445 215.376 448.085Z"
          fill="#3A2933"
        />
        <path
          d="M210.658 456.257C211.766 456.896 213.193 456.5 213.844 455.372C214.495 454.244 214.125 452.81 213.017 452.171C211.909 451.531 210.483 451.927 209.831 453.055C209.18 454.184 209.55 455.617 210.658 456.257Z"
          fill="#3A2933"
        />
        <path
          d="M204.991 447.537C206.1 448.177 207.526 447.781 208.177 446.652C208.829 445.524 208.459 444.091 207.351 443.451C206.242 442.811 204.816 443.207 204.165 444.336C203.513 445.464 203.883 446.897 204.991 447.537Z"
          fill="#3A2933"
        />
        <path
          d="M200.273 455.709C201.381 456.349 202.808 455.953 203.459 454.824C204.111 453.696 203.741 452.263 202.632 451.623C201.524 450.983 200.098 451.379 199.446 452.508C198.795 453.636 199.165 455.069 200.273 455.709Z"
          fill="#3A2933"
        />
        <path
          d="M205.94 464.429C207.048 465.068 208.474 464.672 209.126 463.544C209.777 462.416 209.407 460.982 208.299 460.343C207.191 459.703 205.764 460.099 205.113 461.227C204.462 462.356 204.832 463.789 205.94 464.429Z"
          fill="#3A2933"
        />
        <path
          d="M195.555 463.881C196.663 464.521 198.09 464.125 198.741 462.996C199.393 461.868 199.022 460.435 197.914 459.795C196.806 459.155 195.38 459.551 194.728 460.68C194.077 461.808 194.447 463.241 195.555 463.881Z"
          fill="#3A2933"
        />
        <path
          d="M201.222 472.601C202.33 473.241 203.756 472.844 204.408 471.716C205.059 470.588 204.689 469.154 203.581 468.515C202.473 467.875 201.046 468.271 200.395 469.399C199.743 470.528 200.114 471.961 201.222 472.601Z"
          fill="#3A2933"
        />
        <path
          d="M196.504 480.773C197.612 481.413 199.038 481.017 199.69 479.888C200.341 478.76 199.971 477.327 198.863 476.687C197.755 476.047 196.328 476.443 195.677 477.571C195.025 478.7 195.395 480.133 196.504 480.773Z"
          fill="#3A2933"
        />
        <path
          d="M190.837 472.053C191.945 472.693 193.372 472.297 194.023 471.169C194.674 470.04 194.304 468.607 193.196 467.967C192.088 467.327 190.662 467.723 190.01 468.852C189.359 469.98 189.729 471.413 190.837 472.053Z"
          fill="#3A2933"
        />
        <path
          d="M305.969 309.707C307.077 310.347 308.504 309.951 309.155 308.822C309.807 307.694 309.436 306.261 308.328 305.621C307.22 304.981 305.794 305.377 305.142 306.506C304.491 307.634 304.861 309.067 305.969 309.707Z"
          fill="#3A2933"
        />
        <path
          d="M311.636 318.427C312.744 319.066 314.17 318.67 314.822 317.542C315.473 316.414 315.103 314.98 313.995 314.341C312.887 313.701 311.46 314.097 310.809 315.225C310.158 316.354 310.528 317.787 311.636 318.427Z"
          fill="#3A2933"
        />
        <path
          d="M301.251 317.879C302.359 318.519 303.786 318.123 304.437 316.994C305.089 315.866 304.718 314.433 303.61 313.793C302.502 313.153 301.076 313.549 300.424 314.678C299.773 315.806 300.143 317.239 301.251 317.879Z"
          fill="#3A2933"
        />
        <path
          d="M306.918 326.599C308.026 327.238 309.452 326.842 310.104 325.714C310.755 324.586 310.385 323.152 309.277 322.513C308.169 321.873 306.742 322.269 306.091 323.397C305.439 324.526 305.81 325.959 306.918 326.599Z"
          fill="#3A2933"
        />
        <path
          d="M296.533 326.051C297.641 326.691 299.067 326.295 299.719 325.167C300.37 324.038 300 322.605 298.892 321.965C297.784 321.325 296.358 321.721 295.706 322.85C295.055 323.978 295.425 325.411 296.533 326.051Z"
          fill="#3A2933"
        />
        <path
          d="M302.2 334.771C303.308 335.411 304.734 335.014 305.385 333.886C306.037 332.758 305.667 331.324 304.559 330.685C303.451 330.045 302.024 330.441 301.373 331.569C300.721 332.698 301.091 334.131 302.2 334.771Z"
          fill="#3A2933"
        />
        <path
          d="M297.481 342.943C298.59 343.583 300.016 343.187 300.667 342.058C301.319 340.93 300.949 339.497 299.84 338.857C298.732 338.217 297.306 338.613 296.655 339.741C296.003 340.87 296.373 342.303 297.481 342.943Z"
          fill="#3A2933"
        />
        <path
          d="M291.815 334.223C292.923 334.863 294.349 334.467 295.001 333.339C295.652 332.21 295.282 330.777 294.174 330.137C293.066 329.497 291.639 329.893 290.988 331.022C290.337 332.15 290.707 333.583 291.815 334.223Z"
          fill="#3A2933"
        />
        <path
          d="M287.097 342.395C288.205 343.035 289.631 342.639 290.283 341.511C290.934 340.382 290.564 338.949 289.456 338.309C288.348 337.669 286.921 338.066 286.27 339.194C285.618 340.322 285.989 341.755 287.097 342.395Z"
          fill="#3A2933"
        />
        <path
          d="M292.763 351.115C293.871 351.755 295.298 351.359 295.949 350.23C296.601 349.102 296.23 347.669 295.122 347.029C294.014 346.389 292.588 346.785 291.936 347.913C291.285 349.042 291.655 350.475 292.763 351.115Z"
          fill="#3A2933"
        />
        <path
          d="M282.379 350.567C283.487 351.207 284.913 350.811 285.564 349.683C286.216 348.554 285.846 347.121 284.738 346.481C283.63 345.842 282.203 346.238 281.552 347.366C280.9 348.494 281.27 349.928 282.379 350.567Z"
          fill="#3A2933"
        />
        <path
          d="M288.045 359.287C289.153 359.927 290.58 359.531 291.231 358.402C291.882 357.274 291.512 355.841 290.404 355.201C289.296 354.561 287.87 354.957 287.218 356.086C286.567 357.214 286.937 358.647 288.045 359.287Z"
          fill="#3A2933"
        />
        <path
          d="M277.66 358.739C278.768 359.379 280.195 358.983 280.846 357.855C281.498 356.726 281.128 355.293 280.019 354.653C278.911 354.014 277.485 354.41 276.834 355.538C276.182 356.666 276.552 358.1 277.66 358.739Z"
          fill="#3A2933"
        />
        <path
          d="M283.327 367.459C284.435 368.099 285.861 367.703 286.513 366.574C287.164 365.446 286.794 364.013 285.686 363.373C284.578 362.733 283.152 363.129 282.5 364.258C281.849 365.386 282.219 366.819 283.327 367.459Z"
          fill="#3A2933"
        />
        <path
          d="M278.609 375.631C279.717 376.271 281.143 375.875 281.795 374.746C282.446 373.618 282.076 372.185 280.968 371.545C279.86 370.905 278.433 371.301 277.782 372.43C277.131 373.558 277.501 374.991 278.609 375.631Z"
          fill="#3A2933"
        />
        <path
          d="M272.942 366.911C274.05 367.551 275.477 367.155 276.128 366.027C276.78 364.898 276.409 363.465 275.301 362.825C274.193 362.186 272.767 362.582 272.115 363.71C271.464 364.838 271.834 366.272 272.942 366.911Z"
          fill="#3A2933"
        />
        <path
          d="M268.224 375.083C269.332 375.723 270.759 375.327 271.41 374.199C272.062 373.071 271.691 371.637 270.583 370.997C269.475 370.358 268.049 370.754 267.397 371.882C266.746 373.01 267.116 374.444 268.224 375.083Z"
          fill="#3A2933"
        />
        <path
          d="M273.891 383.803C274.999 384.443 276.425 384.047 277.077 382.919C277.728 381.79 277.358 380.357 276.25 379.717C275.142 379.077 273.715 379.473 273.064 380.602C272.412 381.73 272.783 383.163 273.891 383.803Z"
          fill="#3A2933"
        />
        <path
          d="M263.506 383.256C264.614 383.895 266.04 383.499 266.692 382.371C267.343 381.243 266.973 379.809 265.865 379.17C264.757 378.53 263.331 378.926 262.679 380.054C262.028 381.183 262.398 382.616 263.506 383.256Z"
          fill="#3A2933"
        />
        <path
          d="M269.173 391.975C270.281 392.615 271.707 392.219 272.358 391.091C273.01 389.962 272.64 388.529 271.532 387.889C270.423 387.249 268.997 387.645 268.346 388.774C267.694 389.902 268.064 391.335 269.173 391.975Z"
          fill="#3A2933"
        />
        <path
          d="M264.454 400.147C265.562 400.787 266.989 400.391 267.64 399.263C268.292 398.134 267.922 396.701 266.813 396.061C265.705 395.421 264.279 395.818 263.628 396.946C262.976 398.074 263.346 399.508 264.454 400.147Z"
          fill="#3A2933"
        />
        <path
          d="M258.788 391.428C259.896 392.067 261.322 391.671 261.974 390.543C262.625 389.415 262.255 387.981 261.147 387.342C260.039 386.702 258.612 387.098 257.961 388.226C257.31 389.355 257.68 390.788 258.788 391.428Z"
          fill="#3A2933"
        />
        <path
          d="M254.07 399.6C255.178 400.239 256.604 399.843 257.256 398.715C257.907 397.587 257.537 396.153 256.429 395.514C255.321 394.874 253.894 395.27 253.243 396.398C252.591 397.527 252.962 398.96 254.07 399.6Z"
          fill="#3A2933"
        />
        <path
          d="M259.736 408.319C260.844 408.959 262.271 408.563 262.922 407.435C263.574 406.306 263.203 404.873 262.095 404.233C260.987 403.594 259.561 403.99 258.909 405.118C258.258 406.246 258.628 407.68 259.736 408.319Z"
          fill="#3A2933"
        />
        <path
          d="M249.352 407.772C250.46 408.412 251.886 408.015 252.537 406.887C253.189 405.759 252.819 404.326 251.711 403.686C250.602 403.046 249.176 403.442 248.525 404.57C247.873 405.699 248.243 407.132 249.352 407.772Z"
          fill="#3A2933"
        />
        <path
          d="M255.018 416.491C256.126 417.131 257.553 416.735 258.204 415.607C258.855 414.478 258.485 413.045 257.377 412.405C256.269 411.766 254.843 412.162 254.191 413.29C253.54 414.418 253.91 415.852 255.018 416.491Z"
          fill="#3A2933"
        />
        <path
          d="M244.633 415.944C245.741 416.584 247.168 416.188 247.819 415.059C248.471 413.931 248.101 412.498 246.992 411.858C245.884 411.218 244.458 411.614 243.807 412.742C243.155 413.871 243.525 415.304 244.633 415.944Z"
          fill="#3A2933"
        />
        <path
          d="M250.3 424.663C251.408 425.303 252.834 424.907 253.486 423.779C254.137 422.651 253.767 421.217 252.659 420.577C251.551 419.938 250.125 420.334 249.473 421.462C248.822 422.59 249.192 424.024 250.3 424.663Z"
          fill="#3A2933"
        />
        <path
          d="M245.582 432.836C246.69 433.475 248.116 433.079 248.768 431.951C249.419 430.823 249.049 429.389 247.941 428.749C246.833 428.11 245.406 428.506 244.755 429.634C244.104 430.762 244.474 432.196 245.582 432.836Z"
          fill="#3A2933"
        />
        <path
          d="M239.915 424.116C241.023 424.756 242.45 424.36 243.101 423.231C243.753 422.103 243.382 420.67 242.274 420.03C241.166 419.39 239.74 419.786 239.088 420.914C238.437 422.043 238.807 423.476 239.915 424.116Z"
          fill="#3A2933"
        />
        <path
          d="M235.197 432.288C236.305 432.928 237.732 432.532 238.383 431.403C239.034 430.275 238.664 428.842 237.556 428.202C236.448 427.562 235.022 427.958 234.37 429.087C233.719 430.215 234.089 431.648 235.197 432.288Z"
          fill="#3A2933"
        />
        <path
          d="M240.864 441.008C241.972 441.647 243.398 441.251 244.05 440.123C244.701 438.995 244.331 437.561 243.223 436.922C242.115 436.282 240.688 436.678 240.037 437.806C239.385 438.935 239.756 440.368 240.864 441.008Z"
          fill="#3A2933"
        />
        <path
          d="M230.479 440.46C231.587 441.1 233.013 440.704 233.665 439.575C234.316 438.447 233.946 437.014 232.838 436.374C231.73 435.734 230.304 436.13 229.652 437.259C229.001 438.387 229.371 439.82 230.479 440.46Z"
          fill="#3A2933"
        />
        <path
          d="M236.146 449.18C237.254 449.819 238.68 449.423 239.331 448.295C239.983 447.167 239.613 445.733 238.505 445.094C237.396 444.454 235.97 444.85 235.319 445.978C234.667 447.107 235.037 448.54 236.146 449.18Z"
          fill="#3A2933"
        />
        <path
          d="M225.761 448.632C226.869 449.272 228.295 448.876 228.947 447.748C229.598 446.619 229.228 445.186 228.12 444.546C227.012 443.906 225.585 444.302 224.934 445.431C224.283 446.559 224.653 447.992 225.761 448.632Z"
          fill="#3A2933"
        />
        <path
          d="M231.427 457.352C232.535 457.991 233.962 457.595 234.613 456.467C235.265 455.339 234.895 453.905 233.786 453.266C232.678 452.626 231.252 453.022 230.601 454.15C229.949 455.279 230.319 456.712 231.427 457.352Z"
          fill="#3A2933"
        />
        <path
          d="M226.709 465.524C227.817 466.164 229.244 465.767 229.895 464.639C230.547 463.511 230.176 462.078 229.068 461.438C227.96 460.798 226.534 461.194 225.882 462.322C225.231 463.451 225.601 464.884 226.709 465.524Z"
          fill="#3A2933"
        />
        <path
          d="M221.043 456.804C222.151 457.444 223.577 457.048 224.229 455.92C224.88 454.791 224.51 453.358 223.402 452.718C222.294 452.078 220.867 452.474 220.216 453.603C219.564 454.731 219.935 456.164 221.043 456.804Z"
          fill="#3A2933"
        />
        <path
          d="M216.325 464.976C217.433 465.616 218.859 465.22 219.51 464.092C220.162 462.963 219.792 461.53 218.684 460.89C217.576 460.25 216.149 460.646 215.498 461.775C214.846 462.903 215.216 464.336 216.325 464.976Z"
          fill="#3A2933"
        />
        <path
          d="M221.991 473.696C223.099 474.336 224.526 473.94 225.177 472.811C225.828 471.683 225.458 470.25 224.35 469.61C223.242 468.97 221.816 469.366 221.164 470.494C220.513 471.623 220.883 473.056 221.991 473.696Z"
          fill="#3A2933"
        />
        <path
          d="M211.606 473.148C212.714 473.788 214.141 473.392 214.792 472.264C215.444 471.135 215.074 469.702 213.965 469.062C212.857 468.422 211.431 468.819 210.78 469.947C210.128 471.075 210.498 472.509 211.606 473.148Z"
          fill="#3A2933"
        />
        <path
          d="M217.273 481.868C218.381 482.508 219.807 482.112 220.459 480.983C221.11 479.855 220.74 478.422 219.632 477.782C218.524 477.142 217.098 477.538 216.446 478.667C215.795 479.795 216.165 481.228 217.273 481.868Z"
          fill="#3A2933"
        />
        <path
          d="M212.555 490.04C213.663 490.68 215.089 490.284 215.741 489.155C216.392 488.027 216.022 486.594 214.914 485.954C213.806 485.314 212.379 485.71 211.728 486.839C211.076 487.967 211.447 489.4 212.555 490.04Z"
          fill="#3A2933"
        />
        <path
          d="M206.888 481.32C207.996 481.96 209.423 481.564 210.074 480.436C210.726 479.307 210.355 477.874 209.247 477.234C208.139 476.595 206.713 476.991 206.061 478.119C205.41 479.247 205.78 480.681 206.888 481.32Z"
          fill="#3A2933"
        />
        <path
          d="M322.02 318.974C323.129 319.614 324.555 319.218 325.206 318.09C325.858 316.961 325.488 315.528 324.38 314.888C323.271 314.248 321.845 314.644 321.194 315.773C320.542 316.901 320.912 318.334 322.02 318.974Z"
          fill="#3A2933"
        />
        <path
          d="M327.687 327.694C328.795 328.334 330.222 327.937 330.873 326.809C331.524 325.681 331.154 324.248 330.046 323.608C328.938 322.968 327.512 323.364 326.86 324.492C326.209 325.621 326.579 327.054 327.687 327.694Z"
          fill="#3A2933"
        />
        <path
          d="M317.302 327.146C318.41 327.786 319.837 327.39 320.488 326.262C321.14 325.133 320.77 323.7 319.661 323.06C318.553 322.42 317.127 322.816 316.475 323.945C315.824 325.073 316.194 326.506 317.302 327.146Z"
          fill="#3A2933"
        />
        <path
          d="M322.969 335.866C324.077 336.506 325.503 336.11 326.155 334.981C326.806 333.853 326.436 332.42 325.328 331.78C324.22 331.14 322.793 331.536 322.142 332.664C321.491 333.793 321.861 335.226 322.969 335.866Z"
          fill="#3A2933"
        />
        <path
          d="M312.584 335.318C313.692 335.958 315.119 335.562 315.77 334.434C316.422 333.305 316.051 331.872 314.943 331.232C313.835 330.593 312.409 330.989 311.757 332.117C311.106 333.245 311.476 334.679 312.584 335.318Z"
          fill="#3A2933"
        />
        <path
          d="M318.251 344.038C319.359 344.678 320.785 344.282 321.437 343.153C322.088 342.025 321.718 340.592 320.61 339.952C319.502 339.312 318.075 339.708 317.424 340.837C316.772 341.965 317.143 343.398 318.251 344.038Z"
          fill="#3A2933"
        />
        <path
          d="M313.533 352.21C314.641 352.85 316.067 352.454 316.719 351.325C317.37 350.197 317 348.764 315.892 348.124C314.784 347.484 313.357 347.88 312.706 349.009C312.054 350.137 312.424 351.57 313.533 352.21Z"
          fill="#3A2933"
        />
        <path
          d="M307.866 343.49C308.974 344.13 310.401 343.734 311.052 342.606C311.703 341.477 311.333 340.044 310.225 339.404C309.117 338.765 307.691 339.161 307.039 340.289C306.388 341.417 306.758 342.851 307.866 343.49Z"
          fill="#3A2933"
        />
        <path
          d="M303.148 351.662C304.256 352.302 305.682 351.906 306.334 350.778C306.985 349.649 306.615 348.216 305.507 347.576C304.399 346.937 302.972 347.333 302.321 348.461C301.67 349.589 302.04 351.023 303.148 351.662Z"
          fill="#3A2933"
        />
        <path
          d="M308.814 360.382C309.923 361.022 311.349 360.626 312 359.497C312.652 358.369 312.282 356.936 311.174 356.296C310.065 355.656 308.639 356.052 307.988 357.181C307.336 358.309 307.706 359.742 308.814 360.382Z"
          fill="#3A2933"
        />
        <path
          d="M298.43 359.834C299.538 360.474 300.964 360.078 301.616 358.95C302.267 357.822 301.897 356.388 300.789 355.748C299.681 355.109 298.254 355.505 297.603 356.633C296.951 357.761 297.322 359.195 298.43 359.834Z"
          fill="#3A2933"
        />
        <path
          d="M304.096 368.554C305.204 369.194 306.631 368.798 307.282 367.67C307.934 366.541 307.563 365.108 306.455 364.468C305.347 363.828 303.921 364.224 303.269 365.353C302.618 366.481 302.988 367.914 304.096 368.554Z"
          fill="#3A2933"
        />
        <path
          d="M293.712 368.007C294.82 368.646 296.246 368.25 296.898 367.122C297.549 365.994 297.179 364.56 296.071 363.921C294.963 363.281 293.536 363.677 292.885 364.805C292.233 365.933 292.604 367.367 293.712 368.007Z"
          fill="#3A2933"
        />
        <path
          d="M299.378 376.726C300.486 377.366 301.913 376.97 302.564 375.842C303.216 374.713 302.845 373.28 301.737 372.64C300.629 372 299.203 372.396 298.551 373.525C297.9 374.653 298.27 376.086 299.378 376.726Z"
          fill="#3A2933"
        />
        <path
          d="M294.66 384.898C295.768 385.538 297.195 385.142 297.846 384.014C298.497 382.885 298.127 381.452 297.019 380.812C295.911 380.172 294.485 380.568 293.833 381.697C293.182 382.825 293.552 384.258 294.66 384.898Z"
          fill="#3A2933"
        />
        <path
          d="M288.993 376.179C290.102 376.818 291.528 376.422 292.179 375.294C292.831 374.166 292.461 372.732 291.353 372.093C290.244 371.453 288.818 371.849 288.167 372.977C287.515 374.106 287.885 375.539 288.993 376.179Z"
          fill="#3A2933"
        />
        <path
          d="M284.275 384.351C285.383 384.99 286.81 384.594 287.461 383.466C288.113 382.338 287.743 380.904 286.634 380.265C285.526 379.625 284.1 380.021 283.448 381.149C282.797 382.278 283.167 383.711 284.275 384.351Z"
          fill="#3A2933"
        />
        <path
          d="M289.942 393.07C291.05 393.71 292.476 393.314 293.128 392.186C293.779 391.057 293.409 389.624 292.301 388.984C291.193 388.344 289.766 388.741 289.115 389.869C288.464 390.997 288.834 392.431 289.942 393.07Z"
          fill="#3A2933"
        />
        <path
          d="M279.557 392.523C280.665 393.163 282.092 392.766 282.743 391.638C283.395 390.51 283.024 389.076 281.916 388.437C280.808 387.797 279.382 388.193 278.73 389.321C278.079 390.45 278.449 391.883 279.557 392.523Z"
          fill="#3A2933"
        />
        <path
          d="M285.224 401.242C286.332 401.882 287.758 401.486 288.41 400.358C289.061 399.229 288.691 397.796 287.583 397.156C286.475 396.517 285.048 396.913 284.397 398.041C283.745 399.169 284.116 400.603 285.224 401.242Z"
          fill="#3A2933"
        />
        <path
          d="M280.506 409.414C281.614 410.054 283.04 409.658 283.692 408.53C284.343 407.402 283.973 405.968 282.865 405.328C281.757 404.689 280.33 405.085 279.679 406.213C279.027 407.341 279.397 408.775 280.506 409.414Z"
          fill="#3A2933"
        />
        <path
          d="M274.839 400.695C275.947 401.335 277.374 400.939 278.025 399.81C278.676 398.682 278.306 397.249 277.198 396.609C276.09 395.969 274.664 396.365 274.012 397.493C273.361 398.622 273.731 400.055 274.839 400.695Z"
          fill="#3A2933"
        />
        <path
          d="M270.121 408.867C271.229 409.507 272.655 409.111 273.307 407.982C273.958 406.854 273.588 405.421 272.48 404.781C271.372 404.141 269.945 404.537 269.294 405.665C268.643 406.794 269.013 408.227 270.121 408.867Z"
          fill="#3A2933"
        />
        <path
          d="M275.787 417.587C276.896 418.226 278.322 417.83 278.973 416.702C279.625 415.574 279.255 414.14 278.147 413.5C277.038 412.861 275.612 413.257 274.961 414.385C274.309 415.513 274.679 416.947 275.787 417.587Z"
          fill="#3A2933"
        />
        <path
          d="M265.403 417.039C266.511 417.679 267.937 417.283 268.589 416.154C269.24 415.026 268.87 413.593 267.762 412.953C266.654 412.313 265.227 412.709 264.576 413.838C263.924 414.966 264.295 416.399 265.403 417.039Z"
          fill="#3A2933"
        />
        <path
          d="M271.069 425.759C272.177 426.398 273.604 426.002 274.255 424.874C274.907 423.746 274.536 422.312 273.428 421.673C272.32 421.033 270.894 421.429 270.242 422.557C269.591 423.685 269.961 425.119 271.069 425.759Z"
          fill="#3A2933"
        />
        <path
          d="M260.685 425.211C261.793 425.851 263.219 425.455 263.871 424.326C264.522 423.198 264.152 421.765 263.044 421.125C261.936 420.485 260.509 420.881 259.858 422.01C259.206 423.138 259.577 424.571 260.685 425.211Z"
          fill="#3A2933"
        />
        <path
          d="M266.351 433.931C267.459 434.57 268.886 434.174 269.537 433.046C270.189 431.918 269.818 430.484 268.71 429.845C267.602 429.205 266.176 429.601 265.524 430.729C264.873 431.858 265.243 433.291 266.351 433.931Z"
          fill="#3A2933"
        />
        <path
          d="M261.633 442.103C262.741 442.742 264.168 442.346 264.819 441.218C265.47 440.09 265.1 438.656 263.992 438.017C262.884 437.377 261.458 437.773 260.806 438.901C260.155 440.03 260.525 441.463 261.633 442.103Z"
          fill="#3A2933"
        />
        <path
          d="M255.966 433.383C257.075 434.023 258.501 433.627 259.152 432.498C259.804 431.37 259.434 429.937 258.326 429.297C257.217 428.657 255.791 429.053 255.14 430.182C254.488 431.31 254.858 432.743 255.966 433.383Z"
          fill="#3A2933"
        />
        <path
          d="M251.248 441.555C252.356 442.195 253.783 441.799 254.434 440.671C255.086 439.542 254.716 438.109 253.607 437.469C252.499 436.829 251.073 437.225 250.421 438.354C249.77 439.482 250.14 440.915 251.248 441.555Z"
          fill="#3A2933"
        />
        <path
          d="M256.915 450.275C258.023 450.915 259.449 450.518 260.101 449.39C260.752 448.262 260.382 446.829 259.274 446.189C258.166 445.549 256.739 445.945 256.088 447.073C255.437 448.202 255.807 449.635 256.915 450.275Z"
          fill="#3A2933"
        />
        <path
          d="M246.53 449.727C247.638 450.367 249.065 449.971 249.716 448.843C250.368 447.714 249.997 446.281 248.889 445.641C247.781 445.001 246.355 445.397 245.703 446.526C245.052 447.654 245.422 449.087 246.53 449.727Z"
          fill="#3A2933"
        />
        <path
          d="M252.197 458.447C253.305 459.087 254.731 458.691 255.383 457.562C256.034 456.434 255.664 455.001 254.556 454.361C253.448 453.721 252.021 454.117 251.37 455.245C250.718 456.374 251.089 457.807 252.197 458.447Z"
          fill="#3A2933"
        />
        <path
          d="M241.812 457.899C242.92 458.539 244.347 458.143 244.998 457.015C245.649 455.886 245.279 454.453 244.171 453.813C243.063 453.173 241.637 453.57 240.985 454.698C240.334 455.826 240.704 457.26 241.812 457.899Z"
          fill="#3A2933"
        />
        <path
          d="M247.479 466.619C248.587 467.259 250.013 466.863 250.665 465.734C251.316 464.606 250.946 463.173 249.838 462.533C248.73 461.893 247.303 462.289 246.652 463.417C246 464.546 246.37 465.979 247.479 466.619Z"
          fill="#3A2933"
        />
        <path
          d="M242.76 474.791C243.869 475.431 245.295 475.035 245.946 473.906C246.598 472.778 246.228 471.345 245.12 470.705C244.011 470.065 242.585 470.461 241.934 471.59C241.282 472.718 241.652 474.151 242.76 474.791Z"
          fill="#3A2933"
        />
        <path
          d="M237.094 466.071C238.202 466.711 239.628 466.315 240.28 465.187C240.931 464.058 240.561 462.625 239.453 461.985C238.345 461.346 236.918 461.742 236.267 462.87C235.616 463.998 235.986 465.432 237.094 466.071Z"
          fill="#3A2933"
        />
        <path
          d="M232.376 474.243C233.484 474.883 234.91 474.487 235.562 473.359C236.213 472.23 235.843 470.797 234.735 470.157C233.627 469.518 232.2 469.914 231.549 471.042C230.897 472.17 231.268 473.604 232.376 474.243Z"
          fill="#3A2933"
        />
        <path
          d="M238.042 482.963C239.15 483.603 240.577 483.207 241.228 482.078C241.88 480.95 241.509 479.517 240.401 478.877C239.293 478.237 237.867 478.633 237.215 479.762C236.564 480.89 236.934 482.323 238.042 482.963Z"
          fill="#3A2933"
        />
        <path
          d="M227.658 482.415C228.766 483.055 230.192 482.659 230.844 481.531C231.495 480.403 231.125 478.969 230.017 478.329C228.909 477.69 227.482 478.086 226.831 479.214C226.179 480.342 226.55 481.776 227.658 482.415Z"
          fill="#3A2933"
        />
        <path
          d="M233.324 491.135C234.432 491.775 235.859 491.379 236.51 490.25C237.162 489.122 236.791 487.689 235.683 487.049C234.575 486.409 233.149 486.805 232.497 487.934C231.846 489.062 232.216 490.495 233.324 491.135Z"
          fill="#3A2933"
        />
        <path
          d="M228.606 499.307C229.714 499.947 231.141 499.551 231.792 498.423C232.443 497.294 232.073 495.861 230.965 495.221C229.857 494.581 228.431 494.977 227.779 496.106C227.128 497.234 227.498 498.667 228.606 499.307Z"
          fill="#3A2933"
        />
        <path
          d="M222.939 490.588C224.048 491.227 225.474 490.831 226.125 489.703C226.777 488.575 226.407 487.141 225.299 486.502C224.19 485.862 222.764 486.258 222.113 487.386C221.461 488.514 221.831 489.948 222.939 490.588Z"
          fill="#3A2933"
        />
        <path
          d="M338.072 328.241C339.18 328.881 340.606 328.485 341.258 327.357C341.909 326.228 341.539 324.795 340.431 324.155C339.323 323.516 337.896 323.912 337.245 325.04C336.593 326.168 336.964 327.602 338.072 328.241Z"
          fill="#3A2933"
        />
        <path
          d="M343.738 336.961C344.846 337.601 346.273 337.205 346.924 336.076C347.576 334.948 347.205 333.515 346.097 332.875C344.989 332.235 343.563 332.631 342.911 333.76C342.26 334.888 342.63 336.321 343.738 336.961Z"
          fill="#3A2933"
        />
        <path
          d="M333.354 336.413C334.462 337.053 335.888 336.657 336.54 335.529C337.191 334.4 336.821 332.967 335.713 332.327C334.605 331.688 333.178 332.084 332.527 333.212C331.875 334.34 332.245 335.774 333.354 336.413Z"
          fill="#3A2933"
        />
        <path
          d="M339.02 345.133C340.128 345.773 341.555 345.377 342.206 344.248C342.857 343.12 342.487 341.687 341.379 341.047C340.271 340.407 338.845 340.803 338.193 341.932C337.542 343.06 337.912 344.493 339.02 345.133Z"
          fill="#3A2933"
        />
        <path
          d="M328.635 344.585C329.744 345.225 331.17 344.829 331.821 343.701C332.473 342.573 332.103 341.139 330.994 340.499C329.886 339.86 328.46 340.256 327.809 341.384C327.157 342.512 327.527 343.946 328.635 344.585Z"
          fill="#3A2933"
        />
        <path
          d="M334.302 353.305C335.41 353.945 336.836 353.549 337.488 352.42C338.139 351.292 337.769 349.859 336.661 349.219C335.553 348.579 334.127 348.975 333.475 350.104C332.824 351.232 333.194 352.665 334.302 353.305Z"
          fill="#3A2933"
        />
        <path
          d="M329.584 361.477C330.692 362.117 332.118 361.721 332.77 360.593C333.421 359.464 333.051 358.031 331.943 357.391C330.835 356.751 329.408 357.147 328.757 358.276C328.106 359.404 328.476 360.837 329.584 361.477Z"
          fill="#3A2933"
        />
        <path
          d="M323.917 352.758C325.025 353.397 326.452 353.001 327.103 351.873C327.755 350.745 327.384 349.311 326.276 348.672C325.168 348.032 323.742 348.428 323.09 349.556C322.439 350.684 322.809 352.118 323.917 352.758Z"
          fill="#3A2933"
        />
        <path
          d="M319.199 360.93C320.307 361.569 321.734 361.173 322.385 360.045C323.037 358.917 322.666 357.483 321.558 356.844C320.45 356.204 319.024 356.6 318.372 357.728C317.721 358.857 318.091 360.29 319.199 360.93Z"
          fill="#3A2933"
        />
        <path
          d="M324.866 369.649C325.974 370.289 327.4 369.893 328.052 368.765C328.703 367.636 328.333 366.203 327.225 365.563C326.117 364.923 324.69 365.32 324.039 366.448C323.387 367.576 323.758 369.009 324.866 369.649Z"
          fill="#3A2933"
        />
        <path
          d="M314.481 369.102C315.589 369.741 317.016 369.345 317.667 368.217C318.318 367.089 317.948 365.655 316.84 365.016C315.732 364.376 314.306 364.772 313.654 365.9C313.003 367.029 313.373 368.462 314.481 369.102Z"
          fill="#3A2933"
        />
        <path
          d="M320.148 377.821C321.256 378.461 322.682 378.065 323.333 376.937C323.985 375.808 323.615 374.375 322.507 373.735C321.399 373.096 319.972 373.492 319.321 374.62C318.669 375.748 319.039 377.182 320.148 377.821Z"
          fill="#3A2933"
        />
        <path
          d="M309.763 377.274C310.871 377.914 312.297 377.517 312.949 376.389C313.6 375.261 313.23 373.827 312.122 373.188C311.014 372.548 309.587 372.944 308.936 374.072C308.285 375.201 308.655 376.634 309.763 377.274Z"
          fill="#3A2933"
        />
        <path
          d="M315.429 385.993C316.538 386.633 317.964 386.237 318.615 385.109C319.267 383.98 318.897 382.547 317.788 381.907C316.68 381.268 315.254 381.664 314.603 382.792C313.951 383.92 314.321 385.354 315.429 385.993Z"
          fill="#3A2933"
        />
        <path
          d="M310.711 394.165C311.819 394.805 313.246 394.409 313.897 393.281C314.549 392.152 314.178 390.719 313.07 390.079C311.962 389.44 310.536 389.836 309.884 390.964C309.233 392.092 309.603 393.526 310.711 394.165Z"
          fill="#3A2933"
        />
        <path
          d="M305.045 385.446C306.153 386.086 307.579 385.69 308.231 384.561C308.882 383.433 308.512 382 307.404 381.36C306.296 380.72 304.869 381.116 304.218 382.244C303.566 383.373 303.937 384.806 305.045 385.446Z"
          fill="#3A2933"
        />
        <path
          d="M300.327 393.618C301.435 394.258 302.861 393.862 303.513 392.733C304.164 391.605 303.794 390.172 302.686 389.532C301.578 388.892 300.151 389.288 299.5 390.416C298.848 391.545 299.218 392.978 300.327 393.618Z"
          fill="#3A2933"
        />
        <path
          d="M305.993 402.337C307.101 402.977 308.528 402.581 309.179 401.453C309.83 400.325 309.46 398.891 308.352 398.251C307.244 397.612 305.818 398.008 305.166 399.136C304.515 400.264 304.885 401.698 305.993 402.337Z"
          fill="#3A2933"
        />
        <path
          d="M295.608 401.79C296.717 402.43 298.143 402.034 298.794 400.905C299.446 399.777 299.076 398.344 297.967 397.704C296.859 397.064 295.433 397.46 294.782 398.589C294.13 399.717 294.5 401.15 295.608 401.79Z"
          fill="#3A2933"
        />
        <path
          d="M301.275 410.51C302.383 411.149 303.809 410.753 304.461 409.625C305.112 408.497 304.742 407.063 303.634 406.424C302.526 405.784 301.1 406.18 300.448 407.308C299.797 408.436 300.167 409.87 301.275 410.51Z"
          fill="#3A2933"
        />
        <path
          d="M296.557 418.682C297.665 419.321 299.091 418.925 299.743 417.797C300.394 416.669 300.024 415.235 298.916 414.596C297.808 413.956 296.381 414.352 295.73 415.48C295.079 416.609 295.449 418.042 296.557 418.682Z"
          fill="#3A2933"
        />
        <path
          d="M290.89 409.962C291.998 410.602 293.425 410.206 294.076 409.077C294.728 407.949 294.357 406.516 293.249 405.876C292.141 405.236 290.715 405.632 290.063 406.761C289.412 407.889 289.782 409.322 290.89 409.962Z"
          fill="#3A2933"
        />
        <path
          d="M286.172 418.134C287.28 418.774 288.707 418.378 289.358 417.249C290.01 416.121 289.639 414.688 288.531 414.048C287.423 413.408 285.997 413.804 285.345 414.933C284.694 416.061 285.064 417.494 286.172 418.134Z"
          fill="#3A2933"
        />
        <path
          d="M291.839 426.854C292.947 427.493 294.373 427.097 295.025 425.969C295.676 424.841 295.306 423.407 294.198 422.768C293.09 422.128 291.663 422.524 291.012 423.652C290.36 424.781 290.731 426.214 291.839 426.854Z"
          fill="#3A2933"
        />
        <path
          d="M281.454 426.306C282.562 426.946 283.989 426.55 284.64 425.421C285.291 424.293 284.921 422.86 283.813 422.22C282.705 421.58 281.279 421.976 280.627 423.105C279.976 424.233 280.346 425.666 281.454 426.306Z"
          fill="#3A2933"
        />
        <path
          d="M287.121 435.026C288.229 435.666 289.655 435.269 290.306 434.141C290.958 433.013 290.588 431.579 289.48 430.94C288.372 430.3 286.945 430.696 286.294 431.824C285.642 432.953 286.012 434.386 287.121 435.026Z"
          fill="#3A2933"
        />
        <path
          d="M276.736 434.478C277.844 435.118 279.27 434.722 279.922 433.594C280.573 432.465 280.203 431.032 279.095 430.392C277.987 429.752 276.56 430.148 275.909 431.277C275.258 432.405 275.628 433.838 276.736 434.478Z"
          fill="#3A2933"
        />
        <path
          d="M282.402 443.198C283.511 443.838 284.937 443.442 285.588 442.313C286.24 441.185 285.87 439.752 284.761 439.112C283.653 438.472 282.227 438.868 281.576 439.996C280.924 441.125 281.294 442.558 282.402 443.198Z"
          fill="#3A2933"
        />
        <path
          d="M277.684 451.37C278.792 452.01 280.219 451.614 280.87 450.485C281.522 449.357 281.151 447.924 280.043 447.284C278.935 446.644 277.509 447.04 276.857 448.168C276.206 449.297 276.576 450.73 277.684 451.37Z"
          fill="#3A2933"
        />
        <path
          d="M272.018 442.65C273.126 443.29 274.552 442.894 275.204 441.766C275.855 440.637 275.485 439.204 274.377 438.564C273.269 437.924 271.842 438.321 271.191 439.449C270.539 440.577 270.91 442.01 272.018 442.65Z"
          fill="#3A2933"
        />
        <path
          d="M267.3 450.822C268.408 451.462 269.834 451.066 270.486 449.938C271.137 448.809 270.767 447.376 269.659 446.736C268.551 446.097 267.124 446.493 266.473 447.621C265.821 448.749 266.191 450.183 267.3 450.822Z"
          fill="#3A2933"
        />
        <path
          d="M272.966 459.542C274.074 460.182 275.501 459.786 276.152 458.657C276.803 457.529 276.433 456.096 275.325 455.456C274.217 454.816 272.791 455.212 272.139 456.341C271.488 457.469 271.858 458.902 272.966 459.542Z"
          fill="#3A2933"
        />
        <path
          d="M262.581 458.994C263.69 459.634 265.116 459.238 265.767 458.11C266.419 456.981 266.049 455.548 264.94 454.908C263.832 454.269 262.406 454.665 261.755 455.793C261.103 456.921 261.473 458.355 262.581 458.994Z"
          fill="#3A2933"
        />
        <path
          d="M268.248 467.714C269.356 468.354 270.782 467.958 271.434 466.829C272.085 465.701 271.715 464.268 270.607 463.628C269.499 462.988 268.073 463.384 267.421 464.513C266.77 465.641 267.14 467.074 268.248 467.714Z"
          fill="#3A2933"
        />
        <path
          d="M257.863 467.166C258.971 467.806 260.398 467.41 261.049 466.282C261.701 465.154 261.33 463.72 260.222 463.08C259.114 462.441 257.688 462.837 257.036 463.965C256.385 465.093 256.755 466.527 257.863 467.166Z"
          fill="#3A2933"
        />
        <path
          d="M263.53 475.886C264.638 476.526 266.064 476.13 266.716 475.001C267.367 473.873 266.997 472.44 265.889 471.8C264.781 471.16 263.354 471.556 262.703 472.685C262.052 473.813 262.422 475.246 263.53 475.886Z"
          fill="#3A2933"
        />
        <path
          d="M258.812 484.058C259.92 484.698 261.346 484.302 261.998 483.174C262.649 482.045 262.279 480.612 261.171 479.972C260.063 479.332 258.636 479.728 257.985 480.857C257.333 481.985 257.704 483.418 258.812 484.058Z"
          fill="#3A2933"
        />
        <path
          d="M253.145 475.339C254.253 475.978 255.68 475.582 256.331 474.454C256.983 473.326 256.612 471.892 255.504 471.252C254.396 470.613 252.97 471.009 252.318 472.137C251.667 473.265 252.037 474.699 253.145 475.339Z"
          fill="#3A2933"
        />
        <path
          d="M248.427 483.511C249.535 484.15 250.962 483.754 251.613 482.626C252.264 481.498 251.894 480.064 250.786 479.425C249.678 478.785 248.252 479.181 247.6 480.309C246.949 481.437 247.319 482.871 248.427 483.511Z"
          fill="#3A2933"
        />
        <path
          d="M254.094 492.23C255.202 492.87 256.628 492.474 257.279 491.346C257.931 490.217 257.561 488.784 256.453 488.144C255.344 487.504 253.918 487.9 253.267 489.029C252.615 490.157 252.985 491.59 254.094 492.23Z"
          fill="#3A2933"
        />
        <path
          d="M243.709 491.683C244.817 492.322 246.243 491.926 246.895 490.798C247.546 489.67 247.176 488.236 246.068 487.597C244.96 486.957 243.533 487.353 242.882 488.481C242.231 489.61 242.601 491.043 243.709 491.683Z"
          fill="#3A2933"
        />
        <path
          d="M249.375 500.402C250.483 501.042 251.91 500.646 252.561 499.518C253.213 498.389 252.843 496.956 251.734 496.316C250.626 495.676 249.2 496.073 248.549 497.201C247.897 498.329 248.267 499.763 249.375 500.402Z"
          fill="#3A2933"
        />
        <path
          d="M244.657 508.574C245.765 509.214 247.192 508.818 247.843 507.69C248.495 506.561 248.124 505.128 247.016 504.488C245.908 503.849 244.482 504.245 243.83 505.373C243.179 506.501 243.549 507.935 244.657 508.574Z"
          fill="#3A2933"
        />
        <path
          d="M238.991 499.855C240.099 500.495 241.525 500.098 242.177 498.97C242.828 497.842 242.458 496.408 241.35 495.769C240.242 495.129 238.815 495.525 238.164 496.653C237.512 497.782 237.883 499.215 238.991 499.855Z"
          fill="#3A2933"
        />
        <path
          d="M354.123 337.509C355.231 338.148 356.657 337.752 357.309 336.624C357.96 335.496 357.59 334.062 356.482 333.423C355.374 332.783 353.948 333.179 353.296 334.307C352.645 335.435 353.015 336.869 354.123 337.509Z"
          fill="#3A2933"
        />
        <path
          d="M359.789 346.228C360.898 346.868 362.324 346.472 362.975 345.344C363.627 344.215 363.257 342.782 362.149 342.142C361.04 341.502 359.614 341.898 358.963 343.027C358.311 344.155 358.681 345.588 359.789 346.228Z"
          fill="#3A2933"
        />
        <path
          d="M349.405 345.681C350.513 346.32 351.939 345.924 352.591 344.796C353.242 343.668 352.872 342.234 351.764 341.595C350.656 340.955 349.229 341.351 348.578 342.479C347.927 343.608 348.297 345.041 349.405 345.681Z"
          fill="#3A2933"
        />
        <path
          d="M355.071 354.4C356.179 355.04 357.606 354.644 358.257 353.516C358.909 352.387 358.539 350.954 357.43 350.314C356.322 349.674 354.896 350.07 354.244 351.199C353.593 352.327 353.963 353.76 355.071 354.4Z"
          fill="#3A2933"
        />
        <path
          d="M344.687 353.853C345.795 354.492 347.221 354.096 347.873 352.968C348.524 351.84 348.154 350.406 347.046 349.767C345.938 349.127 344.511 349.523 343.86 350.651C343.208 351.78 343.579 353.213 344.687 353.853Z"
          fill="#3A2933"
        />
        <path
          d="M350.353 362.572C351.461 363.212 352.888 362.816 353.539 361.688C354.191 360.559 353.82 359.126 352.712 358.486C351.604 357.846 350.178 358.243 349.526 359.371C348.875 360.499 349.245 361.933 350.353 362.572Z"
          fill="#3A2933"
        />
        <path
          d="M345.635 370.744C346.743 371.384 348.17 370.988 348.821 369.86C349.472 368.731 349.102 367.298 347.994 366.658C346.886 366.019 345.46 366.415 344.808 367.543C344.157 368.671 344.527 370.105 345.635 370.744Z"
          fill="#3A2933"
        />
        <path
          d="M339.969 362.025C341.077 362.664 342.503 362.268 343.154 361.14C343.806 360.012 343.436 358.578 342.328 357.939C341.22 357.299 339.793 357.695 339.142 358.823C338.49 359.952 338.86 361.385 339.969 362.025Z"
          fill="#3A2933"
        />
        <path
          d="M335.25 370.197C336.359 370.837 337.785 370.44 338.436 369.312C339.088 368.184 338.718 366.751 337.609 366.111C336.501 365.471 335.075 365.867 334.424 366.995C333.772 368.124 334.142 369.557 335.25 370.197Z"
          fill="#3A2933"
        />
        <path
          d="M340.917 378.916C342.025 379.556 343.451 379.16 344.103 378.032C344.754 376.903 344.384 375.47 343.276 374.83C342.168 374.191 340.741 374.587 340.09 375.715C339.439 376.843 339.809 378.277 340.917 378.916Z"
          fill="#3A2933"
        />
        <path
          d="M330.532 378.369C331.64 379.009 333.067 378.613 333.718 377.484C334.37 376.356 333.999 374.923 332.891 374.283C331.783 373.643 330.357 374.039 329.705 375.167C329.054 376.296 329.424 377.729 330.532 378.369Z"
          fill="#3A2933"
        />
        <path
          d="M336.199 387.088C337.307 387.728 338.733 387.332 339.385 386.204C340.036 385.076 339.666 383.642 338.558 383.002C337.45 382.363 336.023 382.759 335.372 383.887C334.72 385.015 335.091 386.449 336.199 387.088Z"
          fill="#3A2933"
        />
        <path
          d="M325.814 386.541C326.922 387.181 328.349 386.785 329 385.656C329.651 384.528 329.281 383.095 328.173 382.455C327.065 381.815 325.639 382.211 324.987 383.34C324.336 384.468 324.706 385.901 325.814 386.541Z"
          fill="#3A2933"
        />
        <path
          d="M331.481 395.261C332.589 395.9 334.015 395.504 334.667 394.376C335.318 393.248 334.948 391.814 333.84 391.175C332.732 390.535 331.305 390.931 330.654 392.059C330.002 393.187 330.373 394.621 331.481 395.261Z"
          fill="#3A2933"
        />
        <path
          d="M326.762 403.433C327.871 404.072 329.297 403.676 329.948 402.548C330.6 401.42 330.23 399.986 329.122 399.347C328.013 398.707 326.587 399.103 325.936 400.231C325.284 401.36 325.654 402.793 326.762 403.433Z"
          fill="#3A2933"
        />
        <path
          d="M321.096 394.713C322.204 395.353 323.63 394.957 324.282 393.828C324.933 392.7 324.563 391.267 323.455 390.627C322.347 389.987 320.921 390.383 320.269 391.512C319.618 392.64 319.988 394.073 321.096 394.713Z"
          fill="#3A2933"
        />
        <path
          d="M316.378 402.885C317.486 403.525 318.912 403.129 319.564 402C320.215 400.872 319.845 399.439 318.737 398.799C317.629 398.159 316.202 398.555 315.551 399.684C314.9 400.812 315.27 402.245 316.378 402.885Z"
          fill="#3A2933"
        />
        <path
          d="M322.044 411.605C323.152 412.244 324.579 411.848 325.23 410.72C325.882 409.592 325.512 408.158 324.403 407.519C323.295 406.879 321.869 407.275 321.217 408.403C320.566 409.532 320.936 410.965 322.044 411.605Z"
          fill="#3A2933"
        />
        <path
          d="M311.66 411.057C312.768 411.697 314.194 411.301 314.846 410.173C315.497 409.044 315.127 407.611 314.019 406.971C312.911 406.331 311.484 406.727 310.833 407.856C310.181 408.984 310.552 410.417 311.66 411.057Z"
          fill="#3A2933"
        />
        <path
          d="M317.326 419.777C318.434 420.417 319.861 420.02 320.512 418.892C321.164 417.764 320.793 416.33 319.685 415.691C318.577 415.051 317.151 415.447 316.499 416.575C315.848 417.704 316.218 419.137 317.326 419.777Z"
          fill="#3A2933"
        />
        <path
          d="M312.608 427.949C313.716 428.589 315.143 428.193 315.794 427.064C316.445 425.936 316.075 424.503 314.967 423.863C313.859 423.223 312.433 423.619 311.781 424.747C311.13 425.876 311.5 427.309 312.608 427.949Z"
          fill="#3A2933"
        />
        <path
          d="M306.942 419.229C308.05 419.869 309.476 419.473 310.127 418.345C310.779 417.216 310.409 415.783 309.301 415.143C308.193 414.503 306.766 414.899 306.115 416.028C305.463 417.156 305.833 418.589 306.942 419.229Z"
          fill="#3A2933"
        />
        <path
          d="M302.223 427.401C303.331 428.041 304.758 427.645 305.409 426.517C306.061 425.388 305.691 423.955 304.582 423.315C303.474 422.675 302.048 423.072 301.397 424.2C300.745 425.328 301.115 426.762 302.223 427.401Z"
          fill="#3A2933"
        />
        <path
          d="M307.89 436.121C308.998 436.761 310.424 436.365 311.076 435.236C311.727 434.108 311.357 432.675 310.249 432.035C309.141 431.395 307.714 431.791 307.063 432.919C306.412 434.048 306.782 435.481 307.89 436.121Z"
          fill="#3A2933"
        />
        <path
          d="M297.505 435.573C298.613 436.213 300.04 435.817 300.691 434.689C301.343 433.56 300.972 432.127 299.864 431.487C298.756 430.848 297.33 431.244 296.678 432.372C296.027 433.5 296.397 434.934 297.505 435.573Z"
          fill="#3A2933"
        />
        <path
          d="M303.172 444.293C304.28 444.933 305.706 444.537 306.358 443.408C307.009 442.28 306.639 440.847 305.531 440.207C304.423 439.567 302.996 439.963 302.345 441.091C301.693 442.22 302.064 443.653 303.172 444.293Z"
          fill="#3A2933"
        />
        <path
          d="M292.787 443.745C293.895 444.385 295.322 443.989 295.973 442.861C296.624 441.732 296.254 440.299 295.146 439.659C294.038 439.02 292.612 439.416 291.96 440.544C291.309 441.672 291.679 443.106 292.787 443.745Z"
          fill="#3A2933"
        />
        <path
          d="M298.454 452.465C299.562 453.105 300.988 452.709 301.64 451.58C302.291 450.452 301.921 449.019 300.813 448.379C299.705 447.739 298.278 448.135 297.627 449.264C296.975 450.392 297.346 451.825 298.454 452.465Z"
          fill="#3A2933"
        />
        <path
          d="M293.735 460.637C294.844 461.277 296.27 460.881 296.921 459.752C297.573 458.624 297.203 457.191 296.095 456.551C294.986 455.911 293.56 456.307 292.909 457.436C292.257 458.564 292.627 459.997 293.735 460.637Z"
          fill="#3A2933"
        />
        <path
          d="M288.069 451.917C289.177 452.557 290.603 452.161 291.255 451.033C291.906 449.904 291.536 448.471 290.428 447.831C289.32 447.192 287.894 447.588 287.242 448.716C286.591 449.844 286.961 451.278 288.069 451.917Z"
          fill="#3A2933"
        />
        <path
          d="M283.351 460.09C284.459 460.729 285.885 460.333 286.537 459.205C287.188 458.077 286.818 456.643 285.71 456.003C284.602 455.364 283.175 455.76 282.524 456.888C281.872 458.016 282.243 459.45 283.351 460.09Z"
          fill="#3A2933"
        />
        <path
          d="M289.017 468.809C290.125 469.449 291.552 469.053 292.203 467.925C292.855 466.796 292.485 465.363 291.376 464.723C290.268 464.083 288.842 464.479 288.19 465.608C287.539 466.736 287.909 468.169 289.017 468.809Z"
          fill="#3A2933"
        />
        <path
          d="M278.633 468.262C279.741 468.901 281.167 468.505 281.819 467.377C282.47 466.249 282.1 464.815 280.992 464.176C279.884 463.536 278.457 463.932 277.806 465.06C277.154 466.189 277.525 467.622 278.633 468.262Z"
          fill="#3A2933"
        />
        <path
          d="M284.299 476.981C285.407 477.621 286.834 477.225 287.485 476.097C288.137 474.968 287.766 473.535 286.658 472.895C285.55 472.255 284.124 472.651 283.472 473.78C282.821 474.908 283.191 476.341 284.299 476.981Z"
          fill="#3A2933"
        />
        <path
          d="M273.915 476.434C275.023 477.073 276.449 476.677 277.1 475.549C277.752 474.421 277.382 472.987 276.274 472.348C275.165 471.708 273.739 472.104 273.088 473.232C272.436 474.361 272.806 475.794 273.915 476.434Z"
          fill="#3A2933"
        />
        <path
          d="M279.581 485.153C280.689 485.793 282.116 485.397 282.767 484.269C283.418 483.14 283.048 481.707 281.94 481.067C280.832 480.427 279.406 480.824 278.754 481.952C278.103 483.08 278.473 484.513 279.581 485.153Z"
          fill="#3A2933"
        />
        <path
          d="M274.863 493.325C275.971 493.965 277.397 493.569 278.049 492.441C278.7 491.312 278.33 489.879 277.222 489.239C276.114 488.6 274.687 488.996 274.036 490.124C273.385 491.252 273.755 492.686 274.863 493.325Z"
          fill="#3A2933"
        />
        <path
          d="M269.196 484.606C270.304 485.245 271.731 484.849 272.382 483.721C273.034 482.593 272.664 481.159 271.555 480.52C270.447 479.88 269.021 480.276 268.37 481.404C267.718 482.533 268.088 483.966 269.196 484.606Z"
          fill="#3A2933"
        />
        <path
          d="M264.478 492.778C265.586 493.418 267.013 493.021 267.664 491.893C268.316 490.765 267.945 489.332 266.837 488.692C265.729 488.052 264.303 488.448 263.651 489.576C263 490.705 263.37 492.138 264.478 492.778Z"
          fill="#3A2933"
        />
        <path
          d="M270.145 501.497C271.253 502.137 272.679 501.741 273.331 500.613C273.982 499.484 273.612 498.051 272.504 497.411C271.396 496.772 269.969 497.168 269.318 498.296C268.666 499.424 269.037 500.858 270.145 501.497Z"
          fill="#3A2933"
        />
        <path
          d="M259.76 500.95C260.868 501.59 262.295 501.194 262.946 500.065C263.597 498.937 263.227 497.504 262.119 496.864C261.011 496.224 259.585 496.62 258.933 497.748C258.282 498.877 258.652 500.31 259.76 500.95Z"
          fill="#3A2933"
        />
        <path
          d="M265.427 509.669C266.535 510.309 267.961 509.913 268.613 508.785C269.264 507.656 268.894 506.223 267.786 505.583C266.678 504.944 265.251 505.34 264.6 506.468C263.948 507.596 264.319 509.03 265.427 509.669Z"
          fill="#3A2933"
        />
        <path
          d="M260.708 517.842C261.817 518.481 263.243 518.085 263.894 516.957C264.546 515.829 264.176 514.395 263.068 513.756C261.959 513.116 260.533 513.512 259.882 514.64C259.23 515.768 259.6 517.202 260.708 517.842Z"
          fill="#3A2933"
        />
        <path
          d="M255.042 509.122C256.15 509.762 257.576 509.366 258.228 508.237C258.879 507.109 258.509 505.676 257.401 505.036C256.293 504.396 254.867 504.792 254.215 505.92C253.564 507.049 253.934 508.482 255.042 509.122Z"
          fill="#3A2933"
        />
        <path
          d="M370.174 346.776C371.282 347.415 372.709 347.019 373.36 345.891C374.012 344.763 373.641 343.329 372.533 342.69C371.425 342.05 369.999 342.446 369.347 343.574C368.696 344.703 369.066 346.136 370.174 346.776Z"
          fill="#3A2933"
        />
        <path
          d="M375.841 355.495C376.949 356.135 378.375 355.739 379.027 354.611C379.678 353.482 379.308 352.049 378.2 351.409C377.092 350.77 375.665 351.166 375.014 352.294C374.362 353.422 374.733 354.856 375.841 355.495Z"
          fill="#3A2933"
        />
        <path
          d="M365.456 354.948C366.564 355.588 367.991 355.191 368.642 354.063C369.293 352.935 368.923 351.502 367.815 350.862C366.707 350.222 365.281 350.618 364.629 351.746C363.978 352.875 364.348 354.308 365.456 354.948Z"
          fill="#3A2933"
        />
        <path
          d="M371.123 363.667C372.231 364.307 373.657 363.911 374.309 362.783C374.96 361.654 374.59 360.221 373.482 359.581C372.374 358.942 370.947 359.338 370.296 360.466C369.644 361.594 370.014 363.028 371.123 363.667Z"
          fill="#3A2933"
        />
        <path
          d="M360.738 363.12C361.846 363.76 363.272 363.364 363.924 362.235C364.575 361.107 364.205 359.674 363.097 359.034C361.989 358.394 360.562 358.79 359.911 359.918C359.26 361.047 359.63 362.48 360.738 363.12Z"
          fill="#3A2933"
        />
        <path
          d="M366.404 371.839C367.513 372.479 368.939 372.083 369.59 370.955C370.242 369.827 369.872 368.393 368.764 367.753C367.655 367.114 366.229 367.51 365.578 368.638C364.926 369.766 365.296 371.2 366.404 371.839Z"
          fill="#3A2933"
        />
        <path
          d="M361.686 380.012C362.794 380.651 364.221 380.255 364.872 379.127C365.524 377.999 365.153 376.565 364.045 375.925C362.937 375.286 361.511 375.682 360.859 376.81C360.208 377.938 360.578 379.372 361.686 380.012Z"
          fill="#3A2933"
        />
        <path
          d="M356.02 371.292C357.128 371.932 358.554 371.536 359.206 370.407C359.857 369.279 359.487 367.846 358.379 367.206C357.271 366.566 355.844 366.962 355.193 368.09C354.541 369.219 354.912 370.652 356.02 371.292Z"
          fill="#3A2933"
        />
        <path
          d="M351.302 379.464C352.41 380.104 353.836 379.708 354.488 378.579C355.139 377.451 354.769 376.018 353.661 375.378C352.553 374.738 351.126 375.134 350.475 376.263C349.823 377.391 350.193 378.824 351.302 379.464Z"
          fill="#3A2933"
        />
        <path
          d="M356.968 388.184C358.076 388.823 359.503 388.427 360.154 387.299C360.806 386.171 360.435 384.737 359.327 384.098C358.219 383.458 356.793 383.854 356.141 384.982C355.49 386.111 355.86 387.544 356.968 388.184Z"
          fill="#3A2933"
        />
        <path
          d="M346.583 387.636C347.692 388.276 349.118 387.88 349.769 386.751C350.421 385.623 350.051 384.19 348.943 383.55C347.834 382.91 346.408 383.306 345.757 384.435C345.105 385.563 345.475 386.996 346.583 387.636Z"
          fill="#3A2933"
        />
        <path
          d="M352.25 396.356C353.358 396.995 354.785 396.599 355.436 395.471C356.087 394.343 355.717 392.909 354.609 392.27C353.501 391.63 352.075 392.026 351.423 393.154C350.772 394.283 351.142 395.716 352.25 396.356Z"
          fill="#3A2933"
        />
        <path
          d="M341.865 395.808C342.973 396.448 344.4 396.052 345.051 394.923C345.703 393.795 345.332 392.362 344.224 391.722C343.116 391.082 341.69 391.478 341.038 392.607C340.387 393.735 340.757 395.168 341.865 395.808Z"
          fill="#3A2933"
        />
        <path
          d="M347.532 404.528C348.64 405.167 350.066 404.771 350.718 403.643C351.369 402.515 350.999 401.081 349.891 400.442C348.783 399.802 347.356 400.198 346.705 401.326C346.054 402.455 346.424 403.888 347.532 404.528Z"
          fill="#3A2933"
        />
        <path
          d="M342.814 412.7C343.922 413.34 345.348 412.943 346 411.815C346.651 410.687 346.281 409.254 345.173 408.614C344.065 407.974 342.638 408.37 341.987 409.498C341.335 410.627 341.706 412.06 342.814 412.7Z"
          fill="#3A2933"
        />
        <path
          d="M337.147 403.98C338.255 404.62 339.682 404.224 340.333 403.096C340.985 401.967 340.614 400.534 339.506 399.894C338.398 399.254 336.972 399.65 336.32 400.779C335.669 401.907 336.039 403.34 337.147 403.98Z"
          fill="#3A2933"
        />
        <path
          d="M332.429 412.152C333.537 412.792 334.964 412.396 335.615 411.268C336.266 410.139 335.896 408.706 334.788 408.066C333.68 407.426 332.254 407.822 331.602 408.951C330.951 410.079 331.321 411.512 332.429 412.152Z"
          fill="#3A2933"
        />
        <path
          d="M338.096 420.872C339.204 421.512 340.63 421.116 341.282 419.987C341.933 418.859 341.563 417.426 340.455 416.786C339.347 416.146 337.92 416.542 337.269 417.67C336.617 418.799 336.987 420.232 338.096 420.872Z"
          fill="#3A2933"
        />
        <path
          d="M327.711 420.324C328.819 420.964 330.245 420.568 330.897 419.44C331.548 418.311 331.178 416.878 330.07 416.238C328.962 415.599 327.535 415.995 326.884 417.123C326.233 418.251 326.603 419.685 327.711 420.324Z"
          fill="#3A2933"
        />
        <path
          d="M333.377 429.044C334.486 429.684 335.912 429.288 336.563 428.159C337.215 427.031 336.845 425.598 335.736 424.958C334.628 424.318 333.202 424.714 332.551 425.842C331.899 426.971 332.269 428.404 333.377 429.044Z"
          fill="#3A2933"
        />
        <path
          d="M328.659 437.216C329.767 437.856 331.194 437.46 331.845 436.331C332.497 435.203 332.126 433.77 331.018 433.13C329.91 432.49 328.484 432.886 327.832 434.015C327.181 435.143 327.551 436.576 328.659 437.216Z"
          fill="#3A2933"
        />
        <path
          d="M322.993 428.496C324.101 429.136 325.527 428.74 326.179 427.612C326.83 426.483 326.46 425.05 325.352 424.41C324.244 423.771 322.817 424.167 322.166 425.295C321.514 426.423 321.885 427.857 322.993 428.496Z"
          fill="#3A2933"
        />
        <path
          d="M318.275 436.668C319.383 437.308 320.809 436.912 321.461 435.784C322.112 434.655 321.742 433.222 320.634 432.582C319.526 431.943 318.099 432.339 317.448 433.467C316.796 434.595 317.166 436.029 318.275 436.668Z"
          fill="#3A2933"
        />
        <path
          d="M323.941 445.388C325.049 446.028 326.476 445.632 327.127 444.503C327.779 443.375 327.408 441.942 326.3 441.302C325.192 440.662 323.766 441.058 323.114 442.187C322.463 443.315 322.833 444.748 323.941 445.388Z"
          fill="#3A2933"
        />
        <path
          d="M313.556 444.84C314.665 445.48 316.091 445.084 316.742 443.956C317.394 442.828 317.024 441.394 315.916 440.754C314.807 440.115 313.381 440.511 312.73 441.639C312.078 442.767 312.448 444.201 313.556 444.84Z"
          fill="#3A2933"
        />
        <path
          d="M319.223 453.56C320.331 454.2 321.758 453.804 322.409 452.675C323.06 451.547 322.69 450.114 321.582 449.474C320.474 448.834 319.048 449.23 318.396 450.359C317.745 451.487 318.115 452.92 319.223 453.56Z"
          fill="#3A2933"
        />
        <path
          d="M308.838 453.013C309.946 453.652 311.373 453.256 312.024 452.128C312.676 451 312.305 449.566 311.197 448.927C310.089 448.287 308.663 448.683 308.011 449.811C307.36 450.939 307.73 452.373 308.838 453.013Z"
          fill="#3A2933"
        />
        <path
          d="M314.505 461.732C315.613 462.372 317.039 461.976 317.691 460.848C318.342 459.719 317.972 458.286 316.864 457.646C315.756 457.006 314.329 457.402 313.678 458.531C313.027 459.659 313.397 461.092 314.505 461.732Z"
          fill="#3A2933"
        />
        <path
          d="M309.787 469.904C310.895 470.544 312.321 470.148 312.973 469.02C313.624 467.891 313.254 466.458 312.146 465.818C311.038 465.178 309.611 465.574 308.96 466.703C308.308 467.831 308.679 469.264 309.787 469.904Z"
          fill="#3A2933"
        />
        <path
          d="M304.12 461.185C305.228 461.824 306.655 461.428 307.306 460.3C307.958 459.172 307.587 457.738 306.479 457.099C305.371 456.459 303.945 456.855 303.293 457.983C302.642 459.112 303.012 460.545 304.12 461.185Z"
          fill="#3A2933"
        />
        <path
          d="M299.402 469.357C300.51 469.996 301.937 469.6 302.588 468.472C303.239 467.344 302.869 465.91 301.761 465.271C300.653 464.631 299.227 465.027 298.575 466.155C297.924 467.284 298.294 468.717 299.402 469.357Z"
          fill="#3A2933"
        />
        <path
          d="M305.069 478.076C306.177 478.716 307.603 478.32 308.255 477.192C308.906 476.063 308.536 474.63 307.428 473.99C306.32 473.351 304.893 473.747 304.242 474.875C303.59 476.003 303.96 477.437 305.069 478.076Z"
          fill="#3A2933"
        />
        <path
          d="M294.684 477.529C295.792 478.169 297.218 477.772 297.87 476.644C298.521 475.516 298.151 474.082 297.043 473.443C295.935 472.803 294.508 473.199 293.857 474.327C293.206 475.456 293.576 476.889 294.684 477.529Z"
          fill="#3A2933"
        />
        <path
          d="M300.35 486.248C301.459 486.888 302.885 486.492 303.536 485.364C304.188 484.235 303.818 482.802 302.709 482.162C301.601 481.523 300.175 481.919 299.524 483.047C298.872 484.175 299.242 485.609 300.35 486.248Z"
          fill="#3A2933"
        />
        <path
          d="M289.966 485.701C291.074 486.341 292.5 485.945 293.152 484.816C293.803 483.688 293.433 482.255 292.325 481.615C291.217 480.975 289.79 481.371 289.139 482.499C288.487 483.628 288.858 485.061 289.966 485.701Z"
          fill="#3A2933"
        />
        <path
          d="M295.632 494.42C296.74 495.06 298.167 494.664 298.818 493.536C299.47 492.407 299.099 490.974 297.991 490.334C296.883 489.695 295.457 490.091 294.805 491.219C294.154 492.347 294.524 493.781 295.632 494.42Z"
          fill="#3A2933"
        />
        <path
          d="M290.914 502.592C292.022 503.232 293.449 502.836 294.1 501.708C294.752 500.58 294.381 499.146 293.273 498.506C292.165 497.867 290.739 498.263 290.087 499.391C289.436 500.519 289.806 501.953 290.914 502.592Z"
          fill="#3A2933"
        />
        <path
          d="M285.248 493.873C286.356 494.513 287.782 494.117 288.434 492.988C289.085 491.86 288.715 490.427 287.607 489.787C286.499 489.147 285.072 489.543 284.421 490.671C283.769 491.8 284.139 493.233 285.248 493.873Z"
          fill="#3A2933"
        />
        <path
          d="M280.529 502.045C281.638 502.685 283.064 502.289 283.715 501.16C284.367 500.032 283.997 498.599 282.889 497.959C281.78 497.319 280.354 497.715 279.703 498.844C279.051 499.972 279.421 501.405 280.529 502.045Z"
          fill="#3A2933"
        />
        <path
          d="M286.196 510.765C287.304 511.404 288.73 511.008 289.382 509.88C290.033 508.752 289.663 507.318 288.555 506.679C287.447 506.039 286.021 506.435 285.369 507.563C284.718 508.691 285.088 510.125 286.196 510.765Z"
          fill="#3A2933"
        />
        <path
          d="M275.811 510.217C276.919 510.857 278.346 510.461 278.997 509.332C279.649 508.204 279.278 506.771 278.17 506.131C277.062 505.491 275.636 505.887 274.984 507.016C274.333 508.144 274.703 509.577 275.811 510.217Z"
          fill="#3A2933"
        />
        <path
          d="M281.478 518.937C282.586 519.576 284.012 519.18 284.664 518.052C285.315 516.924 284.945 515.49 283.837 514.851C282.729 514.211 281.302 514.607 280.651 515.735C280 516.864 280.37 518.297 281.478 518.937Z"
          fill="#3A2933"
        />
        <path
          d="M276.76 527.109C277.868 527.748 279.294 527.352 279.946 526.224C280.597 525.096 280.227 523.662 279.119 523.023C278.011 522.383 276.584 522.779 275.933 523.907C275.281 525.036 275.652 526.469 276.76 527.109Z"
          fill="#3A2933"
        />
        <path
          d="M271.093 518.389C272.201 519.029 273.628 518.633 274.279 517.504C274.931 516.376 274.56 514.943 273.452 514.303C272.344 513.663 270.918 514.059 270.266 515.188C269.615 516.316 269.985 517.749 271.093 518.389Z"
          fill="#3A2933"
        />
        <path
          d="M386.225 356.043C387.334 356.683 388.76 356.287 389.411 355.158C390.063 354.03 389.693 352.597 388.584 351.957C387.476 351.317 386.05 351.713 385.399 352.841C384.747 353.97 385.117 355.403 386.225 356.043Z"
          fill="#3A2933"
        />
        <path
          d="M391.892 364.763C393 365.402 394.426 365.006 395.078 363.878C395.729 362.75 395.359 361.316 394.251 360.676C393.143 360.037 391.717 360.433 391.065 361.561C390.414 362.689 390.784 364.123 391.892 364.763Z"
          fill="#3A2933"
        />
        <path
          d="M381.507 364.215C382.615 364.855 384.042 364.459 384.693 363.33C385.345 362.202 384.974 360.769 383.866 360.129C382.758 359.489 381.332 359.885 380.68 361.014C380.029 362.142 380.399 363.575 381.507 364.215Z"
          fill="#3A2933"
        />
        <path
          d="M387.174 372.935C388.282 373.574 389.708 373.178 390.36 372.05C391.011 370.922 390.641 369.488 389.533 368.849C388.425 368.209 386.998 368.605 386.347 369.733C385.695 370.861 386.066 372.295 387.174 372.935Z"
          fill="#3A2933"
        />
        <path
          d="M376.789 372.387C377.897 373.027 379.324 372.631 379.975 371.502C380.627 370.374 380.256 368.941 379.148 368.301C378.04 367.661 376.614 368.057 375.962 369.186C375.311 370.314 375.681 371.747 376.789 372.387Z"
          fill="#3A2933"
        />
        <path
          d="M382.456 381.107C383.564 381.746 384.99 381.35 385.642 380.222C386.293 379.094 385.923 377.66 384.815 377.021C383.707 376.381 382.28 376.777 381.629 377.905C380.977 379.034 381.348 380.467 382.456 381.107Z"
          fill="#3A2933"
        />
        <path
          d="M377.738 389.279C378.846 389.918 380.272 389.522 380.923 388.394C381.575 387.266 381.205 385.832 380.097 385.193C378.988 384.553 377.562 384.949 376.911 386.077C376.259 387.206 376.629 388.639 377.738 389.279Z"
          fill="#3A2933"
        />
        <path
          d="M372.071 380.559C373.179 381.199 374.605 380.803 375.257 379.674C375.908 378.546 375.538 377.113 374.43 376.473C373.322 375.833 371.896 376.229 371.244 377.358C370.593 378.486 370.963 379.919 372.071 380.559Z"
          fill="#3A2933"
        />
        <path
          d="M367.353 388.731C368.461 389.371 369.887 388.975 370.539 387.847C371.19 386.718 370.82 385.285 369.712 384.645C368.604 384.005 367.177 384.401 366.526 385.53C365.875 386.658 366.245 388.091 367.353 388.731Z"
          fill="#3A2933"
        />
        <path
          d="M373.019 397.451C374.127 398.091 375.554 397.694 376.205 396.566C376.857 395.438 376.487 394.005 375.378 393.365C374.27 392.725 372.844 393.121 372.192 394.249C371.541 395.378 371.911 396.811 373.019 397.451Z"
          fill="#3A2933"
        />
        <path
          d="M362.635 396.903C363.743 397.543 365.169 397.147 365.821 396.019C366.472 394.89 366.102 393.457 364.994 392.817C363.886 392.177 362.459 392.573 361.808 393.702C361.156 394.83 361.527 396.263 362.635 396.903Z"
          fill="#3A2933"
        />
        <path
          d="M368.301 405.623C369.409 406.263 370.836 405.867 371.487 404.738C372.139 403.61 371.768 402.177 370.66 401.537C369.552 400.897 368.126 401.293 367.474 402.421C366.823 403.55 367.193 404.983 368.301 405.623Z"
          fill="#3A2933"
        />
        <path
          d="M357.917 405.075C359.025 405.715 360.451 405.319 361.102 404.191C361.754 403.062 361.384 401.629 360.276 400.989C359.168 400.349 357.741 400.746 357.09 401.874C356.438 403.002 356.808 404.436 357.917 405.075Z"
          fill="#3A2933"
        />
        <path
          d="M363.583 413.795C364.691 414.435 366.118 414.039 366.769 412.91C367.42 411.782 367.05 410.349 365.942 409.709C364.834 409.069 363.408 409.465 362.756 410.594C362.105 411.722 362.475 413.155 363.583 413.795Z"
          fill="#3A2933"
        />
        <path
          d="M358.865 421.967C359.973 422.607 361.399 422.211 362.051 421.082C362.702 419.954 362.332 418.521 361.224 417.881C360.116 417.241 358.69 417.637 358.038 418.766C357.387 419.894 357.757 421.327 358.865 421.967Z"
          fill="#3A2933"
        />
        <path
          d="M353.198 413.247C354.307 413.887 355.733 413.491 356.384 412.363C357.036 411.234 356.666 409.801 355.557 409.161C354.449 408.522 353.023 408.918 352.372 410.046C351.72 411.174 352.09 412.608 353.198 413.247Z"
          fill="#3A2933"
        />
        <path
          d="M348.48 421.419C349.588 422.059 351.015 421.663 351.666 420.535C352.318 419.406 351.947 417.973 350.839 417.333C349.731 416.694 348.305 417.09 347.653 418.218C347.002 419.346 347.372 420.78 348.48 421.419Z"
          fill="#3A2933"
        />
        <path
          d="M354.147 430.139C355.255 430.779 356.681 430.383 357.333 429.254C357.984 428.126 357.614 426.693 356.506 426.053C355.398 425.413 353.971 425.809 353.32 426.938C352.668 428.066 353.039 429.499 354.147 430.139Z"
          fill="#3A2933"
        />
        <path
          d="M343.762 429.591C344.87 430.231 346.297 429.835 346.948 428.707C347.599 427.579 347.229 426.145 346.121 425.505C345.013 424.866 343.587 425.262 342.935 426.39C342.284 427.518 342.654 428.952 343.762 429.591Z"
          fill="#3A2933"
        />
        <path
          d="M349.429 438.311C350.537 438.951 351.963 438.555 352.615 437.426C353.266 436.298 352.896 434.865 351.788 434.225C350.68 433.585 349.253 433.981 348.602 435.11C347.95 436.238 348.321 437.671 349.429 438.311Z"
          fill="#3A2933"
        />
        <path
          d="M344.71 446.483C345.819 447.123 347.245 446.727 347.896 445.599C348.548 444.47 348.178 443.037 347.07 442.397C345.961 441.757 344.535 442.153 343.884 443.282C343.232 444.41 343.602 445.843 344.71 446.483Z"
          fill="#3A2933"
        />
        <path
          d="M339.044 437.764C340.152 438.403 341.578 438.007 342.23 436.879C342.881 435.751 342.511 434.317 341.403 433.678C340.295 433.038 338.869 433.434 338.217 434.562C337.566 435.69 337.936 437.124 339.044 437.764Z"
          fill="#3A2933"
        />
        <path
          d="M334.326 445.936C335.434 446.575 336.86 446.179 337.512 445.051C338.163 443.923 337.793 442.489 336.685 441.85C335.577 441.21 334.15 441.606 333.499 442.734C332.848 443.863 333.218 445.296 334.326 445.936Z"
          fill="#3A2933"
        />
        <path
          d="M339.992 454.655C341.1 455.295 342.527 454.899 343.178 453.771C343.83 452.642 343.46 451.209 342.351 450.569C341.243 449.929 339.817 450.325 339.165 451.454C338.514 452.582 338.884 454.015 339.992 454.655Z"
          fill="#3A2933"
        />
        <path
          d="M329.608 454.108C330.716 454.747 332.142 454.351 332.794 453.223C333.445 452.095 333.075 450.661 331.967 450.022C330.859 449.382 329.432 449.778 328.781 450.906C328.129 452.035 328.5 453.468 329.608 454.108Z"
          fill="#3A2933"
        />
        <path
          d="M335.274 462.827C336.382 463.467 337.809 463.071 338.46 461.943C339.112 460.814 338.741 459.381 337.633 458.741C336.525 458.101 335.099 458.498 334.447 459.626C333.796 460.754 334.166 462.188 335.274 462.827Z"
          fill="#3A2933"
        />
        <path
          d="M324.89 462.28C325.998 462.919 327.424 462.523 328.075 461.395C328.727 460.267 328.357 458.833 327.249 458.194C326.141 457.554 324.714 457.95 324.063 459.078C323.411 460.207 323.781 461.64 324.89 462.28Z"
          fill="#3A2933"
        />
        <path
          d="M330.556 470.999C331.664 471.639 333.091 471.243 333.742 470.115C334.393 468.986 334.023 467.553 332.915 466.913C331.807 466.274 330.381 466.67 329.729 467.798C329.078 468.926 329.448 470.36 330.556 470.999Z"
          fill="#3A2933"
        />
        <path
          d="M325.838 479.171C326.946 479.811 328.372 479.415 329.024 478.287C329.675 477.158 329.305 475.725 328.197 475.085C327.089 474.446 325.663 474.842 325.011 475.97C324.36 477.098 324.73 478.532 325.838 479.171Z"
          fill="#3A2933"
        />
        <path
          d="M320.171 470.452C321.28 471.092 322.706 470.696 323.357 469.567C324.009 468.439 323.639 467.006 322.53 466.366C321.422 465.726 319.996 466.122 319.345 467.25C318.693 468.379 319.063 469.812 320.171 470.452Z"
          fill="#3A2933"
        />
        <path
          d="M315.453 478.624C316.561 479.264 317.988 478.868 318.639 477.739C319.291 476.611 318.92 475.178 317.812 474.538C316.704 473.898 315.278 474.294 314.626 475.422C313.975 476.551 314.345 477.984 315.453 478.624Z"
          fill="#3A2933"
        />
        <path
          d="M321.12 487.343C322.228 487.983 323.654 487.587 324.306 486.459C324.957 485.331 324.587 483.897 323.479 483.257C322.371 482.618 320.944 483.014 320.293 484.142C319.641 485.27 320.012 486.704 321.12 487.343Z"
          fill="#3A2933"
        />
        <path
          d="M310.735 486.796C311.843 487.436 313.27 487.04 313.921 485.911C314.572 484.783 314.202 483.35 313.094 482.71C311.986 482.07 310.56 482.466 309.908 483.595C309.257 484.723 309.627 486.156 310.735 486.796Z"
          fill="#3A2933"
        />
        <path
          d="M316.402 495.516C317.51 496.155 318.936 495.759 319.588 494.631C320.239 493.503 319.869 492.069 318.761 491.43C317.653 490.79 316.226 491.186 315.575 492.314C314.923 493.442 315.294 494.876 316.402 495.516Z"
          fill="#3A2933"
        />
        <path
          d="M306.017 494.968C307.125 495.608 308.551 495.212 309.203 494.083C309.854 492.955 309.484 491.522 308.376 490.882C307.268 490.242 305.842 490.638 305.19 491.767C304.539 492.895 304.909 494.328 306.017 494.968Z"
          fill="#3A2933"
        />
        <path
          d="M311.684 503.688C312.792 504.327 314.218 503.931 314.869 502.803C315.521 501.675 315.151 500.241 314.043 499.602C312.934 498.962 311.508 499.358 310.857 500.486C310.205 501.615 310.575 503.048 311.684 503.688Z"
          fill="#3A2933"
        />
        <path
          d="M306.965 511.86C308.073 512.499 309.5 512.103 310.151 510.975C310.803 509.847 310.433 508.413 309.324 507.774C308.216 507.134 306.79 507.53 306.138 508.658C305.487 509.787 305.857 511.22 306.965 511.86Z"
          fill="#3A2933"
        />
        <path
          d="M301.299 503.14C302.407 503.78 303.833 503.384 304.485 502.255C305.136 501.127 304.766 499.694 303.658 499.054C302.55 498.414 301.123 498.81 300.472 499.939C299.821 501.067 300.191 502.5 301.299 503.14Z"
          fill="#3A2933"
        />
        <path
          d="M296.581 511.312C297.689 511.952 299.115 511.556 299.767 510.427C300.418 509.299 300.048 507.866 298.94 507.226C297.832 506.586 296.405 506.982 295.754 508.111C295.102 509.239 295.473 510.672 296.581 511.312Z"
          fill="#3A2933"
        />
        <path
          d="M302.247 520.032C303.355 520.672 304.782 520.275 305.433 519.147C306.085 518.019 305.714 516.585 304.606 515.946C303.498 515.306 302.072 515.702 301.42 516.83C300.769 517.959 301.139 519.392 302.247 520.032Z"
          fill="#3A2933"
        />
        <path
          d="M291.863 519.484C292.971 520.124 294.397 519.728 295.048 518.6C295.7 517.471 295.33 516.038 294.222 515.398C293.113 514.758 291.687 515.154 291.036 516.283C290.384 517.411 290.754 518.844 291.863 519.484Z"
          fill="#3A2933"
        />
        <path
          d="M297.529 528.204C298.637 528.844 300.064 528.448 300.715 527.319C301.366 526.191 300.996 524.758 299.888 524.118C298.78 523.478 297.354 523.874 296.702 525.002C296.051 526.131 296.421 527.564 297.529 528.204Z"
          fill="#3A2933"
        />
        <path
          d="M292.811 536.376C293.919 537.016 295.345 536.62 295.997 535.491C296.648 534.363 296.278 532.93 295.17 532.29C294.062 531.65 292.635 532.046 291.984 533.174C291.333 534.303 291.703 535.736 292.811 536.376Z"
          fill="#3A2933"
        />
        <path
          d="M287.144 527.656C288.252 528.296 289.679 527.9 290.33 526.772C290.982 525.643 290.612 524.21 289.503 523.57C288.395 522.93 286.969 523.327 286.318 524.455C285.666 525.583 286.036 527.017 287.144 527.656Z"
          fill="#3A2933"
        />
        <path
          d="M402.277 365.31C403.385 365.95 404.811 365.554 405.463 364.425C406.114 363.297 405.744 361.864 404.636 361.224C403.528 360.584 402.101 360.98 401.45 362.109C400.798 363.237 401.169 364.67 402.277 365.31Z"
          fill="#3A2933"
        />
        <path
          d="M407.943 374.03C409.051 374.669 410.478 374.273 411.129 373.145C411.781 372.017 411.41 370.583 410.302 369.944C409.194 369.304 407.768 369.7 407.116 370.828C406.465 371.957 406.835 373.39 407.943 374.03Z"
          fill="#3A2933"
        />
        <path
          d="M397.558 373.482C398.667 374.122 400.093 373.726 400.744 372.597C401.396 371.469 401.026 370.036 399.918 369.396C398.809 368.756 397.383 369.152 396.732 370.281C396.08 371.409 396.45 372.842 397.558 373.482Z"
          fill="#3A2933"
        />
        <path
          d="M403.225 382.202C404.333 382.842 405.76 382.445 406.411 381.317C407.062 380.189 406.692 378.755 405.584 378.116C404.476 377.476 403.05 377.872 402.398 379C401.747 380.129 402.117 381.562 403.225 382.202Z"
          fill="#3A2933"
        />
        <path
          d="M392.84 381.654C393.948 382.294 395.375 381.898 396.026 380.77C396.678 379.641 396.307 378.208 395.199 377.568C394.091 376.928 392.665 377.324 392.013 378.453C391.362 379.581 391.732 381.014 392.84 381.654Z"
          fill="#3A2933"
        />
        <path
          d="M398.507 390.374C399.615 391.014 401.041 390.618 401.693 389.489C402.344 388.361 401.974 386.928 400.866 386.288C399.758 385.648 398.331 386.044 397.68 387.172C397.029 388.301 397.399 389.734 398.507 390.374Z"
          fill="#3A2933"
        />
        <path
          d="M393.789 398.546C394.897 399.186 396.323 398.79 396.975 397.661C397.626 396.533 397.256 395.1 396.148 394.46C395.04 393.82 393.613 394.216 392.962 395.344C392.31 396.473 392.681 397.906 393.789 398.546Z"
          fill="#3A2933"
        />
        <path
          d="M388.122 389.826C389.23 390.466 390.657 390.07 391.308 388.942C391.96 387.813 391.589 386.38 390.481 385.74C389.373 385.1 387.947 385.497 387.295 386.625C386.644 387.753 387.014 389.186 388.122 389.826Z"
          fill="#3A2933"
        />
        <path
          d="M383.404 397.998C384.512 398.638 385.939 398.242 386.59 397.114C387.241 395.985 386.871 394.552 385.763 393.912C384.655 393.273 383.229 393.669 382.577 394.797C381.926 395.925 382.296 397.359 383.404 397.998Z"
          fill="#3A2933"
        />
        <path
          d="M389.071 406.718C390.179 407.358 391.605 406.962 392.257 405.833C392.908 404.705 392.538 403.272 391.43 402.632C390.322 401.992 388.895 402.388 388.244 403.517C387.592 404.645 387.962 406.078 389.071 406.718Z"
          fill="#3A2933"
        />
        <path
          d="M378.686 406.17C379.794 406.81 381.22 406.414 381.872 405.286C382.523 404.157 382.153 402.724 381.045 402.084C379.937 401.445 378.51 401.841 377.859 402.969C377.208 404.097 377.578 405.531 378.686 406.17Z"
          fill="#3A2933"
        />
        <path
          d="M384.352 414.89C385.461 415.53 386.887 415.134 387.538 414.005C388.19 412.877 387.82 411.444 386.711 410.804C385.603 410.164 384.177 410.56 383.526 411.689C382.874 412.817 383.244 414.25 384.352 414.89Z"
          fill="#3A2933"
        />
        <path
          d="M373.968 414.342C375.076 414.982 376.502 414.586 377.154 413.458C377.805 412.33 377.435 410.896 376.327 410.256C375.219 409.617 373.792 410.013 373.141 411.141C372.489 412.269 372.86 413.703 373.968 414.342Z"
          fill="#3A2933"
        />
        <path
          d="M379.634 423.062C380.742 423.702 382.169 423.306 382.82 422.177C383.472 421.049 383.101 419.616 381.993 418.976C380.885 418.336 379.459 418.732 378.807 419.861C378.156 420.989 378.526 422.422 379.634 423.062Z"
          fill="#3A2933"
        />
        <path
          d="M374.916 431.234C376.024 431.874 377.451 431.478 378.102 430.35C378.754 429.221 378.383 427.788 377.275 427.148C376.167 426.508 374.741 426.904 374.089 428.033C373.438 429.161 373.808 430.594 374.916 431.234Z"
          fill="#3A2933"
        />
        <path
          d="M369.25 422.514C370.358 423.154 371.784 422.758 372.436 421.63C373.087 420.502 372.717 419.068 371.609 418.428C370.501 417.789 369.074 418.185 368.423 419.313C367.771 420.441 368.141 421.875 369.25 422.514Z"
          fill="#3A2933"
        />
        <path
          d="M364.531 430.687C365.64 431.326 367.066 430.93 367.717 429.802C368.369 428.674 367.999 427.24 366.891 426.601C365.782 425.961 364.356 426.357 363.705 427.485C363.053 428.613 363.423 430.047 364.531 430.687Z"
          fill="#3A2933"
        />
        <path
          d="M370.198 439.406C371.306 440.046 372.733 439.65 373.384 438.522C374.035 437.393 373.665 435.96 372.557 435.32C371.449 434.68 370.023 435.076 369.371 436.205C368.72 437.333 369.09 438.766 370.198 439.406Z"
          fill="#3A2933"
        />
        <path
          d="M359.813 438.859C360.921 439.498 362.348 439.102 362.999 437.974C363.651 436.846 363.28 435.412 362.172 434.773C361.064 434.133 359.638 434.529 358.986 435.657C358.335 436.786 358.705 438.219 359.813 438.859Z"
          fill="#3A2933"
        />
        <path
          d="M365.48 447.578C366.588 448.218 368.014 447.822 368.666 446.694C369.317 445.565 368.947 444.132 367.839 443.492C366.731 442.852 365.304 443.249 364.653 444.377C364.002 445.505 364.372 446.938 365.48 447.578Z"
          fill="#3A2933"
        />
        <path
          d="M360.762 455.75C361.87 456.39 363.296 455.994 363.948 454.866C364.599 453.737 364.229 452.304 363.121 451.664C362.013 451.025 360.586 451.421 359.935 452.549C359.283 453.677 359.654 455.111 360.762 455.75Z"
          fill="#3A2933"
        />
        <path
          d="M355.095 447.031C356.203 447.67 357.63 447.274 358.281 446.146C358.933 445.018 358.562 443.584 357.454 442.945C356.346 442.305 354.92 442.701 354.268 443.829C353.617 444.958 353.987 446.391 355.095 447.031Z"
          fill="#3A2933"
        />
        <path
          d="M350.377 455.203C351.485 455.843 352.912 455.446 353.563 454.318C354.214 453.19 353.844 451.757 352.736 451.117C351.628 450.477 350.202 450.873 349.55 452.001C348.899 453.13 349.269 454.563 350.377 455.203Z"
          fill="#3A2933"
        />
        <path
          d="M356.044 463.922C357.152 464.562 358.578 464.166 359.23 463.038C359.881 461.909 359.511 460.476 358.403 459.836C357.295 459.197 355.868 459.593 355.217 460.721C354.565 461.849 354.935 463.283 356.044 463.922Z"
          fill="#3A2933"
        />
        <path
          d="M345.659 463.375C346.767 464.015 348.193 463.619 348.845 462.49C349.496 461.362 349.126 459.929 348.018 459.289C346.91 458.649 345.483 459.045 344.832 460.173C344.181 461.302 344.551 462.735 345.659 463.375Z"
          fill="#3A2933"
        />
        <path
          d="M351.325 472.094C352.434 472.734 353.86 472.338 354.511 471.21C355.163 470.081 354.793 468.648 353.685 468.008C352.576 467.369 351.15 467.765 350.499 468.893C349.847 470.021 350.217 471.455 351.325 472.094Z"
          fill="#3A2933"
        />
        <path
          d="M340.941 471.547C342.049 472.187 343.475 471.791 344.127 470.662C344.778 469.534 344.408 468.101 343.3 467.461C342.192 466.821 340.765 467.217 340.114 468.345C339.462 469.474 339.833 470.907 340.941 471.547Z"
          fill="#3A2933"
        />
        <path
          d="M346.607 480.267C347.715 480.906 349.142 480.51 349.793 479.382C350.445 478.254 350.074 476.82 348.966 476.18C347.858 475.541 346.432 475.937 345.78 477.065C345.129 478.193 345.499 479.627 346.607 480.267Z"
          fill="#3A2933"
        />
        <path
          d="M341.889 488.439C342.997 489.078 344.424 488.682 345.075 487.554C345.727 486.426 345.356 484.992 344.248 484.353C343.14 483.713 341.714 484.109 341.062 485.237C340.411 486.366 340.781 487.799 341.889 488.439Z"
          fill="#3A2933"
        />
        <path
          d="M336.223 479.719C337.331 480.359 338.757 479.963 339.409 478.834C340.06 477.706 339.69 476.273 338.582 475.633C337.474 474.993 336.047 475.389 335.396 476.518C334.744 477.646 335.114 479.079 336.223 479.719Z"
          fill="#3A2933"
        />
        <path
          d="M331.504 487.891C332.613 488.531 334.039 488.135 334.69 487.006C335.342 485.878 334.972 484.445 333.864 483.805C332.755 483.165 331.329 483.561 330.678 484.69C330.026 485.818 330.396 487.251 331.504 487.891Z"
          fill="#3A2933"
        />
        <path
          d="M337.171 496.611C338.279 497.25 339.705 496.854 340.357 495.726C341.008 494.598 340.638 493.164 339.53 492.525C338.422 491.885 336.996 492.281 336.344 493.409C335.693 494.538 336.063 495.971 337.171 496.611Z"
          fill="#3A2933"
        />
        <path
          d="M326.786 496.063C327.894 496.703 329.321 496.307 329.972 495.178C330.624 494.05 330.253 492.617 329.145 491.977C328.037 491.337 326.611 491.733 325.959 492.862C325.308 493.99 325.678 495.423 326.786 496.063Z"
          fill="#3A2933"
        />
        <path
          d="M332.453 504.783C333.561 505.422 334.987 505.026 335.639 503.898C336.29 502.77 335.92 501.336 334.812 500.697C333.704 500.057 332.277 500.453 331.626 501.581C330.975 502.71 331.345 504.143 332.453 504.783Z"
          fill="#3A2933"
        />
        <path
          d="M322.068 504.235C323.176 504.875 324.603 504.479 325.254 503.351C325.906 502.222 325.535 500.789 324.427 500.149C323.319 499.509 321.893 499.905 321.241 501.034C320.59 502.162 320.96 503.595 322.068 504.235Z"
          fill="#3A2933"
        />
        <path
          d="M327.735 512.955C328.843 513.595 330.269 513.198 330.921 512.07C331.572 510.942 331.202 509.509 330.094 508.869C328.986 508.229 327.559 508.625 326.908 509.753C326.256 510.882 326.627 512.315 327.735 512.955Z"
          fill="#3A2933"
        />
        <path
          d="M323.017 521.127C324.125 521.767 325.551 521.371 326.203 520.242C326.854 519.114 326.484 517.681 325.376 517.041C324.268 516.401 322.841 516.797 322.19 517.925C321.538 519.054 321.908 520.487 323.017 521.127Z"
          fill="#3A2933"
        />
        <path
          d="M317.35 512.407C318.458 513.047 319.885 512.651 320.536 511.523C321.187 510.394 320.817 508.961 319.709 508.321C318.601 507.681 317.175 508.077 316.523 509.206C315.872 510.334 316.242 511.767 317.35 512.407Z"
          fill="#3A2933"
        />
        <path
          d="M312.632 520.579C313.74 521.219 315.166 520.823 315.818 519.695C316.469 518.566 316.099 517.133 314.991 516.493C313.883 515.853 312.456 516.25 311.805 517.378C311.154 518.506 311.524 519.94 312.632 520.579Z"
          fill="#3A2933"
        />
        <path
          d="M318.298 529.299C319.407 529.939 320.833 529.543 321.484 528.414C322.136 527.286 321.766 525.853 320.657 525.213C319.549 524.573 318.123 524.969 317.472 526.098C316.82 527.226 317.19 528.659 318.298 529.299Z"
          fill="#3A2933"
        />
        <path
          d="M307.914 528.751C309.022 529.391 310.448 528.995 311.1 527.867C311.751 526.738 311.381 525.305 310.273 524.665C309.165 524.026 307.738 524.422 307.087 525.55C306.435 526.678 306.806 528.112 307.914 528.751Z"
          fill="#3A2933"
        />
        <path
          d="M313.58 537.471C314.688 538.111 316.115 537.715 316.766 536.586C317.418 535.458 317.047 534.025 315.939 533.385C314.831 532.745 313.405 533.141 312.753 534.27C312.102 535.398 312.472 536.831 313.58 537.471Z"
          fill="#3A2933"
        />
        <path
          d="M308.862 545.643C309.97 546.283 311.397 545.887 312.048 544.758C312.7 543.63 312.329 542.197 311.221 541.557C310.113 540.917 308.687 541.313 308.035 542.442C307.384 543.57 307.754 545.003 308.862 545.643Z"
          fill="#3A2933"
        />
        <path
          d="M303.196 536.923C304.304 537.563 305.73 537.167 306.382 536.039C307.033 534.91 306.663 533.477 305.555 532.837C304.447 532.198 303.02 532.594 302.369 533.722C301.717 534.85 302.087 536.284 303.196 536.923Z"
          fill="#3A2933"
        />
        <path
          d="M418.328 374.577C419.436 375.217 420.862 374.821 421.514 373.693C422.165 372.564 421.795 371.131 420.687 370.491C419.579 369.851 418.152 370.247 417.501 371.376C416.85 372.504 417.22 373.937 418.328 374.577Z"
          fill="#3A2933"
        />
        <path
          d="M423.994 383.297C425.103 383.937 426.529 383.541 427.18 382.412C427.832 381.284 427.462 379.851 426.353 379.211C425.245 378.571 423.819 378.967 423.168 380.095C422.516 381.224 422.886 382.657 423.994 383.297Z"
          fill="#3A2933"
        />
        <path
          d="M413.61 382.749C414.718 383.389 416.144 382.993 416.796 381.865C417.447 380.736 417.077 379.303 415.969 378.663C414.861 378.024 413.434 378.42 412.783 379.548C412.131 380.676 412.502 382.11 413.61 382.749Z"
          fill="#3A2933"
        />
        <path
          d="M419.276 391.469C420.384 392.109 421.811 391.713 422.462 390.584C423.114 389.456 422.743 388.023 421.635 387.383C420.527 386.743 419.101 387.139 418.449 388.268C417.798 389.396 418.168 390.829 419.276 391.469Z"
          fill="#3A2933"
        />
        <path
          d="M408.892 390.921C410 391.561 411.426 391.165 412.077 390.037C412.729 388.908 412.359 387.475 411.251 386.835C410.143 386.196 408.716 386.592 408.065 387.72C407.413 388.848 407.783 390.282 408.892 390.921Z"
          fill="#3A2933"
        />
        <path
          d="M414.558 399.641C415.666 400.281 417.093 399.885 417.744 398.756C418.395 397.628 418.025 396.195 416.917 395.555C415.809 394.915 414.383 395.311 413.731 396.44C413.08 397.568 413.45 399.001 414.558 399.641Z"
          fill="#3A2933"
        />
        <path
          d="M409.84 407.813C410.948 408.453 412.374 408.057 413.026 406.928C413.677 405.8 413.307 404.367 412.199 403.727C411.091 403.087 409.665 403.483 409.013 404.612C408.362 405.74 408.732 407.173 409.84 407.813Z"
          fill="#3A2933"
        />
        <path
          d="M404.173 399.093C405.282 399.733 406.708 399.337 407.359 398.209C408.011 397.08 407.641 395.647 406.533 395.007C405.424 394.368 403.998 394.764 403.347 395.892C402.695 397.02 403.065 398.454 404.173 399.093Z"
          fill="#3A2933"
        />
        <path
          d="M399.455 407.266C400.563 407.905 401.99 407.509 402.641 406.381C403.293 405.253 402.922 403.819 401.814 403.179C400.706 402.54 399.28 402.936 398.628 404.064C397.977 405.192 398.347 406.626 399.455 407.266Z"
          fill="#3A2933"
        />
        <path
          d="M405.122 415.985C406.23 416.625 407.656 416.229 408.308 415.101C408.959 413.972 408.589 412.539 407.481 411.899C406.373 411.259 404.946 411.655 404.295 412.784C403.644 413.912 404.014 415.345 405.122 415.985Z"
          fill="#3A2933"
        />
        <path
          d="M394.737 415.438C395.845 416.077 397.272 415.681 397.923 414.553C398.574 413.425 398.204 411.991 397.096 411.352C395.988 410.712 394.562 411.108 393.91 412.236C393.259 413.364 393.629 414.798 394.737 415.438Z"
          fill="#3A2933"
        />
        <path
          d="M400.404 424.157C401.512 424.797 402.938 424.401 403.59 423.273C404.241 422.144 403.871 420.711 402.763 420.071C401.655 419.431 400.228 419.827 399.577 420.956C398.925 422.084 399.296 423.517 400.404 424.157Z"
          fill="#3A2933"
        />
        <path
          d="M390.019 423.61C391.127 424.249 392.553 423.853 393.205 422.725C393.856 421.597 393.486 420.163 392.378 419.524C391.27 418.884 389.844 419.28 389.192 420.408C388.541 421.537 388.911 422.97 390.019 423.61Z"
          fill="#3A2933"
        />
        <path
          d="M395.686 432.329C396.794 432.969 398.22 432.573 398.871 431.445C399.523 430.316 399.153 428.883 398.045 428.243C396.936 427.603 395.51 428 394.859 429.128C394.207 430.256 394.577 431.689 395.686 432.329Z"
          fill="#3A2933"
        />
        <path
          d="M390.967 440.501C392.076 441.141 393.502 440.745 394.153 439.617C394.805 438.488 394.435 437.055 393.326 436.415C392.218 435.776 390.792 436.172 390.141 437.3C389.489 438.428 389.859 439.862 390.967 440.501Z"
          fill="#3A2933"
        />
        <path
          d="M385.301 431.782C386.409 432.421 387.835 432.025 388.487 430.897C389.138 429.769 388.768 428.335 387.66 427.696C386.552 427.056 385.125 427.452 384.474 428.58C383.823 429.709 384.193 431.142 385.301 431.782Z"
          fill="#3A2933"
        />
        <path
          d="M380.583 439.954C381.691 440.594 383.117 440.197 383.769 439.069C384.42 437.941 384.05 436.507 382.942 435.868C381.834 435.228 380.407 435.624 379.756 436.752C379.104 437.881 379.475 439.314 380.583 439.954Z"
          fill="#3A2933"
        />
        <path
          d="M386.249 448.673C387.357 449.313 388.784 448.917 389.435 447.789C390.087 446.66 389.716 445.227 388.608 444.587C387.5 443.948 386.074 444.344 385.422 445.472C384.771 446.6 385.141 448.034 386.249 448.673Z"
          fill="#3A2933"
        />
        <path
          d="M375.865 448.126C376.973 448.766 378.399 448.37 379.05 447.241C379.702 446.113 379.332 444.68 378.224 444.04C377.116 443.4 375.689 443.796 375.038 444.924C374.386 446.053 374.756 447.486 375.865 448.126Z"
          fill="#3A2933"
        />
        <path
          d="M381.531 456.845C382.639 457.485 384.066 457.089 384.717 455.961C385.368 454.833 384.998 453.399 383.89 452.759C382.782 452.12 381.356 452.516 380.704 453.644C380.053 454.772 380.423 456.206 381.531 456.845Z"
          fill="#3A2933"
        />
        <path
          d="M376.813 465.018C377.921 465.657 379.347 465.261 379.999 464.133C380.65 463.005 380.28 461.571 379.172 460.931C378.064 460.292 376.638 460.688 375.986 461.816C375.335 462.944 375.705 464.378 376.813 465.018Z"
          fill="#3A2933"
        />
        <path
          d="M371.146 456.298C372.255 456.938 373.681 456.542 374.332 455.413C374.984 454.285 374.614 452.852 373.505 452.212C372.397 451.572 370.971 451.968 370.32 453.096C369.668 454.225 370.038 455.658 371.146 456.298Z"
          fill="#3A2933"
        />
        <path
          d="M366.428 464.47C367.536 465.11 368.963 464.714 369.614 463.585C370.266 462.457 369.895 461.024 368.787 460.384C367.679 459.744 366.253 460.14 365.601 461.269C364.95 462.397 365.32 463.83 366.428 464.47Z"
          fill="#3A2933"
        />
        <path
          d="M372.095 473.19C373.203 473.829 374.629 473.433 375.281 472.305C375.932 471.177 375.562 469.743 374.454 469.104C373.346 468.464 371.919 468.86 371.268 469.988C370.617 471.117 370.987 472.55 372.095 473.19Z"
          fill="#3A2933"
        />
        <path
          d="M361.71 472.642C362.818 473.282 364.245 472.886 364.896 471.757C365.548 470.629 365.177 469.196 364.069 468.556C362.961 467.916 361.535 468.312 360.883 469.441C360.232 470.569 360.602 472.002 361.71 472.642Z"
          fill="#3A2933"
        />
        <path
          d="M367.377 481.362C368.485 482.001 369.911 481.605 370.563 480.477C371.214 479.349 370.844 477.915 369.736 477.276C368.628 476.636 367.201 477.032 366.55 478.16C365.898 479.289 366.269 480.722 367.377 481.362Z"
          fill="#3A2933"
        />
        <path
          d="M356.992 480.814C358.1 481.454 359.526 481.058 360.178 479.929C360.829 478.801 360.459 477.368 359.351 476.728C358.243 476.088 356.817 476.484 356.165 477.613C355.514 478.741 355.884 480.174 356.992 480.814Z"
          fill="#3A2933"
        />
        <path
          d="M362.659 489.534C363.767 490.173 365.193 489.777 365.844 488.649C366.496 487.521 366.126 486.087 365.018 485.448C363.91 484.808 362.483 485.204 361.832 486.332C361.18 487.461 361.55 488.894 362.659 489.534Z"
          fill="#3A2933"
        />
        <path
          d="M357.94 497.706C359.049 498.346 360.475 497.949 361.126 496.821C361.778 495.693 361.408 494.26 360.299 493.62C359.191 492.98 357.765 493.376 357.114 494.504C356.462 495.633 356.832 497.066 357.94 497.706Z"
          fill="#3A2933"
        />
        <path
          d="M352.274 488.986C353.382 489.626 354.808 489.23 355.46 488.102C356.111 486.973 355.741 485.54 354.633 484.9C353.525 484.26 352.098 484.656 351.447 485.785C350.796 486.913 351.166 488.346 352.274 488.986Z"
          fill="#3A2933"
        />
        <path
          d="M347.556 497.158C348.664 497.798 350.09 497.402 350.742 496.274C351.393 495.145 351.023 493.712 349.915 493.072C348.807 492.432 347.38 492.828 346.729 493.957C346.077 495.085 346.448 496.518 347.556 497.158Z"
          fill="#3A2933"
        />
        <path
          d="M353.222 505.878C354.33 506.518 355.757 506.122 356.408 504.993C357.06 503.865 356.689 502.432 355.581 501.792C354.473 501.152 353.047 501.548 352.395 502.676C351.744 503.805 352.114 505.238 353.222 505.878Z"
          fill="#3A2933"
        />
        <path
          d="M342.838 505.33C343.946 505.97 345.372 505.574 346.023 504.446C346.675 503.317 346.305 501.884 345.197 501.244C344.089 500.605 342.662 501.001 342.011 502.129C341.359 503.257 341.729 504.691 342.838 505.33Z"
          fill="#3A2933"
        />
        <path
          d="M348.504 514.05C349.612 514.69 351.039 514.294 351.69 513.165C352.341 512.037 351.971 510.604 350.863 509.964C349.755 509.324 348.329 509.72 347.677 510.848C347.026 511.977 347.396 513.41 348.504 514.05Z"
          fill="#3A2933"
        />
        <path
          d="M338.119 513.502C339.228 514.142 340.654 513.746 341.305 512.618C341.957 511.489 341.587 510.056 340.478 509.416C339.37 508.777 337.944 509.173 337.293 510.301C336.641 511.429 337.011 512.863 338.119 513.502Z"
          fill="#3A2933"
        />
        <path
          d="M343.786 522.222C344.894 522.862 346.32 522.466 346.972 521.337C347.623 520.209 347.253 518.776 346.145 518.136C345.037 517.496 343.611 517.892 342.959 519.021C342.308 520.149 342.678 521.582 343.786 522.222Z"
          fill="#3A2933"
        />
        <path
          d="M339.068 530.394C340.176 531.034 341.602 530.638 342.254 529.509C342.905 528.381 342.535 526.948 341.427 526.308C340.319 525.668 338.892 526.064 338.241 527.193C337.59 528.321 337.96 529.754 339.068 530.394Z"
          fill="#3A2933"
        />
        <path
          d="M333.401 521.674C334.509 522.314 335.936 521.918 336.587 520.79C337.239 519.661 336.868 518.228 335.76 517.588C334.652 516.949 333.226 517.345 332.574 518.473C331.923 519.601 332.293 521.035 333.401 521.674Z"
          fill="#3A2933"
        />
        <path
          d="M328.683 529.846C329.791 530.486 331.218 530.09 331.869 528.962C332.521 527.834 332.15 526.4 331.042 525.76C329.934 525.121 328.508 525.517 327.856 526.645C327.205 527.773 327.575 529.207 328.683 529.846Z"
          fill="#3A2933"
        />
        <path
          d="M334.35 538.566C335.458 539.206 336.884 538.81 337.536 537.682C338.187 536.553 337.817 535.12 336.709 534.48C335.601 533.84 334.174 534.236 333.523 535.365C332.871 536.493 333.242 537.926 334.35 538.566Z"
          fill="#3A2933"
        />
        <path
          d="M323.965 538.019C325.073 538.658 326.499 538.262 327.151 537.134C327.802 536.006 327.432 534.572 326.324 533.933C325.216 533.293 323.79 533.689 323.138 534.817C322.487 535.945 322.857 537.379 323.965 538.019Z"
          fill="#3A2933"
        />
        <path
          d="M329.632 546.738C330.74 547.378 332.166 546.982 332.817 545.854C333.469 544.725 333.099 543.292 331.991 542.652C330.882 542.012 329.456 542.408 328.805 543.537C328.153 544.665 328.523 546.098 329.632 546.738Z"
          fill="#3A2933"
        />
        <path
          d="M324.913 554.91C326.021 555.55 327.448 555.154 328.099 554.026C328.751 552.897 328.381 551.464 327.272 550.824C326.164 550.184 324.738 550.581 324.087 551.709C323.435 552.837 323.805 554.27 324.913 554.91Z"
          fill="#3A2933"
        />
        <path
          d="M319.247 546.191C320.355 546.83 321.781 546.434 322.433 545.306C323.084 544.178 322.714 542.744 321.606 542.105C320.498 541.465 319.071 541.861 318.42 542.989C317.769 544.118 318.139 545.551 319.247 546.191Z"
          fill="#3A2933"
        />
        <path
          d="M434.379 383.844C435.487 384.484 436.914 384.088 437.565 382.96C438.216 381.831 437.846 380.398 436.738 379.758C435.63 379.119 434.204 379.515 433.552 380.643C432.901 381.771 433.271 383.205 434.379 383.844Z"
          fill="#3A2933"
        />
        <path
          d="M429.661 392.016C430.769 392.656 432.195 392.26 432.847 391.132C433.498 390.004 433.128 388.57 432.02 387.93C430.912 387.291 429.486 387.687 428.834 388.815C428.183 389.943 428.553 391.377 429.661 392.016Z"
          fill="#3A2933"
        />
        <path
          d="M424.943 400.189C426.051 400.828 427.477 400.432 428.129 399.304C428.78 398.176 428.41 396.742 427.302 396.103C426.194 395.463 424.767 395.859 424.116 396.987C423.464 398.115 423.835 399.549 424.943 400.189Z"
          fill="#3A2933"
        />
        <path
          d="M420.225 408.361C421.333 409 422.759 408.604 423.411 407.476C424.062 406.348 423.692 404.914 422.584 404.275C421.476 403.635 420.049 404.031 419.398 405.159C418.746 406.288 419.117 407.721 420.225 408.361Z"
          fill="#3A2933"
        />
        <path
          d="M415.507 416.533C416.615 417.172 418.041 416.776 418.692 415.648C419.344 414.52 418.974 413.086 417.866 412.447C416.757 411.807 415.331 412.203 414.68 413.331C414.028 414.46 414.398 415.893 415.507 416.533Z"
          fill="#3A2933"
        />
        <path
          d="M410.788 424.705C411.896 425.345 413.323 424.948 413.974 423.82C414.626 422.692 414.256 421.258 413.147 420.619C412.039 419.979 410.613 420.375 409.961 421.503C409.31 422.632 409.68 424.065 410.788 424.705Z"
          fill="#3A2933"
        />
        <path
          d="M406.07 432.877C407.178 433.517 408.605 433.121 409.256 431.992C409.908 430.864 409.537 429.431 408.429 428.791C407.321 428.151 405.895 428.547 405.243 429.675C404.592 430.804 404.962 432.237 406.07 432.877Z"
          fill="#3A2933"
        />
        <path
          d="M401.352 441.049C402.46 441.689 403.887 441.293 404.538 440.164C405.189 439.036 404.819 437.603 403.711 436.963C402.603 436.323 401.177 436.719 400.525 437.847C399.874 438.976 400.244 440.409 401.352 441.049Z"
          fill="#3A2933"
        />
        <path
          d="M396.634 449.221C397.742 449.861 399.168 449.465 399.82 448.336C400.471 447.208 400.101 445.775 398.993 445.135C397.885 444.495 396.459 444.891 395.807 446.02C395.156 447.148 395.526 448.581 396.634 449.221Z"
          fill="#3A2933"
        />
        <path
          d="M391.916 457.393C393.024 458.033 394.45 457.637 395.102 456.508C395.753 455.38 395.383 453.947 394.275 453.307C393.167 452.667 391.74 453.063 391.089 454.192C390.437 455.32 390.808 456.753 391.916 457.393Z"
          fill="#3A2933"
        />
        <path
          d="M387.198 465.565C388.306 466.205 389.732 465.809 390.384 464.68C391.035 463.552 390.665 462.119 389.557 461.479C388.449 460.839 387.022 461.235 386.371 462.364C385.719 463.492 386.09 464.925 387.198 465.565Z"
          fill="#3A2933"
        />
        <path
          d="M382.48 473.737C383.588 474.377 385.014 473.981 385.665 472.853C386.317 471.724 385.947 470.291 384.839 469.651C383.73 469.011 382.304 469.407 381.653 470.536C381.001 471.664 381.371 473.097 382.48 473.737Z"
          fill="#3A2933"
        />
        <path
          d="M377.761 481.909C378.869 482.549 380.296 482.153 380.947 481.025C381.599 479.896 381.229 478.463 380.12 477.823C379.012 477.183 377.586 477.579 376.935 478.708C376.283 479.836 376.653 481.269 377.761 481.909Z"
          fill="#3A2933"
        />
        <path
          d="M373.043 490.081C374.151 490.721 375.578 490.325 376.229 489.197C376.881 488.068 376.51 486.635 375.402 485.995C374.294 485.355 372.868 485.752 372.216 486.88C371.565 488.008 371.935 489.442 373.043 490.081Z"
          fill="#3A2933"
        />
        <path
          d="M368.325 498.253C369.433 498.893 370.86 498.497 371.511 497.369C372.162 496.24 371.792 494.807 370.684 494.167C369.576 493.528 368.15 493.924 367.498 495.052C366.847 496.18 367.217 497.614 368.325 498.253Z"
          fill="#3A2933"
        />
        <path
          d="M363.607 506.425C364.715 507.065 366.141 506.669 366.793 505.541C367.444 504.412 367.074 502.979 365.966 502.339C364.858 501.7 363.431 502.096 362.78 503.224C362.129 504.352 362.499 505.786 363.607 506.425Z"
          fill="#3A2933"
        />
        <path
          d="M358.889 514.597C359.997 515.237 361.423 514.841 362.075 513.713C362.726 512.585 362.356 511.151 361.248 510.511C360.14 509.872 358.713 510.268 358.062 511.396C357.41 512.524 357.781 513.958 358.889 514.597Z"
          fill="#3A2933"
        />
        <path
          d="M354.171 522.77C355.279 523.409 356.705 523.013 357.357 521.885C358.008 520.757 357.638 519.323 356.53 518.684C355.422 518.044 353.995 518.44 353.344 519.568C352.692 520.696 353.063 522.13 354.171 522.77Z"
          fill="#3A2933"
        />
        <path
          d="M349.453 530.942C350.561 531.581 351.987 531.185 352.638 530.057C353.29 528.929 352.92 527.495 351.812 526.856C350.703 526.216 349.277 526.612 348.626 527.74C347.974 528.869 348.344 530.302 349.453 530.942Z"
          fill="#3A2933"
        />
        <path
          d="M344.734 539.114C345.842 539.753 347.269 539.357 347.92 538.229C348.572 537.101 348.202 535.667 347.093 535.028C345.985 534.388 344.559 534.784 343.907 535.912C343.256 537.041 343.626 538.474 344.734 539.114Z"
          fill="#3A2933"
        />
        <path
          d="M340.016 547.286C341.124 547.925 342.551 547.529 343.202 546.401C343.854 545.273 343.483 543.839 342.375 543.2C341.267 542.56 339.841 542.956 339.189 544.084C338.538 545.213 338.908 546.646 340.016 547.286Z"
          fill="#3A2933"
        />
        <path
          d="M335.298 555.458C336.406 556.098 337.833 555.702 338.484 554.573C339.135 553.445 338.765 552.012 337.657 551.372C336.549 550.732 335.123 551.128 334.471 552.256C333.82 553.385 334.19 554.818 335.298 555.458Z"
          fill="#3A2933"
        />
      </g>
    </g>
  </svg>
);

export default SVGDotsWrap;
